
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0031"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0031"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("b34XJ", function(module, exports) {

$parcel$export(module.exports, "l", () => $80b3d2f58e77b583$export$882b5998b3b9117c);
$parcel$export(module.exports, "J", () => $80b3d2f58e77b583$export$b4171a6734a65d42);
$parcel$export(module.exports, "d", () => $80b3d2f58e77b583$export$4368d992c4eafac0);
$parcel$export(module.exports, "m", () => $80b3d2f58e77b583$export$953cecd6e717a553);
$parcel$export(module.exports, "x", () => $80b3d2f58e77b583$export$d141bba7fdc215a3);
$parcel$export(module.exports, "G", () => $80b3d2f58e77b583$export$2329c99376c9d0a4);
$parcel$export(module.exports, "H", () => $80b3d2f58e77b583$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "r", () => $80b3d2f58e77b583$export$43caf9889c228507);
$parcel$export(module.exports, "e", () => $80b3d2f58e77b583$export$f1e1789686576879);
$parcel$export(module.exports, "E", () => $80b3d2f58e77b583$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "B", () => $80b3d2f58e77b583$export$ef35774e6d314e91);
$parcel$export(module.exports, "f", () => $80b3d2f58e77b583$export$2d1720544b23b823);
$parcel$export(module.exports, "Z", () => $80b3d2f58e77b583$export$dc98b0b04f4c7758);
$parcel$export(module.exports, "n", () => $80b3d2f58e77b583$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "k", () => $80b3d2f58e77b583$export$342063e11d6c3cad);
$parcel$export(module.exports, "I", () => $80b3d2f58e77b583$export$9bb611d729802a56);
$parcel$export(module.exports, "y", () => $80b3d2f58e77b583$export$4a5767248b18ef41);
$parcel$export(module.exports, "D", () => $80b3d2f58e77b583$export$96f57966bedc81b4);
$parcel$export(module.exports, "w", () => $80b3d2f58e77b583$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "h", () => $80b3d2f58e77b583$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "j", () => $80b3d2f58e77b583$export$35e795649ee09318);
$parcel$export(module.exports, "C", () => $80b3d2f58e77b583$export$e7094788287c5e9b);
$parcel$export(module.exports, "u", () => $80b3d2f58e77b583$export$3b14a55fb2447963);
$parcel$export(module.exports, "M", () => $80b3d2f58e77b583$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "F", () => $80b3d2f58e77b583$export$d66501df72047452);
$parcel$export(module.exports, "i", () => $80b3d2f58e77b583$export$23f2a1d2818174ef);
$parcel$export(module.exports, "o", () => $80b3d2f58e77b583$export$ae1af26003f05816);
$parcel$export(module.exports, "v", () => $80b3d2f58e77b583$export$90a7f3efeed30595);
$parcel$export(module.exports, "s", () => $80b3d2f58e77b583$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "g", () => $80b3d2f58e77b583$export$39b482c5e57630a8);
$parcel$export(module.exports, "b", () => $80b3d2f58e77b583$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "a", () => $80b3d2f58e77b583$export$407448d2b89b1813);
$parcel$export(module.exports, "q", () => $80b3d2f58e77b583$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $80b3d2f58e77b583$export$625550452a3fa3ec);
$parcel$export(module.exports, "L", () => $80b3d2f58e77b583$export$61196ced6d74a310);
$parcel$export(module.exports, "c", () => $80b3d2f58e77b583$export$db3b6bfb95261072);
$parcel$export(module.exports, "p", () => $80b3d2f58e77b583$export$ffb5f4729a158638);
$parcel$export(module.exports, "K", () => $80b3d2f58e77b583$export$3466f893ebf79586);
$parcel$export(module.exports, "z", () => $80b3d2f58e77b583$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $80b3d2f58e77b583$export$ebd11618f299a286);
$parcel$export(module.exports, "N", () => $80b3d2f58e77b583$export$a07804094c3ecf2d);

var $eJNXH = parcelRequire("eJNXH");

var $gngdn = parcelRequire("gngdn");

var $2ujND = parcelRequire("2ujND");
parcelRequire("2YFJl");
var $6QL1t = parcelRequire("6QL1t");
var $2515N = parcelRequire("2515N");
var $e1bEB = parcelRequire("e1bEB");
var $gpIrV = parcelRequire("gpIrV");
var $l8Mye = parcelRequire("l8Mye");
var $hga9n = parcelRequire("hga9n");
var $9XrSP = parcelRequire("9XrSP");
var $dUIyz = parcelRequire("dUIyz");
var $6FEsA = parcelRequire("6FEsA");
var $loyNQ = parcelRequire("loyNQ");
var $4tc8L = parcelRequire("4tc8L");
var $gEcf1 = parcelRequire("gEcf1");
var $4CT3t = parcelRequire("4CT3t");
var $hp3ls = parcelRequire("hp3ls");
var $kjPWc = parcelRequire("kjPWc");
var $1zRZO = parcelRequire("1zRZO");
var $hOxpW = parcelRequire("hOxpW");

var $i8Fxz = parcelRequire("i8Fxz");

var $7Mv8O = parcelRequire("7Mv8O");
var $c94qS = parcelRequire("c94qS");
var $1LW8F = parcelRequire("1LW8F");
var $75Ue8 = parcelRequire("75Ue8");
var $1Ez1E = parcelRequire("1Ez1E");
var $b1Vti = parcelRequire("b1Vti");

var $e21Zk = parcelRequire("e21Zk");

var $gocXo = parcelRequire("gocXo");

var $fm8kz = parcelRequire("fm8kz");

var $02tYw = parcelRequire("02tYw");
const $80b3d2f58e77b583$var$LEVELS = {
    trace: 0,
    debug: 1,
    info: 2,
    warn: 3,
    error: 4,
    fatal: 5
};
const $80b3d2f58e77b583$export$882b5998b3b9117c = {
    trace: (..._args)=>{},
    debug: (..._args)=>{},
    info: (..._args)=>{},
    warn: (..._args)=>{},
    error: (..._args)=>{},
    fatal: (..._args)=>{}
};
const $80b3d2f58e77b583$var$setLogLevel$1 = function(level = "fatal") {
    let numericLevel = $80b3d2f58e77b583$var$LEVELS.fatal;
    if (typeof level === "string") {
        level = level.toLowerCase();
        if (level in $80b3d2f58e77b583$var$LEVELS) numericLevel = $80b3d2f58e77b583$var$LEVELS[level];
    } else if (typeof level === "number") numericLevel = level;
    $80b3d2f58e77b583$export$882b5998b3b9117c.trace = ()=>{};
    $80b3d2f58e77b583$export$882b5998b3b9117c.debug = ()=>{};
    $80b3d2f58e77b583$export$882b5998b3b9117c.info = ()=>{};
    $80b3d2f58e77b583$export$882b5998b3b9117c.warn = ()=>{};
    $80b3d2f58e77b583$export$882b5998b3b9117c.error = ()=>{};
    $80b3d2f58e77b583$export$882b5998b3b9117c.fatal = ()=>{};
    if (numericLevel <= $80b3d2f58e77b583$var$LEVELS.fatal) $80b3d2f58e77b583$export$882b5998b3b9117c.fatal = console.error ? console.error.bind(console, $80b3d2f58e77b583$var$format("FATAL"), "color: orange") : console.log.bind(console, "\x1B[35m", $80b3d2f58e77b583$var$format("FATAL"));
    if (numericLevel <= $80b3d2f58e77b583$var$LEVELS.error) $80b3d2f58e77b583$export$882b5998b3b9117c.error = console.error ? console.error.bind(console, $80b3d2f58e77b583$var$format("ERROR"), "color: orange") : console.log.bind(console, "\x1B[31m", $80b3d2f58e77b583$var$format("ERROR"));
    if (numericLevel <= $80b3d2f58e77b583$var$LEVELS.warn) $80b3d2f58e77b583$export$882b5998b3b9117c.warn = console.warn ? console.warn.bind(console, $80b3d2f58e77b583$var$format("WARN"), "color: orange") : console.log.bind(console, `\x1B[33m`, $80b3d2f58e77b583$var$format("WARN"));
    if (numericLevel <= $80b3d2f58e77b583$var$LEVELS.info) $80b3d2f58e77b583$export$882b5998b3b9117c.info = console.info ? console.info.bind(console, $80b3d2f58e77b583$var$format("INFO"), "color: lightblue") : console.log.bind(console, "\x1B[34m", $80b3d2f58e77b583$var$format("INFO"));
    if (numericLevel <= $80b3d2f58e77b583$var$LEVELS.debug) $80b3d2f58e77b583$export$882b5998b3b9117c.debug = console.debug ? console.debug.bind(console, $80b3d2f58e77b583$var$format("DEBUG"), "color: lightgreen") : console.log.bind(console, "\x1B[32m", $80b3d2f58e77b583$var$format("DEBUG"));
    if (numericLevel <= $80b3d2f58e77b583$var$LEVELS.trace) $80b3d2f58e77b583$export$882b5998b3b9117c.trace = console.debug ? console.debug.bind(console, $80b3d2f58e77b583$var$format("TRACE"), "color: lightgreen") : console.log.bind(console, "\x1B[32m", $80b3d2f58e77b583$var$format("TRACE"));
};
const $80b3d2f58e77b583$var$format = (level)=>{
    const time = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))().format("ss.SSS");
    return `%c${time} : ${level} : `;
};
const $80b3d2f58e77b583$export$b4171a6734a65d42 = /<br\s*\/?>/gi;
const $80b3d2f58e77b583$var$getRows = (s)=>{
    if (!s) return [
        ""
    ];
    const str2 = $80b3d2f58e77b583$var$breakToPlaceholder(s).replace(/\\n/g, "#br#");
    return str2.split("#br#");
};
const $80b3d2f58e77b583$var$setupDompurifyHooksIfNotSetup = (()=>{
    let setup = false;
    return ()=>{
        if (!setup) {
            $80b3d2f58e77b583$var$setupDompurifyHooks();
            setup = true;
        }
    };
})();
function $80b3d2f58e77b583$var$setupDompurifyHooks() {
    const TEMPORARY_ATTRIBUTE = "data-temp-href-target";
    (0, (/*@__PURE__*/$parcel$interopDefault($i8Fxz))).addHook("beforeSanitizeAttributes", (node)=>{
        if (node.tagName === "A" && node.hasAttribute("target")) node.setAttribute(TEMPORARY_ATTRIBUTE, node.getAttribute("target") || "");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($i8Fxz))).addHook("afterSanitizeAttributes", (node)=>{
        if (node.tagName === "A" && node.hasAttribute(TEMPORARY_ATTRIBUTE)) {
            node.setAttribute("target", node.getAttribute(TEMPORARY_ATTRIBUTE) || "");
            node.removeAttribute(TEMPORARY_ATTRIBUTE);
            if (node.getAttribute("target") === "_blank") node.setAttribute("rel", "noopener");
        }
    });
}
const $80b3d2f58e77b583$var$removeScript = (txt)=>{
    $80b3d2f58e77b583$var$setupDompurifyHooksIfNotSetup();
    const sanitizedText = (0, (/*@__PURE__*/$parcel$interopDefault($i8Fxz))).sanitize(txt);
    return sanitizedText;
};
const $80b3d2f58e77b583$var$sanitizeMore = (text, config2)=>{
    var _a;
    if (((_a = config2.flowchart) == null ? void 0 : _a.htmlLabels) !== false) {
        const level = config2.securityLevel;
        if (level === "antiscript" || level === "strict") text = $80b3d2f58e77b583$var$removeScript(text);
        else if (level !== "loose") {
            text = $80b3d2f58e77b583$var$breakToPlaceholder(text);
            text = text.replace(/</g, "&lt;").replace(/>/g, "&gt;");
            text = text.replace(/=/g, "&equals;");
            text = $80b3d2f58e77b583$var$placeholderToBreak(text);
        }
    }
    return text;
};
const $80b3d2f58e77b583$export$4368d992c4eafac0 = (text, config2)=>{
    if (!text) return text;
    if (config2.dompurifyConfig) text = (0, (/*@__PURE__*/$parcel$interopDefault($i8Fxz))).sanitize($80b3d2f58e77b583$var$sanitizeMore(text, config2), config2.dompurifyConfig).toString();
    else text = (0, (/*@__PURE__*/$parcel$interopDefault($i8Fxz))).sanitize($80b3d2f58e77b583$var$sanitizeMore(text, config2), {
        FORBID_TAGS: [
            "style"
        ]
    }).toString();
    return text;
};
const $80b3d2f58e77b583$var$sanitizeTextOrArray = (a, config2)=>{
    if (typeof a === "string") return $80b3d2f58e77b583$export$4368d992c4eafac0(a, config2);
    return a.flat().map((x)=>$80b3d2f58e77b583$export$4368d992c4eafac0(x, config2));
};
const $80b3d2f58e77b583$var$hasBreaks = (text)=>{
    return $80b3d2f58e77b583$export$b4171a6734a65d42.test(text);
};
const $80b3d2f58e77b583$var$splitBreaks = (text)=>{
    return text.split($80b3d2f58e77b583$export$b4171a6734a65d42);
};
const $80b3d2f58e77b583$var$placeholderToBreak = (s)=>{
    return s.replace(/#br#/g, "<br/>");
};
const $80b3d2f58e77b583$var$breakToPlaceholder = (s)=>{
    return s.replace($80b3d2f58e77b583$export$b4171a6734a65d42, "#br#");
};
const $80b3d2f58e77b583$var$getUrl = (useAbsolute)=>{
    let url = "";
    if (useAbsolute) {
        url = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search;
        url = url.replaceAll(/\(/g, "\\(");
        url = url.replaceAll(/\)/g, "\\)");
    }
    return url;
};
const $80b3d2f58e77b583$export$953cecd6e717a553 = (val)=>val === false || [
        "false",
        "null",
        "0"
    ].includes(String(val).trim().toLowerCase()) ? false : true;
const $80b3d2f58e77b583$var$getMax = function(...values) {
    const newValues = values.filter((value)=>{
        return !isNaN(value);
    });
    return Math.max(...newValues);
};
const $80b3d2f58e77b583$var$getMin = function(...values) {
    const newValues = values.filter((value)=>{
        return !isNaN(value);
    });
    return Math.min(...newValues);
};
const $80b3d2f58e77b583$export$d141bba7fdc215a3 = function(input) {
    const inputSets = input.split(/(,)/);
    const output = [];
    for(let i = 0; i < inputSets.length; i++){
        let thisSet = inputSets[i];
        if (thisSet === "," && i > 0 && i + 1 < inputSets.length) {
            const previousSet = inputSets[i - 1];
            const nextSet = inputSets[i + 1];
            if ($80b3d2f58e77b583$var$shouldCombineSets(previousSet, nextSet)) {
                thisSet = previousSet + "," + nextSet;
                i++;
                output.pop();
            }
        }
        output.push($80b3d2f58e77b583$var$processSet(thisSet));
    }
    return output.join("");
};
const $80b3d2f58e77b583$var$countOccurrence = (string, substring)=>{
    return Math.max(0, string.split(substring).length - 1);
};
const $80b3d2f58e77b583$var$shouldCombineSets = (previousSet, nextSet)=>{
    const prevCount = $80b3d2f58e77b583$var$countOccurrence(previousSet, "~");
    const nextCount = $80b3d2f58e77b583$var$countOccurrence(nextSet, "~");
    return prevCount === 1 && nextCount === 1;
};
const $80b3d2f58e77b583$var$processSet = (input)=>{
    const tildeCount = $80b3d2f58e77b583$var$countOccurrence(input, "~");
    let hasStartingTilde = false;
    if (tildeCount <= 1) return input;
    if (tildeCount % 2 !== 0 && input.startsWith("~")) {
        input = input.substring(1);
        hasStartingTilde = true;
    }
    const chars = [
        ...input
    ];
    let first = chars.indexOf("~");
    let last = chars.lastIndexOf("~");
    while(first !== -1 && last !== -1 && first !== last){
        chars[first] = "<";
        chars[last] = ">";
        first = chars.indexOf("~");
        last = chars.lastIndexOf("~");
    }
    if (hasStartingTilde) chars.unshift("~");
    return chars.join("");
};
const $80b3d2f58e77b583$var$isMathMLSupported = ()=>window.MathMLElement !== void 0;
const $80b3d2f58e77b583$var$katexRegex = /\$\$(.*)\$\$/g;
const $80b3d2f58e77b583$export$2329c99376c9d0a4 = (text)=>{
    var _a;
    return (((_a = text.match($80b3d2f58e77b583$var$katexRegex)) == null ? void 0 : _a.length) ?? 0) > 0;
};
const $80b3d2f58e77b583$export$7f8ddf7c7c20b3cd = async (text, config2)=>{
    text = await $80b3d2f58e77b583$export$43caf9889c228507(text, config2);
    const divElem = document.createElement("div");
    divElem.innerHTML = text;
    divElem.id = "katex-temp";
    divElem.style.visibility = "hidden";
    divElem.style.position = "absolute";
    divElem.style.top = "0";
    const body = document.querySelector("body");
    body == null || body.insertAdjacentElement("beforeend", divElem);
    const dim = {
        width: divElem.clientWidth,
        height: divElem.clientHeight
    };
    divElem.remove();
    return dim;
};

const $80b3d2f58e77b583$export$43caf9889c228507 = async (text, config2)=>{
    if (!$80b3d2f58e77b583$export$2329c99376c9d0a4(text)) return text;
    if (!$80b3d2f58e77b583$var$isMathMLSupported() && !config2.legacyMathML) return text.replace($80b3d2f58e77b583$var$katexRegex, "MathML is unsupported in this environment.");
    const { default: katex } = await (parcelRequire("24OkN"));
    return text.split($80b3d2f58e77b583$export$b4171a6734a65d42).map((line)=>$80b3d2f58e77b583$export$2329c99376c9d0a4(line) ? `
            <div style="display: flex; align-items: center; justify-content: center; white-space: nowrap;">
              ${line}
            </div>
          ` : `<div>${line}</div>`).join("").replace($80b3d2f58e77b583$var$katexRegex, (_, c)=>katex.renderToString(c, {
            throwOnError: true,
            displayMode: true,
            output: $80b3d2f58e77b583$var$isMathMLSupported() ? "mathml" : "htmlAndMathml"
        }).replace(/\n/g, " ").replace(/<annotation.*<\/annotation>/g, ""));
};
const $80b3d2f58e77b583$export$f1e1789686576879 = {
    getRows: $80b3d2f58e77b583$var$getRows,
    sanitizeText: $80b3d2f58e77b583$export$4368d992c4eafac0,
    sanitizeTextOrArray: $80b3d2f58e77b583$var$sanitizeTextOrArray,
    hasBreaks: $80b3d2f58e77b583$var$hasBreaks,
    splitBreaks: $80b3d2f58e77b583$var$splitBreaks,
    lineBreakRegex: $80b3d2f58e77b583$export$b4171a6734a65d42,
    removeScript: $80b3d2f58e77b583$var$removeScript,
    getUrl: $80b3d2f58e77b583$var$getUrl,
    evaluate: $80b3d2f58e77b583$export$953cecd6e717a553,
    getMax: $80b3d2f58e77b583$var$getMax,
    getMin: $80b3d2f58e77b583$var$getMin
};
const $80b3d2f58e77b583$var$mkBorder = (col, darkMode)=>darkMode ? (0, $7Mv8O.default)(col, {
        s: -40,
        l: 10
    }) : (0, $7Mv8O.default)(col, {
        s: -40,
        l: -10
    });
const $80b3d2f58e77b583$var$oldAttributeBackgroundColorOdd = "#ffffff";
const $80b3d2f58e77b583$var$oldAttributeBackgroundColorEven = "#f2f2f2";
let $80b3d2f58e77b583$var$Theme$4 = class Theme {
    constructor(){
        this.background = "#f4f4f4";
        this.primaryColor = "#fff4dd";
        this.noteBkgColor = "#fff5ad";
        this.noteTextColor = "#333";
        this.THEME_COLOR_LIMIT = 12;
        this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif';
        this.fontSize = "16px";
    }
    updateColors() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
        this.primaryTextColor = this.primaryTextColor || (this.darkMode ? "#eee" : "#333");
        this.secondaryColor = this.secondaryColor || (0, $7Mv8O.default)(this.primaryColor, {
            h: -120
        });
        this.tertiaryColor = this.tertiaryColor || (0, $7Mv8O.default)(this.primaryColor, {
            h: 180,
            l: 5
        });
        this.primaryBorderColor = this.primaryBorderColor || $80b3d2f58e77b583$var$mkBorder(this.primaryColor, this.darkMode);
        this.secondaryBorderColor = this.secondaryBorderColor || $80b3d2f58e77b583$var$mkBorder(this.secondaryColor, this.darkMode);
        this.tertiaryBorderColor = this.tertiaryBorderColor || $80b3d2f58e77b583$var$mkBorder(this.tertiaryColor, this.darkMode);
        this.noteBorderColor = this.noteBorderColor || $80b3d2f58e77b583$var$mkBorder(this.noteBkgColor, this.darkMode);
        this.noteBkgColor = this.noteBkgColor || "#fff5ad";
        this.noteTextColor = this.noteTextColor || "#333";
        this.secondaryTextColor = this.secondaryTextColor || (0, $1LW8F.default)(this.secondaryColor);
        this.tertiaryTextColor = this.tertiaryTextColor || (0, $1LW8F.default)(this.tertiaryColor);
        this.lineColor = this.lineColor || (0, $1LW8F.default)(this.background);
        this.arrowheadColor = this.arrowheadColor || (0, $1LW8F.default)(this.background);
        this.textColor = this.textColor || this.primaryTextColor;
        this.border2 = this.border2 || this.tertiaryBorderColor;
        this.nodeBkg = this.nodeBkg || this.primaryColor;
        this.mainBkg = this.mainBkg || this.primaryColor;
        this.nodeBorder = this.nodeBorder || this.primaryBorderColor;
        this.clusterBkg = this.clusterBkg || this.tertiaryColor;
        this.clusterBorder = this.clusterBorder || this.tertiaryBorderColor;
        this.defaultLinkColor = this.defaultLinkColor || this.lineColor;
        this.titleColor = this.titleColor || this.tertiaryTextColor;
        this.edgeLabelBackground = this.edgeLabelBackground || (this.darkMode ? (0, $c94qS.default)(this.secondaryColor, 30) : this.secondaryColor);
        this.nodeTextColor = this.nodeTextColor || this.primaryTextColor;
        this.actorBorder = this.actorBorder || this.primaryBorderColor;
        this.actorBkg = this.actorBkg || this.mainBkg;
        this.actorTextColor = this.actorTextColor || this.primaryTextColor;
        this.actorLineColor = this.actorLineColor || "grey";
        this.labelBoxBkgColor = this.labelBoxBkgColor || this.actorBkg;
        this.signalColor = this.signalColor || this.textColor;
        this.signalTextColor = this.signalTextColor || this.textColor;
        this.labelBoxBorderColor = this.labelBoxBorderColor || this.actorBorder;
        this.labelTextColor = this.labelTextColor || this.actorTextColor;
        this.loopTextColor = this.loopTextColor || this.actorTextColor;
        this.activationBorderColor = this.activationBorderColor || (0, $c94qS.default)(this.secondaryColor, 10);
        this.activationBkgColor = this.activationBkgColor || this.secondaryColor;
        this.sequenceNumberColor = this.sequenceNumberColor || (0, $1LW8F.default)(this.lineColor);
        this.sectionBkgColor = this.sectionBkgColor || this.tertiaryColor;
        this.altSectionBkgColor = this.altSectionBkgColor || "white";
        this.sectionBkgColor = this.sectionBkgColor || this.secondaryColor;
        this.sectionBkgColor2 = this.sectionBkgColor2 || this.primaryColor;
        this.excludeBkgColor = this.excludeBkgColor || "#eeeeee";
        this.taskBorderColor = this.taskBorderColor || this.primaryBorderColor;
        this.taskBkgColor = this.taskBkgColor || this.primaryColor;
        this.activeTaskBorderColor = this.activeTaskBorderColor || this.primaryColor;
        this.activeTaskBkgColor = this.activeTaskBkgColor || (0, $1Ez1E.default)(this.primaryColor, 23);
        this.gridColor = this.gridColor || "lightgrey";
        this.doneTaskBkgColor = this.doneTaskBkgColor || "lightgrey";
        this.doneTaskBorderColor = this.doneTaskBorderColor || "grey";
        this.critBorderColor = this.critBorderColor || "#ff8888";
        this.critBkgColor = this.critBkgColor || "red";
        this.todayLineColor = this.todayLineColor || "red";
        this.taskTextColor = this.taskTextColor || this.textColor;
        this.taskTextOutsideColor = this.taskTextOutsideColor || this.textColor;
        this.taskTextLightColor = this.taskTextLightColor || this.textColor;
        this.taskTextColor = this.taskTextColor || this.primaryTextColor;
        this.taskTextDarkColor = this.taskTextDarkColor || this.textColor;
        this.taskTextClickableColor = this.taskTextClickableColor || "#003163";
        this.personBorder = this.personBorder || this.primaryBorderColor;
        this.personBkg = this.personBkg || this.mainBkg;
        this.transitionColor = this.transitionColor || this.lineColor;
        this.transitionLabelColor = this.transitionLabelColor || this.textColor;
        this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor;
        this.stateBkg = this.stateBkg || this.mainBkg;
        this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg;
        this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor;
        this.altBackground = this.altBackground || this.tertiaryColor;
        this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg;
        this.compositeBorder = this.compositeBorder || this.nodeBorder;
        this.innerEndBackground = this.nodeBorder;
        this.errorBkgColor = this.errorBkgColor || this.tertiaryColor;
        this.errorTextColor = this.errorTextColor || this.tertiaryTextColor;
        this.transitionColor = this.transitionColor || this.lineColor;
        this.specialStateColor = this.lineColor;
        this.cScale0 = this.cScale0 || this.primaryColor;
        this.cScale1 = this.cScale1 || this.secondaryColor;
        this.cScale2 = this.cScale2 || this.tertiaryColor;
        this.cScale3 = this.cScale3 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 30
        });
        this.cScale4 = this.cScale4 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 60
        });
        this.cScale5 = this.cScale5 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 90
        });
        this.cScale6 = this.cScale6 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 120
        });
        this.cScale7 = this.cScale7 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 150
        });
        this.cScale8 = this.cScale8 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 210,
            l: 150
        });
        this.cScale9 = this.cScale9 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 270
        });
        this.cScale10 = this.cScale10 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 300
        });
        this.cScale11 = this.cScale11 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 330
        });
        if (this.darkMode) for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScale" + i] = (0, $c94qS.default)(this["cScale" + i], 75);
        else for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScale" + i] = (0, $c94qS.default)(this["cScale" + i], 25);
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleInv" + i] = this["cScaleInv" + i] || (0, $1LW8F.default)(this["cScale" + i]);
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)if (this.darkMode) this["cScalePeer" + i] = this["cScalePeer" + i] || (0, $1Ez1E.default)(this["cScale" + i], 10);
        else this["cScalePeer" + i] = this["cScalePeer" + i] || (0, $c94qS.default)(this["cScale" + i], 10);
        this.scaleLabelColor = this.scaleLabelColor || this.labelTextColor;
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleLabel" + i] = this["cScaleLabel" + i] || this.scaleLabelColor;
        const multiplier = this.darkMode ? -4 : -1;
        for(let i = 0; i < 5; i++){
            this["surface" + i] = this["surface" + i] || (0, $7Mv8O.default)(this.mainBkg, {
                h: 180,
                s: -15,
                l: multiplier * (5 + i * 3)
            });
            this["surfacePeer" + i] = this["surfacePeer" + i] || (0, $7Mv8O.default)(this.mainBkg, {
                h: 180,
                s: -15,
                l: multiplier * (8 + i * 3)
            });
        }
        this.classText = this.classText || this.textColor;
        this.fillType0 = this.fillType0 || this.primaryColor;
        this.fillType1 = this.fillType1 || this.secondaryColor;
        this.fillType2 = this.fillType2 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 64
        });
        this.fillType3 = this.fillType3 || (0, $7Mv8O.default)(this.secondaryColor, {
            h: 64
        });
        this.fillType4 = this.fillType4 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -64
        });
        this.fillType5 = this.fillType5 || (0, $7Mv8O.default)(this.secondaryColor, {
            h: -64
        });
        this.fillType6 = this.fillType6 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 128
        });
        this.fillType7 = this.fillType7 || (0, $7Mv8O.default)(this.secondaryColor, {
            h: 128
        });
        this.pie1 = this.pie1 || this.primaryColor;
        this.pie2 = this.pie2 || this.secondaryColor;
        this.pie3 = this.pie3 || this.tertiaryColor;
        this.pie4 = this.pie4 || (0, $7Mv8O.default)(this.primaryColor, {
            l: -10
        });
        this.pie5 = this.pie5 || (0, $7Mv8O.default)(this.secondaryColor, {
            l: -10
        });
        this.pie6 = this.pie6 || (0, $7Mv8O.default)(this.tertiaryColor, {
            l: -10
        });
        this.pie7 = this.pie7 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 60,
            l: -10
        });
        this.pie8 = this.pie8 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -60,
            l: -10
        });
        this.pie9 = this.pie9 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 120,
            l: 0
        });
        this.pie10 = this.pie10 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 60,
            l: -20
        });
        this.pie11 = this.pie11 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -60,
            l: -20
        });
        this.pie12 = this.pie12 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 120,
            l: -10
        });
        this.pieTitleTextSize = this.pieTitleTextSize || "25px";
        this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor;
        this.pieSectionTextSize = this.pieSectionTextSize || "17px";
        this.pieSectionTextColor = this.pieSectionTextColor || this.textColor;
        this.pieLegendTextSize = this.pieLegendTextSize || "17px";
        this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor;
        this.pieStrokeColor = this.pieStrokeColor || "black";
        this.pieStrokeWidth = this.pieStrokeWidth || "2px";
        this.pieOuterStrokeWidth = this.pieOuterStrokeWidth || "2px";
        this.pieOuterStrokeColor = this.pieOuterStrokeColor || "black";
        this.pieOpacity = this.pieOpacity || "0.7";
        this.quadrant1Fill = this.quadrant1Fill || this.primaryColor;
        this.quadrant2Fill = this.quadrant2Fill || (0, $7Mv8O.default)(this.primaryColor, {
            r: 5,
            g: 5,
            b: 5
        });
        this.quadrant3Fill = this.quadrant3Fill || (0, $7Mv8O.default)(this.primaryColor, {
            r: 10,
            g: 10,
            b: 10
        });
        this.quadrant4Fill = this.quadrant4Fill || (0, $7Mv8O.default)(this.primaryColor, {
            r: 15,
            g: 15,
            b: 15
        });
        this.quadrant1TextFill = this.quadrant1TextFill || this.primaryTextColor;
        this.quadrant2TextFill = this.quadrant2TextFill || (0, $7Mv8O.default)(this.primaryTextColor, {
            r: -5,
            g: -5,
            b: -5
        });
        this.quadrant3TextFill = this.quadrant3TextFill || (0, $7Mv8O.default)(this.primaryTextColor, {
            r: -10,
            g: -10,
            b: -10
        });
        this.quadrant4TextFill = this.quadrant4TextFill || (0, $7Mv8O.default)(this.primaryTextColor, {
            r: -15,
            g: -15,
            b: -15
        });
        this.quadrantPointFill = this.quadrantPointFill || (0, $75Ue8.default)(this.quadrant1Fill) ? (0, $1Ez1E.default)(this.quadrant1Fill) : (0, $c94qS.default)(this.quadrant1Fill);
        this.quadrantPointTextFill = this.quadrantPointTextFill || this.primaryTextColor;
        this.quadrantXAxisTextFill = this.quadrantXAxisTextFill || this.primaryTextColor;
        this.quadrantYAxisTextFill = this.quadrantYAxisTextFill || this.primaryTextColor;
        this.quadrantInternalBorderStrokeFill = this.quadrantInternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantExternalBorderStrokeFill = this.quadrantExternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantTitleFill = this.quadrantTitleFill || this.primaryTextColor;
        this.xyChart = {
            backgroundColor: ((_a = this.xyChart) == null ? void 0 : _a.backgroundColor) || this.background,
            titleColor: ((_b = this.xyChart) == null ? void 0 : _b.titleColor) || this.primaryTextColor,
            xAxisTitleColor: ((_c = this.xyChart) == null ? void 0 : _c.xAxisTitleColor) || this.primaryTextColor,
            xAxisLabelColor: ((_d = this.xyChart) == null ? void 0 : _d.xAxisLabelColor) || this.primaryTextColor,
            xAxisTickColor: ((_e = this.xyChart) == null ? void 0 : _e.xAxisTickColor) || this.primaryTextColor,
            xAxisLineColor: ((_f = this.xyChart) == null ? void 0 : _f.xAxisLineColor) || this.primaryTextColor,
            yAxisTitleColor: ((_g = this.xyChart) == null ? void 0 : _g.yAxisTitleColor) || this.primaryTextColor,
            yAxisLabelColor: ((_h = this.xyChart) == null ? void 0 : _h.yAxisLabelColor) || this.primaryTextColor,
            yAxisTickColor: ((_i = this.xyChart) == null ? void 0 : _i.yAxisTickColor) || this.primaryTextColor,
            yAxisLineColor: ((_j = this.xyChart) == null ? void 0 : _j.yAxisLineColor) || this.primaryTextColor,
            plotColorPalette: ((_k = this.xyChart) == null ? void 0 : _k.plotColorPalette) || "#FFF4DD,#FFD8B1,#FFA07A,#ECEFF1,#D6DBDF,#C3E0A8,#FFB6A4,#FFD74D,#738FA7,#FFFFF0"
        };
        this.requirementBackground = this.requirementBackground || this.primaryColor;
        this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor;
        this.requirementBorderSize = this.requirementBorderSize || "1";
        this.requirementTextColor = this.requirementTextColor || this.primaryTextColor;
        this.relationColor = this.relationColor || this.lineColor;
        this.relationLabelBackground = this.relationLabelBackground || (this.darkMode ? (0, $c94qS.default)(this.secondaryColor, 30) : this.secondaryColor);
        this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
        this.git0 = this.git0 || this.primaryColor;
        this.git1 = this.git1 || this.secondaryColor;
        this.git2 = this.git2 || this.tertiaryColor;
        this.git3 = this.git3 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -30
        });
        this.git4 = this.git4 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -60
        });
        this.git5 = this.git5 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -90
        });
        this.git6 = this.git6 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 60
        });
        this.git7 = this.git7 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 120
        });
        if (this.darkMode) {
            this.git0 = (0, $1Ez1E.default)(this.git0, 25);
            this.git1 = (0, $1Ez1E.default)(this.git1, 25);
            this.git2 = (0, $1Ez1E.default)(this.git2, 25);
            this.git3 = (0, $1Ez1E.default)(this.git3, 25);
            this.git4 = (0, $1Ez1E.default)(this.git4, 25);
            this.git5 = (0, $1Ez1E.default)(this.git5, 25);
            this.git6 = (0, $1Ez1E.default)(this.git6, 25);
            this.git7 = (0, $1Ez1E.default)(this.git7, 25);
        } else {
            this.git0 = (0, $c94qS.default)(this.git0, 25);
            this.git1 = (0, $c94qS.default)(this.git1, 25);
            this.git2 = (0, $c94qS.default)(this.git2, 25);
            this.git3 = (0, $c94qS.default)(this.git3, 25);
            this.git4 = (0, $c94qS.default)(this.git4, 25);
            this.git5 = (0, $c94qS.default)(this.git5, 25);
            this.git6 = (0, $c94qS.default)(this.git6, 25);
            this.git7 = (0, $c94qS.default)(this.git7, 25);
        }
        this.gitInv0 = this.gitInv0 || (0, $1LW8F.default)(this.git0);
        this.gitInv1 = this.gitInv1 || (0, $1LW8F.default)(this.git1);
        this.gitInv2 = this.gitInv2 || (0, $1LW8F.default)(this.git2);
        this.gitInv3 = this.gitInv3 || (0, $1LW8F.default)(this.git3);
        this.gitInv4 = this.gitInv4 || (0, $1LW8F.default)(this.git4);
        this.gitInv5 = this.gitInv5 || (0, $1LW8F.default)(this.git5);
        this.gitInv6 = this.gitInv6 || (0, $1LW8F.default)(this.git6);
        this.gitInv7 = this.gitInv7 || (0, $1LW8F.default)(this.git7);
        this.branchLabelColor = this.branchLabelColor || (this.darkMode ? "black" : this.labelTextColor);
        this.gitBranchLabel0 = this.gitBranchLabel0 || this.branchLabelColor;
        this.gitBranchLabel1 = this.gitBranchLabel1 || this.branchLabelColor;
        this.gitBranchLabel2 = this.gitBranchLabel2 || this.branchLabelColor;
        this.gitBranchLabel3 = this.gitBranchLabel3 || this.branchLabelColor;
        this.gitBranchLabel4 = this.gitBranchLabel4 || this.branchLabelColor;
        this.gitBranchLabel5 = this.gitBranchLabel5 || this.branchLabelColor;
        this.gitBranchLabel6 = this.gitBranchLabel6 || this.branchLabelColor;
        this.gitBranchLabel7 = this.gitBranchLabel7 || this.branchLabelColor;
        this.tagLabelColor = this.tagLabelColor || this.primaryTextColor;
        this.tagLabelBackground = this.tagLabelBackground || this.primaryColor;
        this.tagLabelBorder = this.tagBorder || this.primaryBorderColor;
        this.tagLabelFontSize = this.tagLabelFontSize || "10px";
        this.commitLabelColor = this.commitLabelColor || this.secondaryTextColor;
        this.commitLabelBackground = this.commitLabelBackground || this.secondaryColor;
        this.commitLabelFontSize = this.commitLabelFontSize || "10px";
        this.attributeBackgroundColorOdd = this.attributeBackgroundColorOdd || $80b3d2f58e77b583$var$oldAttributeBackgroundColorOdd;
        this.attributeBackgroundColorEven = this.attributeBackgroundColorEven || $80b3d2f58e77b583$var$oldAttributeBackgroundColorEven;
    }
    calculate(overrides) {
        if (typeof overrides !== "object") {
            this.updateColors();
            return;
        }
        const keys = Object.keys(overrides);
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
        this.updateColors();
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
    }
};
const $80b3d2f58e77b583$var$getThemeVariables$4 = (userOverrides)=>{
    const theme2 = new $80b3d2f58e77b583$var$Theme$4();
    theme2.calculate(userOverrides);
    return theme2;
};
let $80b3d2f58e77b583$var$Theme$3 = class Theme2 {
    constructor(){
        this.background = "#333";
        this.primaryColor = "#1f2020";
        this.secondaryColor = (0, $1Ez1E.default)(this.primaryColor, 16);
        this.tertiaryColor = (0, $7Mv8O.default)(this.primaryColor, {
            h: -160
        });
        this.primaryBorderColor = (0, $1LW8F.default)(this.background);
        this.secondaryBorderColor = $80b3d2f58e77b583$var$mkBorder(this.secondaryColor, this.darkMode);
        this.tertiaryBorderColor = $80b3d2f58e77b583$var$mkBorder(this.tertiaryColor, this.darkMode);
        this.primaryTextColor = (0, $1LW8F.default)(this.primaryColor);
        this.secondaryTextColor = (0, $1LW8F.default)(this.secondaryColor);
        this.tertiaryTextColor = (0, $1LW8F.default)(this.tertiaryColor);
        this.lineColor = (0, $1LW8F.default)(this.background);
        this.textColor = (0, $1LW8F.default)(this.background);
        this.mainBkg = "#1f2020";
        this.secondBkg = "calculated";
        this.mainContrastColor = "lightgrey";
        this.darkTextColor = (0, $1Ez1E.default)((0, $1LW8F.default)("#323D47"), 10);
        this.lineColor = "calculated";
        this.border1 = "#81B1DB";
        this.border2 = (0, $b1Vti.default)(255, 255, 255, 0.25);
        this.arrowheadColor = "calculated";
        this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif';
        this.fontSize = "16px";
        this.labelBackground = "#181818";
        this.textColor = "#ccc";
        this.THEME_COLOR_LIMIT = 12;
        this.nodeBkg = "calculated";
        this.nodeBorder = "calculated";
        this.clusterBkg = "calculated";
        this.clusterBorder = "calculated";
        this.defaultLinkColor = "calculated";
        this.titleColor = "#F9FFFE";
        this.edgeLabelBackground = "calculated";
        this.actorBorder = "calculated";
        this.actorBkg = "calculated";
        this.actorTextColor = "calculated";
        this.actorLineColor = "calculated";
        this.signalColor = "calculated";
        this.signalTextColor = "calculated";
        this.labelBoxBkgColor = "calculated";
        this.labelBoxBorderColor = "calculated";
        this.labelTextColor = "calculated";
        this.loopTextColor = "calculated";
        this.noteBorderColor = "calculated";
        this.noteBkgColor = "#fff5ad";
        this.noteTextColor = "calculated";
        this.activationBorderColor = "calculated";
        this.activationBkgColor = "calculated";
        this.sequenceNumberColor = "black";
        this.sectionBkgColor = (0, $c94qS.default)("#EAE8D9", 30);
        this.altSectionBkgColor = "calculated";
        this.sectionBkgColor2 = "#EAE8D9";
        this.excludeBkgColor = (0, $c94qS.default)(this.sectionBkgColor, 10);
        this.taskBorderColor = (0, $b1Vti.default)(255, 255, 255, 70);
        this.taskBkgColor = "calculated";
        this.taskTextColor = "calculated";
        this.taskTextLightColor = "calculated";
        this.taskTextOutsideColor = "calculated";
        this.taskTextClickableColor = "#003163";
        this.activeTaskBorderColor = (0, $b1Vti.default)(255, 255, 255, 50);
        this.activeTaskBkgColor = "#81B1DB";
        this.gridColor = "calculated";
        this.doneTaskBkgColor = "calculated";
        this.doneTaskBorderColor = "grey";
        this.critBorderColor = "#E83737";
        this.critBkgColor = "#E83737";
        this.taskTextDarkColor = "calculated";
        this.todayLineColor = "#DB5757";
        this.personBorder = this.primaryBorderColor;
        this.personBkg = this.mainBkg;
        this.labelColor = "calculated";
        this.errorBkgColor = "#a44141";
        this.errorTextColor = "#ddd";
    }
    updateColors() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
        this.secondBkg = (0, $1Ez1E.default)(this.mainBkg, 16);
        this.lineColor = this.mainContrastColor;
        this.arrowheadColor = this.mainContrastColor;
        this.nodeBkg = this.mainBkg;
        this.nodeBorder = this.border1;
        this.clusterBkg = this.secondBkg;
        this.clusterBorder = this.border2;
        this.defaultLinkColor = this.lineColor;
        this.edgeLabelBackground = (0, $1Ez1E.default)(this.labelBackground, 25);
        this.actorBorder = this.border1;
        this.actorBkg = this.mainBkg;
        this.actorTextColor = this.mainContrastColor;
        this.actorLineColor = this.mainContrastColor;
        this.signalColor = this.mainContrastColor;
        this.signalTextColor = this.mainContrastColor;
        this.labelBoxBkgColor = this.actorBkg;
        this.labelBoxBorderColor = this.actorBorder;
        this.labelTextColor = this.mainContrastColor;
        this.loopTextColor = this.mainContrastColor;
        this.noteBorderColor = this.secondaryBorderColor;
        this.noteBkgColor = this.secondBkg;
        this.noteTextColor = this.secondaryTextColor;
        this.activationBorderColor = this.border1;
        this.activationBkgColor = this.secondBkg;
        this.altSectionBkgColor = this.background;
        this.taskBkgColor = (0, $1Ez1E.default)(this.mainBkg, 23);
        this.taskTextColor = this.darkTextColor;
        this.taskTextLightColor = this.mainContrastColor;
        this.taskTextOutsideColor = this.taskTextLightColor;
        this.gridColor = this.mainContrastColor;
        this.doneTaskBkgColor = this.mainContrastColor;
        this.taskTextDarkColor = this.darkTextColor;
        this.transitionColor = this.transitionColor || this.lineColor;
        this.transitionLabelColor = this.transitionLabelColor || this.textColor;
        this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor;
        this.stateBkg = this.stateBkg || this.mainBkg;
        this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg;
        this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor;
        this.altBackground = this.altBackground || "#555";
        this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg;
        this.compositeBorder = this.compositeBorder || this.nodeBorder;
        this.innerEndBackground = this.primaryBorderColor;
        this.specialStateColor = "#f4f4f4";
        this.errorBkgColor = this.errorBkgColor || this.tertiaryColor;
        this.errorTextColor = this.errorTextColor || this.tertiaryTextColor;
        this.fillType0 = this.primaryColor;
        this.fillType1 = this.secondaryColor;
        this.fillType2 = (0, $7Mv8O.default)(this.primaryColor, {
            h: 64
        });
        this.fillType3 = (0, $7Mv8O.default)(this.secondaryColor, {
            h: 64
        });
        this.fillType4 = (0, $7Mv8O.default)(this.primaryColor, {
            h: -64
        });
        this.fillType5 = (0, $7Mv8O.default)(this.secondaryColor, {
            h: -64
        });
        this.fillType6 = (0, $7Mv8O.default)(this.primaryColor, {
            h: 128
        });
        this.fillType7 = (0, $7Mv8O.default)(this.secondaryColor, {
            h: 128
        });
        this.cScale1 = this.cScale1 || "#0b0000";
        this.cScale2 = this.cScale2 || "#4d1037";
        this.cScale3 = this.cScale3 || "#3f5258";
        this.cScale4 = this.cScale4 || "#4f2f1b";
        this.cScale5 = this.cScale5 || "#6e0a0a";
        this.cScale6 = this.cScale6 || "#3b0048";
        this.cScale7 = this.cScale7 || "#995a01";
        this.cScale8 = this.cScale8 || "#154706";
        this.cScale9 = this.cScale9 || "#161722";
        this.cScale10 = this.cScale10 || "#00296f";
        this.cScale11 = this.cScale11 || "#01629c";
        this.cScale12 = this.cScale12 || "#010029";
        this.cScale0 = this.cScale0 || this.primaryColor;
        this.cScale1 = this.cScale1 || this.secondaryColor;
        this.cScale2 = this.cScale2 || this.tertiaryColor;
        this.cScale3 = this.cScale3 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 30
        });
        this.cScale4 = this.cScale4 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 60
        });
        this.cScale5 = this.cScale5 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 90
        });
        this.cScale6 = this.cScale6 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 120
        });
        this.cScale7 = this.cScale7 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 150
        });
        this.cScale8 = this.cScale8 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 210
        });
        this.cScale9 = this.cScale9 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 270
        });
        this.cScale10 = this.cScale10 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 300
        });
        this.cScale11 = this.cScale11 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 330
        });
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleInv" + i] = this["cScaleInv" + i] || (0, $1LW8F.default)(this["cScale" + i]);
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScalePeer" + i] = this["cScalePeer" + i] || (0, $1Ez1E.default)(this["cScale" + i], 10);
        for(let i = 0; i < 5; i++){
            this["surface" + i] = this["surface" + i] || (0, $7Mv8O.default)(this.mainBkg, {
                h: 30,
                s: -30,
                l: -(-10 + i * 4)
            });
            this["surfacePeer" + i] = this["surfacePeer" + i] || (0, $7Mv8O.default)(this.mainBkg, {
                h: 30,
                s: -30,
                l: -(-7 + i * 4)
            });
        }
        this.scaleLabelColor = this.scaleLabelColor || (this.darkMode ? "black" : this.labelTextColor);
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleLabel" + i] = this["cScaleLabel" + i] || this.scaleLabelColor;
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["pie" + i] = this["cScale" + i];
        this.pieTitleTextSize = this.pieTitleTextSize || "25px";
        this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor;
        this.pieSectionTextSize = this.pieSectionTextSize || "17px";
        this.pieSectionTextColor = this.pieSectionTextColor || this.textColor;
        this.pieLegendTextSize = this.pieLegendTextSize || "17px";
        this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor;
        this.pieStrokeColor = this.pieStrokeColor || "black";
        this.pieStrokeWidth = this.pieStrokeWidth || "2px";
        this.pieOuterStrokeWidth = this.pieOuterStrokeWidth || "2px";
        this.pieOuterStrokeColor = this.pieOuterStrokeColor || "black";
        this.pieOpacity = this.pieOpacity || "0.7";
        this.quadrant1Fill = this.quadrant1Fill || this.primaryColor;
        this.quadrant2Fill = this.quadrant2Fill || (0, $7Mv8O.default)(this.primaryColor, {
            r: 5,
            g: 5,
            b: 5
        });
        this.quadrant3Fill = this.quadrant3Fill || (0, $7Mv8O.default)(this.primaryColor, {
            r: 10,
            g: 10,
            b: 10
        });
        this.quadrant4Fill = this.quadrant4Fill || (0, $7Mv8O.default)(this.primaryColor, {
            r: 15,
            g: 15,
            b: 15
        });
        this.quadrant1TextFill = this.quadrant1TextFill || this.primaryTextColor;
        this.quadrant2TextFill = this.quadrant2TextFill || (0, $7Mv8O.default)(this.primaryTextColor, {
            r: -5,
            g: -5,
            b: -5
        });
        this.quadrant3TextFill = this.quadrant3TextFill || (0, $7Mv8O.default)(this.primaryTextColor, {
            r: -10,
            g: -10,
            b: -10
        });
        this.quadrant4TextFill = this.quadrant4TextFill || (0, $7Mv8O.default)(this.primaryTextColor, {
            r: -15,
            g: -15,
            b: -15
        });
        this.quadrantPointFill = this.quadrantPointFill || (0, $75Ue8.default)(this.quadrant1Fill) ? (0, $1Ez1E.default)(this.quadrant1Fill) : (0, $c94qS.default)(this.quadrant1Fill);
        this.quadrantPointTextFill = this.quadrantPointTextFill || this.primaryTextColor;
        this.quadrantXAxisTextFill = this.quadrantXAxisTextFill || this.primaryTextColor;
        this.quadrantYAxisTextFill = this.quadrantYAxisTextFill || this.primaryTextColor;
        this.quadrantInternalBorderStrokeFill = this.quadrantInternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantExternalBorderStrokeFill = this.quadrantExternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantTitleFill = this.quadrantTitleFill || this.primaryTextColor;
        this.xyChart = {
            backgroundColor: ((_a = this.xyChart) == null ? void 0 : _a.backgroundColor) || this.background,
            titleColor: ((_b = this.xyChart) == null ? void 0 : _b.titleColor) || this.primaryTextColor,
            xAxisTitleColor: ((_c = this.xyChart) == null ? void 0 : _c.xAxisTitleColor) || this.primaryTextColor,
            xAxisLabelColor: ((_d = this.xyChart) == null ? void 0 : _d.xAxisLabelColor) || this.primaryTextColor,
            xAxisTickColor: ((_e = this.xyChart) == null ? void 0 : _e.xAxisTickColor) || this.primaryTextColor,
            xAxisLineColor: ((_f = this.xyChart) == null ? void 0 : _f.xAxisLineColor) || this.primaryTextColor,
            yAxisTitleColor: ((_g = this.xyChart) == null ? void 0 : _g.yAxisTitleColor) || this.primaryTextColor,
            yAxisLabelColor: ((_h = this.xyChart) == null ? void 0 : _h.yAxisLabelColor) || this.primaryTextColor,
            yAxisTickColor: ((_i = this.xyChart) == null ? void 0 : _i.yAxisTickColor) || this.primaryTextColor,
            yAxisLineColor: ((_j = this.xyChart) == null ? void 0 : _j.yAxisLineColor) || this.primaryTextColor,
            plotColorPalette: ((_k = this.xyChart) == null ? void 0 : _k.plotColorPalette) || "#3498db,#2ecc71,#e74c3c,#f1c40f,#bdc3c7,#ffffff,#34495e,#9b59b6,#1abc9c,#e67e22"
        };
        this.classText = this.primaryTextColor;
        this.requirementBackground = this.requirementBackground || this.primaryColor;
        this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor;
        this.requirementBorderSize = this.requirementBorderSize || "1";
        this.requirementTextColor = this.requirementTextColor || this.primaryTextColor;
        this.relationColor = this.relationColor || this.lineColor;
        this.relationLabelBackground = this.relationLabelBackground || (this.darkMode ? (0, $c94qS.default)(this.secondaryColor, 30) : this.secondaryColor);
        this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
        this.git0 = (0, $1Ez1E.default)(this.secondaryColor, 20);
        this.git1 = (0, $1Ez1E.default)(this.pie2 || this.secondaryColor, 20);
        this.git2 = (0, $1Ez1E.default)(this.pie3 || this.tertiaryColor, 20);
        this.git3 = (0, $1Ez1E.default)(this.pie4 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -30
        }), 20);
        this.git4 = (0, $1Ez1E.default)(this.pie5 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -60
        }), 20);
        this.git5 = (0, $1Ez1E.default)(this.pie6 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -90
        }), 10);
        this.git6 = (0, $1Ez1E.default)(this.pie7 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 60
        }), 10);
        this.git7 = (0, $1Ez1E.default)(this.pie8 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 120
        }), 20);
        this.gitInv0 = this.gitInv0 || (0, $1LW8F.default)(this.git0);
        this.gitInv1 = this.gitInv1 || (0, $1LW8F.default)(this.git1);
        this.gitInv2 = this.gitInv2 || (0, $1LW8F.default)(this.git2);
        this.gitInv3 = this.gitInv3 || (0, $1LW8F.default)(this.git3);
        this.gitInv4 = this.gitInv4 || (0, $1LW8F.default)(this.git4);
        this.gitInv5 = this.gitInv5 || (0, $1LW8F.default)(this.git5);
        this.gitInv6 = this.gitInv6 || (0, $1LW8F.default)(this.git6);
        this.gitInv7 = this.gitInv7 || (0, $1LW8F.default)(this.git7);
        this.gitBranchLabel0 = this.gitBranchLabel0 || (0, $1LW8F.default)(this.labelTextColor);
        this.gitBranchLabel1 = this.gitBranchLabel1 || this.labelTextColor;
        this.gitBranchLabel2 = this.gitBranchLabel2 || this.labelTextColor;
        this.gitBranchLabel3 = this.gitBranchLabel3 || (0, $1LW8F.default)(this.labelTextColor);
        this.gitBranchLabel4 = this.gitBranchLabel4 || this.labelTextColor;
        this.gitBranchLabel5 = this.gitBranchLabel5 || this.labelTextColor;
        this.gitBranchLabel6 = this.gitBranchLabel6 || this.labelTextColor;
        this.gitBranchLabel7 = this.gitBranchLabel7 || this.labelTextColor;
        this.tagLabelColor = this.tagLabelColor || this.primaryTextColor;
        this.tagLabelBackground = this.tagLabelBackground || this.primaryColor;
        this.tagLabelBorder = this.tagBorder || this.primaryBorderColor;
        this.tagLabelFontSize = this.tagLabelFontSize || "10px";
        this.commitLabelColor = this.commitLabelColor || this.secondaryTextColor;
        this.commitLabelBackground = this.commitLabelBackground || this.secondaryColor;
        this.commitLabelFontSize = this.commitLabelFontSize || "10px";
        this.attributeBackgroundColorOdd = this.attributeBackgroundColorOdd || (0, $1Ez1E.default)(this.background, 12);
        this.attributeBackgroundColorEven = this.attributeBackgroundColorEven || (0, $1Ez1E.default)(this.background, 2);
    }
    calculate(overrides) {
        if (typeof overrides !== "object") {
            this.updateColors();
            return;
        }
        const keys = Object.keys(overrides);
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
        this.updateColors();
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
    }
};
const $80b3d2f58e77b583$var$getThemeVariables$3 = (userOverrides)=>{
    const theme2 = new $80b3d2f58e77b583$var$Theme$3();
    theme2.calculate(userOverrides);
    return theme2;
};
let $80b3d2f58e77b583$var$Theme$2 = class Theme3 {
    constructor(){
        this.background = "#f4f4f4";
        this.primaryColor = "#ECECFF";
        this.secondaryColor = (0, $7Mv8O.default)(this.primaryColor, {
            h: 120
        });
        this.secondaryColor = "#ffffde";
        this.tertiaryColor = (0, $7Mv8O.default)(this.primaryColor, {
            h: -160
        });
        this.primaryBorderColor = $80b3d2f58e77b583$var$mkBorder(this.primaryColor, this.darkMode);
        this.secondaryBorderColor = $80b3d2f58e77b583$var$mkBorder(this.secondaryColor, this.darkMode);
        this.tertiaryBorderColor = $80b3d2f58e77b583$var$mkBorder(this.tertiaryColor, this.darkMode);
        this.primaryTextColor = (0, $1LW8F.default)(this.primaryColor);
        this.secondaryTextColor = (0, $1LW8F.default)(this.secondaryColor);
        this.tertiaryTextColor = (0, $1LW8F.default)(this.tertiaryColor);
        this.lineColor = (0, $1LW8F.default)(this.background);
        this.textColor = (0, $1LW8F.default)(this.background);
        this.background = "white";
        this.mainBkg = "#ECECFF";
        this.secondBkg = "#ffffde";
        this.lineColor = "#333333";
        this.border1 = "#9370DB";
        this.border2 = "#aaaa33";
        this.arrowheadColor = "#333333";
        this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif';
        this.fontSize = "16px";
        this.labelBackground = "#e8e8e8";
        this.textColor = "#333";
        this.THEME_COLOR_LIMIT = 12;
        this.nodeBkg = "calculated";
        this.nodeBorder = "calculated";
        this.clusterBkg = "calculated";
        this.clusterBorder = "calculated";
        this.defaultLinkColor = "calculated";
        this.titleColor = "calculated";
        this.edgeLabelBackground = "calculated";
        this.actorBorder = "calculated";
        this.actorBkg = "calculated";
        this.actorTextColor = "black";
        this.actorLineColor = "grey";
        this.signalColor = "calculated";
        this.signalTextColor = "calculated";
        this.labelBoxBkgColor = "calculated";
        this.labelBoxBorderColor = "calculated";
        this.labelTextColor = "calculated";
        this.loopTextColor = "calculated";
        this.noteBorderColor = "calculated";
        this.noteBkgColor = "#fff5ad";
        this.noteTextColor = "calculated";
        this.activationBorderColor = "#666";
        this.activationBkgColor = "#f4f4f4";
        this.sequenceNumberColor = "white";
        this.sectionBkgColor = "calculated";
        this.altSectionBkgColor = "calculated";
        this.sectionBkgColor2 = "calculated";
        this.excludeBkgColor = "#eeeeee";
        this.taskBorderColor = "calculated";
        this.taskBkgColor = "calculated";
        this.taskTextLightColor = "calculated";
        this.taskTextColor = this.taskTextLightColor;
        this.taskTextDarkColor = "calculated";
        this.taskTextOutsideColor = this.taskTextDarkColor;
        this.taskTextClickableColor = "calculated";
        this.activeTaskBorderColor = "calculated";
        this.activeTaskBkgColor = "calculated";
        this.gridColor = "calculated";
        this.doneTaskBkgColor = "calculated";
        this.doneTaskBorderColor = "calculated";
        this.critBorderColor = "calculated";
        this.critBkgColor = "calculated";
        this.todayLineColor = "calculated";
        this.sectionBkgColor = (0, $b1Vti.default)(102, 102, 255, 0.49);
        this.altSectionBkgColor = "white";
        this.sectionBkgColor2 = "#fff400";
        this.taskBorderColor = "#534fbc";
        this.taskBkgColor = "#8a90dd";
        this.taskTextLightColor = "white";
        this.taskTextColor = "calculated";
        this.taskTextDarkColor = "black";
        this.taskTextOutsideColor = "calculated";
        this.taskTextClickableColor = "#003163";
        this.activeTaskBorderColor = "#534fbc";
        this.activeTaskBkgColor = "#bfc7ff";
        this.gridColor = "lightgrey";
        this.doneTaskBkgColor = "lightgrey";
        this.doneTaskBorderColor = "grey";
        this.critBorderColor = "#ff8888";
        this.critBkgColor = "red";
        this.todayLineColor = "red";
        this.personBorder = this.primaryBorderColor;
        this.personBkg = this.mainBkg;
        this.labelColor = "black";
        this.errorBkgColor = "#552222";
        this.errorTextColor = "#552222";
        this.updateColors();
    }
    updateColors() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
        this.cScale0 = this.cScale0 || this.primaryColor;
        this.cScale1 = this.cScale1 || this.secondaryColor;
        this.cScale2 = this.cScale2 || this.tertiaryColor;
        this.cScale3 = this.cScale3 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 30
        });
        this.cScale4 = this.cScale4 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 60
        });
        this.cScale5 = this.cScale5 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 90
        });
        this.cScale6 = this.cScale6 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 120
        });
        this.cScale7 = this.cScale7 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 150
        });
        this.cScale8 = this.cScale8 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 210
        });
        this.cScale9 = this.cScale9 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 270
        });
        this.cScale10 = this.cScale10 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 300
        });
        this.cScale11 = this.cScale11 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 330
        });
        this["cScalePeer1"] = this["cScalePeer1"] || (0, $c94qS.default)(this.secondaryColor, 45);
        this["cScalePeer2"] = this["cScalePeer2"] || (0, $c94qS.default)(this.tertiaryColor, 40);
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++){
            this["cScale" + i] = (0, $c94qS.default)(this["cScale" + i], 10);
            this["cScalePeer" + i] = this["cScalePeer" + i] || (0, $c94qS.default)(this["cScale" + i], 25);
        }
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleInv" + i] = this["cScaleInv" + i] || (0, $7Mv8O.default)(this["cScale" + i], {
            h: 180
        });
        for(let i = 0; i < 5; i++){
            this["surface" + i] = this["surface" + i] || (0, $7Mv8O.default)(this.mainBkg, {
                h: 30,
                l: -(5 + i * 5)
            });
            this["surfacePeer" + i] = this["surfacePeer" + i] || (0, $7Mv8O.default)(this.mainBkg, {
                h: 30,
                l: -(7 + i * 5)
            });
        }
        this.scaleLabelColor = this.scaleLabelColor !== "calculated" && this.scaleLabelColor ? this.scaleLabelColor : this.labelTextColor;
        if (this.labelTextColor !== "calculated") {
            this.cScaleLabel0 = this.cScaleLabel0 || (0, $1LW8F.default)(this.labelTextColor);
            this.cScaleLabel3 = this.cScaleLabel3 || (0, $1LW8F.default)(this.labelTextColor);
            for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleLabel" + i] = this["cScaleLabel" + i] || this.labelTextColor;
        }
        this.nodeBkg = this.mainBkg;
        this.nodeBorder = this.border1;
        this.clusterBkg = this.secondBkg;
        this.clusterBorder = this.border2;
        this.defaultLinkColor = this.lineColor;
        this.titleColor = this.textColor;
        this.edgeLabelBackground = this.labelBackground;
        this.actorBorder = (0, $1Ez1E.default)(this.border1, 23);
        this.actorBkg = this.mainBkg;
        this.labelBoxBkgColor = this.actorBkg;
        this.signalColor = this.textColor;
        this.signalTextColor = this.textColor;
        this.labelBoxBorderColor = this.actorBorder;
        this.labelTextColor = this.actorTextColor;
        this.loopTextColor = this.actorTextColor;
        this.noteBorderColor = this.border2;
        this.noteTextColor = this.actorTextColor;
        this.taskTextColor = this.taskTextLightColor;
        this.taskTextOutsideColor = this.taskTextDarkColor;
        this.transitionColor = this.transitionColor || this.lineColor;
        this.transitionLabelColor = this.transitionLabelColor || this.textColor;
        this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor;
        this.stateBkg = this.stateBkg || this.mainBkg;
        this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg;
        this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor;
        this.altBackground = this.altBackground || "#f0f0f0";
        this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg;
        this.compositeBorder = this.compositeBorder || this.nodeBorder;
        this.innerEndBackground = this.nodeBorder;
        this.specialStateColor = this.lineColor;
        this.errorBkgColor = this.errorBkgColor || this.tertiaryColor;
        this.errorTextColor = this.errorTextColor || this.tertiaryTextColor;
        this.transitionColor = this.transitionColor || this.lineColor;
        this.classText = this.primaryTextColor;
        this.fillType0 = this.primaryColor;
        this.fillType1 = this.secondaryColor;
        this.fillType2 = (0, $7Mv8O.default)(this.primaryColor, {
            h: 64
        });
        this.fillType3 = (0, $7Mv8O.default)(this.secondaryColor, {
            h: 64
        });
        this.fillType4 = (0, $7Mv8O.default)(this.primaryColor, {
            h: -64
        });
        this.fillType5 = (0, $7Mv8O.default)(this.secondaryColor, {
            h: -64
        });
        this.fillType6 = (0, $7Mv8O.default)(this.primaryColor, {
            h: 128
        });
        this.fillType7 = (0, $7Mv8O.default)(this.secondaryColor, {
            h: 128
        });
        this.pie1 = this.pie1 || this.primaryColor;
        this.pie2 = this.pie2 || this.secondaryColor;
        this.pie3 = this.pie3 || (0, $7Mv8O.default)(this.tertiaryColor, {
            l: -40
        });
        this.pie4 = this.pie4 || (0, $7Mv8O.default)(this.primaryColor, {
            l: -10
        });
        this.pie5 = this.pie5 || (0, $7Mv8O.default)(this.secondaryColor, {
            l: -30
        });
        this.pie6 = this.pie6 || (0, $7Mv8O.default)(this.tertiaryColor, {
            l: -20
        });
        this.pie7 = this.pie7 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 60,
            l: -20
        });
        this.pie8 = this.pie8 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -60,
            l: -40
        });
        this.pie9 = this.pie9 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 120,
            l: -40
        });
        this.pie10 = this.pie10 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 60,
            l: -40
        });
        this.pie11 = this.pie11 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -90,
            l: -40
        });
        this.pie12 = this.pie12 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 120,
            l: -30
        });
        this.pieTitleTextSize = this.pieTitleTextSize || "25px";
        this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor;
        this.pieSectionTextSize = this.pieSectionTextSize || "17px";
        this.pieSectionTextColor = this.pieSectionTextColor || this.textColor;
        this.pieLegendTextSize = this.pieLegendTextSize || "17px";
        this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor;
        this.pieStrokeColor = this.pieStrokeColor || "black";
        this.pieStrokeWidth = this.pieStrokeWidth || "2px";
        this.pieOuterStrokeWidth = this.pieOuterStrokeWidth || "2px";
        this.pieOuterStrokeColor = this.pieOuterStrokeColor || "black";
        this.pieOpacity = this.pieOpacity || "0.7";
        this.quadrant1Fill = this.quadrant1Fill || this.primaryColor;
        this.quadrant2Fill = this.quadrant2Fill || (0, $7Mv8O.default)(this.primaryColor, {
            r: 5,
            g: 5,
            b: 5
        });
        this.quadrant3Fill = this.quadrant3Fill || (0, $7Mv8O.default)(this.primaryColor, {
            r: 10,
            g: 10,
            b: 10
        });
        this.quadrant4Fill = this.quadrant4Fill || (0, $7Mv8O.default)(this.primaryColor, {
            r: 15,
            g: 15,
            b: 15
        });
        this.quadrant1TextFill = this.quadrant1TextFill || this.primaryTextColor;
        this.quadrant2TextFill = this.quadrant2TextFill || (0, $7Mv8O.default)(this.primaryTextColor, {
            r: -5,
            g: -5,
            b: -5
        });
        this.quadrant3TextFill = this.quadrant3TextFill || (0, $7Mv8O.default)(this.primaryTextColor, {
            r: -10,
            g: -10,
            b: -10
        });
        this.quadrant4TextFill = this.quadrant4TextFill || (0, $7Mv8O.default)(this.primaryTextColor, {
            r: -15,
            g: -15,
            b: -15
        });
        this.quadrantPointFill = this.quadrantPointFill || (0, $75Ue8.default)(this.quadrant1Fill) ? (0, $1Ez1E.default)(this.quadrant1Fill) : (0, $c94qS.default)(this.quadrant1Fill);
        this.quadrantPointTextFill = this.quadrantPointTextFill || this.primaryTextColor;
        this.quadrantXAxisTextFill = this.quadrantXAxisTextFill || this.primaryTextColor;
        this.quadrantYAxisTextFill = this.quadrantYAxisTextFill || this.primaryTextColor;
        this.quadrantInternalBorderStrokeFill = this.quadrantInternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantExternalBorderStrokeFill = this.quadrantExternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantTitleFill = this.quadrantTitleFill || this.primaryTextColor;
        this.xyChart = {
            backgroundColor: ((_a = this.xyChart) == null ? void 0 : _a.backgroundColor) || this.background,
            titleColor: ((_b = this.xyChart) == null ? void 0 : _b.titleColor) || this.primaryTextColor,
            xAxisTitleColor: ((_c = this.xyChart) == null ? void 0 : _c.xAxisTitleColor) || this.primaryTextColor,
            xAxisLabelColor: ((_d = this.xyChart) == null ? void 0 : _d.xAxisLabelColor) || this.primaryTextColor,
            xAxisTickColor: ((_e = this.xyChart) == null ? void 0 : _e.xAxisTickColor) || this.primaryTextColor,
            xAxisLineColor: ((_f = this.xyChart) == null ? void 0 : _f.xAxisLineColor) || this.primaryTextColor,
            yAxisTitleColor: ((_g = this.xyChart) == null ? void 0 : _g.yAxisTitleColor) || this.primaryTextColor,
            yAxisLabelColor: ((_h = this.xyChart) == null ? void 0 : _h.yAxisLabelColor) || this.primaryTextColor,
            yAxisTickColor: ((_i = this.xyChart) == null ? void 0 : _i.yAxisTickColor) || this.primaryTextColor,
            yAxisLineColor: ((_j = this.xyChart) == null ? void 0 : _j.yAxisLineColor) || this.primaryTextColor,
            plotColorPalette: ((_k = this.xyChart) == null ? void 0 : _k.plotColorPalette) || "#ECECFF,#8493A6,#FFC3A0,#DCDDE1,#B8E994,#D1A36F,#C3CDE6,#FFB6C1,#496078,#F8F3E3"
        };
        this.requirementBackground = this.requirementBackground || this.primaryColor;
        this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor;
        this.requirementBorderSize = this.requirementBorderSize || "1";
        this.requirementTextColor = this.requirementTextColor || this.primaryTextColor;
        this.relationColor = this.relationColor || this.lineColor;
        this.relationLabelBackground = this.relationLabelBackground || this.labelBackground;
        this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
        this.git0 = this.git0 || this.primaryColor;
        this.git1 = this.git1 || this.secondaryColor;
        this.git2 = this.git2 || this.tertiaryColor;
        this.git3 = this.git3 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -30
        });
        this.git4 = this.git4 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -60
        });
        this.git5 = this.git5 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -90
        });
        this.git6 = this.git6 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 60
        });
        this.git7 = this.git7 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 120
        });
        if (this.darkMode) {
            this.git0 = (0, $1Ez1E.default)(this.git0, 25);
            this.git1 = (0, $1Ez1E.default)(this.git1, 25);
            this.git2 = (0, $1Ez1E.default)(this.git2, 25);
            this.git3 = (0, $1Ez1E.default)(this.git3, 25);
            this.git4 = (0, $1Ez1E.default)(this.git4, 25);
            this.git5 = (0, $1Ez1E.default)(this.git5, 25);
            this.git6 = (0, $1Ez1E.default)(this.git6, 25);
            this.git7 = (0, $1Ez1E.default)(this.git7, 25);
        } else {
            this.git0 = (0, $c94qS.default)(this.git0, 25);
            this.git1 = (0, $c94qS.default)(this.git1, 25);
            this.git2 = (0, $c94qS.default)(this.git2, 25);
            this.git3 = (0, $c94qS.default)(this.git3, 25);
            this.git4 = (0, $c94qS.default)(this.git4, 25);
            this.git5 = (0, $c94qS.default)(this.git5, 25);
            this.git6 = (0, $c94qS.default)(this.git6, 25);
            this.git7 = (0, $c94qS.default)(this.git7, 25);
        }
        this.gitInv0 = this.gitInv0 || (0, $c94qS.default)((0, $1LW8F.default)(this.git0), 25);
        this.gitInv1 = this.gitInv1 || (0, $1LW8F.default)(this.git1);
        this.gitInv2 = this.gitInv2 || (0, $1LW8F.default)(this.git2);
        this.gitInv3 = this.gitInv3 || (0, $1LW8F.default)(this.git3);
        this.gitInv4 = this.gitInv4 || (0, $1LW8F.default)(this.git4);
        this.gitInv5 = this.gitInv5 || (0, $1LW8F.default)(this.git5);
        this.gitInv6 = this.gitInv6 || (0, $1LW8F.default)(this.git6);
        this.gitInv7 = this.gitInv7 || (0, $1LW8F.default)(this.git7);
        this.gitBranchLabel0 = this.gitBranchLabel0 || (0, $1LW8F.default)(this.labelTextColor);
        this.gitBranchLabel1 = this.gitBranchLabel1 || this.labelTextColor;
        this.gitBranchLabel2 = this.gitBranchLabel2 || this.labelTextColor;
        this.gitBranchLabel3 = this.gitBranchLabel3 || (0, $1LW8F.default)(this.labelTextColor);
        this.gitBranchLabel4 = this.gitBranchLabel4 || this.labelTextColor;
        this.gitBranchLabel5 = this.gitBranchLabel5 || this.labelTextColor;
        this.gitBranchLabel6 = this.gitBranchLabel6 || this.labelTextColor;
        this.gitBranchLabel7 = this.gitBranchLabel7 || this.labelTextColor;
        this.tagLabelColor = this.tagLabelColor || this.primaryTextColor;
        this.tagLabelBackground = this.tagLabelBackground || this.primaryColor;
        this.tagLabelBorder = this.tagBorder || this.primaryBorderColor;
        this.tagLabelFontSize = this.tagLabelFontSize || "10px";
        this.commitLabelColor = this.commitLabelColor || this.secondaryTextColor;
        this.commitLabelBackground = this.commitLabelBackground || this.secondaryColor;
        this.commitLabelFontSize = this.commitLabelFontSize || "10px";
        this.attributeBackgroundColorOdd = this.attributeBackgroundColorOdd || $80b3d2f58e77b583$var$oldAttributeBackgroundColorOdd;
        this.attributeBackgroundColorEven = this.attributeBackgroundColorEven || $80b3d2f58e77b583$var$oldAttributeBackgroundColorEven;
    }
    calculate(overrides) {
        if (typeof overrides !== "object") {
            this.updateColors();
            return;
        }
        const keys = Object.keys(overrides);
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
        this.updateColors();
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
    }
};
const $80b3d2f58e77b583$export$a9c23c6ac3fc3eca = (userOverrides)=>{
    const theme2 = new $80b3d2f58e77b583$var$Theme$2();
    theme2.calculate(userOverrides);
    return theme2;
};
let $80b3d2f58e77b583$var$Theme$1 = class Theme4 {
    constructor(){
        this.background = "#f4f4f4";
        this.primaryColor = "#cde498";
        this.secondaryColor = "#cdffb2";
        this.background = "white";
        this.mainBkg = "#cde498";
        this.secondBkg = "#cdffb2";
        this.lineColor = "green";
        this.border1 = "#13540c";
        this.border2 = "#6eaa49";
        this.arrowheadColor = "green";
        this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif';
        this.fontSize = "16px";
        this.tertiaryColor = (0, $1Ez1E.default)("#cde498", 10);
        this.primaryBorderColor = $80b3d2f58e77b583$var$mkBorder(this.primaryColor, this.darkMode);
        this.secondaryBorderColor = $80b3d2f58e77b583$var$mkBorder(this.secondaryColor, this.darkMode);
        this.tertiaryBorderColor = $80b3d2f58e77b583$var$mkBorder(this.tertiaryColor, this.darkMode);
        this.primaryTextColor = (0, $1LW8F.default)(this.primaryColor);
        this.secondaryTextColor = (0, $1LW8F.default)(this.secondaryColor);
        this.tertiaryTextColor = (0, $1LW8F.default)(this.primaryColor);
        this.lineColor = (0, $1LW8F.default)(this.background);
        this.textColor = (0, $1LW8F.default)(this.background);
        this.THEME_COLOR_LIMIT = 12;
        this.nodeBkg = "calculated";
        this.nodeBorder = "calculated";
        this.clusterBkg = "calculated";
        this.clusterBorder = "calculated";
        this.defaultLinkColor = "calculated";
        this.titleColor = "#333";
        this.edgeLabelBackground = "#e8e8e8";
        this.actorBorder = "calculated";
        this.actorBkg = "calculated";
        this.actorTextColor = "black";
        this.actorLineColor = "grey";
        this.signalColor = "#333";
        this.signalTextColor = "#333";
        this.labelBoxBkgColor = "calculated";
        this.labelBoxBorderColor = "#326932";
        this.labelTextColor = "calculated";
        this.loopTextColor = "calculated";
        this.noteBorderColor = "calculated";
        this.noteBkgColor = "#fff5ad";
        this.noteTextColor = "calculated";
        this.activationBorderColor = "#666";
        this.activationBkgColor = "#f4f4f4";
        this.sequenceNumberColor = "white";
        this.sectionBkgColor = "#6eaa49";
        this.altSectionBkgColor = "white";
        this.sectionBkgColor2 = "#6eaa49";
        this.excludeBkgColor = "#eeeeee";
        this.taskBorderColor = "calculated";
        this.taskBkgColor = "#487e3a";
        this.taskTextLightColor = "white";
        this.taskTextColor = "calculated";
        this.taskTextDarkColor = "black";
        this.taskTextOutsideColor = "calculated";
        this.taskTextClickableColor = "#003163";
        this.activeTaskBorderColor = "calculated";
        this.activeTaskBkgColor = "calculated";
        this.gridColor = "lightgrey";
        this.doneTaskBkgColor = "lightgrey";
        this.doneTaskBorderColor = "grey";
        this.critBorderColor = "#ff8888";
        this.critBkgColor = "red";
        this.todayLineColor = "red";
        this.personBorder = this.primaryBorderColor;
        this.personBkg = this.mainBkg;
        this.labelColor = "black";
        this.errorBkgColor = "#552222";
        this.errorTextColor = "#552222";
    }
    updateColors() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
        this.actorBorder = (0, $c94qS.default)(this.mainBkg, 20);
        this.actorBkg = this.mainBkg;
        this.labelBoxBkgColor = this.actorBkg;
        this.labelTextColor = this.actorTextColor;
        this.loopTextColor = this.actorTextColor;
        this.noteBorderColor = this.border2;
        this.noteTextColor = this.actorTextColor;
        this.cScale0 = this.cScale0 || this.primaryColor;
        this.cScale1 = this.cScale1 || this.secondaryColor;
        this.cScale2 = this.cScale2 || this.tertiaryColor;
        this.cScale3 = this.cScale3 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 30
        });
        this.cScale4 = this.cScale4 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 60
        });
        this.cScale5 = this.cScale5 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 90
        });
        this.cScale6 = this.cScale6 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 120
        });
        this.cScale7 = this.cScale7 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 150
        });
        this.cScale8 = this.cScale8 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 210
        });
        this.cScale9 = this.cScale9 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 270
        });
        this.cScale10 = this.cScale10 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 300
        });
        this.cScale11 = this.cScale11 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 330
        });
        this["cScalePeer1"] = this["cScalePeer1"] || (0, $c94qS.default)(this.secondaryColor, 45);
        this["cScalePeer2"] = this["cScalePeer2"] || (0, $c94qS.default)(this.tertiaryColor, 40);
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++){
            this["cScale" + i] = (0, $c94qS.default)(this["cScale" + i], 10);
            this["cScalePeer" + i] = this["cScalePeer" + i] || (0, $c94qS.default)(this["cScale" + i], 25);
        }
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleInv" + i] = this["cScaleInv" + i] || (0, $7Mv8O.default)(this["cScale" + i], {
            h: 180
        });
        this.scaleLabelColor = this.scaleLabelColor !== "calculated" && this.scaleLabelColor ? this.scaleLabelColor : this.labelTextColor;
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleLabel" + i] = this["cScaleLabel" + i] || this.scaleLabelColor;
        for(let i = 0; i < 5; i++){
            this["surface" + i] = this["surface" + i] || (0, $7Mv8O.default)(this.mainBkg, {
                h: 30,
                s: -30,
                l: -(5 + i * 5)
            });
            this["surfacePeer" + i] = this["surfacePeer" + i] || (0, $7Mv8O.default)(this.mainBkg, {
                h: 30,
                s: -30,
                l: -(8 + i * 5)
            });
        }
        this.nodeBkg = this.mainBkg;
        this.nodeBorder = this.border1;
        this.clusterBkg = this.secondBkg;
        this.clusterBorder = this.border2;
        this.defaultLinkColor = this.lineColor;
        this.taskBorderColor = this.border1;
        this.taskTextColor = this.taskTextLightColor;
        this.taskTextOutsideColor = this.taskTextDarkColor;
        this.activeTaskBorderColor = this.taskBorderColor;
        this.activeTaskBkgColor = this.mainBkg;
        this.transitionColor = this.transitionColor || this.lineColor;
        this.transitionLabelColor = this.transitionLabelColor || this.textColor;
        this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor;
        this.stateBkg = this.stateBkg || this.mainBkg;
        this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg;
        this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor;
        this.altBackground = this.altBackground || "#f0f0f0";
        this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg;
        this.compositeBorder = this.compositeBorder || this.nodeBorder;
        this.innerEndBackground = this.primaryBorderColor;
        this.specialStateColor = this.lineColor;
        this.errorBkgColor = this.errorBkgColor || this.tertiaryColor;
        this.errorTextColor = this.errorTextColor || this.tertiaryTextColor;
        this.transitionColor = this.transitionColor || this.lineColor;
        this.classText = this.primaryTextColor;
        this.fillType0 = this.primaryColor;
        this.fillType1 = this.secondaryColor;
        this.fillType2 = (0, $7Mv8O.default)(this.primaryColor, {
            h: 64
        });
        this.fillType3 = (0, $7Mv8O.default)(this.secondaryColor, {
            h: 64
        });
        this.fillType4 = (0, $7Mv8O.default)(this.primaryColor, {
            h: -64
        });
        this.fillType5 = (0, $7Mv8O.default)(this.secondaryColor, {
            h: -64
        });
        this.fillType6 = (0, $7Mv8O.default)(this.primaryColor, {
            h: 128
        });
        this.fillType7 = (0, $7Mv8O.default)(this.secondaryColor, {
            h: 128
        });
        this.pie1 = this.pie1 || this.primaryColor;
        this.pie2 = this.pie2 || this.secondaryColor;
        this.pie3 = this.pie3 || this.tertiaryColor;
        this.pie4 = this.pie4 || (0, $7Mv8O.default)(this.primaryColor, {
            l: -30
        });
        this.pie5 = this.pie5 || (0, $7Mv8O.default)(this.secondaryColor, {
            l: -30
        });
        this.pie6 = this.pie6 || (0, $7Mv8O.default)(this.tertiaryColor, {
            h: 40,
            l: -40
        });
        this.pie7 = this.pie7 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 60,
            l: -10
        });
        this.pie8 = this.pie8 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -60,
            l: -10
        });
        this.pie9 = this.pie9 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 120,
            l: 0
        });
        this.pie10 = this.pie10 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 60,
            l: -50
        });
        this.pie11 = this.pie11 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -60,
            l: -50
        });
        this.pie12 = this.pie12 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 120,
            l: -50
        });
        this.pieTitleTextSize = this.pieTitleTextSize || "25px";
        this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor;
        this.pieSectionTextSize = this.pieSectionTextSize || "17px";
        this.pieSectionTextColor = this.pieSectionTextColor || this.textColor;
        this.pieLegendTextSize = this.pieLegendTextSize || "17px";
        this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor;
        this.pieStrokeColor = this.pieStrokeColor || "black";
        this.pieStrokeWidth = this.pieStrokeWidth || "2px";
        this.pieOuterStrokeWidth = this.pieOuterStrokeWidth || "2px";
        this.pieOuterStrokeColor = this.pieOuterStrokeColor || "black";
        this.pieOpacity = this.pieOpacity || "0.7";
        this.quadrant1Fill = this.quadrant1Fill || this.primaryColor;
        this.quadrant2Fill = this.quadrant2Fill || (0, $7Mv8O.default)(this.primaryColor, {
            r: 5,
            g: 5,
            b: 5
        });
        this.quadrant3Fill = this.quadrant3Fill || (0, $7Mv8O.default)(this.primaryColor, {
            r: 10,
            g: 10,
            b: 10
        });
        this.quadrant4Fill = this.quadrant4Fill || (0, $7Mv8O.default)(this.primaryColor, {
            r: 15,
            g: 15,
            b: 15
        });
        this.quadrant1TextFill = this.quadrant1TextFill || this.primaryTextColor;
        this.quadrant2TextFill = this.quadrant2TextFill || (0, $7Mv8O.default)(this.primaryTextColor, {
            r: -5,
            g: -5,
            b: -5
        });
        this.quadrant3TextFill = this.quadrant3TextFill || (0, $7Mv8O.default)(this.primaryTextColor, {
            r: -10,
            g: -10,
            b: -10
        });
        this.quadrant4TextFill = this.quadrant4TextFill || (0, $7Mv8O.default)(this.primaryTextColor, {
            r: -15,
            g: -15,
            b: -15
        });
        this.quadrantPointFill = this.quadrantPointFill || (0, $75Ue8.default)(this.quadrant1Fill) ? (0, $1Ez1E.default)(this.quadrant1Fill) : (0, $c94qS.default)(this.quadrant1Fill);
        this.quadrantPointTextFill = this.quadrantPointTextFill || this.primaryTextColor;
        this.quadrantXAxisTextFill = this.quadrantXAxisTextFill || this.primaryTextColor;
        this.quadrantYAxisTextFill = this.quadrantYAxisTextFill || this.primaryTextColor;
        this.quadrantInternalBorderStrokeFill = this.quadrantInternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantExternalBorderStrokeFill = this.quadrantExternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantTitleFill = this.quadrantTitleFill || this.primaryTextColor;
        this.xyChart = {
            backgroundColor: ((_a = this.xyChart) == null ? void 0 : _a.backgroundColor) || this.background,
            titleColor: ((_b = this.xyChart) == null ? void 0 : _b.titleColor) || this.primaryTextColor,
            xAxisTitleColor: ((_c = this.xyChart) == null ? void 0 : _c.xAxisTitleColor) || this.primaryTextColor,
            xAxisLabelColor: ((_d = this.xyChart) == null ? void 0 : _d.xAxisLabelColor) || this.primaryTextColor,
            xAxisTickColor: ((_e = this.xyChart) == null ? void 0 : _e.xAxisTickColor) || this.primaryTextColor,
            xAxisLineColor: ((_f = this.xyChart) == null ? void 0 : _f.xAxisLineColor) || this.primaryTextColor,
            yAxisTitleColor: ((_g = this.xyChart) == null ? void 0 : _g.yAxisTitleColor) || this.primaryTextColor,
            yAxisLabelColor: ((_h = this.xyChart) == null ? void 0 : _h.yAxisLabelColor) || this.primaryTextColor,
            yAxisTickColor: ((_i = this.xyChart) == null ? void 0 : _i.yAxisTickColor) || this.primaryTextColor,
            yAxisLineColor: ((_j = this.xyChart) == null ? void 0 : _j.yAxisLineColor) || this.primaryTextColor,
            plotColorPalette: ((_k = this.xyChart) == null ? void 0 : _k.plotColorPalette) || "#CDE498,#FF6B6B,#A0D2DB,#D7BDE2,#F0F0F0,#FFC3A0,#7FD8BE,#FF9A8B,#FAF3E0,#FFF176"
        };
        this.requirementBackground = this.requirementBackground || this.primaryColor;
        this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor;
        this.requirementBorderSize = this.requirementBorderSize || "1";
        this.requirementTextColor = this.requirementTextColor || this.primaryTextColor;
        this.relationColor = this.relationColor || this.lineColor;
        this.relationLabelBackground = this.relationLabelBackground || this.edgeLabelBackground;
        this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
        this.git0 = this.git0 || this.primaryColor;
        this.git1 = this.git1 || this.secondaryColor;
        this.git2 = this.git2 || this.tertiaryColor;
        this.git3 = this.git3 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -30
        });
        this.git4 = this.git4 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -60
        });
        this.git5 = this.git5 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -90
        });
        this.git6 = this.git6 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 60
        });
        this.git7 = this.git7 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 120
        });
        if (this.darkMode) {
            this.git0 = (0, $1Ez1E.default)(this.git0, 25);
            this.git1 = (0, $1Ez1E.default)(this.git1, 25);
            this.git2 = (0, $1Ez1E.default)(this.git2, 25);
            this.git3 = (0, $1Ez1E.default)(this.git3, 25);
            this.git4 = (0, $1Ez1E.default)(this.git4, 25);
            this.git5 = (0, $1Ez1E.default)(this.git5, 25);
            this.git6 = (0, $1Ez1E.default)(this.git6, 25);
            this.git7 = (0, $1Ez1E.default)(this.git7, 25);
        } else {
            this.git0 = (0, $c94qS.default)(this.git0, 25);
            this.git1 = (0, $c94qS.default)(this.git1, 25);
            this.git2 = (0, $c94qS.default)(this.git2, 25);
            this.git3 = (0, $c94qS.default)(this.git3, 25);
            this.git4 = (0, $c94qS.default)(this.git4, 25);
            this.git5 = (0, $c94qS.default)(this.git5, 25);
            this.git6 = (0, $c94qS.default)(this.git6, 25);
            this.git7 = (0, $c94qS.default)(this.git7, 25);
        }
        this.gitInv0 = this.gitInv0 || (0, $1LW8F.default)(this.git0);
        this.gitInv1 = this.gitInv1 || (0, $1LW8F.default)(this.git1);
        this.gitInv2 = this.gitInv2 || (0, $1LW8F.default)(this.git2);
        this.gitInv3 = this.gitInv3 || (0, $1LW8F.default)(this.git3);
        this.gitInv4 = this.gitInv4 || (0, $1LW8F.default)(this.git4);
        this.gitInv5 = this.gitInv5 || (0, $1LW8F.default)(this.git5);
        this.gitInv6 = this.gitInv6 || (0, $1LW8F.default)(this.git6);
        this.gitInv7 = this.gitInv7 || (0, $1LW8F.default)(this.git7);
        this.gitBranchLabel0 = this.gitBranchLabel0 || (0, $1LW8F.default)(this.labelTextColor);
        this.gitBranchLabel1 = this.gitBranchLabel1 || this.labelTextColor;
        this.gitBranchLabel2 = this.gitBranchLabel2 || this.labelTextColor;
        this.gitBranchLabel3 = this.gitBranchLabel3 || (0, $1LW8F.default)(this.labelTextColor);
        this.gitBranchLabel4 = this.gitBranchLabel4 || this.labelTextColor;
        this.gitBranchLabel5 = this.gitBranchLabel5 || this.labelTextColor;
        this.gitBranchLabel6 = this.gitBranchLabel6 || this.labelTextColor;
        this.gitBranchLabel7 = this.gitBranchLabel7 || this.labelTextColor;
        this.tagLabelColor = this.tagLabelColor || this.primaryTextColor;
        this.tagLabelBackground = this.tagLabelBackground || this.primaryColor;
        this.tagLabelBorder = this.tagBorder || this.primaryBorderColor;
        this.tagLabelFontSize = this.tagLabelFontSize || "10px";
        this.commitLabelColor = this.commitLabelColor || this.secondaryTextColor;
        this.commitLabelBackground = this.commitLabelBackground || this.secondaryColor;
        this.commitLabelFontSize = this.commitLabelFontSize || "10px";
        this.attributeBackgroundColorOdd = this.attributeBackgroundColorOdd || $80b3d2f58e77b583$var$oldAttributeBackgroundColorOdd;
        this.attributeBackgroundColorEven = this.attributeBackgroundColorEven || $80b3d2f58e77b583$var$oldAttributeBackgroundColorEven;
    }
    calculate(overrides) {
        if (typeof overrides !== "object") {
            this.updateColors();
            return;
        }
        const keys = Object.keys(overrides);
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
        this.updateColors();
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
    }
};
const $80b3d2f58e77b583$var$getThemeVariables$1 = (userOverrides)=>{
    const theme2 = new $80b3d2f58e77b583$var$Theme$1();
    theme2.calculate(userOverrides);
    return theme2;
};
class $80b3d2f58e77b583$var$Theme5 {
    constructor(){
        this.primaryColor = "#eee";
        this.contrast = "#707070";
        this.secondaryColor = (0, $1Ez1E.default)(this.contrast, 55);
        this.background = "#ffffff";
        this.tertiaryColor = (0, $7Mv8O.default)(this.primaryColor, {
            h: -160
        });
        this.primaryBorderColor = $80b3d2f58e77b583$var$mkBorder(this.primaryColor, this.darkMode);
        this.secondaryBorderColor = $80b3d2f58e77b583$var$mkBorder(this.secondaryColor, this.darkMode);
        this.tertiaryBorderColor = $80b3d2f58e77b583$var$mkBorder(this.tertiaryColor, this.darkMode);
        this.primaryTextColor = (0, $1LW8F.default)(this.primaryColor);
        this.secondaryTextColor = (0, $1LW8F.default)(this.secondaryColor);
        this.tertiaryTextColor = (0, $1LW8F.default)(this.tertiaryColor);
        this.lineColor = (0, $1LW8F.default)(this.background);
        this.textColor = (0, $1LW8F.default)(this.background);
        this.mainBkg = "#eee";
        this.secondBkg = "calculated";
        this.lineColor = "#666";
        this.border1 = "#999";
        this.border2 = "calculated";
        this.note = "#ffa";
        this.text = "#333";
        this.critical = "#d42";
        this.done = "#bbb";
        this.arrowheadColor = "#333333";
        this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif';
        this.fontSize = "16px";
        this.THEME_COLOR_LIMIT = 12;
        this.nodeBkg = "calculated";
        this.nodeBorder = "calculated";
        this.clusterBkg = "calculated";
        this.clusterBorder = "calculated";
        this.defaultLinkColor = "calculated";
        this.titleColor = "calculated";
        this.edgeLabelBackground = "white";
        this.actorBorder = "calculated";
        this.actorBkg = "calculated";
        this.actorTextColor = "calculated";
        this.actorLineColor = "calculated";
        this.signalColor = "calculated";
        this.signalTextColor = "calculated";
        this.labelBoxBkgColor = "calculated";
        this.labelBoxBorderColor = "calculated";
        this.labelTextColor = "calculated";
        this.loopTextColor = "calculated";
        this.noteBorderColor = "calculated";
        this.noteBkgColor = "calculated";
        this.noteTextColor = "calculated";
        this.activationBorderColor = "#666";
        this.activationBkgColor = "#f4f4f4";
        this.sequenceNumberColor = "white";
        this.sectionBkgColor = "calculated";
        this.altSectionBkgColor = "white";
        this.sectionBkgColor2 = "calculated";
        this.excludeBkgColor = "#eeeeee";
        this.taskBorderColor = "calculated";
        this.taskBkgColor = "calculated";
        this.taskTextLightColor = "white";
        this.taskTextColor = "calculated";
        this.taskTextDarkColor = "calculated";
        this.taskTextOutsideColor = "calculated";
        this.taskTextClickableColor = "#003163";
        this.activeTaskBorderColor = "calculated";
        this.activeTaskBkgColor = "calculated";
        this.gridColor = "calculated";
        this.doneTaskBkgColor = "calculated";
        this.doneTaskBorderColor = "calculated";
        this.critBkgColor = "calculated";
        this.critBorderColor = "calculated";
        this.todayLineColor = "calculated";
        this.personBorder = this.primaryBorderColor;
        this.personBkg = this.mainBkg;
        this.labelColor = "black";
        this.errorBkgColor = "#552222";
        this.errorTextColor = "#552222";
    }
    updateColors() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
        this.secondBkg = (0, $1Ez1E.default)(this.contrast, 55);
        this.border2 = this.contrast;
        this.actorBorder = (0, $1Ez1E.default)(this.border1, 23);
        this.actorBkg = this.mainBkg;
        this.actorTextColor = this.text;
        this.actorLineColor = this.lineColor;
        this.signalColor = this.text;
        this.signalTextColor = this.text;
        this.labelBoxBkgColor = this.actorBkg;
        this.labelBoxBorderColor = this.actorBorder;
        this.labelTextColor = this.text;
        this.loopTextColor = this.text;
        this.noteBorderColor = "#999";
        this.noteBkgColor = "#666";
        this.noteTextColor = "#fff";
        this.cScale0 = this.cScale0 || "#555";
        this.cScale1 = this.cScale1 || "#F4F4F4";
        this.cScale2 = this.cScale2 || "#555";
        this.cScale3 = this.cScale3 || "#BBB";
        this.cScale4 = this.cScale4 || "#777";
        this.cScale5 = this.cScale5 || "#999";
        this.cScale6 = this.cScale6 || "#DDD";
        this.cScale7 = this.cScale7 || "#FFF";
        this.cScale8 = this.cScale8 || "#DDD";
        this.cScale9 = this.cScale9 || "#BBB";
        this.cScale10 = this.cScale10 || "#999";
        this.cScale11 = this.cScale11 || "#777";
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleInv" + i] = this["cScaleInv" + i] || (0, $1LW8F.default)(this["cScale" + i]);
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)if (this.darkMode) this["cScalePeer" + i] = this["cScalePeer" + i] || (0, $1Ez1E.default)(this["cScale" + i], 10);
        else this["cScalePeer" + i] = this["cScalePeer" + i] || (0, $c94qS.default)(this["cScale" + i], 10);
        this.scaleLabelColor = this.scaleLabelColor || (this.darkMode ? "black" : this.labelTextColor);
        this["cScaleLabel0"] = this["cScaleLabel0"] || this.cScale1;
        this["cScaleLabel2"] = this["cScaleLabel2"] || this.cScale1;
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleLabel" + i] = this["cScaleLabel" + i] || this.scaleLabelColor;
        for(let i = 0; i < 5; i++){
            this["surface" + i] = this["surface" + i] || (0, $7Mv8O.default)(this.mainBkg, {
                l: -(5 + i * 5)
            });
            this["surfacePeer" + i] = this["surfacePeer" + i] || (0, $7Mv8O.default)(this.mainBkg, {
                l: -(8 + i * 5)
            });
        }
        this.nodeBkg = this.mainBkg;
        this.nodeBorder = this.border1;
        this.clusterBkg = this.secondBkg;
        this.clusterBorder = this.border2;
        this.defaultLinkColor = this.lineColor;
        this.titleColor = this.text;
        this.sectionBkgColor = (0, $1Ez1E.default)(this.contrast, 30);
        this.sectionBkgColor2 = (0, $1Ez1E.default)(this.contrast, 30);
        this.taskBorderColor = (0, $c94qS.default)(this.contrast, 10);
        this.taskBkgColor = this.contrast;
        this.taskTextColor = this.taskTextLightColor;
        this.taskTextDarkColor = this.text;
        this.taskTextOutsideColor = this.taskTextDarkColor;
        this.activeTaskBorderColor = this.taskBorderColor;
        this.activeTaskBkgColor = this.mainBkg;
        this.gridColor = (0, $1Ez1E.default)(this.border1, 30);
        this.doneTaskBkgColor = this.done;
        this.doneTaskBorderColor = this.lineColor;
        this.critBkgColor = this.critical;
        this.critBorderColor = (0, $c94qS.default)(this.critBkgColor, 10);
        this.todayLineColor = this.critBkgColor;
        this.transitionColor = this.transitionColor || "#000";
        this.transitionLabelColor = this.transitionLabelColor || this.textColor;
        this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor;
        this.stateBkg = this.stateBkg || this.mainBkg;
        this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg;
        this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor;
        this.altBackground = this.altBackground || "#f4f4f4";
        this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg;
        this.stateBorder = this.stateBorder || "#000";
        this.innerEndBackground = this.primaryBorderColor;
        this.specialStateColor = "#222";
        this.errorBkgColor = this.errorBkgColor || this.tertiaryColor;
        this.errorTextColor = this.errorTextColor || this.tertiaryTextColor;
        this.classText = this.primaryTextColor;
        this.fillType0 = this.primaryColor;
        this.fillType1 = this.secondaryColor;
        this.fillType2 = (0, $7Mv8O.default)(this.primaryColor, {
            h: 64
        });
        this.fillType3 = (0, $7Mv8O.default)(this.secondaryColor, {
            h: 64
        });
        this.fillType4 = (0, $7Mv8O.default)(this.primaryColor, {
            h: -64
        });
        this.fillType5 = (0, $7Mv8O.default)(this.secondaryColor, {
            h: -64
        });
        this.fillType6 = (0, $7Mv8O.default)(this.primaryColor, {
            h: 128
        });
        this.fillType7 = (0, $7Mv8O.default)(this.secondaryColor, {
            h: 128
        });
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["pie" + i] = this["cScale" + i];
        this.pie12 = this.pie0;
        this.pieTitleTextSize = this.pieTitleTextSize || "25px";
        this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor;
        this.pieSectionTextSize = this.pieSectionTextSize || "17px";
        this.pieSectionTextColor = this.pieSectionTextColor || this.textColor;
        this.pieLegendTextSize = this.pieLegendTextSize || "17px";
        this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor;
        this.pieStrokeColor = this.pieStrokeColor || "black";
        this.pieStrokeWidth = this.pieStrokeWidth || "2px";
        this.pieOuterStrokeWidth = this.pieOuterStrokeWidth || "2px";
        this.pieOuterStrokeColor = this.pieOuterStrokeColor || "black";
        this.pieOpacity = this.pieOpacity || "0.7";
        this.quadrant1Fill = this.quadrant1Fill || this.primaryColor;
        this.quadrant2Fill = this.quadrant2Fill || (0, $7Mv8O.default)(this.primaryColor, {
            r: 5,
            g: 5,
            b: 5
        });
        this.quadrant3Fill = this.quadrant3Fill || (0, $7Mv8O.default)(this.primaryColor, {
            r: 10,
            g: 10,
            b: 10
        });
        this.quadrant4Fill = this.quadrant4Fill || (0, $7Mv8O.default)(this.primaryColor, {
            r: 15,
            g: 15,
            b: 15
        });
        this.quadrant1TextFill = this.quadrant1TextFill || this.primaryTextColor;
        this.quadrant2TextFill = this.quadrant2TextFill || (0, $7Mv8O.default)(this.primaryTextColor, {
            r: -5,
            g: -5,
            b: -5
        });
        this.quadrant3TextFill = this.quadrant3TextFill || (0, $7Mv8O.default)(this.primaryTextColor, {
            r: -10,
            g: -10,
            b: -10
        });
        this.quadrant4TextFill = this.quadrant4TextFill || (0, $7Mv8O.default)(this.primaryTextColor, {
            r: -15,
            g: -15,
            b: -15
        });
        this.quadrantPointFill = this.quadrantPointFill || (0, $75Ue8.default)(this.quadrant1Fill) ? (0, $1Ez1E.default)(this.quadrant1Fill) : (0, $c94qS.default)(this.quadrant1Fill);
        this.quadrantPointTextFill = this.quadrantPointTextFill || this.primaryTextColor;
        this.quadrantXAxisTextFill = this.quadrantXAxisTextFill || this.primaryTextColor;
        this.quadrantYAxisTextFill = this.quadrantYAxisTextFill || this.primaryTextColor;
        this.quadrantInternalBorderStrokeFill = this.quadrantInternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantExternalBorderStrokeFill = this.quadrantExternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantTitleFill = this.quadrantTitleFill || this.primaryTextColor;
        this.xyChart = {
            backgroundColor: ((_a = this.xyChart) == null ? void 0 : _a.backgroundColor) || this.background,
            titleColor: ((_b = this.xyChart) == null ? void 0 : _b.titleColor) || this.primaryTextColor,
            xAxisTitleColor: ((_c = this.xyChart) == null ? void 0 : _c.xAxisTitleColor) || this.primaryTextColor,
            xAxisLabelColor: ((_d = this.xyChart) == null ? void 0 : _d.xAxisLabelColor) || this.primaryTextColor,
            xAxisTickColor: ((_e = this.xyChart) == null ? void 0 : _e.xAxisTickColor) || this.primaryTextColor,
            xAxisLineColor: ((_f = this.xyChart) == null ? void 0 : _f.xAxisLineColor) || this.primaryTextColor,
            yAxisTitleColor: ((_g = this.xyChart) == null ? void 0 : _g.yAxisTitleColor) || this.primaryTextColor,
            yAxisLabelColor: ((_h = this.xyChart) == null ? void 0 : _h.yAxisLabelColor) || this.primaryTextColor,
            yAxisTickColor: ((_i = this.xyChart) == null ? void 0 : _i.yAxisTickColor) || this.primaryTextColor,
            yAxisLineColor: ((_j = this.xyChart) == null ? void 0 : _j.yAxisLineColor) || this.primaryTextColor,
            plotColorPalette: ((_k = this.xyChart) == null ? void 0 : _k.plotColorPalette) || "#EEE,#6BB8E4,#8ACB88,#C7ACD6,#E8DCC2,#FFB2A8,#FFF380,#7E8D91,#FFD8B1,#FAF3E0"
        };
        this.requirementBackground = this.requirementBackground || this.primaryColor;
        this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor;
        this.requirementBorderSize = this.requirementBorderSize || "1";
        this.requirementTextColor = this.requirementTextColor || this.primaryTextColor;
        this.relationColor = this.relationColor || this.lineColor;
        this.relationLabelBackground = this.relationLabelBackground || this.edgeLabelBackground;
        this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
        this.git0 = (0, $c94qS.default)(this.pie1, 25) || this.primaryColor;
        this.git1 = this.pie2 || this.secondaryColor;
        this.git2 = this.pie3 || this.tertiaryColor;
        this.git3 = this.pie4 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -30
        });
        this.git4 = this.pie5 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -60
        });
        this.git5 = this.pie6 || (0, $7Mv8O.default)(this.primaryColor, {
            h: -90
        });
        this.git6 = this.pie7 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 60
        });
        this.git7 = this.pie8 || (0, $7Mv8O.default)(this.primaryColor, {
            h: 120
        });
        this.gitInv0 = this.gitInv0 || (0, $1LW8F.default)(this.git0);
        this.gitInv1 = this.gitInv1 || (0, $1LW8F.default)(this.git1);
        this.gitInv2 = this.gitInv2 || (0, $1LW8F.default)(this.git2);
        this.gitInv3 = this.gitInv3 || (0, $1LW8F.default)(this.git3);
        this.gitInv4 = this.gitInv4 || (0, $1LW8F.default)(this.git4);
        this.gitInv5 = this.gitInv5 || (0, $1LW8F.default)(this.git5);
        this.gitInv6 = this.gitInv6 || (0, $1LW8F.default)(this.git6);
        this.gitInv7 = this.gitInv7 || (0, $1LW8F.default)(this.git7);
        this.branchLabelColor = this.branchLabelColor || this.labelTextColor;
        this.gitBranchLabel0 = this.branchLabelColor;
        this.gitBranchLabel1 = "white";
        this.gitBranchLabel2 = this.branchLabelColor;
        this.gitBranchLabel3 = "white";
        this.gitBranchLabel4 = this.branchLabelColor;
        this.gitBranchLabel5 = this.branchLabelColor;
        this.gitBranchLabel6 = this.branchLabelColor;
        this.gitBranchLabel7 = this.branchLabelColor;
        this.tagLabelColor = this.tagLabelColor || this.primaryTextColor;
        this.tagLabelBackground = this.tagLabelBackground || this.primaryColor;
        this.tagLabelBorder = this.tagBorder || this.primaryBorderColor;
        this.tagLabelFontSize = this.tagLabelFontSize || "10px";
        this.commitLabelColor = this.commitLabelColor || this.secondaryTextColor;
        this.commitLabelBackground = this.commitLabelBackground || this.secondaryColor;
        this.commitLabelFontSize = this.commitLabelFontSize || "10px";
        this.attributeBackgroundColorOdd = this.attributeBackgroundColorOdd || $80b3d2f58e77b583$var$oldAttributeBackgroundColorOdd;
        this.attributeBackgroundColorEven = this.attributeBackgroundColorEven || $80b3d2f58e77b583$var$oldAttributeBackgroundColorEven;
    }
    calculate(overrides) {
        if (typeof overrides !== "object") {
            this.updateColors();
            return;
        }
        const keys = Object.keys(overrides);
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
        this.updateColors();
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
    }
}
const $80b3d2f58e77b583$var$getThemeVariables = (userOverrides)=>{
    const theme2 = new $80b3d2f58e77b583$var$Theme5();
    theme2.calculate(userOverrides);
    return theme2;
};
const $80b3d2f58e77b583$var$theme = {
    base: {
        getThemeVariables: $80b3d2f58e77b583$var$getThemeVariables$4
    },
    dark: {
        getThemeVariables: $80b3d2f58e77b583$var$getThemeVariables$3
    },
    default: {
        getThemeVariables: $80b3d2f58e77b583$export$a9c23c6ac3fc3eca
    },
    forest: {
        getThemeVariables: $80b3d2f58e77b583$var$getThemeVariables$1
    },
    neutral: {
        getThemeVariables: $80b3d2f58e77b583$var$getThemeVariables
    }
};
const $80b3d2f58e77b583$var$defaultConfigJson = {
    "flowchart": {
        "useMaxWidth": true,
        "titleTopMargin": 25,
        "subGraphTitleMargin": {
            "top": 0,
            "bottom": 0
        },
        "diagramPadding": 8,
        "htmlLabels": true,
        "nodeSpacing": 50,
        "rankSpacing": 50,
        "curve": "basis",
        "padding": 15,
        "defaultRenderer": "dagre-wrapper",
        "wrappingWidth": 200
    },
    "sequence": {
        "useMaxWidth": true,
        "hideUnusedParticipants": false,
        "activationWidth": 10,
        "diagramMarginX": 50,
        "diagramMarginY": 10,
        "actorMargin": 50,
        "width": 150,
        "height": 65,
        "boxMargin": 10,
        "boxTextMargin": 5,
        "noteMargin": 10,
        "messageMargin": 35,
        "messageAlign": "center",
        "mirrorActors": true,
        "forceMenus": false,
        "bottomMarginAdj": 1,
        "rightAngles": false,
        "showSequenceNumbers": false,
        "actorFontSize": 14,
        "actorFontFamily": '"Open Sans", sans-serif',
        "actorFontWeight": 400,
        "noteFontSize": 14,
        "noteFontFamily": '"trebuchet ms", verdana, arial, sans-serif',
        "noteFontWeight": 400,
        "noteAlign": "center",
        "messageFontSize": 16,
        "messageFontFamily": '"trebuchet ms", verdana, arial, sans-serif',
        "messageFontWeight": 400,
        "wrap": false,
        "wrapPadding": 10,
        "labelBoxWidth": 50,
        "labelBoxHeight": 20
    },
    "gantt": {
        "useMaxWidth": true,
        "titleTopMargin": 25,
        "barHeight": 20,
        "barGap": 4,
        "topPadding": 50,
        "rightPadding": 75,
        "leftPadding": 75,
        "gridLineStartPadding": 35,
        "fontSize": 11,
        "sectionFontSize": 11,
        "numberSectionStyles": 4,
        "axisFormat": "%Y-%m-%d",
        "topAxis": false,
        "displayMode": "",
        "weekday": "sunday"
    },
    "journey": {
        "useMaxWidth": true,
        "diagramMarginX": 50,
        "diagramMarginY": 10,
        "leftMargin": 150,
        "width": 150,
        "height": 50,
        "boxMargin": 10,
        "boxTextMargin": 5,
        "noteMargin": 10,
        "messageMargin": 35,
        "messageAlign": "center",
        "bottomMarginAdj": 1,
        "rightAngles": false,
        "taskFontSize": 14,
        "taskFontFamily": '"Open Sans", sans-serif',
        "taskMargin": 50,
        "activationWidth": 10,
        "textPlacement": "fo",
        "actorColours": [
            "#8FBC8F",
            "#7CFC00",
            "#00FFFF",
            "#20B2AA",
            "#B0E0E6",
            "#FFFFE0"
        ],
        "sectionFills": [
            "#191970",
            "#8B008B",
            "#4B0082",
            "#2F4F4F",
            "#800000",
            "#8B4513",
            "#00008B"
        ],
        "sectionColours": [
            "#fff"
        ]
    },
    "class": {
        "useMaxWidth": true,
        "titleTopMargin": 25,
        "arrowMarkerAbsolute": false,
        "dividerMargin": 10,
        "padding": 5,
        "textHeight": 10,
        "defaultRenderer": "dagre-wrapper",
        "htmlLabels": false
    },
    "state": {
        "useMaxWidth": true,
        "titleTopMargin": 25,
        "dividerMargin": 10,
        "sizeUnit": 5,
        "padding": 8,
        "textHeight": 10,
        "titleShift": -15,
        "noteMargin": 10,
        "forkWidth": 70,
        "forkHeight": 7,
        "miniPadding": 2,
        "fontSizeFactor": 5.02,
        "fontSize": 24,
        "labelHeight": 16,
        "edgeLengthFactor": "20",
        "compositTitleSize": 35,
        "radius": 5,
        "defaultRenderer": "dagre-wrapper"
    },
    "er": {
        "useMaxWidth": true,
        "titleTopMargin": 25,
        "diagramPadding": 20,
        "layoutDirection": "TB",
        "minEntityWidth": 100,
        "minEntityHeight": 75,
        "entityPadding": 15,
        "stroke": "gray",
        "fill": "honeydew",
        "fontSize": 12
    },
    "pie": {
        "useMaxWidth": true,
        "textPosition": 0.75
    },
    "quadrantChart": {
        "useMaxWidth": true,
        "chartWidth": 500,
        "chartHeight": 500,
        "titleFontSize": 20,
        "titlePadding": 10,
        "quadrantPadding": 5,
        "xAxisLabelPadding": 5,
        "yAxisLabelPadding": 5,
        "xAxisLabelFontSize": 16,
        "yAxisLabelFontSize": 16,
        "quadrantLabelFontSize": 16,
        "quadrantTextTopPadding": 5,
        "pointTextPadding": 5,
        "pointLabelFontSize": 12,
        "pointRadius": 5,
        "xAxisPosition": "top",
        "yAxisPosition": "left",
        "quadrantInternalBorderStrokeWidth": 1,
        "quadrantExternalBorderStrokeWidth": 2
    },
    "xyChart": {
        "useMaxWidth": true,
        "width": 700,
        "height": 500,
        "titleFontSize": 20,
        "titlePadding": 10,
        "showTitle": true,
        "xAxis": {
            "$ref": "#/$defs/XYChartAxisConfig",
            "showLabel": true,
            "labelFontSize": 14,
            "labelPadding": 5,
            "showTitle": true,
            "titleFontSize": 16,
            "titlePadding": 5,
            "showTick": true,
            "tickLength": 5,
            "tickWidth": 2,
            "showAxisLine": true,
            "axisLineWidth": 2
        },
        "yAxis": {
            "$ref": "#/$defs/XYChartAxisConfig",
            "showLabel": true,
            "labelFontSize": 14,
            "labelPadding": 5,
            "showTitle": true,
            "titleFontSize": 16,
            "titlePadding": 5,
            "showTick": true,
            "tickLength": 5,
            "tickWidth": 2,
            "showAxisLine": true,
            "axisLineWidth": 2
        },
        "chartOrientation": "vertical",
        "plotReservedSpacePercent": 50
    },
    "requirement": {
        "useMaxWidth": true,
        "rect_fill": "#f9f9f9",
        "text_color": "#333",
        "rect_border_size": "0.5px",
        "rect_border_color": "#bbb",
        "rect_min_width": 200,
        "rect_min_height": 200,
        "fontSize": 14,
        "rect_padding": 10,
        "line_height": 20
    },
    "mindmap": {
        "useMaxWidth": true,
        "padding": 10,
        "maxNodeWidth": 200
    },
    "timeline": {
        "useMaxWidth": true,
        "diagramMarginX": 50,
        "diagramMarginY": 10,
        "leftMargin": 150,
        "width": 150,
        "height": 50,
        "boxMargin": 10,
        "boxTextMargin": 5,
        "noteMargin": 10,
        "messageMargin": 35,
        "messageAlign": "center",
        "bottomMarginAdj": 1,
        "rightAngles": false,
        "taskFontSize": 14,
        "taskFontFamily": '"Open Sans", sans-serif',
        "taskMargin": 50,
        "activationWidth": 10,
        "textPlacement": "fo",
        "actorColours": [
            "#8FBC8F",
            "#7CFC00",
            "#00FFFF",
            "#20B2AA",
            "#B0E0E6",
            "#FFFFE0"
        ],
        "sectionFills": [
            "#191970",
            "#8B008B",
            "#4B0082",
            "#2F4F4F",
            "#800000",
            "#8B4513",
            "#00008B"
        ],
        "sectionColours": [
            "#fff"
        ],
        "disableMulticolor": false
    },
    "gitGraph": {
        "useMaxWidth": true,
        "titleTopMargin": 25,
        "diagramPadding": 8,
        "nodeLabel": {
            "width": 75,
            "height": 100,
            "x": -25,
            "y": 0
        },
        "mainBranchName": "main",
        "mainBranchOrder": 0,
        "showCommitLabel": true,
        "showBranches": true,
        "rotateCommitLabel": true,
        "parallelCommits": false,
        "arrowMarkerAbsolute": false
    },
    "c4": {
        "useMaxWidth": true,
        "diagramMarginX": 50,
        "diagramMarginY": 10,
        "c4ShapeMargin": 50,
        "c4ShapePadding": 20,
        "width": 216,
        "height": 60,
        "boxMargin": 10,
        "c4ShapeInRow": 4,
        "nextLinePaddingX": 0,
        "c4BoundaryInRow": 2,
        "personFontSize": 14,
        "personFontFamily": '"Open Sans", sans-serif',
        "personFontWeight": "normal",
        "external_personFontSize": 14,
        "external_personFontFamily": '"Open Sans", sans-serif',
        "external_personFontWeight": "normal",
        "systemFontSize": 14,
        "systemFontFamily": '"Open Sans", sans-serif',
        "systemFontWeight": "normal",
        "external_systemFontSize": 14,
        "external_systemFontFamily": '"Open Sans", sans-serif',
        "external_systemFontWeight": "normal",
        "system_dbFontSize": 14,
        "system_dbFontFamily": '"Open Sans", sans-serif',
        "system_dbFontWeight": "normal",
        "external_system_dbFontSize": 14,
        "external_system_dbFontFamily": '"Open Sans", sans-serif',
        "external_system_dbFontWeight": "normal",
        "system_queueFontSize": 14,
        "system_queueFontFamily": '"Open Sans", sans-serif',
        "system_queueFontWeight": "normal",
        "external_system_queueFontSize": 14,
        "external_system_queueFontFamily": '"Open Sans", sans-serif',
        "external_system_queueFontWeight": "normal",
        "boundaryFontSize": 14,
        "boundaryFontFamily": '"Open Sans", sans-serif',
        "boundaryFontWeight": "normal",
        "messageFontSize": 12,
        "messageFontFamily": '"Open Sans", sans-serif',
        "messageFontWeight": "normal",
        "containerFontSize": 14,
        "containerFontFamily": '"Open Sans", sans-serif',
        "containerFontWeight": "normal",
        "external_containerFontSize": 14,
        "external_containerFontFamily": '"Open Sans", sans-serif',
        "external_containerFontWeight": "normal",
        "container_dbFontSize": 14,
        "container_dbFontFamily": '"Open Sans", sans-serif',
        "container_dbFontWeight": "normal",
        "external_container_dbFontSize": 14,
        "external_container_dbFontFamily": '"Open Sans", sans-serif',
        "external_container_dbFontWeight": "normal",
        "container_queueFontSize": 14,
        "container_queueFontFamily": '"Open Sans", sans-serif',
        "container_queueFontWeight": "normal",
        "external_container_queueFontSize": 14,
        "external_container_queueFontFamily": '"Open Sans", sans-serif',
        "external_container_queueFontWeight": "normal",
        "componentFontSize": 14,
        "componentFontFamily": '"Open Sans", sans-serif',
        "componentFontWeight": "normal",
        "external_componentFontSize": 14,
        "external_componentFontFamily": '"Open Sans", sans-serif',
        "external_componentFontWeight": "normal",
        "component_dbFontSize": 14,
        "component_dbFontFamily": '"Open Sans", sans-serif',
        "component_dbFontWeight": "normal",
        "external_component_dbFontSize": 14,
        "external_component_dbFontFamily": '"Open Sans", sans-serif',
        "external_component_dbFontWeight": "normal",
        "component_queueFontSize": 14,
        "component_queueFontFamily": '"Open Sans", sans-serif',
        "component_queueFontWeight": "normal",
        "external_component_queueFontSize": 14,
        "external_component_queueFontFamily": '"Open Sans", sans-serif',
        "external_component_queueFontWeight": "normal",
        "wrap": true,
        "wrapPadding": 10,
        "person_bg_color": "#08427B",
        "person_border_color": "#073B6F",
        "external_person_bg_color": "#686868",
        "external_person_border_color": "#8A8A8A",
        "system_bg_color": "#1168BD",
        "system_border_color": "#3C7FC0",
        "system_db_bg_color": "#1168BD",
        "system_db_border_color": "#3C7FC0",
        "system_queue_bg_color": "#1168BD",
        "system_queue_border_color": "#3C7FC0",
        "external_system_bg_color": "#999999",
        "external_system_border_color": "#8A8A8A",
        "external_system_db_bg_color": "#999999",
        "external_system_db_border_color": "#8A8A8A",
        "external_system_queue_bg_color": "#999999",
        "external_system_queue_border_color": "#8A8A8A",
        "container_bg_color": "#438DD5",
        "container_border_color": "#3C7FC0",
        "container_db_bg_color": "#438DD5",
        "container_db_border_color": "#3C7FC0",
        "container_queue_bg_color": "#438DD5",
        "container_queue_border_color": "#3C7FC0",
        "external_container_bg_color": "#B3B3B3",
        "external_container_border_color": "#A6A6A6",
        "external_container_db_bg_color": "#B3B3B3",
        "external_container_db_border_color": "#A6A6A6",
        "external_container_queue_bg_color": "#B3B3B3",
        "external_container_queue_border_color": "#A6A6A6",
        "component_bg_color": "#85BBF0",
        "component_border_color": "#78A8D8",
        "component_db_bg_color": "#85BBF0",
        "component_db_border_color": "#78A8D8",
        "component_queue_bg_color": "#85BBF0",
        "component_queue_border_color": "#78A8D8",
        "external_component_bg_color": "#CCCCCC",
        "external_component_border_color": "#BFBFBF",
        "external_component_db_bg_color": "#CCCCCC",
        "external_component_db_border_color": "#BFBFBF",
        "external_component_queue_bg_color": "#CCCCCC",
        "external_component_queue_border_color": "#BFBFBF"
    },
    "sankey": {
        "useMaxWidth": true,
        "width": 600,
        "height": 400,
        "linkColor": "gradient",
        "nodeAlignment": "justify",
        "showValues": true,
        "prefix": "",
        "suffix": ""
    },
    "block": {
        "useMaxWidth": true,
        "padding": 8
    },
    "theme": "default",
    "maxTextSize": 5e4,
    "maxEdges": 500,
    "darkMode": false,
    "fontFamily": '"trebuchet ms", verdana, arial, sans-serif;',
    "logLevel": 5,
    "securityLevel": "strict",
    "startOnLoad": true,
    "arrowMarkerAbsolute": false,
    "secure": [
        "secure",
        "securityLevel",
        "startOnLoad",
        "maxTextSize",
        "maxEdges"
    ],
    "legacyMathML": false,
    "deterministicIds": false,
    "fontSize": 16
};
const $80b3d2f58e77b583$var$config = {
    ...$80b3d2f58e77b583$var$defaultConfigJson,
    // Set, even though they're `undefined` so that `configKeys` finds these keys
    // TODO: Should we replace these with `null` so that they can go in the JSON Schema?
    deterministicIDSeed: void 0,
    themeCSS: void 0,
    // add non-JSON default config values
    themeVariables: $80b3d2f58e77b583$var$theme["default"].getThemeVariables(),
    sequence: {
        ...$80b3d2f58e77b583$var$defaultConfigJson.sequence,
        messageFont: function() {
            return {
                fontFamily: this.messageFontFamily,
                fontSize: this.messageFontSize,
                fontWeight: this.messageFontWeight
            };
        },
        noteFont: function() {
            return {
                fontFamily: this.noteFontFamily,
                fontSize: this.noteFontSize,
                fontWeight: this.noteFontWeight
            };
        },
        actorFont: function() {
            return {
                fontFamily: this.actorFontFamily,
                fontSize: this.actorFontSize,
                fontWeight: this.actorFontWeight
            };
        }
    },
    gantt: {
        ...$80b3d2f58e77b583$var$defaultConfigJson.gantt,
        tickInterval: void 0,
        useWidth: void 0
    },
    c4: {
        ...$80b3d2f58e77b583$var$defaultConfigJson.c4,
        useWidth: void 0,
        personFont: function() {
            return {
                fontFamily: this.personFontFamily,
                fontSize: this.personFontSize,
                fontWeight: this.personFontWeight
            };
        },
        external_personFont: function() {
            return {
                fontFamily: this.external_personFontFamily,
                fontSize: this.external_personFontSize,
                fontWeight: this.external_personFontWeight
            };
        },
        systemFont: function() {
            return {
                fontFamily: this.systemFontFamily,
                fontSize: this.systemFontSize,
                fontWeight: this.systemFontWeight
            };
        },
        external_systemFont: function() {
            return {
                fontFamily: this.external_systemFontFamily,
                fontSize: this.external_systemFontSize,
                fontWeight: this.external_systemFontWeight
            };
        },
        system_dbFont: function() {
            return {
                fontFamily: this.system_dbFontFamily,
                fontSize: this.system_dbFontSize,
                fontWeight: this.system_dbFontWeight
            };
        },
        external_system_dbFont: function() {
            return {
                fontFamily: this.external_system_dbFontFamily,
                fontSize: this.external_system_dbFontSize,
                fontWeight: this.external_system_dbFontWeight
            };
        },
        system_queueFont: function() {
            return {
                fontFamily: this.system_queueFontFamily,
                fontSize: this.system_queueFontSize,
                fontWeight: this.system_queueFontWeight
            };
        },
        external_system_queueFont: function() {
            return {
                fontFamily: this.external_system_queueFontFamily,
                fontSize: this.external_system_queueFontSize,
                fontWeight: this.external_system_queueFontWeight
            };
        },
        containerFont: function() {
            return {
                fontFamily: this.containerFontFamily,
                fontSize: this.containerFontSize,
                fontWeight: this.containerFontWeight
            };
        },
        external_containerFont: function() {
            return {
                fontFamily: this.external_containerFontFamily,
                fontSize: this.external_containerFontSize,
                fontWeight: this.external_containerFontWeight
            };
        },
        container_dbFont: function() {
            return {
                fontFamily: this.container_dbFontFamily,
                fontSize: this.container_dbFontSize,
                fontWeight: this.container_dbFontWeight
            };
        },
        external_container_dbFont: function() {
            return {
                fontFamily: this.external_container_dbFontFamily,
                fontSize: this.external_container_dbFontSize,
                fontWeight: this.external_container_dbFontWeight
            };
        },
        container_queueFont: function() {
            return {
                fontFamily: this.container_queueFontFamily,
                fontSize: this.container_queueFontSize,
                fontWeight: this.container_queueFontWeight
            };
        },
        external_container_queueFont: function() {
            return {
                fontFamily: this.external_container_queueFontFamily,
                fontSize: this.external_container_queueFontSize,
                fontWeight: this.external_container_queueFontWeight
            };
        },
        componentFont: function() {
            return {
                fontFamily: this.componentFontFamily,
                fontSize: this.componentFontSize,
                fontWeight: this.componentFontWeight
            };
        },
        external_componentFont: function() {
            return {
                fontFamily: this.external_componentFontFamily,
                fontSize: this.external_componentFontSize,
                fontWeight: this.external_componentFontWeight
            };
        },
        component_dbFont: function() {
            return {
                fontFamily: this.component_dbFontFamily,
                fontSize: this.component_dbFontSize,
                fontWeight: this.component_dbFontWeight
            };
        },
        external_component_dbFont: function() {
            return {
                fontFamily: this.external_component_dbFontFamily,
                fontSize: this.external_component_dbFontSize,
                fontWeight: this.external_component_dbFontWeight
            };
        },
        component_queueFont: function() {
            return {
                fontFamily: this.component_queueFontFamily,
                fontSize: this.component_queueFontSize,
                fontWeight: this.component_queueFontWeight
            };
        },
        external_component_queueFont: function() {
            return {
                fontFamily: this.external_component_queueFontFamily,
                fontSize: this.external_component_queueFontSize,
                fontWeight: this.external_component_queueFontWeight
            };
        },
        boundaryFont: function() {
            return {
                fontFamily: this.boundaryFontFamily,
                fontSize: this.boundaryFontSize,
                fontWeight: this.boundaryFontWeight
            };
        },
        messageFont: function() {
            return {
                fontFamily: this.messageFontFamily,
                fontSize: this.messageFontSize,
                fontWeight: this.messageFontWeight
            };
        }
    },
    pie: {
        ...$80b3d2f58e77b583$var$defaultConfigJson.pie,
        useWidth: 984
    },
    xyChart: {
        ...$80b3d2f58e77b583$var$defaultConfigJson.xyChart,
        useWidth: void 0
    },
    requirement: {
        ...$80b3d2f58e77b583$var$defaultConfigJson.requirement,
        useWidth: void 0
    },
    gitGraph: {
        ...$80b3d2f58e77b583$var$defaultConfigJson.gitGraph,
        // TODO: This is a temporary override for `gitGraph`, since every other
        //       diagram does have `useMaxWidth`, but instead sets it to `true`.
        //       Should we set this to `true` instead?
        useMaxWidth: false
    },
    sankey: {
        ...$80b3d2f58e77b583$var$defaultConfigJson.sankey,
        // this is false, unlike every other diagram (other than gitGraph)
        // TODO: can we make this default to `true` instead?
        useMaxWidth: false
    }
};
const $80b3d2f58e77b583$var$keyify = (obj, prefix = "")=>Object.keys(obj).reduce((res, el)=>{
        if (Array.isArray(obj[el])) return res;
        else if (typeof obj[el] === "object" && obj[el] !== null) return [
            ...res,
            prefix + el,
            ...$80b3d2f58e77b583$var$keyify(obj[el], "")
        ];
        return [
            ...res,
            prefix + el
        ];
    }, []);
const $80b3d2f58e77b583$var$configKeys = new Set($80b3d2f58e77b583$var$keyify($80b3d2f58e77b583$var$config, ""));
const $80b3d2f58e77b583$export$ef35774e6d314e91 = $80b3d2f58e77b583$var$config;
const $80b3d2f58e77b583$var$sanitizeDirective = (args)=>{
    $80b3d2f58e77b583$export$882b5998b3b9117c.debug("sanitizeDirective called with", args);
    if (typeof args !== "object" || args == null) return;
    if (Array.isArray(args)) {
        args.forEach((arg)=>$80b3d2f58e77b583$var$sanitizeDirective(arg));
        return;
    }
    for (const key of Object.keys(args)){
        $80b3d2f58e77b583$export$882b5998b3b9117c.debug("Checking key", key);
        if (key.startsWith("__") || key.includes("proto") || key.includes("constr") || !$80b3d2f58e77b583$var$configKeys.has(key) || args[key] == null) {
            $80b3d2f58e77b583$export$882b5998b3b9117c.debug("sanitize deleting key: ", key);
            delete args[key];
            continue;
        }
        if (typeof args[key] === "object") {
            $80b3d2f58e77b583$export$882b5998b3b9117c.debug("sanitizing object", key);
            $80b3d2f58e77b583$var$sanitizeDirective(args[key]);
            continue;
        }
        const cssMatchers = [
            "themeCSS",
            "fontFamily",
            "altFontFamily"
        ];
        for (const cssKey of cssMatchers)if (key.includes(cssKey)) {
            $80b3d2f58e77b583$export$882b5998b3b9117c.debug("sanitizing css option", key);
            args[key] = $80b3d2f58e77b583$var$sanitizeCss(args[key]);
        }
    }
    if (args.themeVariables) for (const k of Object.keys(args.themeVariables)){
        const val = args.themeVariables[k];
        if ((val == null ? void 0 : val.match) && !val.match(/^[\d "#%(),.;A-Za-z]+$/)) args.themeVariables[k] = "";
    }
    $80b3d2f58e77b583$export$882b5998b3b9117c.debug("After sanitization", args);
};
const $80b3d2f58e77b583$var$sanitizeCss = (str2)=>{
    let startCnt = 0;
    let endCnt = 0;
    for (const element of str2){
        if (startCnt < endCnt) return "{ /* ERROR: Unbalanced CSS */ }";
        if (element === "{") startCnt++;
        else if (element === "}") endCnt++;
    }
    if (startCnt !== endCnt) return "{ /* ERROR: Unbalanced CSS */ }";
    return str2;
};
const $80b3d2f58e77b583$var$frontMatterRegex = /^-{3}\s*[\n\r](.*?)[\n\r]-{3}\s*[\n\r]+/s;
const $80b3d2f58e77b583$var$directiveRegex = /%{2}{\s*(?:(\w+)\s*:|(\w+))\s*(?:(\w+)|((?:(?!}%{2}).|\r?\n)*))?\s*(?:}%{2})?/gi;
const $80b3d2f58e77b583$var$anyCommentRegex = /\s*%%.*\n/gm;
class $80b3d2f58e77b583$var$UnknownDiagramError extends Error {
    constructor(message){
        super(message);
        this.name = "UnknownDiagramError";
    }
}
const $80b3d2f58e77b583$var$detectors = {};
const $80b3d2f58e77b583$var$detectType = function(text, config2) {
    text = text.replace($80b3d2f58e77b583$var$frontMatterRegex, "").replace($80b3d2f58e77b583$var$directiveRegex, "").replace($80b3d2f58e77b583$var$anyCommentRegex, "\n");
    for (const [key, { detector: detector2 }] of Object.entries($80b3d2f58e77b583$var$detectors)){
        const diagram2 = detector2(text, config2);
        if (diagram2) return key;
    }
    throw new $80b3d2f58e77b583$var$UnknownDiagramError(`No diagram type detected matching given configuration for text: ${text}`);
};
const $80b3d2f58e77b583$var$registerLazyLoadedDiagrams = (...diagrams2)=>{
    for (const { id: id2, detector: detector2, loader: loader2 } of diagrams2)$80b3d2f58e77b583$var$addDetector(id2, detector2, loader2);
};
const $80b3d2f58e77b583$var$addDetector = (key, detector2, loader2)=>{
    if ($80b3d2f58e77b583$var$detectors[key]) $80b3d2f58e77b583$export$882b5998b3b9117c.error(`Detector with key ${key} already exists`);
    else $80b3d2f58e77b583$var$detectors[key] = {
        detector: detector2,
        loader: loader2
    };
    $80b3d2f58e77b583$export$882b5998b3b9117c.debug(`Detector with key ${key} added${loader2 ? " with loader" : ""}`);
};
const $80b3d2f58e77b583$var$getDiagramLoader = (key)=>{
    return $80b3d2f58e77b583$var$detectors[key].loader;
};
const $80b3d2f58e77b583$var$assignWithDepth = (dst, src, { depth: depth = 2, clobber: clobber = false } = {})=>{
    const config2 = {
        depth: depth,
        clobber: clobber
    };
    if (Array.isArray(src) && !Array.isArray(dst)) {
        src.forEach((s)=>$80b3d2f58e77b583$var$assignWithDepth(dst, s, config2));
        return dst;
    } else if (Array.isArray(src) && Array.isArray(dst)) {
        src.forEach((s)=>{
            if (!dst.includes(s)) dst.push(s);
        });
        return dst;
    }
    if (dst === void 0 || depth <= 0) {
        if (dst !== void 0 && dst !== null && typeof dst === "object" && typeof src === "object") return Object.assign(dst, src);
        else return src;
    }
    if (src !== void 0 && typeof dst === "object" && typeof src === "object") Object.keys(src).forEach((key)=>{
        if (typeof src[key] === "object" && (dst[key] === void 0 || typeof dst[key] === "object")) {
            if (dst[key] === void 0) dst[key] = Array.isArray(src[key]) ? [] : {};
            dst[key] = $80b3d2f58e77b583$var$assignWithDepth(dst[key], src[key], {
                depth: depth - 1,
                clobber: clobber
            });
        } else if (clobber || typeof dst[key] !== "object" && typeof src[key] !== "object") dst[key] = src[key];
    });
    return dst;
};
const $80b3d2f58e77b583$export$2d1720544b23b823 = $80b3d2f58e77b583$var$assignWithDepth;
const $80b3d2f58e77b583$export$dc98b0b04f4c7758 = "\u200B";
const $80b3d2f58e77b583$var$d3CurveTypes = {
    curveBasis: $6QL1t.default,
    curveBasisClosed: $2515N.default,
    curveBasisOpen: $e1bEB.default,
    curveBumpX: $gpIrV.bumpX,
    curveBumpY: $gpIrV.bumpY,
    curveBundle: $l8Mye.default,
    curveCardinalClosed: $9XrSP.default,
    curveCardinalOpen: $dUIyz.default,
    curveCardinal: $hga9n.default,
    curveCatmullRomClosed: $loyNQ.default,
    curveCatmullRomOpen: $4tc8L.default,
    curveCatmullRom: $6FEsA.default,
    curveLinear: $gEcf1.default,
    curveLinearClosed: $4CT3t.default,
    curveMonotoneX: $hp3ls.monotoneX,
    curveMonotoneY: $hp3ls.monotoneY,
    curveNatural: $kjPWc.default,
    curveStep: $1zRZO.default,
    curveStepAfter: $1zRZO.stepAfter,
    curveStepBefore: $1zRZO.stepBefore
};
const $80b3d2f58e77b583$var$directiveWithoutOpen = /\s*(?:(\w+)(?=:):|(\w+))\s*(?:(\w+)|((?:(?!}%{2}).|\r?\n)*))?\s*(?:}%{2})?/gi;
const $80b3d2f58e77b583$var$detectInit = function(text, config2) {
    const inits = $80b3d2f58e77b583$var$detectDirective(text, /(?:init\b)|(?:initialize\b)/);
    let results = {};
    if (Array.isArray(inits)) {
        const args = inits.map((init2)=>init2.args);
        $80b3d2f58e77b583$var$sanitizeDirective(args);
        results = $80b3d2f58e77b583$export$2d1720544b23b823(results, [
            ...args
        ]);
    } else results = inits.args;
    if (!results) return;
    let type2 = $80b3d2f58e77b583$var$detectType(text, config2);
    const prop = "config";
    if (results[prop] !== void 0) {
        if (type2 === "flowchart-v2") type2 = "flowchart";
        results[type2] = results[prop];
        delete results[prop];
    }
    return results;
};
const $80b3d2f58e77b583$var$detectDirective = function(text, type2 = null) {
    try {
        const commentWithoutDirectives = new RegExp(`[%]{2}(?![{]${$80b3d2f58e77b583$var$directiveWithoutOpen.source})(?=[}][%]{2}).*
`, "ig");
        text = text.trim().replace(commentWithoutDirectives, "").replace(/'/gm, '"');
        $80b3d2f58e77b583$export$882b5998b3b9117c.debug(`Detecting diagram directive${type2 !== null ? " type:" + type2 : ""} based on the text:${text}`);
        let match;
        const result = [];
        while((match = $80b3d2f58e77b583$var$directiveRegex.exec(text)) !== null){
            if (match.index === $80b3d2f58e77b583$var$directiveRegex.lastIndex) $80b3d2f58e77b583$var$directiveRegex.lastIndex++;
            if (match && !type2 || type2 && match[1] && match[1].match(type2) || type2 && match[2] && match[2].match(type2)) {
                const type22 = match[1] ? match[1] : match[2];
                const args = match[3] ? match[3].trim() : match[4] ? JSON.parse(match[4].trim()) : null;
                result.push({
                    type: type22,
                    args: args
                });
            }
        }
        if (result.length === 0) return {
            type: text,
            args: null
        };
        return result.length === 1 ? result[0] : result;
    } catch (error) {
        $80b3d2f58e77b583$export$882b5998b3b9117c.error(`ERROR: ${error.message} - Unable to parse directive type: '${type2}' based on the text: '${text}'`);
        return {
            type: void 0,
            args: null
        };
    }
};
const $80b3d2f58e77b583$var$removeDirectives = function(text) {
    return text.replace($80b3d2f58e77b583$var$directiveRegex, "");
};
const $80b3d2f58e77b583$var$isSubstringInArray = function(str2, arr) {
    for (const [i, element] of arr.entries()){
        if (element.match(str2)) return i;
    }
    return -1;
};
function $80b3d2f58e77b583$export$7ccc53e8f1e7dfc5(interpolate, defaultCurve) {
    if (!interpolate) return defaultCurve;
    const curveName = `curve${interpolate.charAt(0).toUpperCase() + interpolate.slice(1)}`;
    return $80b3d2f58e77b583$var$d3CurveTypes[curveName] ?? defaultCurve;
}
function $80b3d2f58e77b583$var$formatUrl(linkStr, config2) {
    const url = linkStr.trim();
    if (!url) return void 0;
    if (config2.securityLevel !== "loose") return (0, $2ujND.sanitizeUrl)(url);
    return url;
}
const $80b3d2f58e77b583$var$runFunc = (functionName, ...params)=>{
    const arrPaths = functionName.split(".");
    const len = arrPaths.length - 1;
    const fnName = arrPaths[len];
    let obj = window;
    for(let i = 0; i < len; i++){
        obj = obj[arrPaths[i]];
        if (!obj) {
            $80b3d2f58e77b583$export$882b5998b3b9117c.error(`Function name: ${functionName} not found in window`);
            return;
        }
    }
    obj[fnName](...params);
};
function $80b3d2f58e77b583$var$distance(p1, p2) {
    if (!p1 || !p2) return 0;
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}
function $80b3d2f58e77b583$var$traverseEdge(points) {
    let prevPoint;
    let totalDistance = 0;
    points.forEach((point)=>{
        totalDistance += $80b3d2f58e77b583$var$distance(point, prevPoint);
        prevPoint = point;
    });
    const remainingDistance = totalDistance / 2;
    return $80b3d2f58e77b583$var$calculatePoint(points, remainingDistance);
}
function $80b3d2f58e77b583$var$calcLabelPosition(points) {
    if (points.length === 1) return points[0];
    return $80b3d2f58e77b583$var$traverseEdge(points);
}
const $80b3d2f58e77b583$var$roundNumber = (num, precision = 2)=>{
    const factor = Math.pow(10, precision);
    return Math.round(num * factor) / factor;
};
const $80b3d2f58e77b583$var$calculatePoint = (points, distanceToTraverse)=>{
    let prevPoint = void 0;
    let remainingDistance = distanceToTraverse;
    for (const point of points){
        if (prevPoint) {
            const vectorDistance = $80b3d2f58e77b583$var$distance(point, prevPoint);
            if (vectorDistance < remainingDistance) remainingDistance -= vectorDistance;
            else {
                const distanceRatio = remainingDistance / vectorDistance;
                if (distanceRatio <= 0) return prevPoint;
                if (distanceRatio >= 1) return {
                    x: point.x,
                    y: point.y
                };
                if (distanceRatio > 0 && distanceRatio < 1) return {
                    x: $80b3d2f58e77b583$var$roundNumber((1 - distanceRatio) * prevPoint.x + distanceRatio * point.x, 5),
                    y: $80b3d2f58e77b583$var$roundNumber((1 - distanceRatio) * prevPoint.y + distanceRatio * point.y, 5)
                };
            }
        }
        prevPoint = point;
    }
    throw new Error("Could not find a suitable point for the given distance");
};
const $80b3d2f58e77b583$var$calcCardinalityPosition = (isRelationTypePresent, points, initialPosition)=>{
    $80b3d2f58e77b583$export$882b5998b3b9117c.info(`our points ${JSON.stringify(points)}`);
    if (points[0] !== initialPosition) points = points.reverse();
    const distanceToCardinalityPoint = 25;
    const center = $80b3d2f58e77b583$var$calculatePoint(points, distanceToCardinalityPoint);
    const d = isRelationTypePresent ? 10 : 5;
    const angle = Math.atan2(points[0].y - center.y, points[0].x - center.x);
    const cardinalityPosition = {
        x: 0,
        y: 0
    };
    cardinalityPosition.x = Math.sin(angle) * d + (points[0].x + center.x) / 2;
    cardinalityPosition.y = -Math.cos(angle) * d + (points[0].y + center.y) / 2;
    return cardinalityPosition;
};
function $80b3d2f58e77b583$var$calcTerminalLabelPosition(terminalMarkerSize, position, _points) {
    const points = structuredClone(_points);
    $80b3d2f58e77b583$export$882b5998b3b9117c.info("our points", points);
    if (position !== "start_left" && position !== "start_right") points.reverse();
    const distanceToCardinalityPoint = 25 + terminalMarkerSize;
    const center = $80b3d2f58e77b583$var$calculatePoint(points, distanceToCardinalityPoint);
    const d = 10 + terminalMarkerSize * 0.5;
    const angle = Math.atan2(points[0].y - center.y, points[0].x - center.x);
    const cardinalityPosition = {
        x: 0,
        y: 0
    };
    if (position === "start_left") {
        cardinalityPosition.x = Math.sin(angle + Math.PI) * d + (points[0].x + center.x) / 2;
        cardinalityPosition.y = -Math.cos(angle + Math.PI) * d + (points[0].y + center.y) / 2;
    } else if (position === "end_right") {
        cardinalityPosition.x = Math.sin(angle - Math.PI) * d + (points[0].x + center.x) / 2 - 5;
        cardinalityPosition.y = -Math.cos(angle - Math.PI) * d + (points[0].y + center.y) / 2 - 5;
    } else if (position === "end_left") {
        cardinalityPosition.x = Math.sin(angle) * d + (points[0].x + center.x) / 2 - 5;
        cardinalityPosition.y = -Math.cos(angle) * d + (points[0].y + center.y) / 2 - 5;
    } else {
        cardinalityPosition.x = Math.sin(angle) * d + (points[0].x + center.x) / 2;
        cardinalityPosition.y = -Math.cos(angle) * d + (points[0].y + center.y) / 2;
    }
    return cardinalityPosition;
}
function $80b3d2f58e77b583$export$342063e11d6c3cad(arr) {
    let style = "";
    let labelStyle = "";
    for (const element of arr)if (element !== void 0) {
        if (element.startsWith("color:") || element.startsWith("text-align:")) labelStyle = labelStyle + element + ";";
        else style = style + element + ";";
    }
    return {
        style: style,
        labelStyle: labelStyle
    };
}
let $80b3d2f58e77b583$var$cnt = 0;
const $80b3d2f58e77b583$export$9bb611d729802a56 = ()=>{
    $80b3d2f58e77b583$var$cnt++;
    return "id-" + Math.random().toString(36).substr(2, 12) + "-" + $80b3d2f58e77b583$var$cnt;
};
function $80b3d2f58e77b583$var$makeRandomHex(length) {
    let result = "";
    const characters = "0123456789abcdef";
    const charactersLength = characters.length;
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * charactersLength));
    return result;
}
const $80b3d2f58e77b583$export$4a5767248b18ef41 = (options)=>{
    return $80b3d2f58e77b583$var$makeRandomHex(options.length);
};
const $80b3d2f58e77b583$var$getTextObj = function() {
    return {
        x: 0,
        y: 0,
        fill: void 0,
        anchor: "start",
        style: "#666",
        width: 100,
        height: 100,
        textMargin: 0,
        rx: 0,
        ry: 0,
        valign: void 0,
        text: ""
    };
};
const $80b3d2f58e77b583$var$drawSimpleText = function(elem, textData) {
    const nText = textData.text.replace($80b3d2f58e77b583$export$f1e1789686576879.lineBreakRegex, " ");
    const [, _fontSizePx] = $80b3d2f58e77b583$export$96f57966bedc81b4(textData.fontSize);
    const textElem = elem.append("text");
    textElem.attr("x", textData.x);
    textElem.attr("y", textData.y);
    textElem.style("text-anchor", textData.anchor);
    textElem.style("font-family", textData.fontFamily);
    textElem.style("font-size", _fontSizePx);
    textElem.style("font-weight", textData.fontWeight);
    textElem.attr("fill", textData.fill);
    if (textData.class !== void 0) textElem.attr("class", textData.class);
    const span = textElem.append("tspan");
    span.attr("x", textData.x + textData.textMargin * 2);
    span.attr("fill", textData.fill);
    span.text(nText);
    return textElem;
};
const $80b3d2f58e77b583$export$efccba1c4a2ef57b = (0, $e21Zk.default)((label, maxWidth, config2)=>{
    if (!label) return label;
    config2 = Object.assign({
        fontSize: 12,
        fontWeight: 400,
        fontFamily: "Arial",
        joinWith: "<br/>"
    }, config2);
    if ($80b3d2f58e77b583$export$f1e1789686576879.lineBreakRegex.test(label)) return label;
    const words = label.split(" ");
    const completedLines = [];
    let nextLine = "";
    words.forEach((word, index)=>{
        const wordLength = $80b3d2f58e77b583$export$dda1d9f60106f0e9(`${word} `, config2);
        const nextLineLength = $80b3d2f58e77b583$export$dda1d9f60106f0e9(nextLine, config2);
        if (wordLength > maxWidth) {
            const { hyphenatedStrings: hyphenatedStrings, remainingWord: remainingWord } = $80b3d2f58e77b583$var$breakString(word, maxWidth, "-", config2);
            completedLines.push(nextLine, ...hyphenatedStrings);
            nextLine = remainingWord;
        } else if (nextLineLength + wordLength >= maxWidth) {
            completedLines.push(nextLine);
            nextLine = word;
        } else nextLine = [
            nextLine,
            word
        ].filter(Boolean).join(" ");
        const currentWord = index + 1;
        const isLastWord = currentWord === words.length;
        if (isLastWord) completedLines.push(nextLine);
    });
    return completedLines.filter((line)=>line !== "").join(config2.joinWith);
}, (label, maxWidth, config2)=>`${label}${maxWidth}${config2.fontSize}${config2.fontWeight}${config2.fontFamily}${config2.joinWith}`);
const $80b3d2f58e77b583$var$breakString = (0, $e21Zk.default)((word, maxWidth, hyphenCharacter = "-", config2)=>{
    config2 = Object.assign({
        fontSize: 12,
        fontWeight: 400,
        fontFamily: "Arial",
        margin: 0
    }, config2);
    const characters = [
        ...word
    ];
    const lines = [];
    let currentLine = "";
    characters.forEach((character, index)=>{
        const nextLine = `${currentLine}${character}`;
        const lineWidth = $80b3d2f58e77b583$export$dda1d9f60106f0e9(nextLine, config2);
        if (lineWidth >= maxWidth) {
            const currentCharacter = index + 1;
            const isLastLine = characters.length === currentCharacter;
            const hyphenatedNextLine = `${nextLine}${hyphenCharacter}`;
            lines.push(isLastLine ? nextLine : hyphenatedNextLine);
            currentLine = "";
        } else currentLine = nextLine;
    });
    return {
        hyphenatedStrings: lines,
        remainingWord: currentLine
    };
}, (word, maxWidth, hyphenCharacter = "-", config2)=>`${word}${maxWidth}${hyphenCharacter}${config2.fontSize}${config2.fontWeight}${config2.fontFamily}`);
function $80b3d2f58e77b583$export$35e795649ee09318(text, config2) {
    return $80b3d2f58e77b583$var$calculateTextDimensions(text, config2).height;
}
function $80b3d2f58e77b583$export$dda1d9f60106f0e9(text, config2) {
    return $80b3d2f58e77b583$var$calculateTextDimensions(text, config2).width;
}
const $80b3d2f58e77b583$var$calculateTextDimensions = (0, $e21Zk.default)((text, config2)=>{
    const { fontSize: fontSize = 12, fontFamily: fontFamily = "Arial", fontWeight: fontWeight = 400 } = config2;
    if (!text) return {
        width: 0,
        height: 0
    };
    const [, _fontSizePx] = $80b3d2f58e77b583$export$96f57966bedc81b4(fontSize);
    const fontFamilies = [
        "sans-serif",
        fontFamily
    ];
    const lines = text.split($80b3d2f58e77b583$export$f1e1789686576879.lineBreakRegex);
    const dims = [];
    const body = (0, $hOxpW.default)("body");
    if (!body.remove) return {
        width: 0,
        height: 0,
        lineHeight: 0
    };
    const g = body.append("svg");
    for (const fontFamily2 of fontFamilies){
        let cHeight = 0;
        const dim = {
            width: 0,
            height: 0,
            lineHeight: 0
        };
        for (const line of lines){
            const textObj = $80b3d2f58e77b583$var$getTextObj();
            textObj.text = line || $80b3d2f58e77b583$export$dc98b0b04f4c7758;
            const textElem = $80b3d2f58e77b583$var$drawSimpleText(g, textObj).style("font-size", _fontSizePx).style("font-weight", fontWeight).style("font-family", fontFamily2);
            const bBox = (textElem._groups || textElem)[0][0].getBBox();
            if (bBox.width === 0 && bBox.height === 0) throw new Error("svg element not in render tree");
            dim.width = Math.round(Math.max(dim.width, bBox.width));
            cHeight = Math.round(bBox.height);
            dim.height += cHeight;
            dim.lineHeight = Math.round(Math.max(dim.lineHeight, cHeight));
        }
        dims.push(dim);
    }
    g.remove();
    const index = isNaN(dims[1].height) || isNaN(dims[1].width) || isNaN(dims[1].lineHeight) || dims[0].height > dims[1].height && dims[0].width > dims[1].width && dims[0].lineHeight > dims[1].lineHeight ? 0 : 1;
    return dims[index];
}, (text, config2)=>`${text}${config2.fontSize}${config2.fontWeight}${config2.fontFamily}`);
class $80b3d2f58e77b583$var$InitIDGenerator {
    constructor(deterministic = false, seed){
        this.count = 0;
        this.count = seed ? seed.length : 0;
        this.next = deterministic ? ()=>this.count++ : ()=>Date.now();
    }
}
let $80b3d2f58e77b583$var$decoder;
const $80b3d2f58e77b583$var$entityDecode = function(html) {
    $80b3d2f58e77b583$var$decoder = $80b3d2f58e77b583$var$decoder || document.createElement("div");
    html = escape(html).replace(/%26/g, "&").replace(/%23/g, "#").replace(/%3B/g, ";");
    $80b3d2f58e77b583$var$decoder.innerHTML = html;
    return unescape($80b3d2f58e77b583$var$decoder.textContent);
};
function $80b3d2f58e77b583$var$isDetailedError(error) {
    return "str" in error;
}
const $80b3d2f58e77b583$var$insertTitle = (parent, cssClass, titleTopMargin, title)=>{
    var _a;
    if (!title) return;
    const bounds = (_a = parent.node()) == null ? void 0 : _a.getBBox();
    if (!bounds) return;
    parent.append("text").text(title).attr("x", bounds.x + bounds.width / 2).attr("y", -titleTopMargin).attr("class", cssClass);
};
const $80b3d2f58e77b583$export$96f57966bedc81b4 = (fontSize)=>{
    if (typeof fontSize === "number") return [
        fontSize,
        fontSize + "px"
    ];
    const fontSizeNumber = parseInt(fontSize ?? "", 10);
    if (Number.isNaN(fontSizeNumber)) return [
        void 0,
        void 0
    ];
    else if (fontSize === String(fontSizeNumber)) return [
        fontSizeNumber,
        fontSize + "px"
    ];
    else return [
        fontSizeNumber,
        fontSize
    ];
};
function $80b3d2f58e77b583$export$e7094788287c5e9b(defaultData, data) {
    return (0, $gocXo.default)({}, defaultData, data);
}
const $80b3d2f58e77b583$export$3b14a55fb2447963 = {
    assignWithDepth: $80b3d2f58e77b583$export$2d1720544b23b823,
    wrapLabel: $80b3d2f58e77b583$export$efccba1c4a2ef57b,
    calculateTextHeight: $80b3d2f58e77b583$export$35e795649ee09318,
    calculateTextWidth: $80b3d2f58e77b583$export$dda1d9f60106f0e9,
    calculateTextDimensions: $80b3d2f58e77b583$var$calculateTextDimensions,
    cleanAndMerge: $80b3d2f58e77b583$export$e7094788287c5e9b,
    detectInit: $80b3d2f58e77b583$var$detectInit,
    detectDirective: $80b3d2f58e77b583$var$detectDirective,
    isSubstringInArray: $80b3d2f58e77b583$var$isSubstringInArray,
    interpolateToCurve: $80b3d2f58e77b583$export$7ccc53e8f1e7dfc5,
    calcLabelPosition: $80b3d2f58e77b583$var$calcLabelPosition,
    calcCardinalityPosition: $80b3d2f58e77b583$var$calcCardinalityPosition,
    calcTerminalLabelPosition: $80b3d2f58e77b583$var$calcTerminalLabelPosition,
    formatUrl: $80b3d2f58e77b583$var$formatUrl,
    getStylesFromArray: $80b3d2f58e77b583$export$342063e11d6c3cad,
    generateId: $80b3d2f58e77b583$export$9bb611d729802a56,
    random: $80b3d2f58e77b583$export$4a5767248b18ef41,
    runFunc: $80b3d2f58e77b583$var$runFunc,
    entityDecode: $80b3d2f58e77b583$var$entityDecode,
    insertTitle: $80b3d2f58e77b583$var$insertTitle,
    parseFontSize: $80b3d2f58e77b583$export$96f57966bedc81b4,
    InitIDGenerator: $80b3d2f58e77b583$var$InitIDGenerator
};
const $80b3d2f58e77b583$var$encodeEntities = function(text) {
    let txt = text;
    txt = txt.replace(/style.*:\S*#.*;/g, function(s) {
        return s.substring(0, s.length - 1);
    });
    txt = txt.replace(/classDef.*:\S*#.*;/g, function(s) {
        return s.substring(0, s.length - 1);
    });
    txt = txt.replace(/#\w+;/g, function(s) {
        const innerTxt = s.substring(1, s.length - 1);
        const isInt = /^\+?\d+$/.test(innerTxt);
        if (isInt) return "\uFB02\xb0\xb0" + innerTxt + "\xb6\xdf";
        else return "\uFB02\xb0" + innerTxt + "\xb6\xdf";
    });
    return txt;
};
const $80b3d2f58e77b583$export$3a1a48c8f6ef640e = function(text) {
    return text.replace(/ﬂ°°/g, "&#").replace(/ﬂ°/g, "&").replace(/¶ß/g, ";");
};
const $80b3d2f58e77b583$var$version = "10.9.3";
const $80b3d2f58e77b583$var$defaultConfig$1 = Object.freeze($80b3d2f58e77b583$export$ef35774e6d314e91);
let $80b3d2f58e77b583$var$siteConfig = $80b3d2f58e77b583$export$2d1720544b23b823({}, $80b3d2f58e77b583$var$defaultConfig$1);
let $80b3d2f58e77b583$var$configFromInitialize;
let $80b3d2f58e77b583$var$directives = [];
let $80b3d2f58e77b583$var$currentConfig = $80b3d2f58e77b583$export$2d1720544b23b823({}, $80b3d2f58e77b583$var$defaultConfig$1);
const $80b3d2f58e77b583$var$updateCurrentConfig = (siteCfg, _directives)=>{
    let cfg = $80b3d2f58e77b583$export$2d1720544b23b823({}, siteCfg);
    let sumOfDirectives = {};
    for (const d of _directives){
        $80b3d2f58e77b583$var$sanitize(d);
        sumOfDirectives = $80b3d2f58e77b583$export$2d1720544b23b823(sumOfDirectives, d);
    }
    cfg = $80b3d2f58e77b583$export$2d1720544b23b823(cfg, sumOfDirectives);
    if (sumOfDirectives.theme && sumOfDirectives.theme in $80b3d2f58e77b583$var$theme) {
        const tmpConfigFromInitialize = $80b3d2f58e77b583$export$2d1720544b23b823({}, $80b3d2f58e77b583$var$configFromInitialize);
        const themeVariables = $80b3d2f58e77b583$export$2d1720544b23b823(tmpConfigFromInitialize.themeVariables || {}, sumOfDirectives.themeVariables);
        if (cfg.theme && cfg.theme in $80b3d2f58e77b583$var$theme) cfg.themeVariables = $80b3d2f58e77b583$var$theme[cfg.theme].getThemeVariables(themeVariables);
    }
    $80b3d2f58e77b583$var$currentConfig = cfg;
    $80b3d2f58e77b583$var$checkConfig($80b3d2f58e77b583$var$currentConfig);
    return $80b3d2f58e77b583$var$currentConfig;
};
const $80b3d2f58e77b583$var$setSiteConfig = (conf)=>{
    $80b3d2f58e77b583$var$siteConfig = $80b3d2f58e77b583$export$2d1720544b23b823({}, $80b3d2f58e77b583$var$defaultConfig$1);
    $80b3d2f58e77b583$var$siteConfig = $80b3d2f58e77b583$export$2d1720544b23b823($80b3d2f58e77b583$var$siteConfig, conf);
    if (conf.theme && $80b3d2f58e77b583$var$theme[conf.theme]) $80b3d2f58e77b583$var$siteConfig.themeVariables = $80b3d2f58e77b583$var$theme[conf.theme].getThemeVariables(conf.themeVariables);
    $80b3d2f58e77b583$var$updateCurrentConfig($80b3d2f58e77b583$var$siteConfig, $80b3d2f58e77b583$var$directives);
    return $80b3d2f58e77b583$var$siteConfig;
};
const $80b3d2f58e77b583$var$saveConfigFromInitialize = (conf)=>{
    $80b3d2f58e77b583$var$configFromInitialize = $80b3d2f58e77b583$export$2d1720544b23b823({}, conf);
};
const $80b3d2f58e77b583$var$updateSiteConfig = (conf)=>{
    $80b3d2f58e77b583$var$siteConfig = $80b3d2f58e77b583$export$2d1720544b23b823($80b3d2f58e77b583$var$siteConfig, conf);
    $80b3d2f58e77b583$var$updateCurrentConfig($80b3d2f58e77b583$var$siteConfig, $80b3d2f58e77b583$var$directives);
    return $80b3d2f58e77b583$var$siteConfig;
};
const $80b3d2f58e77b583$var$getSiteConfig = ()=>{
    return $80b3d2f58e77b583$export$2d1720544b23b823({}, $80b3d2f58e77b583$var$siteConfig);
};
const $80b3d2f58e77b583$var$setConfig$1 = (conf)=>{
    $80b3d2f58e77b583$var$checkConfig(conf);
    $80b3d2f58e77b583$export$2d1720544b23b823($80b3d2f58e77b583$var$currentConfig, conf);
    return $80b3d2f58e77b583$export$d66501df72047452();
};
const $80b3d2f58e77b583$export$d66501df72047452 = ()=>{
    return $80b3d2f58e77b583$export$2d1720544b23b823({}, $80b3d2f58e77b583$var$currentConfig);
};
const $80b3d2f58e77b583$var$sanitize = (options)=>{
    if (!options) return;
    [
        "secure",
        ...$80b3d2f58e77b583$var$siteConfig.secure ?? []
    ].forEach((key)=>{
        if (Object.hasOwn(options, key)) {
            $80b3d2f58e77b583$export$882b5998b3b9117c.debug(`Denied attempt to modify a secure key ${key}`, options[key]);
            delete options[key];
        }
    });
    Object.keys(options).forEach((key)=>{
        if (key.startsWith("__")) delete options[key];
    });
    Object.keys(options).forEach((key)=>{
        if (typeof options[key] === "string" && (options[key].includes("<") || options[key].includes(">") || options[key].includes("url(data:"))) delete options[key];
        if (typeof options[key] === "object") $80b3d2f58e77b583$var$sanitize(options[key]);
    });
};
const $80b3d2f58e77b583$var$addDirective = (directive)=>{
    $80b3d2f58e77b583$var$sanitizeDirective(directive);
    if (directive.fontFamily && (!directive.themeVariables || !directive.themeVariables.fontFamily)) directive.themeVariables = {
        fontFamily: directive.fontFamily
    };
    $80b3d2f58e77b583$var$directives.push(directive);
    $80b3d2f58e77b583$var$updateCurrentConfig($80b3d2f58e77b583$var$siteConfig, $80b3d2f58e77b583$var$directives);
};
const $80b3d2f58e77b583$var$reset = (config2 = $80b3d2f58e77b583$var$siteConfig)=>{
    $80b3d2f58e77b583$var$directives = [];
    $80b3d2f58e77b583$var$updateCurrentConfig(config2, $80b3d2f58e77b583$var$directives);
};
const $80b3d2f58e77b583$var$ConfigWarning = {
    LAZY_LOAD_DEPRECATED: "The configuration options lazyLoadedDiagrams and loadExternalDiagramsAtStartup are deprecated. Please use registerExternalDiagrams instead."
};
const $80b3d2f58e77b583$var$issuedWarnings = {};
const $80b3d2f58e77b583$var$issueWarning = (warning)=>{
    if ($80b3d2f58e77b583$var$issuedWarnings[warning]) return;
    $80b3d2f58e77b583$export$882b5998b3b9117c.warn($80b3d2f58e77b583$var$ConfigWarning[warning]);
    $80b3d2f58e77b583$var$issuedWarnings[warning] = true;
};
const $80b3d2f58e77b583$var$checkConfig = (config2)=>{
    if (!config2) return;
    if (config2.lazyLoadedDiagrams || config2.loadExternalDiagramsAtStartup) $80b3d2f58e77b583$var$issueWarning("LAZY_LOAD_DEPRECATED");
};
const $80b3d2f58e77b583$var$id$l = "c4";
const $80b3d2f58e77b583$var$detector$l = (txt)=>{
    return /^\s*C4Context|C4Container|C4Component|C4Dynamic|C4Deployment/.test(txt);
};

const $80b3d2f58e77b583$var$loader$m = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("k6i1g"));
    return {
        id: $80b3d2f58e77b583$var$id$l,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin$j = {
    id: $80b3d2f58e77b583$var$id$l,
    detector: $80b3d2f58e77b583$var$detector$l,
    loader: $80b3d2f58e77b583$var$loader$m
};
const $80b3d2f58e77b583$var$c4 = $80b3d2f58e77b583$var$plugin$j;
const $80b3d2f58e77b583$var$id$k = "flowchart";
const $80b3d2f58e77b583$var$detector$k = (txt, config2)=>{
    var _a, _b;
    if (((_a = config2 == null ? void 0 : config2.flowchart) == null ? void 0 : _a.defaultRenderer) === "dagre-wrapper" || ((_b = config2 == null ? void 0 : config2.flowchart) == null ? void 0 : _b.defaultRenderer) === "elk") return false;
    return /^\s*graph/.test(txt);
};

const $80b3d2f58e77b583$var$loader$l = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("k670q"));
    return {
        id: $80b3d2f58e77b583$var$id$k,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin$i = {
    id: $80b3d2f58e77b583$var$id$k,
    detector: $80b3d2f58e77b583$var$detector$k,
    loader: $80b3d2f58e77b583$var$loader$l
};
const $80b3d2f58e77b583$var$flowchart = $80b3d2f58e77b583$var$plugin$i;
const $80b3d2f58e77b583$var$id$j = "flowchart-v2";
const $80b3d2f58e77b583$var$detector$j = (txt, config2)=>{
    var _a, _b, _c;
    if (((_a = config2 == null ? void 0 : config2.flowchart) == null ? void 0 : _a.defaultRenderer) === "dagre-d3" || ((_b = config2 == null ? void 0 : config2.flowchart) == null ? void 0 : _b.defaultRenderer) === "elk") return false;
    if (/^\s*graph/.test(txt) && ((_c = config2 == null ? void 0 : config2.flowchart) == null ? void 0 : _c.defaultRenderer) === "dagre-wrapper") return true;
    return /^\s*flowchart/.test(txt);
};

const $80b3d2f58e77b583$var$loader$k = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("gpwOt"));
    return {
        id: $80b3d2f58e77b583$var$id$j,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin$h = {
    id: $80b3d2f58e77b583$var$id$j,
    detector: $80b3d2f58e77b583$var$detector$j,
    loader: $80b3d2f58e77b583$var$loader$k
};
const $80b3d2f58e77b583$var$flowchartV2 = $80b3d2f58e77b583$var$plugin$h;
const $80b3d2f58e77b583$var$id$i = "er";
const $80b3d2f58e77b583$var$detector$i = (txt)=>{
    return /^\s*erDiagram/.test(txt);
};

const $80b3d2f58e77b583$var$loader$j = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("isK8E"));
    return {
        id: $80b3d2f58e77b583$var$id$i,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin$g = {
    id: $80b3d2f58e77b583$var$id$i,
    detector: $80b3d2f58e77b583$var$detector$i,
    loader: $80b3d2f58e77b583$var$loader$j
};
const $80b3d2f58e77b583$var$er = $80b3d2f58e77b583$var$plugin$g;
const $80b3d2f58e77b583$var$id$h = "gitGraph";
const $80b3d2f58e77b583$var$detector$h = (txt)=>{
    return /^\s*gitGraph/.test(txt);
};

const $80b3d2f58e77b583$var$loader$i = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("40XJq"));
    return {
        id: $80b3d2f58e77b583$var$id$h,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin$f = {
    id: $80b3d2f58e77b583$var$id$h,
    detector: $80b3d2f58e77b583$var$detector$h,
    loader: $80b3d2f58e77b583$var$loader$i
};
const $80b3d2f58e77b583$var$git = $80b3d2f58e77b583$var$plugin$f;
const $80b3d2f58e77b583$var$id$g = "gantt";
const $80b3d2f58e77b583$var$detector$g = (txt)=>{
    return /^\s*gantt/.test(txt);
};

const $80b3d2f58e77b583$var$loader$h = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("gnEYC"));
    return {
        id: $80b3d2f58e77b583$var$id$g,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin$e = {
    id: $80b3d2f58e77b583$var$id$g,
    detector: $80b3d2f58e77b583$var$detector$g,
    loader: $80b3d2f58e77b583$var$loader$h
};
const $80b3d2f58e77b583$var$gantt = $80b3d2f58e77b583$var$plugin$e;
const $80b3d2f58e77b583$var$id$f = "info";
const $80b3d2f58e77b583$var$detector$f = (txt)=>{
    return /^\s*info/.test(txt);
};

const $80b3d2f58e77b583$var$loader$g = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("eFkkr"));
    return {
        id: $80b3d2f58e77b583$var$id$f,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$info = {
    id: $80b3d2f58e77b583$var$id$f,
    detector: $80b3d2f58e77b583$var$detector$f,
    loader: $80b3d2f58e77b583$var$loader$g
};
const $80b3d2f58e77b583$var$id$e = "pie";
const $80b3d2f58e77b583$var$detector$e = (txt)=>{
    return /^\s*pie/.test(txt);
};

const $80b3d2f58e77b583$var$loader$f = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("e99i0"));
    return {
        id: $80b3d2f58e77b583$var$id$e,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$pie = {
    id: $80b3d2f58e77b583$var$id$e,
    detector: $80b3d2f58e77b583$var$detector$e,
    loader: $80b3d2f58e77b583$var$loader$f
};
const $80b3d2f58e77b583$var$id$d = "quadrantChart";
const $80b3d2f58e77b583$var$detector$d = (txt)=>{
    return /^\s*quadrantChart/.test(txt);
};

const $80b3d2f58e77b583$var$loader$e = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("03Oo5"));
    return {
        id: $80b3d2f58e77b583$var$id$d,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin$d = {
    id: $80b3d2f58e77b583$var$id$d,
    detector: $80b3d2f58e77b583$var$detector$d,
    loader: $80b3d2f58e77b583$var$loader$e
};
const $80b3d2f58e77b583$var$quadrantChart = $80b3d2f58e77b583$var$plugin$d;
const $80b3d2f58e77b583$var$id$c = "xychart";
const $80b3d2f58e77b583$var$detector$c = (txt)=>{
    return /^\s*xychart-beta/.test(txt);
};

const $80b3d2f58e77b583$var$loader$d = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("ePP6R"));
    return {
        id: $80b3d2f58e77b583$var$id$c,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin$c = {
    id: $80b3d2f58e77b583$var$id$c,
    detector: $80b3d2f58e77b583$var$detector$c,
    loader: $80b3d2f58e77b583$var$loader$d
};
const $80b3d2f58e77b583$var$xychart = $80b3d2f58e77b583$var$plugin$c;
const $80b3d2f58e77b583$var$id$b = "requirement";
const $80b3d2f58e77b583$var$detector$b = (txt)=>{
    return /^\s*requirement(Diagram)?/.test(txt);
};

const $80b3d2f58e77b583$var$loader$c = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("e16WY"));
    return {
        id: $80b3d2f58e77b583$var$id$b,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin$b = {
    id: $80b3d2f58e77b583$var$id$b,
    detector: $80b3d2f58e77b583$var$detector$b,
    loader: $80b3d2f58e77b583$var$loader$c
};
const $80b3d2f58e77b583$var$requirement = $80b3d2f58e77b583$var$plugin$b;
const $80b3d2f58e77b583$var$id$a = "sequence";
const $80b3d2f58e77b583$var$detector$a = (txt)=>{
    return /^\s*sequenceDiagram/.test(txt);
};

const $80b3d2f58e77b583$var$loader$b = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("jg7i2"));
    return {
        id: $80b3d2f58e77b583$var$id$a,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin$a = {
    id: $80b3d2f58e77b583$var$id$a,
    detector: $80b3d2f58e77b583$var$detector$a,
    loader: $80b3d2f58e77b583$var$loader$b
};
const $80b3d2f58e77b583$var$sequence = $80b3d2f58e77b583$var$plugin$a;
const $80b3d2f58e77b583$var$id$9 = "class";
const $80b3d2f58e77b583$var$detector$9 = (txt, config2)=>{
    var _a;
    if (((_a = config2 == null ? void 0 : config2.class) == null ? void 0 : _a.defaultRenderer) === "dagre-wrapper") return false;
    return /^\s*classDiagram/.test(txt);
};

const $80b3d2f58e77b583$var$loader$a = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("3rh1h"));
    return {
        id: $80b3d2f58e77b583$var$id$9,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin$9 = {
    id: $80b3d2f58e77b583$var$id$9,
    detector: $80b3d2f58e77b583$var$detector$9,
    loader: $80b3d2f58e77b583$var$loader$a
};
const $80b3d2f58e77b583$var$classDiagram = $80b3d2f58e77b583$var$plugin$9;
const $80b3d2f58e77b583$var$id$8 = "classDiagram";
const $80b3d2f58e77b583$var$detector$8 = (txt, config2)=>{
    var _a;
    if (/^\s*classDiagram/.test(txt) && ((_a = config2 == null ? void 0 : config2.class) == null ? void 0 : _a.defaultRenderer) === "dagre-wrapper") return true;
    return /^\s*classDiagram-v2/.test(txt);
};

const $80b3d2f58e77b583$var$loader$9 = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("5hQaA"));
    return {
        id: $80b3d2f58e77b583$var$id$8,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin$8 = {
    id: $80b3d2f58e77b583$var$id$8,
    detector: $80b3d2f58e77b583$var$detector$8,
    loader: $80b3d2f58e77b583$var$loader$9
};
const $80b3d2f58e77b583$var$classDiagramV2 = $80b3d2f58e77b583$var$plugin$8;
const $80b3d2f58e77b583$var$id$7 = "state";
const $80b3d2f58e77b583$var$detector$7 = (txt, config2)=>{
    var _a;
    if (((_a = config2 == null ? void 0 : config2.state) == null ? void 0 : _a.defaultRenderer) === "dagre-wrapper") return false;
    return /^\s*stateDiagram/.test(txt);
};

const $80b3d2f58e77b583$var$loader$8 = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("gUeMN"));
    return {
        id: $80b3d2f58e77b583$var$id$7,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin$7 = {
    id: $80b3d2f58e77b583$var$id$7,
    detector: $80b3d2f58e77b583$var$detector$7,
    loader: $80b3d2f58e77b583$var$loader$8
};
const $80b3d2f58e77b583$var$state = $80b3d2f58e77b583$var$plugin$7;
const $80b3d2f58e77b583$var$id$6 = "stateDiagram";
const $80b3d2f58e77b583$var$detector$6 = (txt, config2)=>{
    var _a;
    if (/^\s*stateDiagram-v2/.test(txt)) return true;
    if (/^\s*stateDiagram/.test(txt) && ((_a = config2 == null ? void 0 : config2.state) == null ? void 0 : _a.defaultRenderer) === "dagre-wrapper") return true;
    return false;
};

const $80b3d2f58e77b583$var$loader$7 = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("hv449"));
    return {
        id: $80b3d2f58e77b583$var$id$6,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin$6 = {
    id: $80b3d2f58e77b583$var$id$6,
    detector: $80b3d2f58e77b583$var$detector$6,
    loader: $80b3d2f58e77b583$var$loader$7
};
const $80b3d2f58e77b583$var$stateV2 = $80b3d2f58e77b583$var$plugin$6;
const $80b3d2f58e77b583$var$id$5 = "journey";
const $80b3d2f58e77b583$var$detector$5 = (txt)=>{
    return /^\s*journey/.test(txt);
};

const $80b3d2f58e77b583$var$loader$6 = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("h4b4r"));
    return {
        id: $80b3d2f58e77b583$var$id$5,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin$5 = {
    id: $80b3d2f58e77b583$var$id$5,
    detector: $80b3d2f58e77b583$var$detector$5,
    loader: $80b3d2f58e77b583$var$loader$6
};
const $80b3d2f58e77b583$var$journey = $80b3d2f58e77b583$var$plugin$5;
const $80b3d2f58e77b583$var$d3Attrs = function(d3Elem, attrs) {
    for (let attr of attrs)d3Elem.attr(attr[0], attr[1]);
};
const $80b3d2f58e77b583$var$calculateSvgSizeAttrs = function(height, width, useMaxWidth) {
    let attrs = /* @__PURE__ */ new Map();
    if (useMaxWidth) {
        attrs.set("width", "100%");
        attrs.set("style", `max-width: ${width}px;`);
    } else {
        attrs.set("height", height);
        attrs.set("width", width);
    }
    return attrs;
};
const $80b3d2f58e77b583$export$23f2a1d2818174ef = function(svgElem, height, width, useMaxWidth) {
    const attrs = $80b3d2f58e77b583$var$calculateSvgSizeAttrs(height, width, useMaxWidth);
    $80b3d2f58e77b583$var$d3Attrs(svgElem, attrs);
};
const $80b3d2f58e77b583$export$ae1af26003f05816 = function(graph, svgElem, padding, useMaxWidth) {
    const svgBounds = svgElem.node().getBBox();
    const sWidth = svgBounds.width;
    const sHeight = svgBounds.height;
    $80b3d2f58e77b583$export$882b5998b3b9117c.info(`SVG bounds: ${sWidth}x${sHeight}`, svgBounds);
    let width = 0;
    let height = 0;
    $80b3d2f58e77b583$export$882b5998b3b9117c.info(`Graph bounds: ${width}x${height}`, graph);
    width = sWidth + padding * 2;
    height = sHeight + padding * 2;
    $80b3d2f58e77b583$export$882b5998b3b9117c.info(`Calculated bounds: ${width}x${height}`);
    $80b3d2f58e77b583$export$23f2a1d2818174ef(svgElem, height, width, useMaxWidth);
    const vBox = `${svgBounds.x - padding} ${svgBounds.y - padding} ${svgBounds.width + 2 * padding} ${svgBounds.height + 2 * padding}`;
    svgElem.attr("viewBox", vBox);
};
const $80b3d2f58e77b583$var$themes = {};
const $80b3d2f58e77b583$var$getStyles = (type2, userStyles, options)=>{
    let diagramStyles = "";
    if (type2 in $80b3d2f58e77b583$var$themes && $80b3d2f58e77b583$var$themes[type2]) diagramStyles = $80b3d2f58e77b583$var$themes[type2](options);
    else $80b3d2f58e77b583$export$882b5998b3b9117c.warn(`No theme found for ${type2}`);
    return ` & {
    font-family: ${options.fontFamily};
    font-size: ${options.fontSize};
    fill: ${options.textColor}
  }

  /* Classes common for multiple diagrams */

  & .error-icon {
    fill: ${options.errorBkgColor};
  }
  & .error-text {
    fill: ${options.errorTextColor};
    stroke: ${options.errorTextColor};
  }

  & .edge-thickness-normal {
    stroke-width: 2px;
  }
  & .edge-thickness-thick {
    stroke-width: 3.5px
  }
  & .edge-pattern-solid {
    stroke-dasharray: 0;
  }

  & .edge-pattern-dashed{
    stroke-dasharray: 3;
  }
  .edge-pattern-dotted {
    stroke-dasharray: 2;
  }

  & .marker {
    fill: ${options.lineColor};
    stroke: ${options.lineColor};
  }
  & .marker.cross {
    stroke: ${options.lineColor};
  }

  & svg {
    font-family: ${options.fontFamily};
    font-size: ${options.fontSize};
  }

  ${diagramStyles}

  ${userStyles}
`;
};
const $80b3d2f58e77b583$var$addStylesForDiagram = (type2, diagramTheme)=>{
    if (diagramTheme !== void 0) $80b3d2f58e77b583$var$themes[type2] = diagramTheme;
};
const $80b3d2f58e77b583$var$getStyles$1 = $80b3d2f58e77b583$var$getStyles;
let $80b3d2f58e77b583$var$accTitle = "";
let $80b3d2f58e77b583$var$diagramTitle = "";
let $80b3d2f58e77b583$var$accDescription = "";
const $80b3d2f58e77b583$var$sanitizeText$1 = (txt)=>$80b3d2f58e77b583$export$4368d992c4eafac0(txt, $80b3d2f58e77b583$export$d66501df72047452());
const $80b3d2f58e77b583$export$90a7f3efeed30595 = ()=>{
    $80b3d2f58e77b583$var$accTitle = "";
    $80b3d2f58e77b583$var$accDescription = "";
    $80b3d2f58e77b583$var$diagramTitle = "";
};
const $80b3d2f58e77b583$export$2408f22a0fab9ae5 = (txt)=>{
    $80b3d2f58e77b583$var$accTitle = $80b3d2f58e77b583$var$sanitizeText$1(txt).replace(/^\s+/g, "");
};
const $80b3d2f58e77b583$export$39b482c5e57630a8 = ()=>$80b3d2f58e77b583$var$accTitle;
const $80b3d2f58e77b583$export$8b22cf2602fb60ce = (txt)=>{
    $80b3d2f58e77b583$var$accDescription = $80b3d2f58e77b583$var$sanitizeText$1(txt).replace(/\n\s+/g, "\n");
};
const $80b3d2f58e77b583$export$407448d2b89b1813 = ()=>$80b3d2f58e77b583$var$accDescription;
const $80b3d2f58e77b583$export$9e5f44173e64f162 = (txt)=>{
    $80b3d2f58e77b583$var$diagramTitle = $80b3d2f58e77b583$var$sanitizeText$1(txt);
};
const $80b3d2f58e77b583$export$625550452a3fa3ec = ()=>$80b3d2f58e77b583$var$diagramTitle;
const $80b3d2f58e77b583$export$61196ced6d74a310 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    clear: $80b3d2f58e77b583$export$90a7f3efeed30595,
    getAccDescription: $80b3d2f58e77b583$export$407448d2b89b1813,
    getAccTitle: $80b3d2f58e77b583$export$39b482c5e57630a8,
    getDiagramTitle: $80b3d2f58e77b583$export$625550452a3fa3ec,
    setAccDescription: $80b3d2f58e77b583$export$8b22cf2602fb60ce,
    setAccTitle: $80b3d2f58e77b583$export$2408f22a0fab9ae5,
    setDiagramTitle: $80b3d2f58e77b583$export$9e5f44173e64f162
}, Symbol.toStringTag, {
    value: "Module"
}));
const $80b3d2f58e77b583$var$log = $80b3d2f58e77b583$export$882b5998b3b9117c;
const $80b3d2f58e77b583$var$setLogLevel = $80b3d2f58e77b583$var$setLogLevel$1;
const $80b3d2f58e77b583$export$db3b6bfb95261072 = $80b3d2f58e77b583$export$d66501df72047452;
const $80b3d2f58e77b583$export$ffb5f4729a158638 = $80b3d2f58e77b583$var$setConfig$1;
const $80b3d2f58e77b583$export$3466f893ebf79586 = $80b3d2f58e77b583$var$defaultConfig$1;
const $80b3d2f58e77b583$var$sanitizeText = (text)=>$80b3d2f58e77b583$export$4368d992c4eafac0(text, $80b3d2f58e77b583$export$db3b6bfb95261072());
const $80b3d2f58e77b583$export$df995fae86a55f06 = $80b3d2f58e77b583$export$ae1af26003f05816;
const $80b3d2f58e77b583$var$getCommonDb = ()=>{
    return $80b3d2f58e77b583$export$61196ced6d74a310;
};
const $80b3d2f58e77b583$var$diagrams = {};
const $80b3d2f58e77b583$var$registerDiagram = (id2, diagram2, detector2)=>{
    var _a;
    if ($80b3d2f58e77b583$var$diagrams[id2]) throw new Error(`Diagram ${id2} already registered.`);
    $80b3d2f58e77b583$var$diagrams[id2] = diagram2;
    if (detector2) $80b3d2f58e77b583$var$addDetector(id2, detector2);
    $80b3d2f58e77b583$var$addStylesForDiagram(id2, diagram2.styles);
    (_a = diagram2.injectUtils) == null || _a.call(diagram2, $80b3d2f58e77b583$var$log, $80b3d2f58e77b583$var$setLogLevel, $80b3d2f58e77b583$export$db3b6bfb95261072, $80b3d2f58e77b583$var$sanitizeText, $80b3d2f58e77b583$export$df995fae86a55f06, $80b3d2f58e77b583$var$getCommonDb(), ()=>{});
};
const $80b3d2f58e77b583$var$getDiagram = (name)=>{
    if (name in $80b3d2f58e77b583$var$diagrams) return $80b3d2f58e77b583$var$diagrams[name];
    throw new $80b3d2f58e77b583$var$DiagramNotFoundError(name);
};
class $80b3d2f58e77b583$var$DiagramNotFoundError extends Error {
    constructor(name){
        super(`Diagram ${name} not found.`);
    }
}
const $80b3d2f58e77b583$export$ebd11618f299a286 = (id2)=>{
    var _a;
    const { securityLevel: securityLevel } = $80b3d2f58e77b583$export$db3b6bfb95261072();
    let root = (0, $hOxpW.default)("body");
    if (securityLevel === "sandbox") {
        const sandboxElement = (0, $hOxpW.default)(`#i${id2}`);
        const doc = ((_a = sandboxElement.node()) == null ? void 0 : _a.contentDocument) ?? document;
        root = (0, $hOxpW.default)(doc.body);
    }
    const svg = root.select(`#${id2}`);
    return svg;
};
const $80b3d2f58e77b583$var$draw = (_text, id2, version2)=>{
    $80b3d2f58e77b583$export$882b5998b3b9117c.debug("rendering svg for syntax error\n");
    const svg = $80b3d2f58e77b583$export$ebd11618f299a286(id2);
    const g = svg.append("g");
    svg.attr("viewBox", "0 0 2412 512");
    $80b3d2f58e77b583$export$23f2a1d2818174ef(svg, 100, 512, true);
    g.append("path").attr("class", "error-icon").attr("d", "m411.313,123.313c6.25-6.25 6.25-16.375 0-22.625s-16.375-6.25-22.625,0l-32,32-9.375,9.375-20.688-20.688c-12.484-12.5-32.766-12.5-45.25,0l-16,16c-1.261,1.261-2.304,2.648-3.31,4.051-21.739-8.561-45.324-13.426-70.065-13.426-105.867,0-192,86.133-192,192s86.133,192 192,192 192-86.133 192-192c0-24.741-4.864-48.327-13.426-70.065 1.402-1.007 2.79-2.049 4.051-3.31l16-16c12.5-12.492 12.5-32.758 0-45.25l-20.688-20.688 9.375-9.375 32.001-31.999zm-219.313,100.687c-52.938,0-96,43.063-96,96 0,8.836-7.164,16-16,16s-16-7.164-16-16c0-70.578 57.422-128 128-128 8.836,0 16,7.164 16,16s-7.164,16-16,16z");
    g.append("path").attr("class", "error-icon").attr("d", "m459.02,148.98c-6.25-6.25-16.375-6.25-22.625,0s-6.25,16.375 0,22.625l16,16c3.125,3.125 7.219,4.688 11.313,4.688 4.094,0 8.188-1.563 11.313-4.688 6.25-6.25 6.25-16.375 0-22.625l-16.001-16z");
    g.append("path").attr("class", "error-icon").attr("d", "m340.395,75.605c3.125,3.125 7.219,4.688 11.313,4.688 4.094,0 8.188-1.563 11.313-4.688 6.25-6.25 6.25-16.375 0-22.625l-16-16c-6.25-6.25-16.375-6.25-22.625,0s-6.25,16.375 0,22.625l15.999,16z");
    g.append("path").attr("class", "error-icon").attr("d", "m400,64c8.844,0 16-7.164 16-16v-32c0-8.836-7.156-16-16-16-8.844,0-16,7.164-16,16v32c0,8.836 7.156,16 16,16z");
    g.append("path").attr("class", "error-icon").attr("d", "m496,96.586h-32c-8.844,0-16,7.164-16,16 0,8.836 7.156,16 16,16h32c8.844,0 16-7.164 16-16 0-8.836-7.156-16-16-16z");
    g.append("path").attr("class", "error-icon").attr("d", "m436.98,75.605c3.125,3.125 7.219,4.688 11.313,4.688 4.094,0 8.188-1.563 11.313-4.688l32-32c6.25-6.25 6.25-16.375 0-22.625s-16.375-6.25-22.625,0l-32,32c-6.251,6.25-6.251,16.375-0.001,22.625z");
    g.append("text").attr("class", "error-text").attr("x", 1440).attr("y", 250).attr("font-size", "150px").style("text-anchor", "middle").text("Syntax error in text");
    g.append("text").attr("class", "error-text").attr("x", 1250).attr("y", 400).attr("font-size", "100px").style("text-anchor", "middle").text(`mermaid version ${version2}`);
};
const $80b3d2f58e77b583$var$renderer = {
    draw: $80b3d2f58e77b583$var$draw
};
const $80b3d2f58e77b583$var$errorRenderer = $80b3d2f58e77b583$var$renderer;
const $80b3d2f58e77b583$var$diagram = {
    db: {},
    renderer: $80b3d2f58e77b583$var$renderer,
    parser: {
        parser: {
            yy: {}
        },
        parse: ()=>{
            return;
        }
    }
};
const $80b3d2f58e77b583$var$errorDiagram = $80b3d2f58e77b583$var$diagram;
const $80b3d2f58e77b583$var$id$4 = "flowchart-elk";
const $80b3d2f58e77b583$var$detector$4 = (txt, config2)=>{
    var _a;
    if (// If diagram explicitly states flowchart-elk
    /^\s*flowchart-elk/.test(txt) || // If a flowchart/graph diagram has their default renderer set to elk
    /^\s*flowchart|graph/.test(txt) && ((_a = config2 == null ? void 0 : config2.flowchart) == null ? void 0 : _a.defaultRenderer) === "elk") return true;
    return false;
};

const $80b3d2f58e77b583$var$loader$5 = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("1mnoh"));
    return {
        id: $80b3d2f58e77b583$var$id$4,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin$4 = {
    id: $80b3d2f58e77b583$var$id$4,
    detector: $80b3d2f58e77b583$var$detector$4,
    loader: $80b3d2f58e77b583$var$loader$5
};
const $80b3d2f58e77b583$var$flowchartElk = $80b3d2f58e77b583$var$plugin$4;
const $80b3d2f58e77b583$var$id$3 = "timeline";
const $80b3d2f58e77b583$var$detector$3 = (txt)=>{
    return /^\s*timeline/.test(txt);
};

const $80b3d2f58e77b583$var$loader$4 = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("lgpFG"));
    return {
        id: $80b3d2f58e77b583$var$id$3,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin$3 = {
    id: $80b3d2f58e77b583$var$id$3,
    detector: $80b3d2f58e77b583$var$detector$3,
    loader: $80b3d2f58e77b583$var$loader$4
};
const $80b3d2f58e77b583$var$timeline = $80b3d2f58e77b583$var$plugin$3;
const $80b3d2f58e77b583$var$id$2 = "mindmap";
const $80b3d2f58e77b583$var$detector$2 = (txt)=>{
    return /^\s*mindmap/.test(txt);
};

const $80b3d2f58e77b583$var$loader$3 = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("ll6G0"));
    return {
        id: $80b3d2f58e77b583$var$id$2,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin$2 = {
    id: $80b3d2f58e77b583$var$id$2,
    detector: $80b3d2f58e77b583$var$detector$2,
    loader: $80b3d2f58e77b583$var$loader$3
};
const $80b3d2f58e77b583$var$mindmap = $80b3d2f58e77b583$var$plugin$2;
const $80b3d2f58e77b583$var$id$1 = "sankey";
const $80b3d2f58e77b583$var$detector$1 = (txt)=>{
    return /^\s*sankey-beta/.test(txt);
};

const $80b3d2f58e77b583$var$loader$2 = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("dBcSy"));
    return {
        id: $80b3d2f58e77b583$var$id$1,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin$1 = {
    id: $80b3d2f58e77b583$var$id$1,
    detector: $80b3d2f58e77b583$var$detector$1,
    loader: $80b3d2f58e77b583$var$loader$2
};
const $80b3d2f58e77b583$var$sankey = $80b3d2f58e77b583$var$plugin$1;
const $80b3d2f58e77b583$var$id = "block";
const $80b3d2f58e77b583$var$detector = (txt)=>{
    return /^\s*block-beta/.test(txt);
};

const $80b3d2f58e77b583$var$loader$1 = async ()=>{
    const { diagram: diagram2 } = await (parcelRequire("1sg64"));
    return {
        id: $80b3d2f58e77b583$var$id,
        diagram: diagram2
    };
};
const $80b3d2f58e77b583$var$plugin = {
    id: $80b3d2f58e77b583$var$id,
    detector: $80b3d2f58e77b583$var$detector,
    loader: $80b3d2f58e77b583$var$loader$1
};
const $80b3d2f58e77b583$var$block = $80b3d2f58e77b583$var$plugin;
let $80b3d2f58e77b583$var$hasLoadedDiagrams = false;
const $80b3d2f58e77b583$var$addDiagrams = ()=>{
    if ($80b3d2f58e77b583$var$hasLoadedDiagrams) return;
    $80b3d2f58e77b583$var$hasLoadedDiagrams = true;
    $80b3d2f58e77b583$var$registerDiagram("error", $80b3d2f58e77b583$var$errorDiagram, (text)=>{
        return text.toLowerCase().trim() === "error";
    });
    $80b3d2f58e77b583$var$registerDiagram("---", // --- diagram type may appear if YAML front-matter is not parsed correctly
    {
        db: {
            clear: ()=>{}
        },
        styles: {},
        // should never be used
        renderer: {
            draw: ()=>{}
        },
        parser: {
            parser: {
                yy: {}
            },
            parse: ()=>{
                throw new Error("Diagrams beginning with --- are not valid. If you were trying to use a YAML front-matter, please ensure that you've correctly opened and closed the YAML front-matter with un-indented `---` blocks");
            }
        },
        init: ()=>null
    }, (text)=>{
        return text.toLowerCase().trimStart().startsWith("---");
    });
    $80b3d2f58e77b583$var$registerLazyLoadedDiagrams($80b3d2f58e77b583$var$c4, $80b3d2f58e77b583$var$classDiagramV2, $80b3d2f58e77b583$var$classDiagram, $80b3d2f58e77b583$var$er, $80b3d2f58e77b583$var$gantt, $80b3d2f58e77b583$var$info, $80b3d2f58e77b583$var$pie, $80b3d2f58e77b583$var$requirement, $80b3d2f58e77b583$var$sequence, $80b3d2f58e77b583$var$flowchartElk, $80b3d2f58e77b583$var$flowchartV2, $80b3d2f58e77b583$var$flowchart, $80b3d2f58e77b583$var$mindmap, $80b3d2f58e77b583$var$timeline, $80b3d2f58e77b583$var$git, $80b3d2f58e77b583$var$stateV2, $80b3d2f58e77b583$var$state, $80b3d2f58e77b583$var$journey, $80b3d2f58e77b583$var$quadrantChart, $80b3d2f58e77b583$var$sankey, $80b3d2f58e77b583$var$xychart, $80b3d2f58e77b583$var$block);
};
class $80b3d2f58e77b583$var$Diagram {
    constructor(text, metadata = {}){
        this.text = text;
        this.metadata = metadata;
        this.type = "graph";
        this.text = $80b3d2f58e77b583$var$encodeEntities(text);
        this.text += "\n";
        const cnf = $80b3d2f58e77b583$export$d66501df72047452();
        try {
            this.type = $80b3d2f58e77b583$var$detectType(text, cnf);
        } catch (e) {
            this.type = "error";
            this.detectError = e;
        }
        const diagram2 = $80b3d2f58e77b583$var$getDiagram(this.type);
        $80b3d2f58e77b583$export$882b5998b3b9117c.debug("Type " + this.type);
        this.db = diagram2.db;
        this.renderer = diagram2.renderer;
        this.parser = diagram2.parser;
        this.parser.parser.yy = this.db;
        this.init = diagram2.init;
        this.parse();
    }
    parse() {
        var _a, _b, _c, _d, _e;
        if (this.detectError) throw this.detectError;
        (_b = (_a = this.db).clear) == null || _b.call(_a);
        const config2 = $80b3d2f58e77b583$export$d66501df72047452();
        (_c = this.init) == null || _c.call(this, config2);
        if (this.metadata.title) (_e = (_d = this.db).setDiagramTitle) == null || _e.call(_d, this.metadata.title);
        this.parser.parse(this.text);
    }
    async render(id2, version2) {
        await this.renderer.draw(this.text, id2, version2, this);
    }
    getParser() {
        return this.parser;
    }
    getType() {
        return this.type;
    }
}
const $80b3d2f58e77b583$var$getDiagramFromText$1 = async (text, metadata = {})=>{
    const type2 = $80b3d2f58e77b583$var$detectType(text, $80b3d2f58e77b583$export$d66501df72047452());
    try {
        $80b3d2f58e77b583$var$getDiagram(type2);
    } catch (error) {
        const loader2 = $80b3d2f58e77b583$var$getDiagramLoader(type2);
        if (!loader2) throw new $80b3d2f58e77b583$var$UnknownDiagramError(`Diagram ${type2} not found.`);
        const { id: id2, diagram: diagram2 } = await loader2();
        $80b3d2f58e77b583$var$registerDiagram(id2, diagram2);
    }
    return new $80b3d2f58e77b583$var$Diagram(text, metadata);
};
let $80b3d2f58e77b583$var$interactionFunctions = [];
const $80b3d2f58e77b583$var$attachFunctions = ()=>{
    $80b3d2f58e77b583$var$interactionFunctions.forEach((f)=>{
        f();
    });
    $80b3d2f58e77b583$var$interactionFunctions = [];
};
const $80b3d2f58e77b583$var$SVG_ROLE = "graphics-document document";
function $80b3d2f58e77b583$var$setA11yDiagramInfo(svg, diagramType) {
    svg.attr("role", $80b3d2f58e77b583$var$SVG_ROLE);
    if (diagramType !== "") svg.attr("aria-roledescription", diagramType);
}
function $80b3d2f58e77b583$var$addSVGa11yTitleDescription(svg, a11yTitle, a11yDesc, baseId) {
    if (svg.insert === void 0) return;
    if (a11yDesc) {
        const descId = `chart-desc-${baseId}`;
        svg.attr("aria-describedby", descId);
        svg.insert("desc", ":first-child").attr("id", descId).text(a11yDesc);
    }
    if (a11yTitle) {
        const titleId = `chart-title-${baseId}`;
        svg.attr("aria-labelledby", titleId);
        svg.insert("title", ":first-child").attr("id", titleId).text(a11yTitle);
    }
}
const $80b3d2f58e77b583$var$cleanupComments = (text)=>{
    return text.replace(/^\s*%%(?!{)[^\n]+\n?/gm, "").trimStart();
};
/*! js-yaml 4.1.0 https://github.com/nodeca/js-yaml @license MIT */ function $80b3d2f58e77b583$var$isNothing(subject) {
    return typeof subject === "undefined" || subject === null;
}
function $80b3d2f58e77b583$var$isObject(subject) {
    return typeof subject === "object" && subject !== null;
}
function $80b3d2f58e77b583$var$toArray(sequence2) {
    if (Array.isArray(sequence2)) return sequence2;
    else if ($80b3d2f58e77b583$var$isNothing(sequence2)) return [];
    return [
        sequence2
    ];
}
function $80b3d2f58e77b583$var$extend(target, source) {
    var index, length, key, sourceKeys;
    if (source) {
        sourceKeys = Object.keys(source);
        for(index = 0, length = sourceKeys.length; index < length; index += 1){
            key = sourceKeys[index];
            target[key] = source[key];
        }
    }
    return target;
}
function $80b3d2f58e77b583$var$repeat(string, count) {
    var result = "", cycle;
    for(cycle = 0; cycle < count; cycle += 1)result += string;
    return result;
}
function $80b3d2f58e77b583$var$isNegativeZero(number) {
    return number === 0 && Number.NEGATIVE_INFINITY === 1 / number;
}
var $80b3d2f58e77b583$var$isNothing_1 = $80b3d2f58e77b583$var$isNothing;
var $80b3d2f58e77b583$var$isObject_1 = $80b3d2f58e77b583$var$isObject;
var $80b3d2f58e77b583$var$toArray_1 = $80b3d2f58e77b583$var$toArray;
var $80b3d2f58e77b583$var$repeat_1 = $80b3d2f58e77b583$var$repeat;
var $80b3d2f58e77b583$var$isNegativeZero_1 = $80b3d2f58e77b583$var$isNegativeZero;
var $80b3d2f58e77b583$var$extend_1 = $80b3d2f58e77b583$var$extend;
var $80b3d2f58e77b583$var$common = {
    isNothing: $80b3d2f58e77b583$var$isNothing_1,
    isObject: $80b3d2f58e77b583$var$isObject_1,
    toArray: $80b3d2f58e77b583$var$toArray_1,
    repeat: $80b3d2f58e77b583$var$repeat_1,
    isNegativeZero: $80b3d2f58e77b583$var$isNegativeZero_1,
    extend: $80b3d2f58e77b583$var$extend_1
};
function $80b3d2f58e77b583$var$formatError(exception2, compact) {
    var where = "", message = exception2.reason || "(unknown reason)";
    if (!exception2.mark) return message;
    if (exception2.mark.name) where += 'in "' + exception2.mark.name + '" ';
    where += "(" + (exception2.mark.line + 1) + ":" + (exception2.mark.column + 1) + ")";
    if (!compact && exception2.mark.snippet) where += "\n\n" + exception2.mark.snippet;
    return message + " " + where;
}
function $80b3d2f58e77b583$var$YAMLException$1(reason, mark) {
    Error.call(this);
    this.name = "YAMLException";
    this.reason = reason;
    this.mark = mark;
    this.message = $80b3d2f58e77b583$var$formatError(this, false);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack || "";
}
$80b3d2f58e77b583$var$YAMLException$1.prototype = Object.create(Error.prototype);
$80b3d2f58e77b583$var$YAMLException$1.prototype.constructor = $80b3d2f58e77b583$var$YAMLException$1;
$80b3d2f58e77b583$var$YAMLException$1.prototype.toString = function toString(compact) {
    return this.name + ": " + $80b3d2f58e77b583$var$formatError(this, compact);
};
var $80b3d2f58e77b583$var$exception = $80b3d2f58e77b583$var$YAMLException$1;
function $80b3d2f58e77b583$var$getLine(buffer, lineStart, lineEnd, position, maxLineLength) {
    var head = "";
    var tail = "";
    var maxHalfLength = Math.floor(maxLineLength / 2) - 1;
    if (position - lineStart > maxHalfLength) {
        head = " ... ";
        lineStart = position - maxHalfLength + head.length;
    }
    if (lineEnd - position > maxHalfLength) {
        tail = " ...";
        lineEnd = position + maxHalfLength - tail.length;
    }
    return {
        str: head + buffer.slice(lineStart, lineEnd).replace(/\t/g, "\u2192") + tail,
        pos: position - lineStart + head.length
    };
}
function $80b3d2f58e77b583$var$padStart(string, max) {
    return $80b3d2f58e77b583$var$common.repeat(" ", max - string.length) + string;
}
function $80b3d2f58e77b583$var$makeSnippet(mark, options) {
    options = Object.create(options || null);
    if (!mark.buffer) return null;
    if (!options.maxLength) options.maxLength = 79;
    if (typeof options.indent !== "number") options.indent = 1;
    if (typeof options.linesBefore !== "number") options.linesBefore = 3;
    if (typeof options.linesAfter !== "number") options.linesAfter = 2;
    var re = /\r?\n|\r|\0/g;
    var lineStarts = [
        0
    ];
    var lineEnds = [];
    var match;
    var foundLineNo = -1;
    while(match = re.exec(mark.buffer)){
        lineEnds.push(match.index);
        lineStarts.push(match.index + match[0].length);
        if (mark.position <= match.index && foundLineNo < 0) foundLineNo = lineStarts.length - 2;
    }
    if (foundLineNo < 0) foundLineNo = lineStarts.length - 1;
    var result = "", i, line;
    var lineNoLength = Math.min(mark.line + options.linesAfter, lineEnds.length).toString().length;
    var maxLineLength = options.maxLength - (options.indent + lineNoLength + 3);
    for(i = 1; i <= options.linesBefore; i++){
        if (foundLineNo - i < 0) break;
        line = $80b3d2f58e77b583$var$getLine(mark.buffer, lineStarts[foundLineNo - i], lineEnds[foundLineNo - i], mark.position - (lineStarts[foundLineNo] - lineStarts[foundLineNo - i]), maxLineLength);
        result = $80b3d2f58e77b583$var$common.repeat(" ", options.indent) + $80b3d2f58e77b583$var$padStart((mark.line - i + 1).toString(), lineNoLength) + " | " + line.str + "\n" + result;
    }
    line = $80b3d2f58e77b583$var$getLine(mark.buffer, lineStarts[foundLineNo], lineEnds[foundLineNo], mark.position, maxLineLength);
    result += $80b3d2f58e77b583$var$common.repeat(" ", options.indent) + $80b3d2f58e77b583$var$padStart((mark.line + 1).toString(), lineNoLength) + " | " + line.str + "\n";
    result += $80b3d2f58e77b583$var$common.repeat("-", options.indent + lineNoLength + 3 + line.pos) + "^\n";
    for(i = 1; i <= options.linesAfter; i++){
        if (foundLineNo + i >= lineEnds.length) break;
        line = $80b3d2f58e77b583$var$getLine(mark.buffer, lineStarts[foundLineNo + i], lineEnds[foundLineNo + i], mark.position - (lineStarts[foundLineNo] - lineStarts[foundLineNo + i]), maxLineLength);
        result += $80b3d2f58e77b583$var$common.repeat(" ", options.indent) + $80b3d2f58e77b583$var$padStart((mark.line + i + 1).toString(), lineNoLength) + " | " + line.str + "\n";
    }
    return result.replace(/\n$/, "");
}
var $80b3d2f58e77b583$var$snippet = $80b3d2f58e77b583$var$makeSnippet;
var $80b3d2f58e77b583$var$TYPE_CONSTRUCTOR_OPTIONS = [
    "kind",
    "multi",
    "resolve",
    "construct",
    "instanceOf",
    "predicate",
    "represent",
    "representName",
    "defaultStyle",
    "styleAliases"
];
var $80b3d2f58e77b583$var$YAML_NODE_KINDS = [
    "scalar",
    "sequence",
    "mapping"
];
function $80b3d2f58e77b583$var$compileStyleAliases(map2) {
    var result = {};
    if (map2 !== null) Object.keys(map2).forEach(function(style) {
        map2[style].forEach(function(alias) {
            result[String(alias)] = style;
        });
    });
    return result;
}
function $80b3d2f58e77b583$var$Type$1(tag, options) {
    options = options || {};
    Object.keys(options).forEach(function(name) {
        if ($80b3d2f58e77b583$var$TYPE_CONSTRUCTOR_OPTIONS.indexOf(name) === -1) throw new $80b3d2f58e77b583$var$exception('Unknown option "' + name + '" is met in definition of "' + tag + '" YAML type.');
    });
    this.options = options;
    this.tag = tag;
    this.kind = options["kind"] || null;
    this.resolve = options["resolve"] || function() {
        return true;
    };
    this.construct = options["construct"] || function(data) {
        return data;
    };
    this.instanceOf = options["instanceOf"] || null;
    this.predicate = options["predicate"] || null;
    this.represent = options["represent"] || null;
    this.representName = options["representName"] || null;
    this.defaultStyle = options["defaultStyle"] || null;
    this.multi = options["multi"] || false;
    this.styleAliases = $80b3d2f58e77b583$var$compileStyleAliases(options["styleAliases"] || null);
    if ($80b3d2f58e77b583$var$YAML_NODE_KINDS.indexOf(this.kind) === -1) throw new $80b3d2f58e77b583$var$exception('Unknown kind "' + this.kind + '" is specified for "' + tag + '" YAML type.');
}
var $80b3d2f58e77b583$var$type = $80b3d2f58e77b583$var$Type$1;
function $80b3d2f58e77b583$var$compileList(schema2, name) {
    var result = [];
    schema2[name].forEach(function(currentType) {
        var newIndex = result.length;
        result.forEach(function(previousType, previousIndex) {
            if (previousType.tag === currentType.tag && previousType.kind === currentType.kind && previousType.multi === currentType.multi) newIndex = previousIndex;
        });
        result[newIndex] = currentType;
    });
    return result;
}
function $80b3d2f58e77b583$var$compileMap() {
    var result = {
        scalar: {},
        sequence: {},
        mapping: {},
        fallback: {},
        multi: {
            scalar: [],
            sequence: [],
            mapping: [],
            fallback: []
        }
    }, index, length;
    function collectType(type2) {
        if (type2.multi) {
            result.multi[type2.kind].push(type2);
            result.multi["fallback"].push(type2);
        } else result[type2.kind][type2.tag] = result["fallback"][type2.tag] = type2;
    }
    for(index = 0, length = arguments.length; index < length; index += 1)arguments[index].forEach(collectType);
    return result;
}
function $80b3d2f58e77b583$var$Schema$1(definition) {
    return this.extend(definition);
}
$80b3d2f58e77b583$var$Schema$1.prototype.extend = function extend2(definition) {
    var implicit = [];
    var explicit = [];
    if (definition instanceof $80b3d2f58e77b583$var$type) explicit.push(definition);
    else if (Array.isArray(definition)) explicit = explicit.concat(definition);
    else if (definition && (Array.isArray(definition.implicit) || Array.isArray(definition.explicit))) {
        if (definition.implicit) implicit = implicit.concat(definition.implicit);
        if (definition.explicit) explicit = explicit.concat(definition.explicit);
    } else throw new $80b3d2f58e77b583$var$exception("Schema.extend argument should be a Type, [ Type ], or a schema definition ({ implicit: [...], explicit: [...] })");
    implicit.forEach(function(type$1) {
        if (!(type$1 instanceof $80b3d2f58e77b583$var$type)) throw new $80b3d2f58e77b583$var$exception("Specified list of YAML types (or a single Type object) contains a non-Type object.");
        if (type$1.loadKind && type$1.loadKind !== "scalar") throw new $80b3d2f58e77b583$var$exception("There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.");
        if (type$1.multi) throw new $80b3d2f58e77b583$var$exception("There is a multi type in the implicit list of a schema. Multi tags can only be listed as explicit.");
    });
    explicit.forEach(function(type$1) {
        if (!(type$1 instanceof $80b3d2f58e77b583$var$type)) throw new $80b3d2f58e77b583$var$exception("Specified list of YAML types (or a single Type object) contains a non-Type object.");
    });
    var result = Object.create($80b3d2f58e77b583$var$Schema$1.prototype);
    result.implicit = (this.implicit || []).concat(implicit);
    result.explicit = (this.explicit || []).concat(explicit);
    result.compiledImplicit = $80b3d2f58e77b583$var$compileList(result, "implicit");
    result.compiledExplicit = $80b3d2f58e77b583$var$compileList(result, "explicit");
    result.compiledTypeMap = $80b3d2f58e77b583$var$compileMap(result.compiledImplicit, result.compiledExplicit);
    return result;
};
var $80b3d2f58e77b583$var$schema = $80b3d2f58e77b583$var$Schema$1;
var $80b3d2f58e77b583$var$str = new $80b3d2f58e77b583$var$type("tag:yaml.org,2002:str", {
    kind: "scalar",
    construct: function(data) {
        return data !== null ? data : "";
    }
});
var $80b3d2f58e77b583$var$seq = new $80b3d2f58e77b583$var$type("tag:yaml.org,2002:seq", {
    kind: "sequence",
    construct: function(data) {
        return data !== null ? data : [];
    }
});
var $80b3d2f58e77b583$var$map = new $80b3d2f58e77b583$var$type("tag:yaml.org,2002:map", {
    kind: "mapping",
    construct: function(data) {
        return data !== null ? data : {};
    }
});
var $80b3d2f58e77b583$var$failsafe = new $80b3d2f58e77b583$var$schema({
    explicit: [
        $80b3d2f58e77b583$var$str,
        $80b3d2f58e77b583$var$seq,
        $80b3d2f58e77b583$var$map
    ]
});
function $80b3d2f58e77b583$var$resolveYamlNull(data) {
    if (data === null) return true;
    var max = data.length;
    return max === 1 && data === "~" || max === 4 && (data === "null" || data === "Null" || data === "NULL");
}
function $80b3d2f58e77b583$var$constructYamlNull() {
    return null;
}
function $80b3d2f58e77b583$var$isNull(object) {
    return object === null;
}
var $80b3d2f58e77b583$var$_null = new $80b3d2f58e77b583$var$type("tag:yaml.org,2002:null", {
    kind: "scalar",
    resolve: $80b3d2f58e77b583$var$resolveYamlNull,
    construct: $80b3d2f58e77b583$var$constructYamlNull,
    predicate: $80b3d2f58e77b583$var$isNull,
    represent: {
        canonical: function() {
            return "~";
        },
        lowercase: function() {
            return "null";
        },
        uppercase: function() {
            return "NULL";
        },
        camelcase: function() {
            return "Null";
        },
        empty: function() {
            return "";
        }
    },
    defaultStyle: "lowercase"
});
function $80b3d2f58e77b583$var$resolveYamlBoolean(data) {
    if (data === null) return false;
    var max = data.length;
    return max === 4 && (data === "true" || data === "True" || data === "TRUE") || max === 5 && (data === "false" || data === "False" || data === "FALSE");
}
function $80b3d2f58e77b583$var$constructYamlBoolean(data) {
    return data === "true" || data === "True" || data === "TRUE";
}
function $80b3d2f58e77b583$var$isBoolean(object) {
    return Object.prototype.toString.call(object) === "[object Boolean]";
}
var $80b3d2f58e77b583$var$bool = new $80b3d2f58e77b583$var$type("tag:yaml.org,2002:bool", {
    kind: "scalar",
    resolve: $80b3d2f58e77b583$var$resolveYamlBoolean,
    construct: $80b3d2f58e77b583$var$constructYamlBoolean,
    predicate: $80b3d2f58e77b583$var$isBoolean,
    represent: {
        lowercase: function(object) {
            return object ? "true" : "false";
        },
        uppercase: function(object) {
            return object ? "TRUE" : "FALSE";
        },
        camelcase: function(object) {
            return object ? "True" : "False";
        }
    },
    defaultStyle: "lowercase"
});
function $80b3d2f58e77b583$var$isHexCode(c) {
    return 48 <= c && c <= 57 || 65 <= c && c <= 70 || 97 <= c && c <= 102;
}
function $80b3d2f58e77b583$var$isOctCode(c) {
    return 48 <= c && c <= 55;
}
function $80b3d2f58e77b583$var$isDecCode(c) {
    return 48 <= c && c <= 57;
}
function $80b3d2f58e77b583$var$resolveYamlInteger(data) {
    if (data === null) return false;
    var max = data.length, index = 0, hasDigits = false, ch;
    if (!max) return false;
    ch = data[index];
    if (ch === "-" || ch === "+") ch = data[++index];
    if (ch === "0") {
        if (index + 1 === max) return true;
        ch = data[++index];
        if (ch === "b") {
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === "_") continue;
                if (ch !== "0" && ch !== "1") return false;
                hasDigits = true;
            }
            return hasDigits && ch !== "_";
        }
        if (ch === "x") {
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === "_") continue;
                if (!$80b3d2f58e77b583$var$isHexCode(data.charCodeAt(index))) return false;
                hasDigits = true;
            }
            return hasDigits && ch !== "_";
        }
        if (ch === "o") {
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === "_") continue;
                if (!$80b3d2f58e77b583$var$isOctCode(data.charCodeAt(index))) return false;
                hasDigits = true;
            }
            return hasDigits && ch !== "_";
        }
    }
    if (ch === "_") return false;
    for(; index < max; index++){
        ch = data[index];
        if (ch === "_") continue;
        if (!$80b3d2f58e77b583$var$isDecCode(data.charCodeAt(index))) return false;
        hasDigits = true;
    }
    if (!hasDigits || ch === "_") return false;
    return true;
}
function $80b3d2f58e77b583$var$constructYamlInteger(data) {
    var value = data, sign = 1, ch;
    if (value.indexOf("_") !== -1) value = value.replace(/_/g, "");
    ch = value[0];
    if (ch === "-" || ch === "+") {
        if (ch === "-") sign = -1;
        value = value.slice(1);
        ch = value[0];
    }
    if (value === "0") return 0;
    if (ch === "0") {
        if (value[1] === "b") return sign * parseInt(value.slice(2), 2);
        if (value[1] === "x") return sign * parseInt(value.slice(2), 16);
        if (value[1] === "o") return sign * parseInt(value.slice(2), 8);
    }
    return sign * parseInt(value, 10);
}
function $80b3d2f58e77b583$var$isInteger(object) {
    return Object.prototype.toString.call(object) === "[object Number]" && object % 1 === 0 && !$80b3d2f58e77b583$var$common.isNegativeZero(object);
}
var $80b3d2f58e77b583$var$int = new $80b3d2f58e77b583$var$type("tag:yaml.org,2002:int", {
    kind: "scalar",
    resolve: $80b3d2f58e77b583$var$resolveYamlInteger,
    construct: $80b3d2f58e77b583$var$constructYamlInteger,
    predicate: $80b3d2f58e77b583$var$isInteger,
    represent: {
        binary: function(obj) {
            return obj >= 0 ? "0b" + obj.toString(2) : "-0b" + obj.toString(2).slice(1);
        },
        octal: function(obj) {
            return obj >= 0 ? "0o" + obj.toString(8) : "-0o" + obj.toString(8).slice(1);
        },
        decimal: function(obj) {
            return obj.toString(10);
        },
        /* eslint-disable max-len */ hexadecimal: function(obj) {
            return obj >= 0 ? "0x" + obj.toString(16).toUpperCase() : "-0x" + obj.toString(16).toUpperCase().slice(1);
        }
    },
    defaultStyle: "decimal",
    styleAliases: {
        binary: [
            2,
            "bin"
        ],
        octal: [
            8,
            "oct"
        ],
        decimal: [
            10,
            "dec"
        ],
        hexadecimal: [
            16,
            "hex"
        ]
    }
});
var $80b3d2f58e77b583$var$YAML_FLOAT_PATTERN = new RegExp(// 2.5e4, 2.5 and integers
"^(?:[-+]?(?:[0-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$");
function $80b3d2f58e77b583$var$resolveYamlFloat(data) {
    if (data === null) return false;
    if (!$80b3d2f58e77b583$var$YAML_FLOAT_PATTERN.test(data) || // Quick hack to not allow integers end with `_`
    // Probably should update regexp & check speed
    data[data.length - 1] === "_") return false;
    return true;
}
function $80b3d2f58e77b583$var$constructYamlFloat(data) {
    var value, sign;
    value = data.replace(/_/g, "").toLowerCase();
    sign = value[0] === "-" ? -1 : 1;
    if ("+-".indexOf(value[0]) >= 0) value = value.slice(1);
    if (value === ".inf") return sign === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
    else if (value === ".nan") return NaN;
    return sign * parseFloat(value, 10);
}
var $80b3d2f58e77b583$var$SCIENTIFIC_WITHOUT_DOT = /^[-+]?[0-9]+e/;
function $80b3d2f58e77b583$var$representYamlFloat(object, style) {
    var res;
    if (isNaN(object)) switch(style){
        case "lowercase":
            return ".nan";
        case "uppercase":
            return ".NAN";
        case "camelcase":
            return ".NaN";
    }
    else if (Number.POSITIVE_INFINITY === object) switch(style){
        case "lowercase":
            return ".inf";
        case "uppercase":
            return ".INF";
        case "camelcase":
            return ".Inf";
    }
    else if (Number.NEGATIVE_INFINITY === object) switch(style){
        case "lowercase":
            return "-.inf";
        case "uppercase":
            return "-.INF";
        case "camelcase":
            return "-.Inf";
    }
    else if ($80b3d2f58e77b583$var$common.isNegativeZero(object)) return "-0.0";
    res = object.toString(10);
    return $80b3d2f58e77b583$var$SCIENTIFIC_WITHOUT_DOT.test(res) ? res.replace("e", ".e") : res;
}
function $80b3d2f58e77b583$var$isFloat(object) {
    return Object.prototype.toString.call(object) === "[object Number]" && (object % 1 !== 0 || $80b3d2f58e77b583$var$common.isNegativeZero(object));
}
var $80b3d2f58e77b583$var$float = new $80b3d2f58e77b583$var$type("tag:yaml.org,2002:float", {
    kind: "scalar",
    resolve: $80b3d2f58e77b583$var$resolveYamlFloat,
    construct: $80b3d2f58e77b583$var$constructYamlFloat,
    predicate: $80b3d2f58e77b583$var$isFloat,
    represent: $80b3d2f58e77b583$var$representYamlFloat,
    defaultStyle: "lowercase"
});
var $80b3d2f58e77b583$var$json = $80b3d2f58e77b583$var$failsafe.extend({
    implicit: [
        $80b3d2f58e77b583$var$_null,
        $80b3d2f58e77b583$var$bool,
        $80b3d2f58e77b583$var$int,
        $80b3d2f58e77b583$var$float
    ]
});
var $80b3d2f58e77b583$var$core = $80b3d2f58e77b583$var$json;
var $80b3d2f58e77b583$var$YAML_DATE_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9])-([0-9][0-9])$");
var $80b3d2f58e77b583$var$YAML_TIMESTAMP_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?$");
function $80b3d2f58e77b583$var$resolveYamlTimestamp(data) {
    if (data === null) return false;
    if ($80b3d2f58e77b583$var$YAML_DATE_REGEXP.exec(data) !== null) return true;
    if ($80b3d2f58e77b583$var$YAML_TIMESTAMP_REGEXP.exec(data) !== null) return true;
    return false;
}
function $80b3d2f58e77b583$var$constructYamlTimestamp(data) {
    var match, year, month, day, hour, minute, second, fraction = 0, delta = null, tz_hour, tz_minute, date;
    match = $80b3d2f58e77b583$var$YAML_DATE_REGEXP.exec(data);
    if (match === null) match = $80b3d2f58e77b583$var$YAML_TIMESTAMP_REGEXP.exec(data);
    if (match === null) throw new Error("Date resolve error");
    year = +match[1];
    month = +match[2] - 1;
    day = +match[3];
    if (!match[4]) return new Date(Date.UTC(year, month, day));
    hour = +match[4];
    minute = +match[5];
    second = +match[6];
    if (match[7]) {
        fraction = match[7].slice(0, 3);
        while(fraction.length < 3)fraction += "0";
        fraction = +fraction;
    }
    if (match[9]) {
        tz_hour = +match[10];
        tz_minute = +(match[11] || 0);
        delta = (tz_hour * 60 + tz_minute) * 6e4;
        if (match[9] === "-") delta = -delta;
    }
    date = new Date(Date.UTC(year, month, day, hour, minute, second, fraction));
    if (delta) date.setTime(date.getTime() - delta);
    return date;
}
function $80b3d2f58e77b583$var$representYamlTimestamp(object) {
    return object.toISOString();
}
var $80b3d2f58e77b583$var$timestamp = new $80b3d2f58e77b583$var$type("tag:yaml.org,2002:timestamp", {
    kind: "scalar",
    resolve: $80b3d2f58e77b583$var$resolveYamlTimestamp,
    construct: $80b3d2f58e77b583$var$constructYamlTimestamp,
    instanceOf: Date,
    represent: $80b3d2f58e77b583$var$representYamlTimestamp
});
function $80b3d2f58e77b583$var$resolveYamlMerge(data) {
    return data === "<<" || data === null;
}
var $80b3d2f58e77b583$var$merge = new $80b3d2f58e77b583$var$type("tag:yaml.org,2002:merge", {
    kind: "scalar",
    resolve: $80b3d2f58e77b583$var$resolveYamlMerge
});
var $80b3d2f58e77b583$var$BASE64_MAP = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\n\r";
function $80b3d2f58e77b583$var$resolveYamlBinary(data) {
    if (data === null) return false;
    var code, idx, bitlen = 0, max = data.length, map2 = $80b3d2f58e77b583$var$BASE64_MAP;
    for(idx = 0; idx < max; idx++){
        code = map2.indexOf(data.charAt(idx));
        if (code > 64) continue;
        if (code < 0) return false;
        bitlen += 6;
    }
    return bitlen % 8 === 0;
}
function $80b3d2f58e77b583$var$constructYamlBinary(data) {
    var idx, tailbits, input = data.replace(/[\r\n=]/g, ""), max = input.length, map2 = $80b3d2f58e77b583$var$BASE64_MAP, bits = 0, result = [];
    for(idx = 0; idx < max; idx++){
        if (idx % 4 === 0 && idx) {
            result.push(bits >> 16 & 255);
            result.push(bits >> 8 & 255);
            result.push(bits & 255);
        }
        bits = bits << 6 | map2.indexOf(input.charAt(idx));
    }
    tailbits = max % 4 * 6;
    if (tailbits === 0) {
        result.push(bits >> 16 & 255);
        result.push(bits >> 8 & 255);
        result.push(bits & 255);
    } else if (tailbits === 18) {
        result.push(bits >> 10 & 255);
        result.push(bits >> 2 & 255);
    } else if (tailbits === 12) result.push(bits >> 4 & 255);
    return new Uint8Array(result);
}
function $80b3d2f58e77b583$var$representYamlBinary(object) {
    var result = "", bits = 0, idx, tail, max = object.length, map2 = $80b3d2f58e77b583$var$BASE64_MAP;
    for(idx = 0; idx < max; idx++){
        if (idx % 3 === 0 && idx) {
            result += map2[bits >> 18 & 63];
            result += map2[bits >> 12 & 63];
            result += map2[bits >> 6 & 63];
            result += map2[bits & 63];
        }
        bits = (bits << 8) + object[idx];
    }
    tail = max % 3;
    if (tail === 0) {
        result += map2[bits >> 18 & 63];
        result += map2[bits >> 12 & 63];
        result += map2[bits >> 6 & 63];
        result += map2[bits & 63];
    } else if (tail === 2) {
        result += map2[bits >> 10 & 63];
        result += map2[bits >> 4 & 63];
        result += map2[bits << 2 & 63];
        result += map2[64];
    } else if (tail === 1) {
        result += map2[bits >> 2 & 63];
        result += map2[bits << 4 & 63];
        result += map2[64];
        result += map2[64];
    }
    return result;
}
function $80b3d2f58e77b583$var$isBinary(obj) {
    return Object.prototype.toString.call(obj) === "[object Uint8Array]";
}
var $80b3d2f58e77b583$var$binary = new $80b3d2f58e77b583$var$type("tag:yaml.org,2002:binary", {
    kind: "scalar",
    resolve: $80b3d2f58e77b583$var$resolveYamlBinary,
    construct: $80b3d2f58e77b583$var$constructYamlBinary,
    predicate: $80b3d2f58e77b583$var$isBinary,
    represent: $80b3d2f58e77b583$var$representYamlBinary
});
var $80b3d2f58e77b583$var$_hasOwnProperty$3 = Object.prototype.hasOwnProperty;
var $80b3d2f58e77b583$var$_toString$2 = Object.prototype.toString;
function $80b3d2f58e77b583$var$resolveYamlOmap(data) {
    if (data === null) return true;
    var objectKeys = [], index, length, pair, pairKey, pairHasKey, object = data;
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        pairHasKey = false;
        if ($80b3d2f58e77b583$var$_toString$2.call(pair) !== "[object Object]") return false;
        for(pairKey in pair)if ($80b3d2f58e77b583$var$_hasOwnProperty$3.call(pair, pairKey)) {
            if (!pairHasKey) pairHasKey = true;
            else return false;
        }
        if (!pairHasKey) return false;
        if (objectKeys.indexOf(pairKey) === -1) objectKeys.push(pairKey);
        else return false;
    }
    return true;
}
function $80b3d2f58e77b583$var$constructYamlOmap(data) {
    return data !== null ? data : [];
}
var $80b3d2f58e77b583$var$omap = new $80b3d2f58e77b583$var$type("tag:yaml.org,2002:omap", {
    kind: "sequence",
    resolve: $80b3d2f58e77b583$var$resolveYamlOmap,
    construct: $80b3d2f58e77b583$var$constructYamlOmap
});
var $80b3d2f58e77b583$var$_toString$1 = Object.prototype.toString;
function $80b3d2f58e77b583$var$resolveYamlPairs(data) {
    if (data === null) return true;
    var index, length, pair, keys, result, object = data;
    result = new Array(object.length);
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        if ($80b3d2f58e77b583$var$_toString$1.call(pair) !== "[object Object]") return false;
        keys = Object.keys(pair);
        if (keys.length !== 1) return false;
        result[index] = [
            keys[0],
            pair[keys[0]]
        ];
    }
    return true;
}
function $80b3d2f58e77b583$var$constructYamlPairs(data) {
    if (data === null) return [];
    var index, length, pair, keys, result, object = data;
    result = new Array(object.length);
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        keys = Object.keys(pair);
        result[index] = [
            keys[0],
            pair[keys[0]]
        ];
    }
    return result;
}
var $80b3d2f58e77b583$var$pairs = new $80b3d2f58e77b583$var$type("tag:yaml.org,2002:pairs", {
    kind: "sequence",
    resolve: $80b3d2f58e77b583$var$resolveYamlPairs,
    construct: $80b3d2f58e77b583$var$constructYamlPairs
});
var $80b3d2f58e77b583$var$_hasOwnProperty$2 = Object.prototype.hasOwnProperty;
function $80b3d2f58e77b583$var$resolveYamlSet(data) {
    if (data === null) return true;
    var key, object = data;
    for(key in object)if ($80b3d2f58e77b583$var$_hasOwnProperty$2.call(object, key)) {
        if (object[key] !== null) return false;
    }
    return true;
}
function $80b3d2f58e77b583$var$constructYamlSet(data) {
    return data !== null ? data : {};
}
var $80b3d2f58e77b583$var$set = new $80b3d2f58e77b583$var$type("tag:yaml.org,2002:set", {
    kind: "mapping",
    resolve: $80b3d2f58e77b583$var$resolveYamlSet,
    construct: $80b3d2f58e77b583$var$constructYamlSet
});
var $80b3d2f58e77b583$var$_default = $80b3d2f58e77b583$var$core.extend({
    implicit: [
        $80b3d2f58e77b583$var$timestamp,
        $80b3d2f58e77b583$var$merge
    ],
    explicit: [
        $80b3d2f58e77b583$var$binary,
        $80b3d2f58e77b583$var$omap,
        $80b3d2f58e77b583$var$pairs,
        $80b3d2f58e77b583$var$set
    ]
});
var $80b3d2f58e77b583$var$_hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var $80b3d2f58e77b583$var$CONTEXT_FLOW_IN = 1;
var $80b3d2f58e77b583$var$CONTEXT_FLOW_OUT = 2;
var $80b3d2f58e77b583$var$CONTEXT_BLOCK_IN = 3;
var $80b3d2f58e77b583$var$CONTEXT_BLOCK_OUT = 4;
var $80b3d2f58e77b583$var$CHOMPING_CLIP = 1;
var $80b3d2f58e77b583$var$CHOMPING_STRIP = 2;
var $80b3d2f58e77b583$var$CHOMPING_KEEP = 3;
var $80b3d2f58e77b583$var$PATTERN_NON_PRINTABLE = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
var $80b3d2f58e77b583$var$PATTERN_NON_ASCII_LINE_BREAKS = /[\x85\u2028\u2029]/;
var $80b3d2f58e77b583$var$PATTERN_FLOW_INDICATORS = /[,\[\]\{\}]/;
var $80b3d2f58e77b583$var$PATTERN_TAG_HANDLE = /^(?:!|!!|![a-z\-]+!)$/i;
var $80b3d2f58e77b583$var$PATTERN_TAG_URI = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;
function $80b3d2f58e77b583$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $80b3d2f58e77b583$var$is_EOL(c) {
    return c === 10 || c === 13;
}
function $80b3d2f58e77b583$var$is_WHITE_SPACE(c) {
    return c === 9 || c === 32;
}
function $80b3d2f58e77b583$var$is_WS_OR_EOL(c) {
    return c === 9 || c === 32 || c === 10 || c === 13;
}
function $80b3d2f58e77b583$var$is_FLOW_INDICATOR(c) {
    return c === 44 || c === 91 || c === 93 || c === 123 || c === 125;
}
function $80b3d2f58e77b583$var$fromHexCode(c) {
    var lc;
    if (48 <= c && c <= 57) return c - 48;
    lc = c | 32;
    if (97 <= lc && lc <= 102) return lc - 97 + 10;
    return -1;
}
function $80b3d2f58e77b583$var$escapedHexLen(c) {
    if (c === 120) return 2;
    if (c === 117) return 4;
    if (c === 85) return 8;
    return 0;
}
function $80b3d2f58e77b583$var$fromDecimalCode(c) {
    if (48 <= c && c <= 57) return c - 48;
    return -1;
}
function $80b3d2f58e77b583$var$simpleEscapeSequence(c) {
    return c === 48 ? "\0" : c === 97 ? "\x07" : c === 98 ? "\b" : c === 116 ? "	" : c === 9 ? "	" : c === 110 ? "\n" : c === 118 ? "\v" : c === 102 ? "\f" : c === 114 ? "\r" : c === 101 ? "\x1B" : c === 32 ? " " : c === 34 ? '"' : c === 47 ? "/" : c === 92 ? "\\" : c === 78 ? "\x85" : c === 95 ? "\xa0" : c === 76 ? "\u2028" : c === 80 ? "\u2029" : "";
}
function $80b3d2f58e77b583$var$charFromCodepoint(c) {
    if (c <= 65535) return String.fromCharCode(c);
    return String.fromCharCode((c - 65536 >> 10) + 55296, (c - 65536 & 1023) + 56320);
}
var $80b3d2f58e77b583$var$simpleEscapeCheck = new Array(256);
var $80b3d2f58e77b583$var$simpleEscapeMap = new Array(256);
for(var $80b3d2f58e77b583$var$i = 0; $80b3d2f58e77b583$var$i < 256; $80b3d2f58e77b583$var$i++){
    $80b3d2f58e77b583$var$simpleEscapeCheck[$80b3d2f58e77b583$var$i] = $80b3d2f58e77b583$var$simpleEscapeSequence($80b3d2f58e77b583$var$i) ? 1 : 0;
    $80b3d2f58e77b583$var$simpleEscapeMap[$80b3d2f58e77b583$var$i] = $80b3d2f58e77b583$var$simpleEscapeSequence($80b3d2f58e77b583$var$i);
}
function $80b3d2f58e77b583$var$State$1(input, options) {
    this.input = input;
    this.filename = options["filename"] || null;
    this.schema = options["schema"] || $80b3d2f58e77b583$var$_default;
    this.onWarning = options["onWarning"] || null;
    this.legacy = options["legacy"] || false;
    this.json = options["json"] || false;
    this.listener = options["listener"] || null;
    this.implicitTypes = this.schema.compiledImplicit;
    this.typeMap = this.schema.compiledTypeMap;
    this.length = input.length;
    this.position = 0;
    this.line = 0;
    this.lineStart = 0;
    this.lineIndent = 0;
    this.firstTabInLine = -1;
    this.documents = [];
}
function $80b3d2f58e77b583$var$generateError(state2, message) {
    var mark = {
        name: state2.filename,
        buffer: state2.input.slice(0, -1),
        // omit trailing \0
        position: state2.position,
        line: state2.line,
        column: state2.position - state2.lineStart
    };
    mark.snippet = $80b3d2f58e77b583$var$snippet(mark);
    return new $80b3d2f58e77b583$var$exception(message, mark);
}
function $80b3d2f58e77b583$var$throwError(state2, message) {
    throw $80b3d2f58e77b583$var$generateError(state2, message);
}
function $80b3d2f58e77b583$var$throwWarning(state2, message) {
    if (state2.onWarning) state2.onWarning.call(null, $80b3d2f58e77b583$var$generateError(state2, message));
}
var $80b3d2f58e77b583$var$directiveHandlers = {
    YAML: function handleYamlDirective(state2, name, args) {
        var match, major, minor;
        if (state2.version !== null) $80b3d2f58e77b583$var$throwError(state2, "duplication of %YAML directive");
        if (args.length !== 1) $80b3d2f58e77b583$var$throwError(state2, "YAML directive accepts exactly one argument");
        match = /^([0-9]+)\.([0-9]+)$/.exec(args[0]);
        if (match === null) $80b3d2f58e77b583$var$throwError(state2, "ill-formed argument of the YAML directive");
        major = parseInt(match[1], 10);
        minor = parseInt(match[2], 10);
        if (major !== 1) $80b3d2f58e77b583$var$throwError(state2, "unacceptable YAML version of the document");
        state2.version = args[0];
        state2.checkLineBreaks = minor < 2;
        if (minor !== 1 && minor !== 2) $80b3d2f58e77b583$var$throwWarning(state2, "unsupported YAML version of the document");
    },
    TAG: function handleTagDirective(state2, name, args) {
        var handle, prefix;
        if (args.length !== 2) $80b3d2f58e77b583$var$throwError(state2, "TAG directive accepts exactly two arguments");
        handle = args[0];
        prefix = args[1];
        if (!$80b3d2f58e77b583$var$PATTERN_TAG_HANDLE.test(handle)) $80b3d2f58e77b583$var$throwError(state2, "ill-formed tag handle (first argument) of the TAG directive");
        if ($80b3d2f58e77b583$var$_hasOwnProperty$1.call(state2.tagMap, handle)) $80b3d2f58e77b583$var$throwError(state2, 'there is a previously declared suffix for "' + handle + '" tag handle');
        if (!$80b3d2f58e77b583$var$PATTERN_TAG_URI.test(prefix)) $80b3d2f58e77b583$var$throwError(state2, "ill-formed tag prefix (second argument) of the TAG directive");
        try {
            prefix = decodeURIComponent(prefix);
        } catch (err) {
            $80b3d2f58e77b583$var$throwError(state2, "tag prefix is malformed: " + prefix);
        }
        state2.tagMap[handle] = prefix;
    }
};
function $80b3d2f58e77b583$var$captureSegment(state2, start, end, checkJson) {
    var _position, _length, _character, _result;
    if (start < end) {
        _result = state2.input.slice(start, end);
        if (checkJson) for(_position = 0, _length = _result.length; _position < _length; _position += 1){
            _character = _result.charCodeAt(_position);
            if (!(_character === 9 || 32 <= _character && _character <= 1114111)) $80b3d2f58e77b583$var$throwError(state2, "expected valid JSON character");
        }
        else if ($80b3d2f58e77b583$var$PATTERN_NON_PRINTABLE.test(_result)) $80b3d2f58e77b583$var$throwError(state2, "the stream contains non-printable characters");
        state2.result += _result;
    }
}
function $80b3d2f58e77b583$var$mergeMappings(state2, destination, source, overridableKeys) {
    var sourceKeys, key, index, quantity;
    if (!$80b3d2f58e77b583$var$common.isObject(source)) $80b3d2f58e77b583$var$throwError(state2, "cannot merge mappings; the provided source object is unacceptable");
    sourceKeys = Object.keys(source);
    for(index = 0, quantity = sourceKeys.length; index < quantity; index += 1){
        key = sourceKeys[index];
        if (!$80b3d2f58e77b583$var$_hasOwnProperty$1.call(destination, key)) {
            destination[key] = source[key];
            overridableKeys[key] = true;
        }
    }
}
function $80b3d2f58e77b583$var$storeMappingPair(state2, _result, overridableKeys, keyTag, keyNode, valueNode, startLine, startLineStart, startPos) {
    var index, quantity;
    if (Array.isArray(keyNode)) {
        keyNode = Array.prototype.slice.call(keyNode);
        for(index = 0, quantity = keyNode.length; index < quantity; index += 1){
            if (Array.isArray(keyNode[index])) $80b3d2f58e77b583$var$throwError(state2, "nested arrays are not supported inside keys");
            if (typeof keyNode === "object" && $80b3d2f58e77b583$var$_class(keyNode[index]) === "[object Object]") keyNode[index] = "[object Object]";
        }
    }
    if (typeof keyNode === "object" && $80b3d2f58e77b583$var$_class(keyNode) === "[object Object]") keyNode = "[object Object]";
    keyNode = String(keyNode);
    if (_result === null) _result = {};
    if (keyTag === "tag:yaml.org,2002:merge") {
        if (Array.isArray(valueNode)) for(index = 0, quantity = valueNode.length; index < quantity; index += 1)$80b3d2f58e77b583$var$mergeMappings(state2, _result, valueNode[index], overridableKeys);
        else $80b3d2f58e77b583$var$mergeMappings(state2, _result, valueNode, overridableKeys);
    } else {
        if (!state2.json && !$80b3d2f58e77b583$var$_hasOwnProperty$1.call(overridableKeys, keyNode) && $80b3d2f58e77b583$var$_hasOwnProperty$1.call(_result, keyNode)) {
            state2.line = startLine || state2.line;
            state2.lineStart = startLineStart || state2.lineStart;
            state2.position = startPos || state2.position;
            $80b3d2f58e77b583$var$throwError(state2, "duplicated mapping key");
        }
        if (keyNode === "__proto__") Object.defineProperty(_result, keyNode, {
            configurable: true,
            enumerable: true,
            writable: true,
            value: valueNode
        });
        else _result[keyNode] = valueNode;
        delete overridableKeys[keyNode];
    }
    return _result;
}
function $80b3d2f58e77b583$var$readLineBreak(state2) {
    var ch;
    ch = state2.input.charCodeAt(state2.position);
    if (ch === 10) state2.position++;
    else if (ch === 13) {
        state2.position++;
        if (state2.input.charCodeAt(state2.position) === 10) state2.position++;
    } else $80b3d2f58e77b583$var$throwError(state2, "a line break is expected");
    state2.line += 1;
    state2.lineStart = state2.position;
    state2.firstTabInLine = -1;
}
function $80b3d2f58e77b583$var$skipSeparationSpace(state2, allowComments, checkIndent) {
    var lineBreaks = 0, ch = state2.input.charCodeAt(state2.position);
    while(ch !== 0){
        while($80b3d2f58e77b583$var$is_WHITE_SPACE(ch)){
            if (ch === 9 && state2.firstTabInLine === -1) state2.firstTabInLine = state2.position;
            ch = state2.input.charCodeAt(++state2.position);
        }
        if (allowComments && ch === 35) do ch = state2.input.charCodeAt(++state2.position);
        while (ch !== 10 && ch !== 13 && ch !== 0);
        if ($80b3d2f58e77b583$var$is_EOL(ch)) {
            $80b3d2f58e77b583$var$readLineBreak(state2);
            ch = state2.input.charCodeAt(state2.position);
            lineBreaks++;
            state2.lineIndent = 0;
            while(ch === 32){
                state2.lineIndent++;
                ch = state2.input.charCodeAt(++state2.position);
            }
        } else break;
    }
    if (checkIndent !== -1 && lineBreaks !== 0 && state2.lineIndent < checkIndent) $80b3d2f58e77b583$var$throwWarning(state2, "deficient indentation");
    return lineBreaks;
}
function $80b3d2f58e77b583$var$testDocumentSeparator(state2) {
    var _position = state2.position, ch;
    ch = state2.input.charCodeAt(_position);
    if ((ch === 45 || ch === 46) && ch === state2.input.charCodeAt(_position + 1) && ch === state2.input.charCodeAt(_position + 2)) {
        _position += 3;
        ch = state2.input.charCodeAt(_position);
        if (ch === 0 || $80b3d2f58e77b583$var$is_WS_OR_EOL(ch)) return true;
    }
    return false;
}
function $80b3d2f58e77b583$var$writeFoldedLines(state2, count) {
    if (count === 1) state2.result += " ";
    else if (count > 1) state2.result += $80b3d2f58e77b583$var$common.repeat("\n", count - 1);
}
function $80b3d2f58e77b583$var$readPlainScalar(state2, nodeIndent, withinFlowCollection) {
    var preceding, following, captureStart, captureEnd, hasPendingContent, _line, _lineStart, _lineIndent, _kind = state2.kind, _result = state2.result, ch;
    ch = state2.input.charCodeAt(state2.position);
    if ($80b3d2f58e77b583$var$is_WS_OR_EOL(ch) || $80b3d2f58e77b583$var$is_FLOW_INDICATOR(ch) || ch === 35 || ch === 38 || ch === 42 || ch === 33 || ch === 124 || ch === 62 || ch === 39 || ch === 34 || ch === 37 || ch === 64 || ch === 96) return false;
    if (ch === 63 || ch === 45) {
        following = state2.input.charCodeAt(state2.position + 1);
        if ($80b3d2f58e77b583$var$is_WS_OR_EOL(following) || withinFlowCollection && $80b3d2f58e77b583$var$is_FLOW_INDICATOR(following)) return false;
    }
    state2.kind = "scalar";
    state2.result = "";
    captureStart = captureEnd = state2.position;
    hasPendingContent = false;
    while(ch !== 0){
        if (ch === 58) {
            following = state2.input.charCodeAt(state2.position + 1);
            if ($80b3d2f58e77b583$var$is_WS_OR_EOL(following) || withinFlowCollection && $80b3d2f58e77b583$var$is_FLOW_INDICATOR(following)) break;
        } else if (ch === 35) {
            preceding = state2.input.charCodeAt(state2.position - 1);
            if ($80b3d2f58e77b583$var$is_WS_OR_EOL(preceding)) break;
        } else if (state2.position === state2.lineStart && $80b3d2f58e77b583$var$testDocumentSeparator(state2) || withinFlowCollection && $80b3d2f58e77b583$var$is_FLOW_INDICATOR(ch)) break;
        else if ($80b3d2f58e77b583$var$is_EOL(ch)) {
            _line = state2.line;
            _lineStart = state2.lineStart;
            _lineIndent = state2.lineIndent;
            $80b3d2f58e77b583$var$skipSeparationSpace(state2, false, -1);
            if (state2.lineIndent >= nodeIndent) {
                hasPendingContent = true;
                ch = state2.input.charCodeAt(state2.position);
                continue;
            } else {
                state2.position = captureEnd;
                state2.line = _line;
                state2.lineStart = _lineStart;
                state2.lineIndent = _lineIndent;
                break;
            }
        }
        if (hasPendingContent) {
            $80b3d2f58e77b583$var$captureSegment(state2, captureStart, captureEnd, false);
            $80b3d2f58e77b583$var$writeFoldedLines(state2, state2.line - _line);
            captureStart = captureEnd = state2.position;
            hasPendingContent = false;
        }
        if (!$80b3d2f58e77b583$var$is_WHITE_SPACE(ch)) captureEnd = state2.position + 1;
        ch = state2.input.charCodeAt(++state2.position);
    }
    $80b3d2f58e77b583$var$captureSegment(state2, captureStart, captureEnd, false);
    if (state2.result) return true;
    state2.kind = _kind;
    state2.result = _result;
    return false;
}
function $80b3d2f58e77b583$var$readSingleQuotedScalar(state2, nodeIndent) {
    var ch, captureStart, captureEnd;
    ch = state2.input.charCodeAt(state2.position);
    if (ch !== 39) return false;
    state2.kind = "scalar";
    state2.result = "";
    state2.position++;
    captureStart = captureEnd = state2.position;
    while((ch = state2.input.charCodeAt(state2.position)) !== 0){
        if (ch === 39) {
            $80b3d2f58e77b583$var$captureSegment(state2, captureStart, state2.position, true);
            ch = state2.input.charCodeAt(++state2.position);
            if (ch === 39) {
                captureStart = state2.position;
                state2.position++;
                captureEnd = state2.position;
            } else return true;
        } else if ($80b3d2f58e77b583$var$is_EOL(ch)) {
            $80b3d2f58e77b583$var$captureSegment(state2, captureStart, captureEnd, true);
            $80b3d2f58e77b583$var$writeFoldedLines(state2, $80b3d2f58e77b583$var$skipSeparationSpace(state2, false, nodeIndent));
            captureStart = captureEnd = state2.position;
        } else if (state2.position === state2.lineStart && $80b3d2f58e77b583$var$testDocumentSeparator(state2)) $80b3d2f58e77b583$var$throwError(state2, "unexpected end of the document within a single quoted scalar");
        else {
            state2.position++;
            captureEnd = state2.position;
        }
    }
    $80b3d2f58e77b583$var$throwError(state2, "unexpected end of the stream within a single quoted scalar");
}
function $80b3d2f58e77b583$var$readDoubleQuotedScalar(state2, nodeIndent) {
    var captureStart, captureEnd, hexLength, hexResult, tmp, ch;
    ch = state2.input.charCodeAt(state2.position);
    if (ch !== 34) return false;
    state2.kind = "scalar";
    state2.result = "";
    state2.position++;
    captureStart = captureEnd = state2.position;
    while((ch = state2.input.charCodeAt(state2.position)) !== 0){
        if (ch === 34) {
            $80b3d2f58e77b583$var$captureSegment(state2, captureStart, state2.position, true);
            state2.position++;
            return true;
        } else if (ch === 92) {
            $80b3d2f58e77b583$var$captureSegment(state2, captureStart, state2.position, true);
            ch = state2.input.charCodeAt(++state2.position);
            if ($80b3d2f58e77b583$var$is_EOL(ch)) $80b3d2f58e77b583$var$skipSeparationSpace(state2, false, nodeIndent);
            else if (ch < 256 && $80b3d2f58e77b583$var$simpleEscapeCheck[ch]) {
                state2.result += $80b3d2f58e77b583$var$simpleEscapeMap[ch];
                state2.position++;
            } else if ((tmp = $80b3d2f58e77b583$var$escapedHexLen(ch)) > 0) {
                hexLength = tmp;
                hexResult = 0;
                for(; hexLength > 0; hexLength--){
                    ch = state2.input.charCodeAt(++state2.position);
                    if ((tmp = $80b3d2f58e77b583$var$fromHexCode(ch)) >= 0) hexResult = (hexResult << 4) + tmp;
                    else $80b3d2f58e77b583$var$throwError(state2, "expected hexadecimal character");
                }
                state2.result += $80b3d2f58e77b583$var$charFromCodepoint(hexResult);
                state2.position++;
            } else $80b3d2f58e77b583$var$throwError(state2, "unknown escape sequence");
            captureStart = captureEnd = state2.position;
        } else if ($80b3d2f58e77b583$var$is_EOL(ch)) {
            $80b3d2f58e77b583$var$captureSegment(state2, captureStart, captureEnd, true);
            $80b3d2f58e77b583$var$writeFoldedLines(state2, $80b3d2f58e77b583$var$skipSeparationSpace(state2, false, nodeIndent));
            captureStart = captureEnd = state2.position;
        } else if (state2.position === state2.lineStart && $80b3d2f58e77b583$var$testDocumentSeparator(state2)) $80b3d2f58e77b583$var$throwError(state2, "unexpected end of the document within a double quoted scalar");
        else {
            state2.position++;
            captureEnd = state2.position;
        }
    }
    $80b3d2f58e77b583$var$throwError(state2, "unexpected end of the stream within a double quoted scalar");
}
function $80b3d2f58e77b583$var$readFlowCollection(state2, nodeIndent) {
    var readNext = true, _line, _lineStart, _pos, _tag = state2.tag, _result, _anchor = state2.anchor, following, terminator, isPair, isExplicitPair, isMapping, overridableKeys = /* @__PURE__ */ Object.create(null), keyNode, keyTag, valueNode, ch;
    ch = state2.input.charCodeAt(state2.position);
    if (ch === 91) {
        terminator = 93;
        isMapping = false;
        _result = [];
    } else if (ch === 123) {
        terminator = 125;
        isMapping = true;
        _result = {};
    } else return false;
    if (state2.anchor !== null) state2.anchorMap[state2.anchor] = _result;
    ch = state2.input.charCodeAt(++state2.position);
    while(ch !== 0){
        $80b3d2f58e77b583$var$skipSeparationSpace(state2, true, nodeIndent);
        ch = state2.input.charCodeAt(state2.position);
        if (ch === terminator) {
            state2.position++;
            state2.tag = _tag;
            state2.anchor = _anchor;
            state2.kind = isMapping ? "mapping" : "sequence";
            state2.result = _result;
            return true;
        } else if (!readNext) $80b3d2f58e77b583$var$throwError(state2, "missed comma between flow collection entries");
        else if (ch === 44) $80b3d2f58e77b583$var$throwError(state2, "expected the node content, but found ','");
        keyTag = keyNode = valueNode = null;
        isPair = isExplicitPair = false;
        if (ch === 63) {
            following = state2.input.charCodeAt(state2.position + 1);
            if ($80b3d2f58e77b583$var$is_WS_OR_EOL(following)) {
                isPair = isExplicitPair = true;
                state2.position++;
                $80b3d2f58e77b583$var$skipSeparationSpace(state2, true, nodeIndent);
            }
        }
        _line = state2.line;
        _lineStart = state2.lineStart;
        _pos = state2.position;
        $80b3d2f58e77b583$var$composeNode(state2, nodeIndent, $80b3d2f58e77b583$var$CONTEXT_FLOW_IN, false, true);
        keyTag = state2.tag;
        keyNode = state2.result;
        $80b3d2f58e77b583$var$skipSeparationSpace(state2, true, nodeIndent);
        ch = state2.input.charCodeAt(state2.position);
        if ((isExplicitPair || state2.line === _line) && ch === 58) {
            isPair = true;
            ch = state2.input.charCodeAt(++state2.position);
            $80b3d2f58e77b583$var$skipSeparationSpace(state2, true, nodeIndent);
            $80b3d2f58e77b583$var$composeNode(state2, nodeIndent, $80b3d2f58e77b583$var$CONTEXT_FLOW_IN, false, true);
            valueNode = state2.result;
        }
        if (isMapping) $80b3d2f58e77b583$var$storeMappingPair(state2, _result, overridableKeys, keyTag, keyNode, valueNode, _line, _lineStart, _pos);
        else if (isPair) _result.push($80b3d2f58e77b583$var$storeMappingPair(state2, null, overridableKeys, keyTag, keyNode, valueNode, _line, _lineStart, _pos));
        else _result.push(keyNode);
        $80b3d2f58e77b583$var$skipSeparationSpace(state2, true, nodeIndent);
        ch = state2.input.charCodeAt(state2.position);
        if (ch === 44) {
            readNext = true;
            ch = state2.input.charCodeAt(++state2.position);
        } else readNext = false;
    }
    $80b3d2f58e77b583$var$throwError(state2, "unexpected end of the stream within a flow collection");
}
function $80b3d2f58e77b583$var$readBlockScalar(state2, nodeIndent) {
    var captureStart, folding, chomping = $80b3d2f58e77b583$var$CHOMPING_CLIP, didReadContent = false, detectedIndent = false, textIndent = nodeIndent, emptyLines = 0, atMoreIndented = false, tmp, ch;
    ch = state2.input.charCodeAt(state2.position);
    if (ch === 124) folding = false;
    else if (ch === 62) folding = true;
    else return false;
    state2.kind = "scalar";
    state2.result = "";
    while(ch !== 0){
        ch = state2.input.charCodeAt(++state2.position);
        if (ch === 43 || ch === 45) {
            if ($80b3d2f58e77b583$var$CHOMPING_CLIP === chomping) chomping = ch === 43 ? $80b3d2f58e77b583$var$CHOMPING_KEEP : $80b3d2f58e77b583$var$CHOMPING_STRIP;
            else $80b3d2f58e77b583$var$throwError(state2, "repeat of a chomping mode identifier");
        } else if ((tmp = $80b3d2f58e77b583$var$fromDecimalCode(ch)) >= 0) {
            if (tmp === 0) $80b3d2f58e77b583$var$throwError(state2, "bad explicit indentation width of a block scalar; it cannot be less than one");
            else if (!detectedIndent) {
                textIndent = nodeIndent + tmp - 1;
                detectedIndent = true;
            } else $80b3d2f58e77b583$var$throwError(state2, "repeat of an indentation width identifier");
        } else break;
    }
    if ($80b3d2f58e77b583$var$is_WHITE_SPACE(ch)) {
        do ch = state2.input.charCodeAt(++state2.position);
        while ($80b3d2f58e77b583$var$is_WHITE_SPACE(ch));
        if (ch === 35) do ch = state2.input.charCodeAt(++state2.position);
        while (!$80b3d2f58e77b583$var$is_EOL(ch) && ch !== 0);
    }
    while(ch !== 0){
        $80b3d2f58e77b583$var$readLineBreak(state2);
        state2.lineIndent = 0;
        ch = state2.input.charCodeAt(state2.position);
        while((!detectedIndent || state2.lineIndent < textIndent) && ch === 32){
            state2.lineIndent++;
            ch = state2.input.charCodeAt(++state2.position);
        }
        if (!detectedIndent && state2.lineIndent > textIndent) textIndent = state2.lineIndent;
        if ($80b3d2f58e77b583$var$is_EOL(ch)) {
            emptyLines++;
            continue;
        }
        if (state2.lineIndent < textIndent) {
            if (chomping === $80b3d2f58e77b583$var$CHOMPING_KEEP) state2.result += $80b3d2f58e77b583$var$common.repeat("\n", didReadContent ? 1 + emptyLines : emptyLines);
            else if (chomping === $80b3d2f58e77b583$var$CHOMPING_CLIP) {
                if (didReadContent) state2.result += "\n";
            }
            break;
        }
        if (folding) {
            if ($80b3d2f58e77b583$var$is_WHITE_SPACE(ch)) {
                atMoreIndented = true;
                state2.result += $80b3d2f58e77b583$var$common.repeat("\n", didReadContent ? 1 + emptyLines : emptyLines);
            } else if (atMoreIndented) {
                atMoreIndented = false;
                state2.result += $80b3d2f58e77b583$var$common.repeat("\n", emptyLines + 1);
            } else if (emptyLines === 0) {
                if (didReadContent) state2.result += " ";
            } else state2.result += $80b3d2f58e77b583$var$common.repeat("\n", emptyLines);
        } else state2.result += $80b3d2f58e77b583$var$common.repeat("\n", didReadContent ? 1 + emptyLines : emptyLines);
        didReadContent = true;
        detectedIndent = true;
        emptyLines = 0;
        captureStart = state2.position;
        while(!$80b3d2f58e77b583$var$is_EOL(ch) && ch !== 0)ch = state2.input.charCodeAt(++state2.position);
        $80b3d2f58e77b583$var$captureSegment(state2, captureStart, state2.position, false);
    }
    return true;
}
function $80b3d2f58e77b583$var$readBlockSequence(state2, nodeIndent) {
    var _line, _tag = state2.tag, _anchor = state2.anchor, _result = [], following, detected = false, ch;
    if (state2.firstTabInLine !== -1) return false;
    if (state2.anchor !== null) state2.anchorMap[state2.anchor] = _result;
    ch = state2.input.charCodeAt(state2.position);
    while(ch !== 0){
        if (state2.firstTabInLine !== -1) {
            state2.position = state2.firstTabInLine;
            $80b3d2f58e77b583$var$throwError(state2, "tab characters must not be used in indentation");
        }
        if (ch !== 45) break;
        following = state2.input.charCodeAt(state2.position + 1);
        if (!$80b3d2f58e77b583$var$is_WS_OR_EOL(following)) break;
        detected = true;
        state2.position++;
        if ($80b3d2f58e77b583$var$skipSeparationSpace(state2, true, -1)) {
            if (state2.lineIndent <= nodeIndent) {
                _result.push(null);
                ch = state2.input.charCodeAt(state2.position);
                continue;
            }
        }
        _line = state2.line;
        $80b3d2f58e77b583$var$composeNode(state2, nodeIndent, $80b3d2f58e77b583$var$CONTEXT_BLOCK_IN, false, true);
        _result.push(state2.result);
        $80b3d2f58e77b583$var$skipSeparationSpace(state2, true, -1);
        ch = state2.input.charCodeAt(state2.position);
        if ((state2.line === _line || state2.lineIndent > nodeIndent) && ch !== 0) $80b3d2f58e77b583$var$throwError(state2, "bad indentation of a sequence entry");
        else if (state2.lineIndent < nodeIndent) break;
    }
    if (detected) {
        state2.tag = _tag;
        state2.anchor = _anchor;
        state2.kind = "sequence";
        state2.result = _result;
        return true;
    }
    return false;
}
function $80b3d2f58e77b583$var$readBlockMapping(state2, nodeIndent, flowIndent) {
    var following, allowCompact, _line, _keyLine, _keyLineStart, _keyPos, _tag = state2.tag, _anchor = state2.anchor, _result = {}, overridableKeys = /* @__PURE__ */ Object.create(null), keyTag = null, keyNode = null, valueNode = null, atExplicitKey = false, detected = false, ch;
    if (state2.firstTabInLine !== -1) return false;
    if (state2.anchor !== null) state2.anchorMap[state2.anchor] = _result;
    ch = state2.input.charCodeAt(state2.position);
    while(ch !== 0){
        if (!atExplicitKey && state2.firstTabInLine !== -1) {
            state2.position = state2.firstTabInLine;
            $80b3d2f58e77b583$var$throwError(state2, "tab characters must not be used in indentation");
        }
        following = state2.input.charCodeAt(state2.position + 1);
        _line = state2.line;
        if ((ch === 63 || ch === 58) && $80b3d2f58e77b583$var$is_WS_OR_EOL(following)) {
            if (ch === 63) {
                if (atExplicitKey) {
                    $80b3d2f58e77b583$var$storeMappingPair(state2, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
                    keyTag = keyNode = valueNode = null;
                }
                detected = true;
                atExplicitKey = true;
                allowCompact = true;
            } else if (atExplicitKey) {
                atExplicitKey = false;
                allowCompact = true;
            } else $80b3d2f58e77b583$var$throwError(state2, "incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line");
            state2.position += 1;
            ch = following;
        } else {
            _keyLine = state2.line;
            _keyLineStart = state2.lineStart;
            _keyPos = state2.position;
            if (!$80b3d2f58e77b583$var$composeNode(state2, flowIndent, $80b3d2f58e77b583$var$CONTEXT_FLOW_OUT, false, true)) break;
            if (state2.line === _line) {
                ch = state2.input.charCodeAt(state2.position);
                while($80b3d2f58e77b583$var$is_WHITE_SPACE(ch))ch = state2.input.charCodeAt(++state2.position);
                if (ch === 58) {
                    ch = state2.input.charCodeAt(++state2.position);
                    if (!$80b3d2f58e77b583$var$is_WS_OR_EOL(ch)) $80b3d2f58e77b583$var$throwError(state2, "a whitespace character is expected after the key-value separator within a block mapping");
                    if (atExplicitKey) {
                        $80b3d2f58e77b583$var$storeMappingPair(state2, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
                        keyTag = keyNode = valueNode = null;
                    }
                    detected = true;
                    atExplicitKey = false;
                    allowCompact = false;
                    keyTag = state2.tag;
                    keyNode = state2.result;
                } else if (detected) $80b3d2f58e77b583$var$throwError(state2, "can not read an implicit mapping pair; a colon is missed");
                else {
                    state2.tag = _tag;
                    state2.anchor = _anchor;
                    return true;
                }
            } else if (detected) $80b3d2f58e77b583$var$throwError(state2, "can not read a block mapping entry; a multiline key may not be an implicit key");
            else {
                state2.tag = _tag;
                state2.anchor = _anchor;
                return true;
            }
        }
        if (state2.line === _line || state2.lineIndent > nodeIndent) {
            if (atExplicitKey) {
                _keyLine = state2.line;
                _keyLineStart = state2.lineStart;
                _keyPos = state2.position;
            }
            if ($80b3d2f58e77b583$var$composeNode(state2, nodeIndent, $80b3d2f58e77b583$var$CONTEXT_BLOCK_OUT, true, allowCompact)) {
                if (atExplicitKey) keyNode = state2.result;
                else valueNode = state2.result;
            }
            if (!atExplicitKey) {
                $80b3d2f58e77b583$var$storeMappingPair(state2, _result, overridableKeys, keyTag, keyNode, valueNode, _keyLine, _keyLineStart, _keyPos);
                keyTag = keyNode = valueNode = null;
            }
            $80b3d2f58e77b583$var$skipSeparationSpace(state2, true, -1);
            ch = state2.input.charCodeAt(state2.position);
        }
        if ((state2.line === _line || state2.lineIndent > nodeIndent) && ch !== 0) $80b3d2f58e77b583$var$throwError(state2, "bad indentation of a mapping entry");
        else if (state2.lineIndent < nodeIndent) break;
    }
    if (atExplicitKey) $80b3d2f58e77b583$var$storeMappingPair(state2, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
    if (detected) {
        state2.tag = _tag;
        state2.anchor = _anchor;
        state2.kind = "mapping";
        state2.result = _result;
    }
    return detected;
}
function $80b3d2f58e77b583$var$readTagProperty(state2) {
    var _position, isVerbatim = false, isNamed = false, tagHandle, tagName, ch;
    ch = state2.input.charCodeAt(state2.position);
    if (ch !== 33) return false;
    if (state2.tag !== null) $80b3d2f58e77b583$var$throwError(state2, "duplication of a tag property");
    ch = state2.input.charCodeAt(++state2.position);
    if (ch === 60) {
        isVerbatim = true;
        ch = state2.input.charCodeAt(++state2.position);
    } else if (ch === 33) {
        isNamed = true;
        tagHandle = "!!";
        ch = state2.input.charCodeAt(++state2.position);
    } else tagHandle = "!";
    _position = state2.position;
    if (isVerbatim) {
        do ch = state2.input.charCodeAt(++state2.position);
        while (ch !== 0 && ch !== 62);
        if (state2.position < state2.length) {
            tagName = state2.input.slice(_position, state2.position);
            ch = state2.input.charCodeAt(++state2.position);
        } else $80b3d2f58e77b583$var$throwError(state2, "unexpected end of the stream within a verbatim tag");
    } else {
        while(ch !== 0 && !$80b3d2f58e77b583$var$is_WS_OR_EOL(ch)){
            if (ch === 33) {
                if (!isNamed) {
                    tagHandle = state2.input.slice(_position - 1, state2.position + 1);
                    if (!$80b3d2f58e77b583$var$PATTERN_TAG_HANDLE.test(tagHandle)) $80b3d2f58e77b583$var$throwError(state2, "named tag handle cannot contain such characters");
                    isNamed = true;
                    _position = state2.position + 1;
                } else $80b3d2f58e77b583$var$throwError(state2, "tag suffix cannot contain exclamation marks");
            }
            ch = state2.input.charCodeAt(++state2.position);
        }
        tagName = state2.input.slice(_position, state2.position);
        if ($80b3d2f58e77b583$var$PATTERN_FLOW_INDICATORS.test(tagName)) $80b3d2f58e77b583$var$throwError(state2, "tag suffix cannot contain flow indicator characters");
    }
    if (tagName && !$80b3d2f58e77b583$var$PATTERN_TAG_URI.test(tagName)) $80b3d2f58e77b583$var$throwError(state2, "tag name cannot contain such characters: " + tagName);
    try {
        tagName = decodeURIComponent(tagName);
    } catch (err) {
        $80b3d2f58e77b583$var$throwError(state2, "tag name is malformed: " + tagName);
    }
    if (isVerbatim) state2.tag = tagName;
    else if ($80b3d2f58e77b583$var$_hasOwnProperty$1.call(state2.tagMap, tagHandle)) state2.tag = state2.tagMap[tagHandle] + tagName;
    else if (tagHandle === "!") state2.tag = "!" + tagName;
    else if (tagHandle === "!!") state2.tag = "tag:yaml.org,2002:" + tagName;
    else $80b3d2f58e77b583$var$throwError(state2, 'undeclared tag handle "' + tagHandle + '"');
    return true;
}
function $80b3d2f58e77b583$var$readAnchorProperty(state2) {
    var _position, ch;
    ch = state2.input.charCodeAt(state2.position);
    if (ch !== 38) return false;
    if (state2.anchor !== null) $80b3d2f58e77b583$var$throwError(state2, "duplication of an anchor property");
    ch = state2.input.charCodeAt(++state2.position);
    _position = state2.position;
    while(ch !== 0 && !$80b3d2f58e77b583$var$is_WS_OR_EOL(ch) && !$80b3d2f58e77b583$var$is_FLOW_INDICATOR(ch))ch = state2.input.charCodeAt(++state2.position);
    if (state2.position === _position) $80b3d2f58e77b583$var$throwError(state2, "name of an anchor node must contain at least one character");
    state2.anchor = state2.input.slice(_position, state2.position);
    return true;
}
function $80b3d2f58e77b583$var$readAlias(state2) {
    var _position, alias, ch;
    ch = state2.input.charCodeAt(state2.position);
    if (ch !== 42) return false;
    ch = state2.input.charCodeAt(++state2.position);
    _position = state2.position;
    while(ch !== 0 && !$80b3d2f58e77b583$var$is_WS_OR_EOL(ch) && !$80b3d2f58e77b583$var$is_FLOW_INDICATOR(ch))ch = state2.input.charCodeAt(++state2.position);
    if (state2.position === _position) $80b3d2f58e77b583$var$throwError(state2, "name of an alias node must contain at least one character");
    alias = state2.input.slice(_position, state2.position);
    if (!$80b3d2f58e77b583$var$_hasOwnProperty$1.call(state2.anchorMap, alias)) $80b3d2f58e77b583$var$throwError(state2, 'unidentified alias "' + alias + '"');
    state2.result = state2.anchorMap[alias];
    $80b3d2f58e77b583$var$skipSeparationSpace(state2, true, -1);
    return true;
}
function $80b3d2f58e77b583$var$composeNode(state2, parentIndent, nodeContext, allowToSeek, allowCompact) {
    var allowBlockStyles, allowBlockScalars, allowBlockCollections, indentStatus = 1, atNewLine = false, hasContent = false, typeIndex, typeQuantity, typeList, type2, flowIndent, blockIndent;
    if (state2.listener !== null) state2.listener("open", state2);
    state2.tag = null;
    state2.anchor = null;
    state2.kind = null;
    state2.result = null;
    allowBlockStyles = allowBlockScalars = allowBlockCollections = $80b3d2f58e77b583$var$CONTEXT_BLOCK_OUT === nodeContext || $80b3d2f58e77b583$var$CONTEXT_BLOCK_IN === nodeContext;
    if (allowToSeek) {
        if ($80b3d2f58e77b583$var$skipSeparationSpace(state2, true, -1)) {
            atNewLine = true;
            if (state2.lineIndent > parentIndent) indentStatus = 1;
            else if (state2.lineIndent === parentIndent) indentStatus = 0;
            else if (state2.lineIndent < parentIndent) indentStatus = -1;
        }
    }
    if (indentStatus === 1) {
        while($80b3d2f58e77b583$var$readTagProperty(state2) || $80b3d2f58e77b583$var$readAnchorProperty(state2))if ($80b3d2f58e77b583$var$skipSeparationSpace(state2, true, -1)) {
            atNewLine = true;
            allowBlockCollections = allowBlockStyles;
            if (state2.lineIndent > parentIndent) indentStatus = 1;
            else if (state2.lineIndent === parentIndent) indentStatus = 0;
            else if (state2.lineIndent < parentIndent) indentStatus = -1;
        } else allowBlockCollections = false;
    }
    if (allowBlockCollections) allowBlockCollections = atNewLine || allowCompact;
    if (indentStatus === 1 || $80b3d2f58e77b583$var$CONTEXT_BLOCK_OUT === nodeContext) {
        if ($80b3d2f58e77b583$var$CONTEXT_FLOW_IN === nodeContext || $80b3d2f58e77b583$var$CONTEXT_FLOW_OUT === nodeContext) flowIndent = parentIndent;
        else flowIndent = parentIndent + 1;
        blockIndent = state2.position - state2.lineStart;
        if (indentStatus === 1) {
            if (allowBlockCollections && ($80b3d2f58e77b583$var$readBlockSequence(state2, blockIndent) || $80b3d2f58e77b583$var$readBlockMapping(state2, blockIndent, flowIndent)) || $80b3d2f58e77b583$var$readFlowCollection(state2, flowIndent)) hasContent = true;
            else {
                if (allowBlockScalars && $80b3d2f58e77b583$var$readBlockScalar(state2, flowIndent) || $80b3d2f58e77b583$var$readSingleQuotedScalar(state2, flowIndent) || $80b3d2f58e77b583$var$readDoubleQuotedScalar(state2, flowIndent)) hasContent = true;
                else if ($80b3d2f58e77b583$var$readAlias(state2)) {
                    hasContent = true;
                    if (state2.tag !== null || state2.anchor !== null) $80b3d2f58e77b583$var$throwError(state2, "alias node should not have any properties");
                } else if ($80b3d2f58e77b583$var$readPlainScalar(state2, flowIndent, $80b3d2f58e77b583$var$CONTEXT_FLOW_IN === nodeContext)) {
                    hasContent = true;
                    if (state2.tag === null) state2.tag = "?";
                }
                if (state2.anchor !== null) state2.anchorMap[state2.anchor] = state2.result;
            }
        } else if (indentStatus === 0) hasContent = allowBlockCollections && $80b3d2f58e77b583$var$readBlockSequence(state2, blockIndent);
    }
    if (state2.tag === null) {
        if (state2.anchor !== null) state2.anchorMap[state2.anchor] = state2.result;
    } else if (state2.tag === "?") {
        if (state2.result !== null && state2.kind !== "scalar") $80b3d2f58e77b583$var$throwError(state2, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + state2.kind + '"');
        for(typeIndex = 0, typeQuantity = state2.implicitTypes.length; typeIndex < typeQuantity; typeIndex += 1){
            type2 = state2.implicitTypes[typeIndex];
            if (type2.resolve(state2.result)) {
                state2.result = type2.construct(state2.result);
                state2.tag = type2.tag;
                if (state2.anchor !== null) state2.anchorMap[state2.anchor] = state2.result;
                break;
            }
        }
    } else if (state2.tag !== "!") {
        if ($80b3d2f58e77b583$var$_hasOwnProperty$1.call(state2.typeMap[state2.kind || "fallback"], state2.tag)) type2 = state2.typeMap[state2.kind || "fallback"][state2.tag];
        else {
            type2 = null;
            typeList = state2.typeMap.multi[state2.kind || "fallback"];
            for(typeIndex = 0, typeQuantity = typeList.length; typeIndex < typeQuantity; typeIndex += 1)if (state2.tag.slice(0, typeList[typeIndex].tag.length) === typeList[typeIndex].tag) {
                type2 = typeList[typeIndex];
                break;
            }
        }
        if (!type2) $80b3d2f58e77b583$var$throwError(state2, "unknown tag !<" + state2.tag + ">");
        if (state2.result !== null && type2.kind !== state2.kind) $80b3d2f58e77b583$var$throwError(state2, "unacceptable node kind for !<" + state2.tag + '> tag; it should be "' + type2.kind + '", not "' + state2.kind + '"');
        if (!type2.resolve(state2.result, state2.tag)) $80b3d2f58e77b583$var$throwError(state2, "cannot resolve a node with !<" + state2.tag + "> explicit tag");
        else {
            state2.result = type2.construct(state2.result, state2.tag);
            if (state2.anchor !== null) state2.anchorMap[state2.anchor] = state2.result;
        }
    }
    if (state2.listener !== null) state2.listener("close", state2);
    return state2.tag !== null || state2.anchor !== null || hasContent;
}
function $80b3d2f58e77b583$var$readDocument(state2) {
    var documentStart = state2.position, _position, directiveName, directiveArgs, hasDirectives = false, ch;
    state2.version = null;
    state2.checkLineBreaks = state2.legacy;
    state2.tagMap = /* @__PURE__ */ Object.create(null);
    state2.anchorMap = /* @__PURE__ */ Object.create(null);
    while((ch = state2.input.charCodeAt(state2.position)) !== 0){
        $80b3d2f58e77b583$var$skipSeparationSpace(state2, true, -1);
        ch = state2.input.charCodeAt(state2.position);
        if (state2.lineIndent > 0 || ch !== 37) break;
        hasDirectives = true;
        ch = state2.input.charCodeAt(++state2.position);
        _position = state2.position;
        while(ch !== 0 && !$80b3d2f58e77b583$var$is_WS_OR_EOL(ch))ch = state2.input.charCodeAt(++state2.position);
        directiveName = state2.input.slice(_position, state2.position);
        directiveArgs = [];
        if (directiveName.length < 1) $80b3d2f58e77b583$var$throwError(state2, "directive name must not be less than one character in length");
        while(ch !== 0){
            while($80b3d2f58e77b583$var$is_WHITE_SPACE(ch))ch = state2.input.charCodeAt(++state2.position);
            if (ch === 35) {
                do ch = state2.input.charCodeAt(++state2.position);
                while (ch !== 0 && !$80b3d2f58e77b583$var$is_EOL(ch));
                break;
            }
            if ($80b3d2f58e77b583$var$is_EOL(ch)) break;
            _position = state2.position;
            while(ch !== 0 && !$80b3d2f58e77b583$var$is_WS_OR_EOL(ch))ch = state2.input.charCodeAt(++state2.position);
            directiveArgs.push(state2.input.slice(_position, state2.position));
        }
        if (ch !== 0) $80b3d2f58e77b583$var$readLineBreak(state2);
        if ($80b3d2f58e77b583$var$_hasOwnProperty$1.call($80b3d2f58e77b583$var$directiveHandlers, directiveName)) $80b3d2f58e77b583$var$directiveHandlers[directiveName](state2, directiveName, directiveArgs);
        else $80b3d2f58e77b583$var$throwWarning(state2, 'unknown document directive "' + directiveName + '"');
    }
    $80b3d2f58e77b583$var$skipSeparationSpace(state2, true, -1);
    if (state2.lineIndent === 0 && state2.input.charCodeAt(state2.position) === 45 && state2.input.charCodeAt(state2.position + 1) === 45 && state2.input.charCodeAt(state2.position + 2) === 45) {
        state2.position += 3;
        $80b3d2f58e77b583$var$skipSeparationSpace(state2, true, -1);
    } else if (hasDirectives) $80b3d2f58e77b583$var$throwError(state2, "directives end mark is expected");
    $80b3d2f58e77b583$var$composeNode(state2, state2.lineIndent - 1, $80b3d2f58e77b583$var$CONTEXT_BLOCK_OUT, false, true);
    $80b3d2f58e77b583$var$skipSeparationSpace(state2, true, -1);
    if (state2.checkLineBreaks && $80b3d2f58e77b583$var$PATTERN_NON_ASCII_LINE_BREAKS.test(state2.input.slice(documentStart, state2.position))) $80b3d2f58e77b583$var$throwWarning(state2, "non-ASCII line breaks are interpreted as content");
    state2.documents.push(state2.result);
    if (state2.position === state2.lineStart && $80b3d2f58e77b583$var$testDocumentSeparator(state2)) {
        if (state2.input.charCodeAt(state2.position) === 46) {
            state2.position += 3;
            $80b3d2f58e77b583$var$skipSeparationSpace(state2, true, -1);
        }
        return;
    }
    if (state2.position < state2.length - 1) $80b3d2f58e77b583$var$throwError(state2, "end of the stream or a document separator is expected");
    else return;
}
function $80b3d2f58e77b583$var$loadDocuments(input, options) {
    input = String(input);
    options = options || {};
    if (input.length !== 0) {
        if (input.charCodeAt(input.length - 1) !== 10 && input.charCodeAt(input.length - 1) !== 13) input += "\n";
        if (input.charCodeAt(0) === 65279) input = input.slice(1);
    }
    var state2 = new $80b3d2f58e77b583$var$State$1(input, options);
    var nullpos = input.indexOf("\0");
    if (nullpos !== -1) {
        state2.position = nullpos;
        $80b3d2f58e77b583$var$throwError(state2, "null byte is not allowed in input");
    }
    state2.input += "\0";
    while(state2.input.charCodeAt(state2.position) === 32){
        state2.lineIndent += 1;
        state2.position += 1;
    }
    while(state2.position < state2.length - 1)$80b3d2f58e77b583$var$readDocument(state2);
    return state2.documents;
}
function $80b3d2f58e77b583$var$loadAll$1(input, iterator, options) {
    if (iterator !== null && typeof iterator === "object" && typeof options === "undefined") {
        options = iterator;
        iterator = null;
    }
    var documents = $80b3d2f58e77b583$var$loadDocuments(input, options);
    if (typeof iterator !== "function") return documents;
    for(var index = 0, length = documents.length; index < length; index += 1)iterator(documents[index]);
}
function $80b3d2f58e77b583$var$load$1(input, options) {
    var documents = $80b3d2f58e77b583$var$loadDocuments(input, options);
    if (documents.length === 0) return void 0;
    else if (documents.length === 1) return documents[0];
    throw new $80b3d2f58e77b583$var$exception("expected a single document in the stream, but found more");
}
var $80b3d2f58e77b583$var$loadAll_1 = $80b3d2f58e77b583$var$loadAll$1;
var $80b3d2f58e77b583$var$load_1 = $80b3d2f58e77b583$var$load$1;
var $80b3d2f58e77b583$var$loader = {
    loadAll: $80b3d2f58e77b583$var$loadAll_1,
    load: $80b3d2f58e77b583$var$load_1
};
var $80b3d2f58e77b583$var$JSON_SCHEMA = $80b3d2f58e77b583$var$json;
var $80b3d2f58e77b583$var$load = $80b3d2f58e77b583$var$loader.load;
function $80b3d2f58e77b583$var$extractFrontMatter(text) {
    const matches = text.match($80b3d2f58e77b583$var$frontMatterRegex);
    if (!matches) return {
        text: text,
        metadata: {}
    };
    let parsed = $80b3d2f58e77b583$var$load(matches[1], {
        // To support config, we need JSON schema.
        // https://www.yaml.org/spec/1.2/spec.html#id2803231
        schema: $80b3d2f58e77b583$var$JSON_SCHEMA
    }) ?? {};
    parsed = typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
    const metadata = {};
    if (parsed.displayMode) metadata.displayMode = parsed.displayMode.toString();
    if (parsed.title) metadata.title = parsed.title.toString();
    if (parsed.config) metadata.config = parsed.config;
    return {
        text: text.slice(matches[0].length),
        metadata: metadata
    };
}
const $80b3d2f58e77b583$var$cleanupText = (code)=>{
    return code.replace(/\r\n?/g, "\n").replace(/<(\w+)([^>]*)>/g, (match, tag, attributes)=>"<" + tag + attributes.replace(/="([^"]*)"/g, "='$1'") + ">");
};
const $80b3d2f58e77b583$var$processFrontmatter = (code)=>{
    const { text: text, metadata: metadata } = $80b3d2f58e77b583$var$extractFrontMatter(code);
    const { displayMode: displayMode, title: title, config: config2 = {} } = metadata;
    if (displayMode) {
        if (!config2.gantt) config2.gantt = {};
        config2.gantt.displayMode = displayMode;
    }
    return {
        title: title,
        config: config2,
        text: text
    };
};
const $80b3d2f58e77b583$var$processDirectives = (code)=>{
    const initDirective = $80b3d2f58e77b583$export$3b14a55fb2447963.detectInit(code) ?? {};
    const wrapDirectives = $80b3d2f58e77b583$export$3b14a55fb2447963.detectDirective(code, "wrap");
    if (Array.isArray(wrapDirectives)) initDirective.wrap = wrapDirectives.some(({ type: type2 })=>{});
    else if ((wrapDirectives == null ? void 0 : wrapDirectives.type) === "wrap") initDirective.wrap = true;
    return {
        text: $80b3d2f58e77b583$var$removeDirectives(code),
        directive: initDirective
    };
};
function $80b3d2f58e77b583$var$preprocessDiagram(code) {
    const cleanedCode = $80b3d2f58e77b583$var$cleanupText(code);
    const frontMatterResult = $80b3d2f58e77b583$var$processFrontmatter(cleanedCode);
    const directiveResult = $80b3d2f58e77b583$var$processDirectives(frontMatterResult.text);
    const config2 = $80b3d2f58e77b583$export$e7094788287c5e9b(frontMatterResult.config, directiveResult.directive);
    code = $80b3d2f58e77b583$var$cleanupComments(directiveResult.text);
    return {
        code: code,
        title: frontMatterResult.title,
        config: config2
    };
}
const $80b3d2f58e77b583$var$MAX_TEXTLENGTH = 5e4;
const $80b3d2f58e77b583$var$MAX_TEXTLENGTH_EXCEEDED_MSG = "graph TB;a[Maximum text size in diagram exceeded];style a fill:#faa";
const $80b3d2f58e77b583$var$SECURITY_LVL_SANDBOX = "sandbox";
const $80b3d2f58e77b583$var$SECURITY_LVL_LOOSE = "loose";
const $80b3d2f58e77b583$var$XMLNS_SVG_STD = "http://www.w3.org/2000/svg";
const $80b3d2f58e77b583$var$XMLNS_XLINK_STD = "http://www.w3.org/1999/xlink";
const $80b3d2f58e77b583$var$XMLNS_XHTML_STD = "http://www.w3.org/1999/xhtml";
const $80b3d2f58e77b583$var$IFRAME_WIDTH = "100%";
const $80b3d2f58e77b583$var$IFRAME_HEIGHT = "100%";
const $80b3d2f58e77b583$var$IFRAME_STYLES = "border:0;margin:0;";
const $80b3d2f58e77b583$var$IFRAME_BODY_STYLE = "margin:0";
const $80b3d2f58e77b583$var$IFRAME_SANDBOX_OPTS = "allow-top-navigation-by-user-activation allow-popups";
const $80b3d2f58e77b583$var$IFRAME_NOT_SUPPORTED_MSG = 'The "iframe" tag is not supported by your browser.';
const $80b3d2f58e77b583$var$DOMPURIFY_TAGS = [
    "foreignobject"
];
const $80b3d2f58e77b583$var$DOMPURIFY_ATTR = [
    "dominant-baseline"
];
function $80b3d2f58e77b583$var$processAndSetConfigs(text) {
    const processed = $80b3d2f58e77b583$var$preprocessDiagram(text);
    $80b3d2f58e77b583$var$reset();
    $80b3d2f58e77b583$var$addDirective(processed.config ?? {});
    return processed;
}
async function $80b3d2f58e77b583$var$parse$1(text, parseOptions) {
    $80b3d2f58e77b583$var$addDiagrams();
    text = $80b3d2f58e77b583$var$processAndSetConfigs(text).code;
    try {
        await $80b3d2f58e77b583$var$getDiagramFromText(text);
    } catch (error) {
        if (parseOptions == null ? void 0 : parseOptions.suppressErrors) return false;
        throw error;
    }
    return true;
}
const $80b3d2f58e77b583$var$cssImportantStyles = (cssClass, element, cssClasses = [])=>{
    return `
.${cssClass} ${element} { ${cssClasses.join(" !important; ")} !important; }`;
};
const $80b3d2f58e77b583$var$createCssStyles = (config2, classDefs = {})=>{
    var _a;
    let cssStyles = "";
    if (config2.themeCSS !== void 0) cssStyles += `
${config2.themeCSS}`;
    if (config2.fontFamily !== void 0) cssStyles += `
:root { --mermaid-font-family: ${config2.fontFamily}}`;
    if (config2.altFontFamily !== void 0) cssStyles += `
:root { --mermaid-alt-font-family: ${config2.altFontFamily}}`;
    if (!(0, $02tYw.default)(classDefs)) {
        const htmlLabels = config2.htmlLabels || ((_a = config2.flowchart) == null ? void 0 : _a.htmlLabels);
        const cssHtmlElements = [
            "> *",
            "span"
        ];
        const cssShapeElements = [
            "rect",
            "polygon",
            "ellipse",
            "circle",
            "path"
        ];
        const cssElements = htmlLabels ? cssHtmlElements : cssShapeElements;
        for(const classId in classDefs){
            const styleClassDef = classDefs[classId];
            if (!(0, $02tYw.default)(styleClassDef.styles)) cssElements.forEach((cssElement)=>{
                cssStyles += $80b3d2f58e77b583$var$cssImportantStyles(styleClassDef.id, cssElement, styleClassDef.styles);
            });
            if (!(0, $02tYw.default)(styleClassDef.textStyles)) cssStyles += $80b3d2f58e77b583$var$cssImportantStyles(styleClassDef.id, "tspan", styleClassDef.textStyles);
        }
    }
    return cssStyles;
};
const $80b3d2f58e77b583$var$createUserStyles = (config2, graphType, classDefs, svgId)=>{
    const userCSSstyles = $80b3d2f58e77b583$var$createCssStyles(config2, classDefs);
    const allStyles = $80b3d2f58e77b583$var$getStyles$1(graphType, userCSSstyles, config2.themeVariables);
    return (0, $fm8kz.serialize)((0, $fm8kz.compile)(`${svgId}{${allStyles}}`), (0, $fm8kz.stringify));
};
const $80b3d2f58e77b583$var$cleanUpSvgCode = (svgCode = "", inSandboxMode, useArrowMarkerUrls)=>{
    let cleanedUpSvg = svgCode;
    if (!useArrowMarkerUrls && !inSandboxMode) cleanedUpSvg = cleanedUpSvg.replace(/marker-end="url\([\d+./:=?A-Za-z-]*?#/g, 'marker-end="url(#');
    cleanedUpSvg = $80b3d2f58e77b583$export$3a1a48c8f6ef640e(cleanedUpSvg);
    cleanedUpSvg = cleanedUpSvg.replace(/<br>/g, "<br/>");
    return cleanedUpSvg;
};
const $80b3d2f58e77b583$var$putIntoIFrame = (svgCode = "", svgElement)=>{
    var _a, _b;
    const height = ((_b = (_a = svgElement == null ? void 0 : svgElement.viewBox) == null ? void 0 : _a.baseVal) == null ? void 0 : _b.height) ? svgElement.viewBox.baseVal.height + "px" : $80b3d2f58e77b583$var$IFRAME_HEIGHT;
    const base64encodedSrc = btoa('<body style="' + $80b3d2f58e77b583$var$IFRAME_BODY_STYLE + '">' + svgCode + "</body>");
    return `<iframe style="width:${$80b3d2f58e77b583$var$IFRAME_WIDTH};height:${height};${$80b3d2f58e77b583$var$IFRAME_STYLES}" src="data:text/html;base64,${base64encodedSrc}" sandbox="${$80b3d2f58e77b583$var$IFRAME_SANDBOX_OPTS}">
  ${$80b3d2f58e77b583$var$IFRAME_NOT_SUPPORTED_MSG}
</iframe>`;
};
const $80b3d2f58e77b583$var$appendDivSvgG = (parentRoot, id2, enclosingDivId, divStyle, svgXlink)=>{
    const enclosingDiv = parentRoot.append("div");
    enclosingDiv.attr("id", enclosingDivId);
    if (divStyle) enclosingDiv.attr("style", divStyle);
    const svgNode = enclosingDiv.append("svg").attr("id", id2).attr("width", "100%").attr("xmlns", $80b3d2f58e77b583$var$XMLNS_SVG_STD);
    if (svgXlink) svgNode.attr("xmlns:xlink", svgXlink);
    svgNode.append("g");
    return parentRoot;
};
function $80b3d2f58e77b583$var$sandboxedIframe(parentNode, iFrameId) {
    return parentNode.append("iframe").attr("id", iFrameId).attr("style", "width: 100%; height: 100%;").attr("sandbox", "");
}
const $80b3d2f58e77b583$var$removeExistingElements = (doc, id2, divId, iFrameId)=>{
    var _a, _b, _c;
    (_a = doc.getElementById(id2)) == null || _a.remove();
    (_b = doc.getElementById(divId)) == null || _b.remove();
    (_c = doc.getElementById(iFrameId)) == null || _c.remove();
};
const $80b3d2f58e77b583$var$render$1 = async function(id2, text, svgContainingElement) {
    var _a, _b, _c, _d, _e, _f;
    $80b3d2f58e77b583$var$addDiagrams();
    const processed = $80b3d2f58e77b583$var$processAndSetConfigs(text);
    text = processed.code;
    const config2 = $80b3d2f58e77b583$export$d66501df72047452();
    $80b3d2f58e77b583$export$882b5998b3b9117c.debug(config2);
    if (text.length > ((config2 == null ? void 0 : config2.maxTextSize) ?? $80b3d2f58e77b583$var$MAX_TEXTLENGTH)) text = $80b3d2f58e77b583$var$MAX_TEXTLENGTH_EXCEEDED_MSG;
    const idSelector = "#" + id2;
    const iFrameID = "i" + id2;
    const iFrameID_selector = "#" + iFrameID;
    const enclosingDivID = "d" + id2;
    const enclosingDivID_selector = "#" + enclosingDivID;
    let root = (0, $hOxpW.default)("body");
    const isSandboxed = config2.securityLevel === $80b3d2f58e77b583$var$SECURITY_LVL_SANDBOX;
    const isLooseSecurityLevel = config2.securityLevel === $80b3d2f58e77b583$var$SECURITY_LVL_LOOSE;
    const fontFamily = config2.fontFamily;
    if (svgContainingElement !== void 0) {
        if (svgContainingElement) svgContainingElement.innerHTML = "";
        if (isSandboxed) {
            const iframe = $80b3d2f58e77b583$var$sandboxedIframe((0, $hOxpW.default)(svgContainingElement), iFrameID);
            root = (0, $hOxpW.default)(iframe.nodes()[0].contentDocument.body);
            root.node().style.margin = 0;
        } else root = (0, $hOxpW.default)(svgContainingElement);
        $80b3d2f58e77b583$var$appendDivSvgG(root, id2, enclosingDivID, `font-family: ${fontFamily}`, $80b3d2f58e77b583$var$XMLNS_XLINK_STD);
    } else {
        $80b3d2f58e77b583$var$removeExistingElements(document, id2, enclosingDivID, iFrameID);
        if (isSandboxed) {
            const iframe = $80b3d2f58e77b583$var$sandboxedIframe((0, $hOxpW.default)("body"), iFrameID);
            root = (0, $hOxpW.default)(iframe.nodes()[0].contentDocument.body);
            root.node().style.margin = 0;
        } else root = (0, $hOxpW.default)("body");
        $80b3d2f58e77b583$var$appendDivSvgG(root, id2, enclosingDivID);
    }
    let diag;
    let parseEncounteredException;
    try {
        diag = await $80b3d2f58e77b583$var$getDiagramFromText(text, {
            title: processed.title
        });
    } catch (error) {
        diag = new $80b3d2f58e77b583$var$Diagram("error");
        parseEncounteredException = error;
    }
    const element = root.select(enclosingDivID_selector).node();
    const diagramType = diag.type;
    const svg = element.firstChild;
    const firstChild = svg.firstChild;
    const diagramClassDefs = (_b = (_a = diag.renderer).getClasses) == null ? void 0 : _b.call(_a, text, diag);
    const rules = $80b3d2f58e77b583$var$createUserStyles(config2, diagramType, diagramClassDefs, idSelector);
    const style1 = document.createElement("style");
    style1.innerHTML = rules;
    svg.insertBefore(style1, firstChild);
    try {
        await diag.renderer.draw(text, id2, $80b3d2f58e77b583$var$version, diag);
    } catch (e) {
        $80b3d2f58e77b583$var$errorRenderer.draw(text, id2, $80b3d2f58e77b583$var$version);
        throw e;
    }
    const svgNode = root.select(`${enclosingDivID_selector} svg`);
    const a11yTitle = (_d = (_c = diag.db).getAccTitle) == null ? void 0 : _d.call(_c);
    const a11yDescr = (_f = (_e = diag.db).getAccDescription) == null ? void 0 : _f.call(_e);
    $80b3d2f58e77b583$var$addA11yInfo(diagramType, svgNode, a11yTitle, a11yDescr);
    root.select(`[id="${id2}"]`).selectAll("foreignobject > *").attr("xmlns", $80b3d2f58e77b583$var$XMLNS_XHTML_STD);
    let svgCode = root.select(enclosingDivID_selector).node().innerHTML;
    $80b3d2f58e77b583$export$882b5998b3b9117c.debug("config.arrowMarkerAbsolute", config2.arrowMarkerAbsolute);
    svgCode = $80b3d2f58e77b583$var$cleanUpSvgCode(svgCode, isSandboxed, $80b3d2f58e77b583$export$953cecd6e717a553(config2.arrowMarkerAbsolute));
    if (isSandboxed) {
        const svgEl = root.select(enclosingDivID_selector + " svg").node();
        svgCode = $80b3d2f58e77b583$var$putIntoIFrame(svgCode, svgEl);
    } else if (!isLooseSecurityLevel) svgCode = (0, (/*@__PURE__*/$parcel$interopDefault($i8Fxz))).sanitize(svgCode, {
        ADD_TAGS: $80b3d2f58e77b583$var$DOMPURIFY_TAGS,
        ADD_ATTR: $80b3d2f58e77b583$var$DOMPURIFY_ATTR
    });
    $80b3d2f58e77b583$var$attachFunctions();
    if (parseEncounteredException) throw parseEncounteredException;
    const tmpElementSelector = isSandboxed ? iFrameID_selector : enclosingDivID_selector;
    const node = (0, $hOxpW.default)(tmpElementSelector).node();
    if (node && "remove" in node) node.remove();
    return {
        svg: svgCode,
        bindFunctions: diag.db.bindFunctions
    };
};
function $80b3d2f58e77b583$var$initialize$1(options = {}) {
    var _a;
    if ((options == null ? void 0 : options.fontFamily) && !((_a = options.themeVariables) == null ? void 0 : _a.fontFamily)) {
        if (!options.themeVariables) options.themeVariables = {};
        options.themeVariables.fontFamily = options.fontFamily;
    }
    $80b3d2f58e77b583$var$saveConfigFromInitialize(options);
    if ((options == null ? void 0 : options.theme) && options.theme in $80b3d2f58e77b583$var$theme) options.themeVariables = $80b3d2f58e77b583$var$theme[options.theme].getThemeVariables(options.themeVariables);
    else if (options) options.themeVariables = $80b3d2f58e77b583$var$theme.default.getThemeVariables(options.themeVariables);
    const config2 = typeof options === "object" ? $80b3d2f58e77b583$var$setSiteConfig(options) : $80b3d2f58e77b583$var$getSiteConfig();
    $80b3d2f58e77b583$var$setLogLevel$1(config2.logLevel);
    $80b3d2f58e77b583$var$addDiagrams();
}
const $80b3d2f58e77b583$var$getDiagramFromText = (text, metadata = {})=>{
    const { code: code } = $80b3d2f58e77b583$var$preprocessDiagram(text);
    return $80b3d2f58e77b583$var$getDiagramFromText$1(code, metadata);
};
function $80b3d2f58e77b583$var$addA11yInfo(diagramType, svgNode, a11yTitle, a11yDescr) {
    $80b3d2f58e77b583$var$setA11yDiagramInfo(svgNode, diagramType);
    $80b3d2f58e77b583$var$addSVGa11yTitleDescription(svgNode, a11yTitle, a11yDescr, svgNode.attr("id"));
}
const $80b3d2f58e77b583$var$mermaidAPI = Object.freeze({
    render: $80b3d2f58e77b583$var$render$1,
    parse: $80b3d2f58e77b583$var$parse$1,
    getDiagramFromText: $80b3d2f58e77b583$var$getDiagramFromText,
    initialize: $80b3d2f58e77b583$var$initialize$1,
    getConfig: $80b3d2f58e77b583$export$d66501df72047452,
    setConfig: $80b3d2f58e77b583$var$setConfig$1,
    getSiteConfig: $80b3d2f58e77b583$var$getSiteConfig,
    updateSiteConfig: $80b3d2f58e77b583$var$updateSiteConfig,
    reset: ()=>{
        $80b3d2f58e77b583$var$reset();
    },
    globalReset: ()=>{
        $80b3d2f58e77b583$var$reset($80b3d2f58e77b583$var$defaultConfig$1);
    },
    defaultConfig: $80b3d2f58e77b583$var$defaultConfig$1
});
$80b3d2f58e77b583$var$setLogLevel$1($80b3d2f58e77b583$export$d66501df72047452().logLevel);
$80b3d2f58e77b583$var$reset($80b3d2f58e77b583$export$d66501df72047452());
const $80b3d2f58e77b583$var$loadRegisteredDiagrams = async ()=>{
    $80b3d2f58e77b583$export$882b5998b3b9117c.debug(`Loading registered diagrams`);
    const results = await Promise.allSettled(Object.entries($80b3d2f58e77b583$var$detectors).map(async ([key, { detector: detector2, loader: loader2 }])=>{
        if (loader2) try {
            $80b3d2f58e77b583$var$getDiagram(key);
        } catch (error) {
            try {
                const { diagram: diagram2, id: id2 } = await loader2();
                $80b3d2f58e77b583$var$registerDiagram(id2, diagram2, detector2);
            } catch (err) {
                $80b3d2f58e77b583$export$882b5998b3b9117c.error(`Failed to load external diagram with key ${key}. Removing from detectors.`);
                delete $80b3d2f58e77b583$var$detectors[key];
                throw err;
            }
        }
    }));
    const failed = results.filter((result)=>result.status === "rejected");
    if (failed.length > 0) {
        $80b3d2f58e77b583$export$882b5998b3b9117c.error(`Failed to load ${failed.length} external diagrams`);
        for (const res of failed)$80b3d2f58e77b583$export$882b5998b3b9117c.error(res);
        throw new Error(`Failed to load ${failed.length} external diagrams`);
    }
};
const $80b3d2f58e77b583$var$handleError = (error, errors, parseError)=>{
    $80b3d2f58e77b583$export$882b5998b3b9117c.warn(error);
    if ($80b3d2f58e77b583$var$isDetailedError(error)) {
        if (parseError) parseError(error.str, error.hash);
        errors.push({
            ...error,
            message: error.str,
            error: error
        });
    } else {
        if (parseError) parseError(error);
        if (error instanceof Error) errors.push({
            str: error.message,
            message: error.message,
            hash: error.name,
            error: error
        });
    }
};
const $80b3d2f58e77b583$var$run = async function(options = {
    querySelector: ".mermaid"
}) {
    try {
        await $80b3d2f58e77b583$var$runThrowsErrors(options);
    } catch (e) {
        if ($80b3d2f58e77b583$var$isDetailedError(e)) $80b3d2f58e77b583$export$882b5998b3b9117c.error(e.str);
        if ($80b3d2f58e77b583$export$a07804094c3ecf2d.parseError) $80b3d2f58e77b583$export$a07804094c3ecf2d.parseError(e);
        if (!options.suppressErrors) {
            $80b3d2f58e77b583$export$882b5998b3b9117c.error("Use the suppressErrors option to suppress these errors");
            throw e;
        }
    }
};
const $80b3d2f58e77b583$var$runThrowsErrors = async function({ postRenderCallback: postRenderCallback, querySelector: querySelector, nodes: nodes } = {
    querySelector: ".mermaid"
}) {
    const conf = $80b3d2f58e77b583$var$mermaidAPI.getConfig();
    $80b3d2f58e77b583$export$882b5998b3b9117c.debug(`${!postRenderCallback ? "No " : ""}Callback function found`);
    let nodesToProcess;
    if (nodes) nodesToProcess = nodes;
    else if (querySelector) nodesToProcess = document.querySelectorAll(querySelector);
    else throw new Error("Nodes and querySelector are both undefined");
    $80b3d2f58e77b583$export$882b5998b3b9117c.debug(`Found ${nodesToProcess.length} diagrams`);
    if ((conf == null ? void 0 : conf.startOnLoad) !== void 0) {
        $80b3d2f58e77b583$export$882b5998b3b9117c.debug("Start On Load: " + (conf == null ? void 0 : conf.startOnLoad));
        $80b3d2f58e77b583$var$mermaidAPI.updateSiteConfig({
            startOnLoad: conf == null ? void 0 : conf.startOnLoad
        });
    }
    const idGenerator = new $80b3d2f58e77b583$export$3b14a55fb2447963.InitIDGenerator(conf.deterministicIds, conf.deterministicIDSeed);
    let txt;
    const errors = [];
    for (const element of Array.from(nodesToProcess)){
        $80b3d2f58e77b583$export$882b5998b3b9117c.info("Rendering diagram: " + element.id);
        /*! Check if previously processed */ if (element.getAttribute("data-processed")) continue;
        element.setAttribute("data-processed", "true");
        const id2 = `mermaid-${idGenerator.next()}`;
        txt = element.innerHTML;
        txt = (0, $eJNXH.dedent)($80b3d2f58e77b583$export$3b14a55fb2447963.entityDecode(txt)).trim().replace(/<br\s*\/?>/gi, "<br/>");
        const init2 = $80b3d2f58e77b583$export$3b14a55fb2447963.detectInit(txt);
        if (init2) $80b3d2f58e77b583$export$882b5998b3b9117c.debug("Detected early reinit: ", init2);
        try {
            const { svg: svg, bindFunctions: bindFunctions } = await $80b3d2f58e77b583$var$render(id2, txt, element);
            element.innerHTML = svg;
            if (postRenderCallback) await postRenderCallback(id2);
            if (bindFunctions) bindFunctions(element);
        } catch (error) {
            $80b3d2f58e77b583$var$handleError(error, errors, $80b3d2f58e77b583$export$a07804094c3ecf2d.parseError);
        }
    }
    if (errors.length > 0) throw errors[0];
};
const $80b3d2f58e77b583$var$initialize = function(config2) {
    $80b3d2f58e77b583$var$mermaidAPI.initialize(config2);
};
const $80b3d2f58e77b583$var$init = async function(config2, nodes, callback) {
    $80b3d2f58e77b583$export$882b5998b3b9117c.warn("mermaid.init is deprecated. Please use run instead.");
    if (config2) $80b3d2f58e77b583$var$initialize(config2);
    const runOptions = {
        postRenderCallback: callback,
        querySelector: ".mermaid"
    };
    if (typeof nodes === "string") runOptions.querySelector = nodes;
    else if (nodes) {
        if (nodes instanceof HTMLElement) runOptions.nodes = [
            nodes
        ];
        else runOptions.nodes = nodes;
    }
    await $80b3d2f58e77b583$var$run(runOptions);
};
const $80b3d2f58e77b583$var$registerExternalDiagrams = async (diagrams2, { lazyLoad: lazyLoad = true } = {})=>{
    $80b3d2f58e77b583$var$registerLazyLoadedDiagrams(...diagrams2);
    if (lazyLoad === false) await $80b3d2f58e77b583$var$loadRegisteredDiagrams();
};
const $80b3d2f58e77b583$var$contentLoaded = function() {
    if ($80b3d2f58e77b583$export$a07804094c3ecf2d.startOnLoad) {
        const { startOnLoad: startOnLoad } = $80b3d2f58e77b583$var$mermaidAPI.getConfig();
        if (startOnLoad) $80b3d2f58e77b583$export$a07804094c3ecf2d.run().catch((err)=>$80b3d2f58e77b583$export$882b5998b3b9117c.error("Mermaid failed to initialize", err));
    }
};
if (typeof document !== "undefined") /*!
   * Wait for document loaded before starting the execution
   */ window.addEventListener("load", $80b3d2f58e77b583$var$contentLoaded, false);
const $80b3d2f58e77b583$var$setParseErrorHandler = function(parseErrorHandler) {
    $80b3d2f58e77b583$export$a07804094c3ecf2d.parseError = parseErrorHandler;
};
const $80b3d2f58e77b583$var$executionQueue = [];
let $80b3d2f58e77b583$var$executionQueueRunning = false;
const $80b3d2f58e77b583$var$executeQueue = async ()=>{
    if ($80b3d2f58e77b583$var$executionQueueRunning) return;
    $80b3d2f58e77b583$var$executionQueueRunning = true;
    while($80b3d2f58e77b583$var$executionQueue.length > 0){
        const f = $80b3d2f58e77b583$var$executionQueue.shift();
        if (f) try {
            await f();
        } catch (e) {
            $80b3d2f58e77b583$export$882b5998b3b9117c.error("Error executing queue", e);
        }
    }
    $80b3d2f58e77b583$var$executionQueueRunning = false;
};
const $80b3d2f58e77b583$var$parse = async (text, parseOptions)=>{
    return new Promise((resolve, reject)=>{
        const performCall = ()=>new Promise((res, rej)=>{
                $80b3d2f58e77b583$var$mermaidAPI.parse(text, parseOptions).then((r)=>{
                    res(r);
                    resolve(r);
                }, (e)=>{
                    var _a;
                    $80b3d2f58e77b583$export$882b5998b3b9117c.error("Error parsing", e);
                    (_a = $80b3d2f58e77b583$export$a07804094c3ecf2d.parseError) == null || _a.call($80b3d2f58e77b583$export$a07804094c3ecf2d, e);
                    rej(e);
                    reject(e);
                });
            });
        $80b3d2f58e77b583$var$executionQueue.push(performCall);
        $80b3d2f58e77b583$var$executeQueue().catch(reject);
    });
};
const $80b3d2f58e77b583$var$render = (id2, text, container)=>{
    return new Promise((resolve, reject)=>{
        const performCall = ()=>new Promise((res, rej)=>{
                $80b3d2f58e77b583$var$mermaidAPI.render(id2, text, container).then((r)=>{
                    res(r);
                    resolve(r);
                }, (e)=>{
                    var _a;
                    $80b3d2f58e77b583$export$882b5998b3b9117c.error("Error parsing", e);
                    (_a = $80b3d2f58e77b583$export$a07804094c3ecf2d.parseError) == null || _a.call($80b3d2f58e77b583$export$a07804094c3ecf2d, e);
                    rej(e);
                    reject(e);
                });
            });
        $80b3d2f58e77b583$var$executionQueue.push(performCall);
        $80b3d2f58e77b583$var$executeQueue().catch(reject);
    });
};
const $80b3d2f58e77b583$export$a07804094c3ecf2d = {
    startOnLoad: true,
    mermaidAPI: $80b3d2f58e77b583$var$mermaidAPI,
    parse: $80b3d2f58e77b583$var$parse,
    render: $80b3d2f58e77b583$var$render,
    init: $80b3d2f58e77b583$var$init,
    run: $80b3d2f58e77b583$var$run,
    registerExternalDiagrams: $80b3d2f58e77b583$var$registerExternalDiagrams,
    initialize: $80b3d2f58e77b583$var$initialize,
    parseError: void 0,
    contentLoaded: $80b3d2f58e77b583$var$contentLoaded,
    setParseErrorHandler: $80b3d2f58e77b583$var$setParseErrorHandler,
    detectType: $80b3d2f58e77b583$var$detectType
};

});
parcelRegister("eJNXH", function(module, exports) {

$parcel$export(module.exports, "dedent", () => $abac060ef2242e64$export$1d81801f981b61e);
function $abac060ef2242e64$export$1d81801f981b61e(templ) {
    var values = [];
    for(var _i = 1; _i < arguments.length; _i++)values[_i - 1] = arguments[_i];
    var strings = Array.from(typeof templ === 'string' ? [
        templ
    ] : templ);
    strings[strings.length - 1] = strings[strings.length - 1].replace(/\r?\n([\t ]*)$/, '');
    var indentLengths = strings.reduce(function(arr, str) {
        var matches = str.match(/\n([\t ]+|(?!\s).)/g);
        if (matches) return arr.concat(matches.map(function(match) {
            var _a, _b;
            return (_b = (_a = match.match(/[\t ]/g)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        }));
        return arr;
    }, []);
    if (indentLengths.length) {
        var pattern_1 = new RegExp("\n[\t ]{" + Math.min.apply(Math, indentLengths) + "}", 'g');
        strings = strings.map(function(str) {
            return str.replace(pattern_1, '\n');
        });
    }
    strings[0] = strings[0].replace(/^\r?\n/, '');
    var string = strings[0];
    values.forEach(function(value, i) {
        var endentations = string.match(/(?:^|\n)( *)$/);
        var endentation = endentations ? endentations[1] : '';
        var indentedValue = value;
        if (typeof value === 'string' && value.includes('\n')) indentedValue = String(value).split('\n').map(function(str, i) {
            return i === 0 ? str : "" + endentation + str;
        }).join('\n');
        string += indentedValue + strings[i + 1];
    });
    return string;
}
var $abac060ef2242e64$export$2e2bcd8739ae039 = $abac060ef2242e64$export$1d81801f981b61e;

});

parcelRegister("gngdn", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("2ujND", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sanitizeUrl = module.exports.BLANK_URL = void 0;
var $1cfdbde1ae470967$var$invalidProtocolRegex = /^([^\w]*)(javascript|data|vbscript)/im;
var $1cfdbde1ae470967$var$htmlEntitiesRegex = /&#(\w+)(^\w|;)?/g;
var $1cfdbde1ae470967$var$htmlCtrlEntityRegex = /&(newline|tab);/gi;
var $1cfdbde1ae470967$var$ctrlCharactersRegex = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
var $1cfdbde1ae470967$var$urlSchemeRegex = /^.+(:|&colon;)/gim;
var $1cfdbde1ae470967$var$relativeFirstCharacters = [
    ".",
    "/"
];
module.exports.BLANK_URL = "about:blank";
function $1cfdbde1ae470967$var$isRelativeUrlWithoutProtocol(url) {
    return $1cfdbde1ae470967$var$relativeFirstCharacters.indexOf(url[0]) > -1;
}
// adapted from https://stackoverflow.com/a/29824550/2601552
function $1cfdbde1ae470967$var$decodeHtmlCharacters(str) {
    var removedNullByte = str.replace($1cfdbde1ae470967$var$ctrlCharactersRegex, "");
    return removedNullByte.replace($1cfdbde1ae470967$var$htmlEntitiesRegex, function(match, dec) {
        return String.fromCharCode(dec);
    });
}
function $1cfdbde1ae470967$var$sanitizeUrl(url) {
    if (!url) return module.exports.BLANK_URL;
    var sanitizedUrl = $1cfdbde1ae470967$var$decodeHtmlCharacters(url).replace($1cfdbde1ae470967$var$htmlCtrlEntityRegex, "").replace($1cfdbde1ae470967$var$ctrlCharactersRegex, "").trim();
    if (!sanitizedUrl) return module.exports.BLANK_URL;
    if ($1cfdbde1ae470967$var$isRelativeUrlWithoutProtocol(sanitizedUrl)) return sanitizedUrl;
    var urlSchemeParseResults = sanitizedUrl.match($1cfdbde1ae470967$var$urlSchemeRegex);
    if (!urlSchemeParseResults) return sanitizedUrl;
    var urlScheme = urlSchemeParseResults[0];
    if ($1cfdbde1ae470967$var$invalidProtocolRegex.test(urlScheme)) return module.exports.BLANK_URL;
    return sanitizedUrl;
}
module.exports.sanitizeUrl = $1cfdbde1ae470967$var$sanitizeUrl;

});

parcelRegister("2YFJl", function(module, exports) {
$parcel$export(module.exports, "axisBottom", () => (parcelRequire("bgSbI")).axisBottom);
$parcel$export(module.exports, "axisTop", () => (parcelRequire("bgSbI")).axisTop);
$parcel$export(module.exports, "svg", () => (parcelRequire("lAcF9")).svg);
$parcel$export(module.exports, "timeDay", () => (parcelRequire("72rFk")).timeDay);
$parcel$export(module.exports, "timeFriday", () => (parcelRequire("aW15j")).timeFriday);
$parcel$export(module.exports, "timeMonday", () => (parcelRequire("aW15j")).timeMonday);
$parcel$export(module.exports, "timeSaturday", () => (parcelRequire("aW15j")).timeSaturday);
$parcel$export(module.exports, "timeSunday", () => (parcelRequire("aW15j")).timeSunday);
$parcel$export(module.exports, "timeThursday", () => (parcelRequire("aW15j")).timeThursday);
$parcel$export(module.exports, "timeTuesday", () => (parcelRequire("aW15j")).timeTuesday);
$parcel$export(module.exports, "timeWednesday", () => (parcelRequire("aW15j")).timeWednesday);
$parcel$export(module.exports, "timeHour", () => (parcelRequire("cKbL9")).timeHour);
$parcel$export(module.exports, "timeMinute", () => (parcelRequire("3wXBo")).timeMinute);
$parcel$export(module.exports, "timeMonth", () => (parcelRequire("gyimR")).timeMonth);
$parcel$export(module.exports, "timeFormat", () => (parcelRequire("UutV9")).timeFormat);
$parcel$export(module.exports, "zoom", () => (parcelRequire("cwuwP")).default);

$parcel$export(module.exports, "max", () => (parcelRequire("7MbYq")).default);
$parcel$export(module.exports, "min", () => (parcelRequire("fzQB8")).default);
$parcel$export(module.exports, "interpolateHcl", () => (parcelRequire("bvJ3W")).default);
$parcel$export(module.exports, "scaleBand", () => (parcelRequire("gEnYl")).default);
$parcel$export(module.exports, "scaleLinear", () => (parcelRequire("iOlPi")).default);
$parcel$export(module.exports, "scaleOrdinal", () => (parcelRequire("4PqgM")).default);
$parcel$export(module.exports, "scaleTime", () => (parcelRequire("48U7R")).default);
$parcel$export(module.exports, "schemeTableau10", () => (parcelRequire("6RbN1")).default);
$parcel$export(module.exports, "select", () => (parcelRequire("hOxpW")).default);
$parcel$export(module.exports, "selectAll", () => (parcelRequire("jJCd9")).default);
$parcel$export(module.exports, "arc", () => (parcelRequire("ffiwJ")).default);
$parcel$export(module.exports, "curveBasis", () => (parcelRequire("6QL1t")).default);
$parcel$export(module.exports, "curveBasisClosed", () => (parcelRequire("2515N")).default);
$parcel$export(module.exports, "curveBasisOpen", () => (parcelRequire("e1bEB")).default);
$parcel$export(module.exports, "curveBumpX", () => (parcelRequire("gpIrV")).bumpX);
$parcel$export(module.exports, "curveBumpY", () => (parcelRequire("gpIrV")).bumpY);
$parcel$export(module.exports, "curveBundle", () => (parcelRequire("l8Mye")).default);
$parcel$export(module.exports, "curveCardinal", () => (parcelRequire("hga9n")).default);
$parcel$export(module.exports, "curveCardinalClosed", () => (parcelRequire("9XrSP")).default);
$parcel$export(module.exports, "curveCardinalOpen", () => (parcelRequire("dUIyz")).default);
$parcel$export(module.exports, "curveCatmullRom", () => (parcelRequire("6FEsA")).default);
$parcel$export(module.exports, "curveCatmullRomClosed", () => (parcelRequire("loyNQ")).default);
$parcel$export(module.exports, "curveCatmullRomOpen", () => (parcelRequire("4tc8L")).default);
$parcel$export(module.exports, "curveLinear", () => (parcelRequire("gEcf1")).default);
$parcel$export(module.exports, "curveLinearClosed", () => (parcelRequire("4CT3t")).default);
$parcel$export(module.exports, "curveMonotoneX", () => (parcelRequire("hp3ls")).monotoneX);
$parcel$export(module.exports, "curveMonotoneY", () => (parcelRequire("hp3ls")).monotoneY);
$parcel$export(module.exports, "curveNatural", () => (parcelRequire("kjPWc")).default);
$parcel$export(module.exports, "curveStep", () => (parcelRequire("1zRZO")).default);
$parcel$export(module.exports, "curveStepAfter", () => (parcelRequire("1zRZO")).stepAfter);
$parcel$export(module.exports, "curveStepBefore", () => (parcelRequire("1zRZO")).stepBefore);
$parcel$export(module.exports, "line", () => (parcelRequire("5ti2H")).default);
$parcel$export(module.exports, "pie", () => (parcelRequire("fo0l5")).default);
$parcel$export(module.exports, "timeMillisecond", () => (parcelRequire("asZKP")).millisecond);
$parcel$export(module.exports, "timeSecond", () => (parcelRequire("6gR0W")).second);

var $7MbYq = parcelRequire("7MbYq");
var $fzQB8 = parcelRequire("fzQB8");
parcelRequire("bgSbI");
parcelRequire("im8sd");








parcelRequire("lAcF9");





var $bvJ3W = parcelRequire("bvJ3W");





var $gEnYl = parcelRequire("gEnYl");
var $iOlPi = parcelRequire("iOlPi");
var $4PqgM = parcelRequire("4PqgM");
var $48U7R = parcelRequire("48U7R");

var $6RbN1 = parcelRequire("6RbN1");

var $hOxpW = parcelRequire("hOxpW");
var $jJCd9 = parcelRequire("jJCd9");

var $ffiwJ = parcelRequire("ffiwJ");
var $6QL1t = parcelRequire("6QL1t");
var $2515N = parcelRequire("2515N");
var $e1bEB = parcelRequire("e1bEB");
var $gpIrV = parcelRequire("gpIrV");
var $l8Mye = parcelRequire("l8Mye");
var $hga9n = parcelRequire("hga9n");
var $9XrSP = parcelRequire("9XrSP");
var $dUIyz = parcelRequire("dUIyz");
var $6FEsA = parcelRequire("6FEsA");
var $loyNQ = parcelRequire("loyNQ");
var $4tc8L = parcelRequire("4tc8L");
var $gEcf1 = parcelRequire("gEcf1");
var $4CT3t = parcelRequire("4CT3t");
var $hp3ls = parcelRequire("hp3ls");
var $kjPWc = parcelRequire("kjPWc");
var $1zRZO = parcelRequire("1zRZO");
var $5ti2H = parcelRequire("5ti2H");
var $fo0l5 = parcelRequire("fo0l5");
parcelRequire("72rFk");parcelRequire("aW15j");parcelRequire("cKbL9");
var $asZKP = parcelRequire("asZKP");parcelRequire("3wXBo");parcelRequire("gyimR");
var $6gR0W = parcelRequire("6gR0W");
parcelRequire("UutV9");

parcelRequire("dxJVY");
parcelRequire("fOARq");

});
parcelRegister("7MbYq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a964dca3df4eea7$export$2e2bcd8739ae039);
function $5a964dca3df4eea7$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("fzQB8", function(module, exports) {

$parcel$export(module.exports, "default", () => $02ed355deaa9e190$export$2e2bcd8739ae039);
function $02ed355deaa9e190$export$2e2bcd8739ae039(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("bgSbI", function(module, exports) {

$parcel$export(module.exports, "axisTop", () => $834b38f205523964$export$59b8cfab074bdeb1);
$parcel$export(module.exports, "axisBottom", () => $834b38f205523964$export$e5cb22533a15e72e);

var $7v1sx = parcelRequire("7v1sx");
var $834b38f205523964$var$top = 1, $834b38f205523964$var$right = 2, $834b38f205523964$var$bottom = 3, $834b38f205523964$var$left = 4, $834b38f205523964$var$epsilon = 1e-6;
function $834b38f205523964$var$translateX(x) {
    return "translate(" + x + ",0)";
}
function $834b38f205523964$var$translateY(y) {
    return "translate(0," + y + ")";
}
function $834b38f205523964$var$number(scale) {
    return (d)=>+scale(d);
}
function $834b38f205523964$var$center(scale, offset) {
    offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
    if (scale.round()) offset = Math.round(offset);
    return (d)=>+scale(d) + offset;
}
function $834b38f205523964$var$entering() {
    return !this.__axis;
}
function $834b38f205523964$var$axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === $834b38f205523964$var$top || orient === $834b38f205523964$var$left ? -1 : 1, x = orient === $834b38f205523964$var$left || orient === $834b38f205523964$var$right ? "x" : "y", transform = orient === $834b38f205523964$var$top || orient === $834b38f205523964$var$bottom ? $834b38f205523964$var$translateX : $834b38f205523964$var$translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, $7v1sx.default) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + offset, range1 = +range[range.length - 1] + offset, position = (scale.bandwidth ? $834b38f205523964$var$center : $834b38f205523964$var$number)(scale.copy(), offset), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === $834b38f205523964$var$top ? "0em" : orient === $834b38f205523964$var$bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", $834b38f205523964$var$epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", $834b38f205523964$var$epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
            });
        }
        tickExit.remove();
        path.attr("d", orient === $834b38f205523964$var$left || orient === $834b38f205523964$var$right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d) + offset);
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter($834b38f205523964$var$entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === $834b38f205523964$var$right ? "start" : orient === $834b38f205523964$var$left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = Array.from(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : Array.from(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : Array.from(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    axis.offset = function(_) {
        return arguments.length ? (offset = +_, axis) : offset;
    };
    return axis;
}
function $834b38f205523964$export$59b8cfab074bdeb1(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$top, scale);
}
function $834b38f205523964$export$b0d2e24dc4f898f0(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$right, scale);
}
function $834b38f205523964$export$e5cb22533a15e72e(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$bottom, scale);
}
function $834b38f205523964$export$2749afb169a520d2(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$left, scale);
}

});
parcelRegister("7v1sx", function(module, exports) {

$parcel$export(module.exports, "default", () => $575c8f74500ed33b$export$2e2bcd8739ae039);
function $575c8f74500ed33b$export$2e2bcd8739ae039(x) {
    return x;
}

});


parcelRegister("im8sd", function(module, exports) {

var $7Wzrn = parcelRequire("7Wzrn");

});
parcelRegister("7Wzrn", function(module, exports) {

var $aFEgl = parcelRequire("aFEgl");

var $cohyw = parcelRequire("cohyw");

var $bi4KR = parcelRequire("bi4KR");

var $2oxcP = parcelRequire("2oxcP");
var $hOxpW = parcelRequire("hOxpW");
parcelRequire("dxJVY");
var $f8M3T = parcelRequire("f8M3T");

var $6QApF = parcelRequire("6QApF");

var $j3W5K = parcelRequire("j3W5K");

var $6fYbl = parcelRequire("6fYbl");
var $5c8970f4694d4107$var$MODE_DRAG = {
    name: "drag"
}, $5c8970f4694d4107$var$MODE_SPACE = {
    name: "space"
}, $5c8970f4694d4107$var$MODE_HANDLE = {
    name: "handle"
}, $5c8970f4694d4107$var$MODE_CENTER = {
    name: "center"
};
const { abs: $5c8970f4694d4107$var$abs, max: $5c8970f4694d4107$var$max, min: $5c8970f4694d4107$var$min } = Math;
function $5c8970f4694d4107$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $5c8970f4694d4107$var$number2(e) {
    return [
        $5c8970f4694d4107$var$number1(e[0]),
        $5c8970f4694d4107$var$number1(e[1])
    ];
}
var $5c8970f4694d4107$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($5c8970f4694d4107$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $5c8970f4694d4107$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($5c8970f4694d4107$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $5c8970f4694d4107$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($5c8970f4694d4107$var$type),
    input: function(xy) {
        return xy == null ? null : $5c8970f4694d4107$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $5c8970f4694d4107$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $5c8970f4694d4107$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $5c8970f4694d4107$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $5c8970f4694d4107$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $5c8970f4694d4107$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $5c8970f4694d4107$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $5c8970f4694d4107$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $5c8970f4694d4107$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $5c8970f4694d4107$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $5c8970f4694d4107$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $5c8970f4694d4107$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $5c8970f4694d4107$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $5c8970f4694d4107$export$979ace6c88860aa8() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$X);
}
function $5c8970f4694d4107$export$468748b530991c54() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$Y);
}
function $5c8970f4694d4107$export$2e2bcd8739ae039() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$XY);
}
function $5c8970f4694d4107$var$brush(dim) {
    var extent = $5c8970f4694d4107$var$defaultExtent, filter = $5c8970f4694d4107$var$defaultFilter, touchable = $5c8970f4694d4107$var$defaultTouchable, keys = true, listeners = (0, $aFEgl.default)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $5c8970f4694d4107$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $5c8970f4694d4107$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $5c8970f4694d4107$var$local(this).extent;
            (0, $hOxpW.default)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $5c8970f4694d4107$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $5c8970f4694d4107$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $5c8970f4694d4107$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection, event) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $bi4KR.default)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $f8M3T.default)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start(event).brush(event).end(event);
        });
    };
    brush.clear = function(group, event) {
        brush.move(group, null, event);
    };
    function redraw() {
        var group = (0, $hOxpW.default)(this), selection = $5c8970f4694d4107$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, $hOxpW.default)(this.that).datum();
            listeners.call(type, this.that, new (0, $j3W5K.default)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? $5c8970f4694d4107$var$MODE_DRAG : keys && event.altKey ? $5c8970f4694d4107$var$MODE_CENTER : $5c8970f4694d4107$var$MODE_HANDLE, signX = dim === $5c8970f4694d4107$var$Y ? null : $5c8970f4694d4107$var$signsX[type], signY = dim === $5c8970f4694d4107$var$X ? null : $5c8970f4694d4107$var$signsY[type], state = $5c8970f4694d4107$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, $2oxcP.default)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        (0, $f8M3T.default)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === $5c8970f4694d4107$var$Y ? W : $5c8970f4694d4107$var$min(pts[0][0], pts[1][0]),
                    n0 = dim === $5c8970f4694d4107$var$X ? N : $5c8970f4694d4107$var$min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === $5c8970f4694d4107$var$Y ? E : $5c8970f4694d4107$var$max(pts[0][0], pts[1][0]),
                    s0 = dim === $5c8970f4694d4107$var$X ? S : $5c8970f4694d4107$var$max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move(event);
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $hOxpW.default)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $5c8970f4694d4107$var$cursors[type]);
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $hOxpW.default)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $cohyw.default)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, $2oxcP.default)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if ($5c8970f4694d4107$var$abs(point.cur[0] - point[0]) > $5c8970f4694d4107$var$abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, $6fYbl.default)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $5c8970f4694d4107$var$MODE_SPACE:
                case $5c8970f4694d4107$var$MODE_DRAG:
                    if (signX) dx = $5c8970f4694d4107$var$max(W - w0, $5c8970f4694d4107$var$min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = $5c8970f4694d4107$var$max(N - n0, $5c8970f4694d4107$var$min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $5c8970f4694d4107$var$MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, points[0][0])), e1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, points[1][0])), signX = 1;
                        if (signY) n1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, points[0][1])), s1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = $5c8970f4694d4107$var$max(W - w0, $5c8970f4694d4107$var$min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = $5c8970f4694d4107$var$max(W - e0, $5c8970f4694d4107$var$min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = $5c8970f4694d4107$var$max(N - n0, $5c8970f4694d4107$var$min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = $5c8970f4694d4107$var$max(N - s0, $5c8970f4694d4107$var$min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case $5c8970f4694d4107$var$MODE_CENTER:
                    if (signX) w1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, w0 - dx * signX)), e1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, e0 + dx * signX));
                    if (signY) n1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, n0 - dy * signY)), s1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $5c8970f4694d4107$var$flipX) overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type = $5c8970f4694d4107$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $5c8970f4694d4107$var$flipY) overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type = $5c8970f4694d4107$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, $6fYbl.nopropagation)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $cohyw.yesdrag)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $5c8970f4694d4107$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($5c8970f4694d4107$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $5c8970f4694d4107$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $5c8970f4694d4107$var$MODE_CENTER;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $5c8970f4694d4107$var$MODE_HANDLE || mode === $5c8970f4694d4107$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $5c8970f4694d4107$var$MODE_SPACE;
                        overlay.attr("cursor", $5c8970f4694d4107$var$cursors.selection);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $6fYbl.default)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move(event);
                    }
                    break;
                case 18:
                    if (mode === $5c8970f4694d4107$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $5c8970f4694d4107$var$MODE_HANDLE;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $5c8970f4694d4107$var$MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $5c8970f4694d4107$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $5c8970f4694d4107$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type]);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $6fYbl.default)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $5c8970f4694d4107$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $6QApF.default)($5c8970f4694d4107$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $6QApF.default)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $6QApF.default)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}

});
parcelRegister("aFEgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4cf709d1826294$export$2e2bcd8739ae039);
var $7c4cf709d1826294$var$noop = {
    value: ()=>{}
};
function $7c4cf709d1826294$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $7c4cf709d1826294$var$Dispatch(_);
}
function $7c4cf709d1826294$var$Dispatch(_) {
    this._ = _;
}
function $7c4cf709d1826294$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$7c4cf709d1826294$var$Dispatch.prototype = $7c4cf709d1826294$var$dispatch.prototype = {
    constructor: $7c4cf709d1826294$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $7c4cf709d1826294$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $7c4cf709d1826294$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $7c4cf709d1826294$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $7c4cf709d1826294$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $7c4cf709d1826294$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $7c4cf709d1826294$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $7c4cf709d1826294$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $7c4cf709d1826294$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $7c4cf709d1826294$export$2e2bcd8739ae039 = $7c4cf709d1826294$var$dispatch;

});

parcelRegister("cohyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $905558291b0c219c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "yesdrag", () => $905558291b0c219c$export$833237748009e1e1);

var $hOxpW = parcelRequire("hOxpW");

var $cttdm = parcelRequire("cttdm");
function $905558291b0c219c$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $hOxpW.default)(view).on("dragstart.drag", (0, $cttdm.default), (0, $cttdm.nonpassivecapture));
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $cttdm.default), (0, $cttdm.nonpassivecapture));
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $905558291b0c219c$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $hOxpW.default)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $cttdm.default), (0, $cttdm.nonpassivecapture));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

});
parcelRegister("hOxpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf81072cf307ee25$export$2e2bcd8739ae039);

var $3us5W = parcelRequire("3us5W");
function $cf81072cf307ee25$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $3us5W.Selection)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $3us5W.Selection)([
        [
            selector
        ]
    ], (0, $3us5W.root));
}

});
parcelRegister("3us5W", function(module, exports) {

$parcel$export(module.exports, "root", () => $28a9f77d63e1ff25$export$e8e78c978b129247);
$parcel$export(module.exports, "Selection", () => $28a9f77d63e1ff25$export$52baac22726c72bf);
$parcel$export(module.exports, "default", () => $28a9f77d63e1ff25$export$2e2bcd8739ae039);

var $4dcxD = parcelRequire("4dcxD");

var $e48mM = parcelRequire("e48mM");

var $4i911 = parcelRequire("4i911");

var $cP92U = parcelRequire("cP92U");

var $kePFY = parcelRequire("kePFY");

var $hOWaJ = parcelRequire("hOWaJ");

var $5ndv3 = parcelRequire("5ndv3");

var $94na1 = parcelRequire("94na1");

var $b4sDG = parcelRequire("b4sDG");

var $8yR9d = parcelRequire("8yR9d");

var $awsX1 = parcelRequire("awsX1");

var $lxGnS = parcelRequire("lxGnS");

var $lv7c7 = parcelRequire("lv7c7");

var $gJ79D = parcelRequire("gJ79D");

var $hryK9 = parcelRequire("hryK9");

var $c7pKF = parcelRequire("c7pKF");

var $5ouhg = parcelRequire("5ouhg");

var $6neWh = parcelRequire("6neWh");

var $bZhEJ = parcelRequire("bZhEJ");

var $9a8q4 = parcelRequire("9a8q4");

var $3I2BK = parcelRequire("3I2BK");

var $8G4xj = parcelRequire("8G4xj");

var $34eax = parcelRequire("34eax");

var $iju2Z = parcelRequire("iju2Z");

var $h3vbL = parcelRequire("h3vbL");

var $62NTp = parcelRequire("62NTp");

var $03tNP = parcelRequire("03tNP");

var $5WMZy = parcelRequire("5WMZy");

var $ikClj = parcelRequire("ikClj");

var $4odnA = parcelRequire("4odnA");

var $hSH4f = parcelRequire("hSH4f");

var $iZ2is = parcelRequire("iZ2is");

var $3pIv8 = parcelRequire("3pIv8");

var $d4eXd = parcelRequire("d4eXd");
var $28a9f77d63e1ff25$export$e8e78c978b129247 = [
    null
];
function $28a9f77d63e1ff25$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $28a9f77d63e1ff25$var$selection() {
    return new $28a9f77d63e1ff25$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $28a9f77d63e1ff25$export$e8e78c978b129247);
}
function $28a9f77d63e1ff25$var$selection_selection() {
    return this;
}
$28a9f77d63e1ff25$export$52baac22726c72bf.prototype = $28a9f77d63e1ff25$var$selection.prototype = {
    constructor: $28a9f77d63e1ff25$export$52baac22726c72bf,
    select: (0, $4dcxD.default),
    selectAll: (0, $e48mM.default),
    selectChild: (0, $4i911.default),
    selectChildren: (0, $cP92U.default),
    filter: (0, $kePFY.default),
    data: (0, $hOWaJ.default),
    enter: (0, $5ndv3.default),
    exit: (0, $94na1.default),
    join: (0, $b4sDG.default),
    merge: (0, $8yR9d.default),
    selection: $28a9f77d63e1ff25$var$selection_selection,
    order: (0, $awsX1.default),
    sort: (0, $lxGnS.default),
    call: (0, $lv7c7.default),
    nodes: (0, $gJ79D.default),
    node: (0, $hryK9.default),
    size: (0, $c7pKF.default),
    empty: (0, $5ouhg.default),
    each: (0, $6neWh.default),
    attr: (0, $bZhEJ.default),
    style: (0, $9a8q4.default),
    property: (0, $3I2BK.default),
    classed: (0, $8G4xj.default),
    text: (0, $34eax.default),
    html: (0, $iju2Z.default),
    raise: (0, $h3vbL.default),
    lower: (0, $62NTp.default),
    append: (0, $03tNP.default),
    insert: (0, $5WMZy.default),
    remove: (0, $ikClj.default),
    clone: (0, $4odnA.default),
    datum: (0, $hSH4f.default),
    on: (0, $iZ2is.default),
    dispatch: (0, $3pIv8.default),
    [Symbol.iterator]: (0, $d4eXd.default)
};
var $28a9f77d63e1ff25$export$2e2bcd8739ae039 = $28a9f77d63e1ff25$var$selection;

});
parcelRegister("4dcxD", function(module, exports) {

$parcel$export(module.exports, "default", () => $31121acbef1e6956$export$2e2bcd8739ae039);

var $3us5W = parcelRequire("3us5W");

var $9rOh8 = parcelRequire("9rOh8");
function $31121acbef1e6956$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $9rOh8.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $3us5W.Selection)(subgroups, this._parents);
}

});
parcelRegister("9rOh8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e0da2549057218e$export$2e2bcd8739ae039);
function $6e0da2549057218e$var$none() {}
function $6e0da2549057218e$export$2e2bcd8739ae039(selector) {
    return selector == null ? $6e0da2549057218e$var$none : function() {
        return this.querySelector(selector);
    };
}

});


parcelRegister("e48mM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3d7edd03ec30cc1$export$2e2bcd8739ae039);

var $3us5W = parcelRequire("3us5W");

var $hpRkj = parcelRequire("hpRkj");

var $aMqra = parcelRequire("aMqra");
function $a3d7edd03ec30cc1$var$arrayAll(select) {
    return function() {
        return (0, $hpRkj.default)(select.apply(this, arguments));
    };
}
function $a3d7edd03ec30cc1$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $a3d7edd03ec30cc1$var$arrayAll(select);
    else select = (0, $aMqra.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $3us5W.Selection)(subgroups, parents);
}

});
parcelRegister("hpRkj", function(module, exports) {

$parcel$export(module.exports, "default", () => $cade2308c136039a$export$2e2bcd8739ae039);
// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function $cade2308c136039a$export$2e2bcd8739ae039(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}

});

parcelRegister("aMqra", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d92e4f75dbef49d$export$2e2bcd8739ae039);
function $7d92e4f75dbef49d$var$empty() {
    return [];
}
function $7d92e4f75dbef49d$export$2e2bcd8739ae039(selector) {
    return selector == null ? $7d92e4f75dbef49d$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}

});


parcelRegister("4i911", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ffd623f27a3a65$export$2e2bcd8739ae039);

var $8doa3 = parcelRequire("8doa3");
var $31ffd623f27a3a65$var$find = Array.prototype.find;
function $31ffd623f27a3a65$var$childFind(match) {
    return function() {
        return $31ffd623f27a3a65$var$find.call(this.children, match);
    };
}
function $31ffd623f27a3a65$var$childFirst() {
    return this.firstElementChild;
}
function $31ffd623f27a3a65$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $31ffd623f27a3a65$var$childFirst : $31ffd623f27a3a65$var$childFind(typeof match === "function" ? match : (0, $8doa3.childMatcher)(match)));
}

});
parcelRegister("8doa3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fb24786d2a5f87a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "childMatcher", () => $5fb24786d2a5f87a$export$90c2759c036528);
function $5fb24786d2a5f87a$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $5fb24786d2a5f87a$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}

});


parcelRegister("cP92U", function(module, exports) {

$parcel$export(module.exports, "default", () => $956143cec557381d$export$2e2bcd8739ae039);

var $8doa3 = parcelRequire("8doa3");
var $956143cec557381d$var$filter = Array.prototype.filter;
function $956143cec557381d$var$children() {
    return Array.from(this.children);
}
function $956143cec557381d$var$childrenFilter(match) {
    return function() {
        return $956143cec557381d$var$filter.call(this.children, match);
    };
}
function $956143cec557381d$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $956143cec557381d$var$children : $956143cec557381d$var$childrenFilter(typeof match === "function" ? match : (0, $8doa3.childMatcher)(match)));
}

});

parcelRegister("kePFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebbd333b038c2847$export$2e2bcd8739ae039);

var $3us5W = parcelRequire("3us5W");

var $8doa3 = parcelRequire("8doa3");
function $ebbd333b038c2847$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $8doa3.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $3us5W.Selection)(subgroups, this._parents);
}

});

parcelRegister("hOWaJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf943aeeeea8dffb$export$2e2bcd8739ae039);

var $3us5W = parcelRequire("3us5W");

var $5ndv3 = parcelRequire("5ndv3");

var $iCdMC = parcelRequire("iCdMC");
function $cf943aeeeea8dffb$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $5ndv3.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $cf943aeeeea8dffb$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $5ndv3.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $cf943aeeeea8dffb$var$datum(node) {
    return node.__data__;
}
function $cf943aeeeea8dffb$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $cf943aeeeea8dffb$var$datum);
    var bind = key ? $cf943aeeeea8dffb$var$bindKey : $cf943aeeeea8dffb$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $iCdMC.default)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = $cf943aeeeea8dffb$var$arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $3us5W.Selection)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function $cf943aeeeea8dffb$var$arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}

});
parcelRegister("5ndv3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e99928b06782938$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EnterNode", () => $3e99928b06782938$export$67b01759a14cf6a4);

var $jUPKb = parcelRequire("jUPKb");

var $3us5W = parcelRequire("3us5W");
function $3e99928b06782938$export$2e2bcd8739ae039() {
    return new (0, $3us5W.Selection)(this._enter || this._groups.map((0, $jUPKb.default)), this._parents);
}
function $3e99928b06782938$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$3e99928b06782938$export$67b01759a14cf6a4.prototype = {
    constructor: $3e99928b06782938$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

});
parcelRegister("jUPKb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7fb628d3a97a780$export$2e2bcd8739ae039);
function $e7fb628d3a97a780$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}

});


parcelRegister("iCdMC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8d677a8510c2e55$export$2e2bcd8739ae039);
function $d8d677a8510c2e55$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("94na1", function(module, exports) {

$parcel$export(module.exports, "default", () => $69a673ff94b874e4$export$2e2bcd8739ae039);

var $jUPKb = parcelRequire("jUPKb");

var $3us5W = parcelRequire("3us5W");
function $69a673ff94b874e4$export$2e2bcd8739ae039() {
    return new (0, $3us5W.Selection)(this._exit || this._groups.map((0, $jUPKb.default)), this._parents);
}

});

parcelRegister("b4sDG", function(module, exports) {

$parcel$export(module.exports, "default", () => $80f6488751784891$export$2e2bcd8739ae039);
function $80f6488751784891$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    if (typeof onenter === "function") {
        enter = onenter(enter);
        if (enter) enter = enter.selection();
    } else enter = enter.append(onenter + "");
    if (onupdate != null) {
        update = onupdate(update);
        if (update) update = update.selection();
    }
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}

});

parcelRegister("8yR9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $63bab9b342eb32db$export$2e2bcd8739ae039);

var $3us5W = parcelRequire("3us5W");
function $63bab9b342eb32db$export$2e2bcd8739ae039(context) {
    var selection = context.selection ? context.selection() : context;
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $3us5W.Selection)(merges, this._parents);
}

});

parcelRegister("awsX1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a935994b7a1f6cf$export$2e2bcd8739ae039);
function $7a935994b7a1f6cf$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}

});

parcelRegister("lxGnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $faed8eab1469f61d$export$2e2bcd8739ae039);

var $3us5W = parcelRequire("3us5W");
function $faed8eab1469f61d$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $faed8eab1469f61d$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $3us5W.Selection)(sortgroups, this._parents).order();
}
function $faed8eab1469f61d$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("lv7c7", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa7212ea177e0f60$export$2e2bcd8739ae039);
function $fa7212ea177e0f60$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}

});

parcelRegister("gJ79D", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2d66609f799a53b$export$2e2bcd8739ae039);
function $c2d66609f799a53b$export$2e2bcd8739ae039() {
    return Array.from(this);
}

});

parcelRegister("hryK9", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2fe8996a284614$export$2e2bcd8739ae039);
function $cb2fe8996a284614$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}

});

parcelRegister("c7pKF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d2a1d37edc5fc51$export$2e2bcd8739ae039);
function $8d2a1d37edc5fc51$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}

});

parcelRegister("5ouhg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ed6ae19ad0a17a6$export$2e2bcd8739ae039);
function $3ed6ae19ad0a17a6$export$2e2bcd8739ae039() {
    return !this.node();
}

});

parcelRegister("6neWh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a407aa055eb21e9$export$2e2bcd8739ae039);
function $4a407aa055eb21e9$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}

});

parcelRegister("bZhEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ba31651ad7591ba$export$2e2bcd8739ae039);

var $fEEcv = parcelRequire("fEEcv");
function $8ba31651ad7591ba$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $8ba31651ad7591ba$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $8ba31651ad7591ba$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $8ba31651ad7591ba$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $8ba31651ad7591ba$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $8ba31651ad7591ba$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $8ba31651ad7591ba$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $fEEcv.default)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $8ba31651ad7591ba$var$attrRemoveNS : $8ba31651ad7591ba$var$attrRemove : typeof value === "function" ? fullname.local ? $8ba31651ad7591ba$var$attrFunctionNS : $8ba31651ad7591ba$var$attrFunction : fullname.local ? $8ba31651ad7591ba$var$attrConstantNS : $8ba31651ad7591ba$var$attrConstant)(fullname, value));
}

});
parcelRegister("fEEcv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b659c67af9335162$export$2e2bcd8739ae039);

var $7cQXC = parcelRequire("7cQXC");
function $b659c67af9335162$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $7cQXC.default).hasOwnProperty(prefix) ? {
        space: (0, $7cQXC.default)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}

});
parcelRegister("7cQXC", function(module, exports) {

$parcel$export(module.exports, "xhtml", () => $53f2bc3e7847f93d$export$201a3f7520ccc326);
$parcel$export(module.exports, "default", () => $53f2bc3e7847f93d$export$2e2bcd8739ae039);
var $53f2bc3e7847f93d$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $53f2bc3e7847f93d$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $53f2bc3e7847f93d$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

});



parcelRegister("9a8q4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6abb942964e997ae$export$2e2bcd8739ae039);
$parcel$export(module.exports, "styleValue", () => $6abb942964e997ae$export$5e3cec964f0b5efd);

var $bQhLV = parcelRequire("bQhLV");
function $6abb942964e997ae$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $6abb942964e997ae$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $6abb942964e997ae$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $6abb942964e997ae$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $6abb942964e997ae$var$styleRemove : typeof value === "function" ? $6abb942964e997ae$var$styleFunction : $6abb942964e997ae$var$styleConstant)(name, value, priority == null ? "" : priority)) : $6abb942964e997ae$export$5e3cec964f0b5efd(this.node(), name);
}
function $6abb942964e997ae$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $bQhLV.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

});
parcelRegister("bQhLV", function(module, exports) {

$parcel$export(module.exports, "default", () => $89f2562a5a0d5a13$export$2e2bcd8739ae039);
function $89f2562a5a0d5a13$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}

});


parcelRegister("3I2BK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b37810bbc11c28b$export$2e2bcd8739ae039);
function $2b37810bbc11c28b$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $2b37810bbc11c28b$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $2b37810bbc11c28b$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $2b37810bbc11c28b$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $2b37810bbc11c28b$var$propertyRemove : typeof value === "function" ? $2b37810bbc11c28b$var$propertyFunction : $2b37810bbc11c28b$var$propertyConstant)(name, value)) : this.node()[name];
}

});

parcelRegister("8G4xj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6515c3ccac9efd7a$export$2e2bcd8739ae039);
function $6515c3ccac9efd7a$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $6515c3ccac9efd7a$var$classList(node) {
    return node.classList || new $6515c3ccac9efd7a$var$ClassList(node);
}
function $6515c3ccac9efd7a$var$ClassList(node) {
    this._node = node;
    this._names = $6515c3ccac9efd7a$var$classArray(node.getAttribute("class") || "");
}
$6515c3ccac9efd7a$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $6515c3ccac9efd7a$var$classedAdd(node, names) {
    var list = $6515c3ccac9efd7a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $6515c3ccac9efd7a$var$classedRemove(node, names) {
    var list = $6515c3ccac9efd7a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $6515c3ccac9efd7a$var$classedTrue(names) {
    return function() {
        $6515c3ccac9efd7a$var$classedAdd(this, names);
    };
}
function $6515c3ccac9efd7a$var$classedFalse(names) {
    return function() {
        $6515c3ccac9efd7a$var$classedRemove(this, names);
    };
}
function $6515c3ccac9efd7a$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $6515c3ccac9efd7a$var$classedAdd : $6515c3ccac9efd7a$var$classedRemove)(this, names);
    };
}
function $6515c3ccac9efd7a$export$2e2bcd8739ae039(name, value) {
    var names = $6515c3ccac9efd7a$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $6515c3ccac9efd7a$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $6515c3ccac9efd7a$var$classedFunction : value ? $6515c3ccac9efd7a$var$classedTrue : $6515c3ccac9efd7a$var$classedFalse)(names, value));
}

});

parcelRegister("34eax", function(module, exports) {

$parcel$export(module.exports, "default", () => $23bcbc7d81179ba9$export$2e2bcd8739ae039);
function $23bcbc7d81179ba9$var$textRemove() {
    this.textContent = "";
}
function $23bcbc7d81179ba9$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $23bcbc7d81179ba9$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $23bcbc7d81179ba9$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $23bcbc7d81179ba9$var$textRemove : (typeof value === "function" ? $23bcbc7d81179ba9$var$textFunction : $23bcbc7d81179ba9$var$textConstant)(value)) : this.node().textContent;
}

});

parcelRegister("iju2Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5514f1406649954$export$2e2bcd8739ae039);
function $d5514f1406649954$var$htmlRemove() {
    this.innerHTML = "";
}
function $d5514f1406649954$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $d5514f1406649954$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $d5514f1406649954$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $d5514f1406649954$var$htmlRemove : (typeof value === "function" ? $d5514f1406649954$var$htmlFunction : $d5514f1406649954$var$htmlConstant)(value)) : this.node().innerHTML;
}

});

parcelRegister("h3vbL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6aae8ef09c3d03d$export$2e2bcd8739ae039);
function $c6aae8ef09c3d03d$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $c6aae8ef09c3d03d$export$2e2bcd8739ae039() {
    return this.each($c6aae8ef09c3d03d$var$raise);
}

});

parcelRegister("62NTp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4669a19c71181bd1$export$2e2bcd8739ae039);
function $4669a19c71181bd1$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $4669a19c71181bd1$export$2e2bcd8739ae039() {
    return this.each($4669a19c71181bd1$var$lower);
}

});

parcelRegister("03tNP", function(module, exports) {

$parcel$export(module.exports, "default", () => $00a766249763e814$export$2e2bcd8739ae039);

var $bkOxa = parcelRequire("bkOxa");
function $00a766249763e814$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $bkOxa.default)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}

});
parcelRegister("bkOxa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8408c2f95f59818f$export$2e2bcd8739ae039);

var $fEEcv = parcelRequire("fEEcv");

var $7cQXC = parcelRequire("7cQXC");
function $8408c2f95f59818f$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $7cQXC.xhtml) && document.documentElement.namespaceURI === (0, $7cQXC.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $8408c2f95f59818f$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $8408c2f95f59818f$export$2e2bcd8739ae039(name) {
    var fullname = (0, $fEEcv.default)(name);
    return (fullname.local ? $8408c2f95f59818f$var$creatorFixed : $8408c2f95f59818f$var$creatorInherit)(fullname);
}

});


parcelRegister("5WMZy", function(module, exports) {

$parcel$export(module.exports, "default", () => $45485f4f27d149f8$export$2e2bcd8739ae039);

var $bkOxa = parcelRequire("bkOxa");

var $9rOh8 = parcelRequire("9rOh8");
function $45485f4f27d149f8$var$constantNull() {
    return null;
}
function $45485f4f27d149f8$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $bkOxa.default)(name), select = before == null ? $45485f4f27d149f8$var$constantNull : typeof before === "function" ? before : (0, $9rOh8.default)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}

});

parcelRegister("ikClj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d587d6535138580c$export$2e2bcd8739ae039);
function $d587d6535138580c$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $d587d6535138580c$export$2e2bcd8739ae039() {
    return this.each($d587d6535138580c$var$remove);
}

});

parcelRegister("4odnA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3323c835dc2d74de$export$2e2bcd8739ae039);
function $3323c835dc2d74de$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $3323c835dc2d74de$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $3323c835dc2d74de$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $3323c835dc2d74de$var$selection_cloneDeep : $3323c835dc2d74de$var$selection_cloneShallow);
}

});

parcelRegister("hSH4f", function(module, exports) {

$parcel$export(module.exports, "default", () => $d048e3258aa4fe8e$export$2e2bcd8739ae039);
function $d048e3258aa4fe8e$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}

});

parcelRegister("iZ2is", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd1fb49221ad966f$export$2e2bcd8739ae039);
function $dd1fb49221ad966f$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $dd1fb49221ad966f$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $dd1fb49221ad966f$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $dd1fb49221ad966f$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $dd1fb49221ad966f$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $dd1fb49221ad966f$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $dd1fb49221ad966f$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $dd1fb49221ad966f$var$onAdd : $dd1fb49221ad966f$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}

});

parcelRegister("3pIv8", function(module, exports) {

$parcel$export(module.exports, "default", () => $27c639e461d8a390$export$2e2bcd8739ae039);

var $bQhLV = parcelRequire("bQhLV");
function $27c639e461d8a390$var$dispatchEvent(node, type, params) {
    var window = (0, $bQhLV.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $27c639e461d8a390$var$dispatchConstant(type, params) {
    return function() {
        return $27c639e461d8a390$var$dispatchEvent(this, type, params);
    };
}
function $27c639e461d8a390$var$dispatchFunction(type, params) {
    return function() {
        return $27c639e461d8a390$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $27c639e461d8a390$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $27c639e461d8a390$var$dispatchFunction : $27c639e461d8a390$var$dispatchConstant)(type, params));
}

});

parcelRegister("d4eXd", function(module, exports) {

$parcel$export(module.exports, "default", () => $98373fa9c0ecbfb2$export$2e2bcd8739ae039);
function* $98373fa9c0ecbfb2$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}

});



parcelRegister("cttdm", function(module, exports) {

$parcel$export(module.exports, "nonpassivecapture", () => $914edae09cbfb4c0$export$35431a0e47022de1);
$parcel$export(module.exports, "default", () => $914edae09cbfb4c0$export$2e2bcd8739ae039);
// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
const $914edae09cbfb4c0$export$524615cd03e458cc = {
    passive: false
};
const $914edae09cbfb4c0$export$35431a0e47022de1 = {
    capture: true,
    passive: false
};
function $914edae09cbfb4c0$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $914edae09cbfb4c0$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

});


parcelRegister("bi4KR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8385105b4986daed$export$2e2bcd8739ae039);

var $bYoiY = parcelRequire("bYoiY");

var $jUrtA = parcelRequire("jUrtA");

var $34d8K = parcelRequire("34d8K");

var $xcrgO = parcelRequire("xcrgO");

var $gnkFs = parcelRequire("gnkFs");

var $hNADL = parcelRequire("hNADL");

var $aPLyh = parcelRequire("aPLyh");

var $amdqR = parcelRequire("amdqR");

var $aE1fz = parcelRequire("aE1fz");
function $8385105b4986daed$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $amdqR.default)(b) : (t === "number" ? (0, $gnkFs.default) : t === "string" ? (c = (0, $bYoiY.default)(b)) ? (b = c, $jUrtA.default) : (0, $aPLyh.default) : b instanceof (0, $bYoiY.default) ? (0, $jUrtA.default) : b instanceof Date ? (0, $xcrgO.default) : (0, $aE1fz.isNumberArray)(b) ? (0, $aE1fz.default) : Array.isArray(b) ? (0, $34d8K.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $hNADL.default) : (0, $gnkFs.default))(a, b);
}

});
parcelRegister("bYoiY", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $bfWFq = parcelRequire("bfWFq");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $bfWFq.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Rgb, rgb, (0, $bfWFq.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Hsl, hsl, (0, $bfWFq.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("bfWFq", function(module, exports) {

$parcel$export(module.exports, "default", () => $831e9a7deaab9d1d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $831e9a7deaab9d1d$export$8b58be045bf06082);
function $831e9a7deaab9d1d$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $831e9a7deaab9d1d$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("jUrtA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7e88f7f6ed95eef$export$2e2bcd8739ae039);

var $bYoiY = parcelRequire("bYoiY");

var $j0bQ2 = parcelRequire("j0bQ2");

var $8XYWK = parcelRequire("8XYWK");

var $75Lq4 = parcelRequire("75Lq4");
var $e7e88f7f6ed95eef$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $75Lq4.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $bYoiY.rgb)(start)).r, (end = (0, $bYoiY.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $75Lq4.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $e7e88f7f6ed95eef$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $bYoiY.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $e7e88f7f6ed95eef$export$2c0e28f2e2852d3f = $e7e88f7f6ed95eef$var$rgbSpline((0, $j0bQ2.default));
var $e7e88f7f6ed95eef$export$53d5214f625ccd4c = $e7e88f7f6ed95eef$var$rgbSpline((0, $8XYWK.default));

});
parcelRegister("j0bQ2", function(module, exports) {

$parcel$export(module.exports, "basis", () => $dd5733431a2d0880$export$4e41033bfeec1a4c);
$parcel$export(module.exports, "default", () => $dd5733431a2d0880$export$2e2bcd8739ae039);
function $dd5733431a2d0880$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $dd5733431a2d0880$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $dd5733431a2d0880$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("8XYWK", function(module, exports) {

$parcel$export(module.exports, "default", () => $68731c1c421d9916$export$2e2bcd8739ae039);

var $j0bQ2 = parcelRequire("j0bQ2");
function $68731c1c421d9916$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $j0bQ2.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("75Lq4", function(module, exports) {

$parcel$export(module.exports, "hue", () => $529dc8928f6a4077$export$97d7b0c7ddb78dcf);
$parcel$export(module.exports, "gamma", () => $529dc8928f6a4077$export$a7ebe8cc6aaf8d37);
$parcel$export(module.exports, "default", () => $529dc8928f6a4077$export$2e2bcd8739ae039);

var $amdqR = parcelRequire("amdqR");
function $529dc8928f6a4077$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $529dc8928f6a4077$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $529dc8928f6a4077$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $amdqR.default)(isNaN(a) ? b : a);
}
function $529dc8928f6a4077$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $529dc8928f6a4077$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $529dc8928f6a4077$var$exponential(a, b, y) : (0, $amdqR.default)(isNaN(a) ? b : a);
    };
}
function $529dc8928f6a4077$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d) : (0, $amdqR.default)(isNaN(a) ? b : a);
}

});
parcelRegister("amdqR", function(module, exports) {

$parcel$export(module.exports, "default", () => $78a660cd70c52f6f$export$2e2bcd8739ae039);
var $78a660cd70c52f6f$export$2e2bcd8739ae039 = (x)=>()=>x;

});



parcelRegister("34d8K", function(module, exports) {

$parcel$export(module.exports, "genericArray", () => $23bbf03008765dcc$export$15d09067c6a5ee49);

var $bi4KR = parcelRequire("bi4KR");

var $aE1fz = parcelRequire("aE1fz");
function $23bbf03008765dcc$export$2e2bcd8739ae039(a, b) {
    return ((0, $aE1fz.isNumberArray)(b) ? (0, $aE1fz.default) : $23bbf03008765dcc$export$15d09067c6a5ee49)(a, b);
}
function $23bbf03008765dcc$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $bi4KR.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("aE1fz", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isNumberArray", () => $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8);
function $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("xcrgO", function(module, exports) {

$parcel$export(module.exports, "default", () => $063cbb46f86ba478$export$2e2bcd8739ae039);
function $063cbb46f86ba478$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("gnkFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $bebed377ddb9d3af$export$2e2bcd8739ae039);
function $bebed377ddb9d3af$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("hNADL", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf536f4647e343d9$export$2e2bcd8739ae039);

var $bi4KR = parcelRequire("bi4KR");
function $cf536f4647e343d9$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $bi4KR.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("aPLyh", function(module, exports) {

$parcel$export(module.exports, "default", () => $020916edd93bff72$export$2e2bcd8739ae039);

var $gnkFs = parcelRequire("gnkFs");
var $020916edd93bff72$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $020916edd93bff72$var$reB = new RegExp($020916edd93bff72$var$reA.source, "g");
function $020916edd93bff72$var$zero(b) {
    return function() {
        return b;
    };
}
function $020916edd93bff72$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $020916edd93bff72$export$2e2bcd8739ae039(a, b) {
    var bi = $020916edd93bff72$var$reA.lastIndex = $020916edd93bff72$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $020916edd93bff72$var$reA.exec(a)) && (bm = $020916edd93bff72$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $gnkFs.default)(am, bm)
            });
        }
        bi = $020916edd93bff72$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $020916edd93bff72$var$one(q[0].x) : $020916edd93bff72$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("2oxcP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1be794af963d8372$export$2e2bcd8739ae039);

var $gQNdD = parcelRequire("gQNdD");
function $1be794af963d8372$export$2e2bcd8739ae039(event, node) {
    event = (0, $gQNdD.default)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}

});
parcelRegister("gQNdD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c447ae86a8320d39$export$2e2bcd8739ae039);
function $c447ae86a8320d39$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}

});


parcelRegister("dxJVY", function(module, exports) {

$parcel$export(module.exports, "interrupt", () => (parcelRequire("f8M3T")).default);
parcelRequire("2k9Hs");



var $f8M3T = parcelRequire("f8M3T");

});
parcelRegister("2k9Hs", function(module, exports) {

var $3us5W = parcelRequire("3us5W");

var $gDVVi = parcelRequire("gDVVi");

var $fBcKd = parcelRequire("fBcKd");
(0, $3us5W.default).prototype.interrupt = (0, $gDVVi.default);
(0, $3us5W.default).prototype.transition = (0, $fBcKd.default);

});
parcelRegister("gDVVi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1dd383074e2630e$export$2e2bcd8739ae039);

var $f8M3T = parcelRequire("f8M3T");
function $c1dd383074e2630e$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $f8M3T.default)(this, name);
    });
}

});
parcelRegister("f8M3T", function(module, exports) {

$parcel$export(module.exports, "default", () => $b05ce272ee11a654$export$2e2bcd8739ae039);

var $1O1wu = parcelRequire("1O1wu");
function $b05ce272ee11a654$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $1O1wu.STARTING) && schedule.state < (0, $1O1wu.ENDING);
        schedule.state = (0, $1O1wu.ENDED);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}

});
parcelRegister("1O1wu", function(module, exports) {

$parcel$export(module.exports, "STARTING", () => $150ba4634a330696$export$a5d151aee16efd42);
$parcel$export(module.exports, "ENDING", () => $150ba4634a330696$export$a2e792214ded83b2);
$parcel$export(module.exports, "ENDED", () => $150ba4634a330696$export$9d38167254403955);
$parcel$export(module.exports, "default", () => $150ba4634a330696$export$2e2bcd8739ae039);
$parcel$export(module.exports, "init", () => $150ba4634a330696$export$2cd8252107eb640b);
$parcel$export(module.exports, "get", () => $150ba4634a330696$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $150ba4634a330696$export$adaa4cf7ef1b65be);

var $aFEgl = parcelRequire("aFEgl");

var $hYquC = parcelRequire("hYquC");
var $jSjsP = parcelRequire("jSjsP");
var $150ba4634a330696$var$emptyOn = (0, $aFEgl.default)("start", "end", "cancel", "interrupt");
var $150ba4634a330696$var$emptyTween = [];
var $150ba4634a330696$export$ff39ebd4bb12b718 = 0;
var $150ba4634a330696$export$584530fe98d14a84 = 1;
var $150ba4634a330696$export$a5d151aee16efd42 = 2;
var $150ba4634a330696$export$fb935ab5849a0db9 = 3;
var $150ba4634a330696$export$1573e22b087389af = 4;
var $150ba4634a330696$export$a2e792214ded83b2 = 5;
var $150ba4634a330696$export$9d38167254403955 = 6;
function $150ba4634a330696$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $150ba4634a330696$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $150ba4634a330696$var$emptyOn,
        tween: $150ba4634a330696$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $150ba4634a330696$export$ff39ebd4bb12b718
    });
}
function $150ba4634a330696$export$2cd8252107eb640b(node, id) {
    var schedule = $150ba4634a330696$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $150ba4634a330696$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $150ba4634a330696$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $150ba4634a330696$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $150ba4634a330696$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $150ba4634a330696$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $150ba4634a330696$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $jSjsP.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $150ba4634a330696$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $150ba4634a330696$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $150ba4634a330696$export$fb935ab5849a0db9) return (0, $hYquC.default)(start);
            // Interrupt the active transition, if any.
            if (o.state === $150ba4634a330696$export$1573e22b087389af) {
                o.state = $150ba4634a330696$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $150ba4634a330696$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $hYquC.default)(function() {
            if (self.state === $150ba4634a330696$export$fb935ab5849a0db9) {
                self.state = $150ba4634a330696$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $150ba4634a330696$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $150ba4634a330696$export$a5d151aee16efd42) return; // interrupted
        self.state = $150ba4634a330696$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $150ba4634a330696$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $150ba4634a330696$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $150ba4634a330696$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}

});
parcelRegister("hYquC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d15c972f8843a0f2$export$2e2bcd8739ae039);

var $jSjsP = parcelRequire("jSjsP");
function $d15c972f8843a0f2$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $jSjsP.Timer);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}

});
parcelRegister("jSjsP", function(module, exports) {

$parcel$export(module.exports, "now", () => $e782289d8bd71451$export$461939dd4422153);
$parcel$export(module.exports, "Timer", () => $e782289d8bd71451$export$c57e9b2d8b9e4de);
$parcel$export(module.exports, "timer", () => $e782289d8bd71451$export$9dc4ecf953986f04);
var $e782289d8bd71451$var$frame = 0, $e782289d8bd71451$var$timeout = 0, $e782289d8bd71451$var$interval = 0, $e782289d8bd71451$var$pokeDelay = 1000, $e782289d8bd71451$var$taskHead, $e782289d8bd71451$var$taskTail, $e782289d8bd71451$var$clockLast = 0, $e782289d8bd71451$var$clockNow = 0, $e782289d8bd71451$var$clockSkew = 0, $e782289d8bd71451$var$clock = typeof performance === "object" && performance.now ? performance : Date, $e782289d8bd71451$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $e782289d8bd71451$export$461939dd4422153() {
    return $e782289d8bd71451$var$clockNow || ($e782289d8bd71451$var$setFrame($e782289d8bd71451$var$clearNow), $e782289d8bd71451$var$clockNow = $e782289d8bd71451$var$clock.now() + $e782289d8bd71451$var$clockSkew);
}
function $e782289d8bd71451$var$clearNow() {
    $e782289d8bd71451$var$clockNow = 0;
}
function $e782289d8bd71451$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$e782289d8bd71451$export$c57e9b2d8b9e4de.prototype = $e782289d8bd71451$export$9dc4ecf953986f04.prototype = {
    constructor: $e782289d8bd71451$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $e782289d8bd71451$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $e782289d8bd71451$var$taskTail !== this) {
            if ($e782289d8bd71451$var$taskTail) $e782289d8bd71451$var$taskTail._next = this;
            else $e782289d8bd71451$var$taskHead = this;
            $e782289d8bd71451$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $e782289d8bd71451$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $e782289d8bd71451$var$sleep();
        }
    }
};
function $e782289d8bd71451$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $e782289d8bd71451$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $e782289d8bd71451$export$d60154c1d7f3990e() {
    $e782289d8bd71451$export$461939dd4422153(); // Get the current time, if not already set.
    ++$e782289d8bd71451$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $e782289d8bd71451$var$taskHead, e;
    while(t){
        if ((e = $e782289d8bd71451$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$e782289d8bd71451$var$frame;
}
function $e782289d8bd71451$var$wake() {
    $e782289d8bd71451$var$clockNow = ($e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now()) + $e782289d8bd71451$var$clockSkew;
    $e782289d8bd71451$var$frame = $e782289d8bd71451$var$timeout = 0;
    try {
        $e782289d8bd71451$export$d60154c1d7f3990e();
    } finally{
        $e782289d8bd71451$var$frame = 0;
        $e782289d8bd71451$var$nap();
        $e782289d8bd71451$var$clockNow = 0;
    }
}
function $e782289d8bd71451$var$poke() {
    var now = $e782289d8bd71451$var$clock.now(), delay = now - $e782289d8bd71451$var$clockLast;
    if (delay > $e782289d8bd71451$var$pokeDelay) $e782289d8bd71451$var$clockSkew -= delay, $e782289d8bd71451$var$clockLast = now;
}
function $e782289d8bd71451$var$nap() {
    var t0, t1 = $e782289d8bd71451$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $e782289d8bd71451$var$taskHead = t2;
    }
    $e782289d8bd71451$var$taskTail = t0;
    $e782289d8bd71451$var$sleep(time);
}
function $e782289d8bd71451$var$sleep(time) {
    if ($e782289d8bd71451$var$frame) return; // Soonest alarm already set, or will be.
    if ($e782289d8bd71451$var$timeout) $e782289d8bd71451$var$timeout = clearTimeout($e782289d8bd71451$var$timeout);
    var delay = time - $e782289d8bd71451$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $e782289d8bd71451$var$timeout = setTimeout($e782289d8bd71451$var$wake, time - $e782289d8bd71451$var$clock.now() - $e782289d8bd71451$var$clockSkew);
        if ($e782289d8bd71451$var$interval) $e782289d8bd71451$var$interval = clearInterval($e782289d8bd71451$var$interval);
    } else {
        if (!$e782289d8bd71451$var$interval) $e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now(), $e782289d8bd71451$var$interval = setInterval($e782289d8bd71451$var$poke, $e782289d8bd71451$var$pokeDelay);
        $e782289d8bd71451$var$frame = 1, $e782289d8bd71451$var$setFrame($e782289d8bd71451$var$wake);
    }
}

});





parcelRegister("fBcKd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5b43281074f9351$export$2e2bcd8739ae039);

var $e9pyf = parcelRequire("e9pyf");

var $1O1wu = parcelRequire("1O1wu");

var $7OMS0 = parcelRequire("7OMS0");

var $jSjsP = parcelRequire("jSjsP");
var $b5b43281074f9351$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $7OMS0.cubicInOut)
};
function $b5b43281074f9351$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $b5b43281074f9351$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $e9pyf.Transition)) id = name._id, name = name._name;
    else id = (0, $e9pyf.newId)(), (timing = $b5b43281074f9351$var$defaultTiming).time = (0, $jSjsP.now)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $1O1wu.default)(node, name, id, i, group, timing || $b5b43281074f9351$var$inherit(node, id));
    }
    return new (0, $e9pyf.Transition)(groups, this._parents, name, id);
}

});
parcelRegister("e9pyf", function(module, exports) {

$parcel$export(module.exports, "Transition", () => $a4d5b9ef4f9cfabb$export$be58926105124dd4);
$parcel$export(module.exports, "newId", () => $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b);

var $3us5W = parcelRequire("3us5W");

var $3DFnF = parcelRequire("3DFnF");

var $hpADm = parcelRequire("hpADm");

var $QaWfs = parcelRequire("QaWfs");

var $drGTC = parcelRequire("drGTC");

var $cflrC = parcelRequire("cflrC");

var $dudkO = parcelRequire("dudkO");

var $gE3NB = parcelRequire("gE3NB");

var $jUpER = parcelRequire("jUpER");

var $lKQ2g = parcelRequire("lKQ2g");

var $fAKgz = parcelRequire("fAKgz");

var $dp6Bd = parcelRequire("dp6Bd");

var $asVWM = parcelRequire("asVWM");

var $1H5R6 = parcelRequire("1H5R6");

var $hV9BK = parcelRequire("hV9BK");

var $bhsa4 = parcelRequire("bhsa4");

var $jLbDc = parcelRequire("jLbDc");

var $8EN5J = parcelRequire("8EN5J");

var $jZTje = parcelRequire("jZTje");

var $cy9mc = parcelRequire("cy9mc");

var $73a8S = parcelRequire("73a8S");
var $a4d5b9ef4f9cfabb$var$id = 0;
function $a4d5b9ef4f9cfabb$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $a4d5b9ef4f9cfabb$export$2e2bcd8739ae039(name) {
    return (0, $3us5W.default)().transition(name);
}
function $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b() {
    return ++$a4d5b9ef4f9cfabb$var$id;
}
var $a4d5b9ef4f9cfabb$var$selection_prototype = (0, $3us5W.default).prototype;
$a4d5b9ef4f9cfabb$export$be58926105124dd4.prototype = $a4d5b9ef4f9cfabb$export$2e2bcd8739ae039.prototype = {
    constructor: $a4d5b9ef4f9cfabb$export$be58926105124dd4,
    select: (0, $dp6Bd.default),
    selectAll: (0, $asVWM.default),
    selectChild: $a4d5b9ef4f9cfabb$var$selection_prototype.selectChild,
    selectChildren: $a4d5b9ef4f9cfabb$var$selection_prototype.selectChildren,
    filter: (0, $gE3NB.default),
    merge: (0, $jUpER.default),
    selection: (0, $1H5R6.default),
    transition: (0, $jZTje.default),
    call: $a4d5b9ef4f9cfabb$var$selection_prototype.call,
    nodes: $a4d5b9ef4f9cfabb$var$selection_prototype.nodes,
    node: $a4d5b9ef4f9cfabb$var$selection_prototype.node,
    size: $a4d5b9ef4f9cfabb$var$selection_prototype.size,
    empty: $a4d5b9ef4f9cfabb$var$selection_prototype.empty,
    each: $a4d5b9ef4f9cfabb$var$selection_prototype.each,
    on: (0, $lKQ2g.default),
    attr: (0, $3DFnF.default),
    attrTween: (0, $hpADm.default),
    style: (0, $hV9BK.default),
    styleTween: (0, $bhsa4.default),
    text: (0, $jLbDc.default),
    textTween: (0, $8EN5J.default),
    remove: (0, $fAKgz.default),
    tween: (0, $cy9mc.default),
    delay: (0, $QaWfs.default),
    duration: (0, $drGTC.default),
    ease: (0, $cflrC.default),
    easeVarying: (0, $dudkO.default),
    end: (0, $73a8S.default),
    [Symbol.iterator]: $a4d5b9ef4f9cfabb$var$selection_prototype[Symbol.iterator]
};

});
parcelRegister("3DFnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a651cfc4e49b53d$export$2e2bcd8739ae039);

var $jDZQw = parcelRequire("jDZQw");

var $fEEcv = parcelRequire("fEEcv");

var $cy9mc = parcelRequire("cy9mc");

var $bSVkw = parcelRequire("bSVkw");
function $2a651cfc4e49b53d$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $2a651cfc4e49b53d$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $2a651cfc4e49b53d$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $2a651cfc4e49b53d$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $2a651cfc4e49b53d$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $2a651cfc4e49b53d$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $2a651cfc4e49b53d$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $fEEcv.default)(name), i = fullname === "transform" ? (0, $jDZQw.interpolateTransformSvg) : (0, $bSVkw.default);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $2a651cfc4e49b53d$var$attrFunctionNS : $2a651cfc4e49b53d$var$attrFunction)(fullname, i, (0, $cy9mc.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? $2a651cfc4e49b53d$var$attrRemoveNS : $2a651cfc4e49b53d$var$attrRemove)(fullname) : (fullname.local ? $2a651cfc4e49b53d$var$attrConstantNS : $2a651cfc4e49b53d$var$attrConstant)(fullname, i, value));
}

});
parcelRegister("jDZQw", function(module, exports) {

$parcel$export(module.exports, "interpolateTransformCss", () => $e4d1a233c7242264$export$56bec7123bb3589a);
$parcel$export(module.exports, "interpolateTransformSvg", () => $e4d1a233c7242264$export$da8cba906d64c082);

var $gnkFs = parcelRequire("gnkFs");

var $6lTYu = parcelRequire("6lTYu");
function $e4d1a233c7242264$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $gnkFs.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $gnkFs.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $gnkFs.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $gnkFs.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $gnkFs.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $gnkFs.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $e4d1a233c7242264$export$56bec7123bb3589a = $e4d1a233c7242264$var$interpolateTransform((0, $6lTYu.parseCss), "px, ", "px)", "deg)");
var $e4d1a233c7242264$export$da8cba906d64c082 = $e4d1a233c7242264$var$interpolateTransform((0, $6lTYu.parseSvg), ", ", ")", ")");

});
parcelRegister("6lTYu", function(module, exports) {

$parcel$export(module.exports, "parseCss", () => $4a001faa54972590$export$59ad369bf4938177);
$parcel$export(module.exports, "parseSvg", () => $4a001faa54972590$export$f9ef43f9a1d89a18);

var $3xqrJ = parcelRequire("3xqrJ");
var $4a001faa54972590$var$svgNode;
function $4a001faa54972590$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $3xqrJ.identity) : (0, $3xqrJ.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $4a001faa54972590$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $3xqrJ.identity;
    if (!$4a001faa54972590$var$svgNode) $4a001faa54972590$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $4a001faa54972590$var$svgNode.setAttribute("transform", value);
    if (!(value = $4a001faa54972590$var$svgNode.transform.baseVal.consolidate())) return 0, $3xqrJ.identity;
    value = value.matrix;
    return (0, $3xqrJ.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("3xqrJ", function(module, exports) {

$parcel$export(module.exports, "identity", () => $2938f7d64470581a$export$f0954fd7d5368655);
$parcel$export(module.exports, "default", () => $2938f7d64470581a$export$2e2bcd8739ae039);
var $2938f7d64470581a$var$degrees = 180 / Math.PI;
var $2938f7d64470581a$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $2938f7d64470581a$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $2938f7d64470581a$var$degrees,
        skewX: Math.atan(skewX) * $2938f7d64470581a$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("cy9mc", function(module, exports) {

$parcel$export(module.exports, "default", () => $922feb1dfe9c8dcf$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tweenValue", () => $922feb1dfe9c8dcf$export$f78ce6ab10405d82);

var $1O1wu = parcelRequire("1O1wu");
function $922feb1dfe9c8dcf$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $1O1wu.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $922feb1dfe9c8dcf$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $1O1wu.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $922feb1dfe9c8dcf$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $1O1wu.get)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $922feb1dfe9c8dcf$var$tweenRemove : $922feb1dfe9c8dcf$var$tweenFunction)(id, name, value));
}
function $922feb1dfe9c8dcf$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $1O1wu.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $1O1wu.get)(node, id).value[name];
    };
}

});

parcelRegister("bSVkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a713565676b726d$export$2e2bcd8739ae039);

var $bYoiY = parcelRequire("bYoiY");

var $gnkFs = parcelRequire("gnkFs");
var $jUrtA = parcelRequire("jUrtA");
var $aPLyh = parcelRequire("aPLyh");
function $8a713565676b726d$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $gnkFs.default) : b instanceof (0, $bYoiY.default) ? (0, $jUrtA.default) : (c = (0, $bYoiY.default)(b)) ? (b = c, $jUrtA.default) : (0, $aPLyh.default))(a, b);
}

});


parcelRegister("hpADm", function(module, exports) {

$parcel$export(module.exports, "default", () => $cad13035adb29669$export$2e2bcd8739ae039);

var $fEEcv = parcelRequire("fEEcv");
function $cad13035adb29669$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $cad13035adb29669$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $cad13035adb29669$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $cad13035adb29669$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $cad13035adb29669$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $cad13035adb29669$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $cad13035adb29669$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $fEEcv.default)(name);
    return this.tween(key, (fullname.local ? $cad13035adb29669$var$attrTweenNS : $cad13035adb29669$var$attrTween)(fullname, value));
}

});

parcelRegister("QaWfs", function(module, exports) {

$parcel$export(module.exports, "default", () => $09cd57996bd81614$export$2e2bcd8739ae039);

var $1O1wu = parcelRequire("1O1wu");
function $09cd57996bd81614$var$delayFunction(id, value) {
    return function() {
        (0, $1O1wu.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function $09cd57996bd81614$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $1O1wu.init)(this, id).delay = value;
    };
}
function $09cd57996bd81614$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $09cd57996bd81614$var$delayFunction : $09cd57996bd81614$var$delayConstant)(id, value)) : (0, $1O1wu.get)(this.node(), id).delay;
}

});

parcelRegister("drGTC", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c9f124117d5bf14$export$2e2bcd8739ae039);

var $1O1wu = parcelRequire("1O1wu");
function $9c9f124117d5bf14$var$durationFunction(id, value) {
    return function() {
        (0, $1O1wu.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function $9c9f124117d5bf14$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $1O1wu.set)(this, id).duration = value;
    };
}
function $9c9f124117d5bf14$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $9c9f124117d5bf14$var$durationFunction : $9c9f124117d5bf14$var$durationConstant)(id, value)) : (0, $1O1wu.get)(this.node(), id).duration;
}

});

parcelRegister("cflrC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ea7852b6976e6d1$export$2e2bcd8739ae039);

var $1O1wu = parcelRequire("1O1wu");
function $8ea7852b6976e6d1$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $1O1wu.set)(this, id).ease = value;
    };
}
function $8ea7852b6976e6d1$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($8ea7852b6976e6d1$var$easeConstant(id, value)) : (0, $1O1wu.get)(this.node(), id).ease;
}

});

parcelRegister("dudkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d186bb80d60f6c9$export$2e2bcd8739ae039);

var $1O1wu = parcelRequire("1O1wu");
function $9d186bb80d60f6c9$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $1O1wu.set)(this, id).ease = v;
    };
}
function $9d186bb80d60f6c9$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($9d186bb80d60f6c9$var$easeVarying(this._id, value));
}

});

parcelRegister("gE3NB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1e3543439d9f5fd$export$2e2bcd8739ae039);

var $8doa3 = parcelRequire("8doa3");

var $e9pyf = parcelRequire("e9pyf");
function $c1e3543439d9f5fd$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $8doa3.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $e9pyf.Transition)(subgroups, this._parents, this._name, this._id);
}

});

parcelRegister("jUpER", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7e726720f484153$export$2e2bcd8739ae039);

var $e9pyf = parcelRequire("e9pyf");
function $e7e726720f484153$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $e9pyf.Transition)(merges, this._parents, this._name, this._id);
}

});

parcelRegister("lKQ2g", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd664209e896113c$export$2e2bcd8739ae039);

var $1O1wu = parcelRequire("1O1wu");
function $fd664209e896113c$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $fd664209e896113c$var$onFunction(id, name, listener) {
    var on0, on1, sit = $fd664209e896113c$var$start(name) ? (0, $1O1wu.init) : (0, $1O1wu.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $fd664209e896113c$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $1O1wu.get)(this.node(), id).on.on(name) : this.each($fd664209e896113c$var$onFunction(id, name, listener));
}

});

parcelRegister("fAKgz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b59e1b517983ad92$export$2e2bcd8739ae039);
function $b59e1b517983ad92$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $b59e1b517983ad92$export$2e2bcd8739ae039() {
    return this.on("end.remove", $b59e1b517983ad92$var$removeFunction(this._id));
}

});

parcelRegister("dp6Bd", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c22ba9ec568d18f$export$2e2bcd8739ae039);

var $9rOh8 = parcelRequire("9rOh8");

var $e9pyf = parcelRequire("e9pyf");

var $1O1wu = parcelRequire("1O1wu");
function $9c22ba9ec568d18f$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $9rOh8.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $1O1wu.default)(subgroup[i], name, id, i, subgroup, (0, $1O1wu.get)(node, id));
        }
    }
    return new (0, $e9pyf.Transition)(subgroups, this._parents, name, id);
}

});

parcelRegister("asVWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $79e977f9a26c99f1$export$2e2bcd8739ae039);

var $aMqra = parcelRequire("aMqra");

var $e9pyf = parcelRequire("e9pyf");

var $1O1wu = parcelRequire("1O1wu");
function $79e977f9a26c99f1$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $aMqra.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $1O1wu.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $1O1wu.default)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $e9pyf.Transition)(subgroups, parents, name, id);
}

});

parcelRegister("1H5R6", function(module, exports) {

$parcel$export(module.exports, "default", () => $13be595fcf5febb7$export$2e2bcd8739ae039);

var $3us5W = parcelRequire("3us5W");
var $13be595fcf5febb7$var$Selection = (0, $3us5W.default).prototype.constructor;
function $13be595fcf5febb7$export$2e2bcd8739ae039() {
    return new $13be595fcf5febb7$var$Selection(this._groups, this._parents);
}

});

parcelRegister("hV9BK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0bf366fdef4c332$export$2e2bcd8739ae039);

var $jDZQw = parcelRequire("jDZQw");

var $9a8q4 = parcelRequire("9a8q4");

var $1O1wu = parcelRequire("1O1wu");

var $cy9mc = parcelRequire("cy9mc");

var $bSVkw = parcelRequire("bSVkw");
function $d0bf366fdef4c332$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $9a8q4.styleValue)(this, name), string1 = (this.style.removeProperty(name), (0, $9a8q4.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $d0bf366fdef4c332$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $d0bf366fdef4c332$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $9a8q4.styleValue)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $d0bf366fdef4c332$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $9a8q4.styleValue)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $9a8q4.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $d0bf366fdef4c332$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $1O1wu.set)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $d0bf366fdef4c332$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $d0bf366fdef4c332$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $jDZQw.interpolateTransformCss) : (0, $bSVkw.default);
    return value == null ? this.styleTween(name, $d0bf366fdef4c332$var$styleNull(name, i)).on("end.style." + name, $d0bf366fdef4c332$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $d0bf366fdef4c332$var$styleFunction(name, i, (0, $cy9mc.tweenValue)(this, "style." + name, value))).each($d0bf366fdef4c332$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $d0bf366fdef4c332$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}

});

parcelRegister("bhsa4", function(module, exports) {

$parcel$export(module.exports, "default", () => $83672080502c9717$export$2e2bcd8739ae039);
function $83672080502c9717$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $83672080502c9717$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $83672080502c9717$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $83672080502c9717$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $83672080502c9717$var$styleTween(name, value, priority == null ? "" : priority));
}

});

parcelRegister("jLbDc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e62b6dd5e7df40e7$export$2e2bcd8739ae039);

var $cy9mc = parcelRequire("cy9mc");
function $e62b6dd5e7df40e7$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $e62b6dd5e7df40e7$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $e62b6dd5e7df40e7$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $e62b6dd5e7df40e7$var$textFunction((0, $cy9mc.tweenValue)(this, "text", value)) : $e62b6dd5e7df40e7$var$textConstant(value == null ? "" : value + ""));
}

});

parcelRegister("8EN5J", function(module, exports) {

$parcel$export(module.exports, "default", () => $64d823b28aa7019a$export$2e2bcd8739ae039);
function $64d823b28aa7019a$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $64d823b28aa7019a$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $64d823b28aa7019a$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $64d823b28aa7019a$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $64d823b28aa7019a$var$textTween(value));
}

});

parcelRegister("jZTje", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8ee9e113d6ecbba$export$2e2bcd8739ae039);

var $e9pyf = parcelRequire("e9pyf");

var $1O1wu = parcelRequire("1O1wu");
function $e8ee9e113d6ecbba$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $e9pyf.newId)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $1O1wu.get)(node, id0);
            (0, $1O1wu.default)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $e9pyf.Transition)(groups, this._parents, name, id1);
}

});

parcelRegister("73a8S", function(module, exports) {

$parcel$export(module.exports, "default", () => $5220ae42feb560ba$export$2e2bcd8739ae039);

var $1O1wu = parcelRequire("1O1wu");
function $5220ae42feb560ba$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $1O1wu.set)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}

});


parcelRegister("7OMS0", function(module, exports) {

$parcel$export(module.exports, "cubicInOut", () => $5b131c7b61a09e82$export$89238d3bc79d3ada);
function $5b131c7b61a09e82$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $5b131c7b61a09e82$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $5b131c7b61a09e82$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

});




parcelRegister("6QApF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fc3d848825eb4c8$export$2e2bcd8739ae039);
var $4fc3d848825eb4c8$export$2e2bcd8739ae039 = (x)=>()=>x;

});

parcelRegister("j3W5K", function(module, exports) {

$parcel$export(module.exports, "default", () => $de0b5bec424cf247$export$2e2bcd8739ae039);
function $de0b5bec424cf247$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

});

parcelRegister("6fYbl", function(module, exports) {

$parcel$export(module.exports, "nopropagation", () => $48e2d3ac3b9a75ee$export$2e2561858db9bf47);
$parcel$export(module.exports, "default", () => $48e2d3ac3b9a75ee$export$2e2bcd8739ae039);
function $48e2d3ac3b9a75ee$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $48e2d3ac3b9a75ee$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

});



parcelRegister("lAcF9", function(module, exports) {

$parcel$export(module.exports, "svg", () => $fb66c851eb4dc391$export$7ed1367e7fa1ad68);

var $iKoDh = parcelRequire("iKoDh");
function $fb66c851eb4dc391$var$parser(type) {
    return (input, init)=>(0, $iKoDh.default)(input, init).then((text)=>(new DOMParser).parseFromString(text, type));
}
var $fb66c851eb4dc391$export$2e2bcd8739ae039 = $fb66c851eb4dc391$var$parser("application/xml");
var $fb66c851eb4dc391$export$c0bb0b647f701bb5 = $fb66c851eb4dc391$var$parser("text/html");
var $fb66c851eb4dc391$export$7ed1367e7fa1ad68 = $fb66c851eb4dc391$var$parser("image/svg+xml");

});
parcelRegister("iKoDh", function(module, exports) {

$parcel$export(module.exports, "default", () => $da5fa16673f32559$export$2e2bcd8739ae039);
function $da5fa16673f32559$var$responseText(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.text();
}
function $da5fa16673f32559$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($da5fa16673f32559$var$responseText);
}

});


parcelRegister("bvJ3W", function(module, exports) {

$parcel$export(module.exports, "default", () => $86158b7019ca6112$export$2e2bcd8739ae039);

var $b48rH = parcelRequire("b48rH");

var $75Lq4 = parcelRequire("75Lq4");
function $86158b7019ca6112$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $b48rH.hcl)(start)).h, (end = (0, $b48rH.hcl)(end)).h), c = (0, $75Lq4.default)(start.c, end.c), l = (0, $75Lq4.default)(start.l, end.l), opacity = (0, $75Lq4.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $86158b7019ca6112$export$2e2bcd8739ae039 = $86158b7019ca6112$var$hcl((0, $75Lq4.hue));
var $86158b7019ca6112$export$5aaa50f7615f9b70 = $86158b7019ca6112$var$hcl((0, $75Lq4.default));

});
parcelRegister("b48rH", function(module, exports) {

$parcel$export(module.exports, "hcl", () => $80e69e9a1ed94a67$export$d0e870ba50062ff1);

var $bfWFq = parcelRequire("bfWFq");

var $bYoiY = parcelRequire("bYoiY");

var $9DZrZ = parcelRequire("9DZrZ");
// https://observablehq.com/@mbostock/lab-and-rgb
const $80e69e9a1ed94a67$var$K = 18, $80e69e9a1ed94a67$var$Xn = 0.96422, $80e69e9a1ed94a67$var$Yn = 1, $80e69e9a1ed94a67$var$Zn = 0.82521, $80e69e9a1ed94a67$var$t0 = 4 / 29, $80e69e9a1ed94a67$var$t1 = 6 / 29, $80e69e9a1ed94a67$var$t2 = 3 * $80e69e9a1ed94a67$var$t1 * $80e69e9a1ed94a67$var$t1, $80e69e9a1ed94a67$var$t3 = $80e69e9a1ed94a67$var$t1 * $80e69e9a1ed94a67$var$t1 * $80e69e9a1ed94a67$var$t1;
function $80e69e9a1ed94a67$var$labConvert(o) {
    if (o instanceof $80e69e9a1ed94a67$export$f2722c70a60257f7) return new $80e69e9a1ed94a67$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
    if (o instanceof $80e69e9a1ed94a67$export$d9397e094a5fbb9a) return $80e69e9a1ed94a67$var$hcl2lab(o);
    if (!(o instanceof (0, $bYoiY.Rgb))) o = (0, $bYoiY.rgbConvert)(o);
    var r = $80e69e9a1ed94a67$var$rgb2lrgb(o.r), g = $80e69e9a1ed94a67$var$rgb2lrgb(o.g), b = $80e69e9a1ed94a67$var$rgb2lrgb(o.b), y = $80e69e9a1ed94a67$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $80e69e9a1ed94a67$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $80e69e9a1ed94a67$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $80e69e9a1ed94a67$var$Xn);
        z = $80e69e9a1ed94a67$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $80e69e9a1ed94a67$var$Zn);
    }
    return new $80e69e9a1ed94a67$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $80e69e9a1ed94a67$export$3e2c219d3ab79d01(l, opacity) {
    return new $80e69e9a1ed94a67$export$f2722c70a60257f7(l, 0, 0, opacity == null ? 1 : opacity);
}
function $80e69e9a1ed94a67$export$2e2bcd8739ae039(l, a, b, opacity) {
    return arguments.length === 1 ? $80e69e9a1ed94a67$var$labConvert(l) : new $80e69e9a1ed94a67$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
}
function $80e69e9a1ed94a67$export$f2722c70a60257f7(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bfWFq.default)($80e69e9a1ed94a67$export$f2722c70a60257f7, $80e69e9a1ed94a67$export$2e2bcd8739ae039, (0, $bfWFq.extend)((0, $bYoiY.Color), {
    brighter (k) {
        return new $80e69e9a1ed94a67$export$f2722c70a60257f7(this.l + $80e69e9a1ed94a67$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $80e69e9a1ed94a67$export$f2722c70a60257f7(this.l - $80e69e9a1ed94a67$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $80e69e9a1ed94a67$var$Xn * $80e69e9a1ed94a67$var$lab2xyz(x);
        y = $80e69e9a1ed94a67$var$Yn * $80e69e9a1ed94a67$var$lab2xyz(y);
        z = $80e69e9a1ed94a67$var$Zn * $80e69e9a1ed94a67$var$lab2xyz(z);
        return new (0, $bYoiY.Rgb)($80e69e9a1ed94a67$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $80e69e9a1ed94a67$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $80e69e9a1ed94a67$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $80e69e9a1ed94a67$var$xyz2lab(t) {
    return t > $80e69e9a1ed94a67$var$t3 ? Math.pow(t, 1 / 3) : t / $80e69e9a1ed94a67$var$t2 + $80e69e9a1ed94a67$var$t0;
}
function $80e69e9a1ed94a67$var$lab2xyz(t) {
    return t > $80e69e9a1ed94a67$var$t1 ? t * t * t : $80e69e9a1ed94a67$var$t2 * (t - $80e69e9a1ed94a67$var$t0);
}
function $80e69e9a1ed94a67$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $80e69e9a1ed94a67$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $80e69e9a1ed94a67$var$hclConvert(o) {
    if (o instanceof $80e69e9a1ed94a67$export$d9397e094a5fbb9a) return new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $80e69e9a1ed94a67$export$f2722c70a60257f7)) o = $80e69e9a1ed94a67$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, $9DZrZ.degrees);
    return new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $80e69e9a1ed94a67$export$5a21418738164530(l, c, h, opacity) {
    return arguments.length === 1 ? $80e69e9a1ed94a67$var$hclConvert(l) : new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $80e69e9a1ed94a67$export$d0e870ba50062ff1(h, c, l, opacity) {
    return arguments.length === 1 ? $80e69e9a1ed94a67$var$hclConvert(h) : new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $80e69e9a1ed94a67$export$d9397e094a5fbb9a(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $80e69e9a1ed94a67$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $80e69e9a1ed94a67$export$f2722c70a60257f7(o.l, 0, 0, o.opacity);
    var h = o.h * (0, $9DZrZ.radians);
    return new $80e69e9a1ed94a67$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $bfWFq.default)($80e69e9a1ed94a67$export$d9397e094a5fbb9a, $80e69e9a1ed94a67$export$d0e870ba50062ff1, (0, $bfWFq.extend)((0, $bYoiY.Color), {
    brighter (k) {
        return new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(this.h, this.c, this.l + $80e69e9a1ed94a67$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(this.h, this.c, this.l - $80e69e9a1ed94a67$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $80e69e9a1ed94a67$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("9DZrZ", function(module, exports) {

$parcel$export(module.exports, "radians", () => $70576c5c5ae147f6$export$8449e153fbd325fc);
$parcel$export(module.exports, "degrees", () => $70576c5c5ae147f6$export$41fc368e1a942b97);
const $70576c5c5ae147f6$export$8449e153fbd325fc = Math.PI / 180;
const $70576c5c5ae147f6$export$41fc368e1a942b97 = 180 / Math.PI;

});



parcelRegister("gEnYl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1f2fa2a7653ca3a$export$2e2bcd8739ae039);

var $8oHIF = parcelRequire("8oHIF");

var $7QzZn = parcelRequire("7QzZn");

var $4PqgM = parcelRequire("4PqgM");
function $c1f2fa2a7653ca3a$export$2e2bcd8739ae039() {
    var scale = (0, $4PqgM.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $8oHIF.default)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $c1f2fa2a7653ca3a$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $7QzZn.initRange).apply(rescale(), arguments);
}
function $c1f2fa2a7653ca3a$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $c1f2fa2a7653ca3a$var$pointish(copy());
    };
    return scale;
}
function $c1f2fa2a7653ca3a$export$105684a3041cb6f3() {
    return $c1f2fa2a7653ca3a$var$pointish($c1f2fa2a7653ca3a$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("8oHIF", function(module, exports) {

$parcel$export(module.exports, "default", () => $61d27a61db04c1a6$export$2e2bcd8739ae039);
function $61d27a61db04c1a6$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("7QzZn", function(module, exports) {

$parcel$export(module.exports, "initRange", () => $5b694e64f5326630$export$23c7bb9e6558da2a);
function $5b694e64f5326630$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $5b694e64f5326630$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("4PqgM", function(module, exports) {

$parcel$export(module.exports, "default", () => $38404d762c7ac827$export$2e2bcd8739ae039);

var $4ePtk = parcelRequire("4ePtk");

var $7QzZn = parcelRequire("7QzZn");
const $38404d762c7ac827$export$e4f898ab14d9d460 = Symbol("implicit");
function $38404d762c7ac827$export$2e2bcd8739ae039() {
    var index = new (0, $4ePtk.InternMap)(), domain = [], range = [], unknown = $38404d762c7ac827$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $38404d762c7ac827$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $4ePtk.InternMap)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $38404d762c7ac827$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $7QzZn.initRange).apply(scale, arguments);
    return scale;
}

});
parcelRegister("4ePtk", function(module, exports) {

$parcel$export(module.exports, "InternMap", () => $3160658555deb5c9$export$dcc6fb7d82b5bc7b);
class $3160658555deb5c9$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries, key = $3160658555deb5c9$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($3160658555deb5c9$var$intern_get(this, key));
    }
    has(key) {
        return super.has($3160658555deb5c9$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($3160658555deb5c9$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($3160658555deb5c9$var$intern_delete(this, key));
    }
}
class $3160658555deb5c9$export$55278c3294239828 extends Set {
    constructor(values, key = $3160658555deb5c9$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($3160658555deb5c9$var$intern_get(this, value));
    }
    add(value) {
        return super.add($3160658555deb5c9$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($3160658555deb5c9$var$intern_delete(this, value));
    }
}
function $3160658555deb5c9$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $3160658555deb5c9$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $3160658555deb5c9$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $3160658555deb5c9$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});



parcelRegister("iOlPi", function(module, exports) {

$parcel$export(module.exports, "default", () => $db1dd3c66a0cbf94$export$2e2bcd8739ae039);

var $aE6k7 = parcelRequire("aE6k7");

var $f6dVf = parcelRequire("f6dVf");

var $7QzZn = parcelRequire("7QzZn");

var $fabdk = parcelRequire("fabdk");
function $db1dd3c66a0cbf94$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $aE6k7.default)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $fabdk.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $aE6k7.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $db1dd3c66a0cbf94$export$2e2bcd8739ae039() {
    var scale = (0, $f6dVf.default)();
    scale.copy = function() {
        return (0, $f6dVf.copy)(scale, $db1dd3c66a0cbf94$export$2e2bcd8739ae039());
    };
    (0, $7QzZn.initRange).apply(scale, arguments);
    return $db1dd3c66a0cbf94$export$16a5d4b4a61a274d(scale);
}

});
parcelRegister("aE6k7", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c028b8201e48c5a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tickIncrement", () => $7c028b8201e48c5a$export$bc64d00cc98e7e95);
$parcel$export(module.exports, "tickStep", () => $7c028b8201e48c5a$export$81087d9b915d4ede);
const $7c028b8201e48c5a$var$e10 = Math.sqrt(50), $7c028b8201e48c5a$var$e5 = Math.sqrt(10), $7c028b8201e48c5a$var$e2 = Math.sqrt(2);
function $7c028b8201e48c5a$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $7c028b8201e48c5a$var$e10 ? 10 : error >= $7c028b8201e48c5a$var$e5 ? 5 : error >= $7c028b8201e48c5a$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $7c028b8201e48c5a$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $7c028b8201e48c5a$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $7c028b8201e48c5a$var$tickSpec(stop, start, count) : $7c028b8201e48c5a$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $7c028b8201e48c5a$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $7c028b8201e48c5a$var$tickSpec(start, stop, count)[2];
}
function $7c028b8201e48c5a$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $7c028b8201e48c5a$export$bc64d00cc98e7e95(stop, start, count) : $7c028b8201e48c5a$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}

});

parcelRegister("f6dVf", function(module, exports) {

$parcel$export(module.exports, "copy", () => $afe237385175446a$export$784d13d8ee351f07);
$parcel$export(module.exports, "default", () => $afe237385175446a$export$2e2bcd8739ae039);

var $ekiL6 = parcelRequire("ekiL6");

var $bi4KR = parcelRequire("bi4KR");
var $gnkFs = parcelRequire("gnkFs");
var $gzbhl = parcelRequire("gzbhl");

var $ePWrs = parcelRequire("ePWrs");

var $9krIo = parcelRequire("9krIo");
var $afe237385175446a$var$unit = [
    0,
    1
];
function $afe237385175446a$export$f0954fd7d5368655(x) {
    return x;
}
function $afe237385175446a$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $ePWrs.default)(isNaN(b) ? NaN : 0.5);
}
function $afe237385175446a$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $afe237385175446a$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $afe237385175446a$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $afe237385175446a$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $afe237385175446a$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $afe237385175446a$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $ekiL6.default)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $afe237385175446a$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $afe237385175446a$export$6b468dcfb64c653c() {
    var domain = $afe237385175446a$var$unit, range = $afe237385175446a$var$unit, interpolate = (0, $bi4KR.default), transform, untransform, unknown, clamp = $afe237385175446a$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $afe237385175446a$export$f0954fd7d5368655) clamp = $afe237385175446a$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $afe237385175446a$var$polymap : $afe237385175446a$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $gnkFs.default))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $9krIo.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $gzbhl.default), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $afe237385175446a$export$f0954fd7d5368655, rescale()) : clamp !== $afe237385175446a$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $afe237385175446a$export$2e2bcd8739ae039() {
    return $afe237385175446a$export$6b468dcfb64c653c()($afe237385175446a$export$f0954fd7d5368655, $afe237385175446a$export$f0954fd7d5368655);
}

});
parcelRegister("ekiL6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6e17c0ec55d7735$export$2e2bcd8739ae039);

var $8zdji = parcelRequire("8zdji");

var $W4CTv = parcelRequire("W4CTv");

var $7EiNs = parcelRequire("7EiNs");
const $a6e17c0ec55d7735$var$ascendingBisect = (0, $W4CTv.default)((0, $8zdji.default));
const $a6e17c0ec55d7735$export$4d945ad3ad5751b0 = $a6e17c0ec55d7735$var$ascendingBisect.right;
const $a6e17c0ec55d7735$export$df7d25c84ebd12a5 = $a6e17c0ec55d7735$var$ascendingBisect.left;
const $a6e17c0ec55d7735$export$c1cb828b1117c77b = (0, $W4CTv.default)((0, $7EiNs.default)).center;
var $a6e17c0ec55d7735$export$2e2bcd8739ae039 = $a6e17c0ec55d7735$export$4d945ad3ad5751b0;

});
parcelRegister("8zdji", function(module, exports) {

$parcel$export(module.exports, "default", () => $63cbeabc75241824$export$2e2bcd8739ae039);
function $63cbeabc75241824$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("W4CTv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ae9019609d046a1$export$2e2bcd8739ae039);

var $8zdji = parcelRequire("8zdji");

var $5303J = parcelRequire("5303J");
function $0ae9019609d046a1$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $8zdji.default);
        compare2 = (d, x)=>(0, $8zdji.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $8zdji.default) || f === (0, $5303J.default) ? f : $0ae9019609d046a1$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $0ae9019609d046a1$var$zero() {
    return 0;
}

});
parcelRegister("5303J", function(module, exports) {

$parcel$export(module.exports, "default", () => $3acd474ceacf8a38$export$2e2bcd8739ae039);
function $3acd474ceacf8a38$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("7EiNs", function(module, exports) {

$parcel$export(module.exports, "default", () => $591ad978f2ce6133$export$2e2bcd8739ae039);
function $591ad978f2ce6133$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $591ad978f2ce6133$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("gzbhl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0f8a9efb1caa699$export$2e2bcd8739ae039);
function $c0f8a9efb1caa699$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("ePWrs", function(module, exports) {

$parcel$export(module.exports, "default", () => $acd329741cbdf381$export$2e2bcd8739ae039);
function $acd329741cbdf381$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("9krIo", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cab7aea8ef8b40b$export$2e2bcd8739ae039);
function $6cab7aea8ef8b40b$export$2e2bcd8739ae039(x) {
    return +x;
}

});


parcelRegister("fabdk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0a07d06c8b316c1$export$2e2bcd8739ae039);

var $aE6k7 = parcelRequire("aE6k7");

var $7gBNf = parcelRequire("7gBNf");
var $ikvwP = parcelRequire("ikvwP");
var $l1vM3 = parcelRequire("l1vM3");
var $1TXup = parcelRequire("1TXup");
var $i4t6x = parcelRequire("i4t6x");
function $b0a07d06c8b316c1$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $aE6k7.tickStep)(start, stop, count), precision;
    specifier = (0, $ikvwP.default)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $1TXup.default)(step, value))) specifier.precision = precision;
            return (0, $7gBNf.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $i4t6x.default)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $l1vM3.default)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $7gBNf.format)(specifier);
}

});
parcelRegister("7gBNf", function(module, exports) {

$parcel$export(module.exports, "format", () => $54a757fa53542946$export$d9468344d3651243);
$parcel$export(module.exports, "formatPrefix", () => $54a757fa53542946$export$8d85692a469dde6f);

var $jYBVj = parcelRequire("jYBVj");
var $54a757fa53542946$var$locale;
var $54a757fa53542946$export$d9468344d3651243;
var $54a757fa53542946$export$8d85692a469dde6f;
$54a757fa53542946$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $54a757fa53542946$export$2e2bcd8739ae039(definition) {
    $54a757fa53542946$var$locale = (0, $jYBVj.default)(definition);
    $54a757fa53542946$export$d9468344d3651243 = $54a757fa53542946$var$locale.format;
    $54a757fa53542946$export$8d85692a469dde6f = $54a757fa53542946$var$locale.formatPrefix;
    return $54a757fa53542946$var$locale;
}

});
parcelRegister("jYBVj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8b109bb95cf9845$export$2e2bcd8739ae039);

var $1QDsO = parcelRequire("1QDsO");

var $l0OJc = parcelRequire("l0OJc");

var $cRZ1i = parcelRequire("cRZ1i");

var $ikvwP = parcelRequire("ikvwP");

var $j0yhO = parcelRequire("j0yhO");

var $kGAxb = parcelRequire("kGAxb");

var $lPyuV = parcelRequire("lPyuV");

var $2nOSB = parcelRequire("2nOSB");
var $e8b109bb95cf9845$var$map = Array.prototype.map, $e8b109bb95cf9845$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $e8b109bb95cf9845$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $2nOSB.default) : (0, $l0OJc.default)($e8b109bb95cf9845$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $2nOSB.default) : (0, $cRZ1i.default)($e8b109bb95cf9845$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $ikvwP.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $kGAxb.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $kGAxb.default)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $j0yhO.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $e8b109bb95cf9845$var$prefixes[8 + (0, $lPyuV.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $ikvwP.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $1QDsO.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $e8b109bb95cf9845$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("1QDsO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1589426e0436f502$export$2e2bcd8739ae039);

var $1fLhe = parcelRequire("1fLhe");
function $1589426e0436f502$export$2e2bcd8739ae039(x) {
    return x = (0, $1fLhe.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("1fLhe", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e9bdd5fefd6a5f6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "formatDecimalParts", () => $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5);
function $0e9bdd5fefd6a5f6$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("l0OJc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4c0f29ad920aaa1$export$2e2bcd8739ae039);
function $f4c0f29ad920aaa1$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("cRZ1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $95e9c493347f9308$export$2e2bcd8739ae039);
function $95e9c493347f9308$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("ikvwP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5828d241e6c1f75$export$2e2bcd8739ae039);
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $d5828d241e6c1f75$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $d5828d241e6c1f75$export$2e2bcd8739ae039(specifier) {
    if (!(match = $d5828d241e6c1f75$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $d5828d241e6c1f75$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$d5828d241e6c1f75$export$2e2bcd8739ae039.prototype = $d5828d241e6c1f75$export$963aac351db36ed4.prototype; // instanceof
function $d5828d241e6c1f75$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$d5828d241e6c1f75$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("j0yhO", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd689cef4c920567$export$2e2bcd8739ae039);
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $dd689cef4c920567$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("kGAxb", function(module, exports) {

$parcel$export(module.exports, "default", () => $03e2e7837f70dba5$export$2e2bcd8739ae039);

var $1fLhe = parcelRequire("1fLhe");

var $lPyuV = parcelRequire("lPyuV");

var $5YhaN = parcelRequire("5YhaN");
var $03e2e7837f70dba5$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $1fLhe.default),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $5YhaN.default)(x * 100, p),
    "r": (0, $5YhaN.default),
    "s": (0, $lPyuV.default),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

});
parcelRegister("lPyuV", function(module, exports) {

$parcel$export(module.exports, "prefixExponent", () => $fe491ef31c379765$export$6863724d9a42263);
$parcel$export(module.exports, "default", () => $fe491ef31c379765$export$2e2bcd8739ae039);

var $1fLhe = parcelRequire("1fLhe");
var $fe491ef31c379765$export$6863724d9a42263;
function $fe491ef31c379765$export$2e2bcd8739ae039(x, p) {
    var d = (0, $1fLhe.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($fe491ef31c379765$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $1fLhe.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("5YhaN", function(module, exports) {

$parcel$export(module.exports, "default", () => $458fe095863893c0$export$2e2bcd8739ae039);

var $1fLhe = parcelRequire("1fLhe");
function $458fe095863893c0$export$2e2bcd8739ae039(x, p) {
    var d = (0, $1fLhe.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("2nOSB", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bc532601db445af$export$2e2bcd8739ae039);
function $1bc532601db445af$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("l1vM3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4e256a3cb9c44da$export$2e2bcd8739ae039);

var $1QDsO = parcelRequire("1QDsO");
function $f4e256a3cb9c44da$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $1QDsO.default)(Math.abs(step)));
}

});

parcelRegister("1TXup", function(module, exports) {

$parcel$export(module.exports, "default", () => $162912dc121d0934$export$2e2bcd8739ae039);

var $1QDsO = parcelRequire("1QDsO");
function $162912dc121d0934$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $1QDsO.default)(value) / 3))) * 3 - (0, $1QDsO.default)(Math.abs(step)));
}

});

parcelRegister("i4t6x", function(module, exports) {

$parcel$export(module.exports, "default", () => $d27f2d3c2137f747$export$2e2bcd8739ae039);

var $1QDsO = parcelRequire("1QDsO");
function $d27f2d3c2137f747$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $1QDsO.default)(max) - (0, $1QDsO.default)(step)) + 1;
}

});



parcelRegister("48U7R", function(module, exports) {

$parcel$export(module.exports, "default", () => $304372357472b2a4$export$2e2bcd8739ae039);

var $72rFk = parcelRequire("72rFk");
var $cKbL9 = parcelRequire("cKbL9");
var $3wXBo = parcelRequire("3wXBo");
var $gyimR = parcelRequire("gyimR");
var $6gR0W = parcelRequire("6gR0W");
var $nRuo6 = parcelRequire("nRuo6");
var $aW15j = parcelRequire("aW15j");
var $j0Fj9 = parcelRequire("j0Fj9");

var $UutV9 = parcelRequire("UutV9");

var $f6dVf = parcelRequire("f6dVf");

var $7QzZn = parcelRequire("7QzZn");

var $13gv1 = parcelRequire("13gv1");
function $304372357472b2a4$var$date(t) {
    return new Date(t);
}
function $304372357472b2a4$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $304372357472b2a4$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $f6dVf.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $304372357472b2a4$var$number)) : domain().map($304372357472b2a4$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $13gv1.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $f6dVf.copy)(scale, $304372357472b2a4$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $304372357472b2a4$export$2e2bcd8739ae039() {
    return (0, $7QzZn.initRange).apply($304372357472b2a4$export$56bbcdb8aca31149((0, $nRuo6.timeTicks), (0, $nRuo6.timeTickInterval), (0, $j0Fj9.timeYear), (0, $gyimR.timeMonth), (0, $aW15j.timeSunday), (0, $72rFk.timeDay), (0, $cKbL9.timeHour), (0, $3wXBo.timeMinute), (0, $6gR0W.second), (0, $UutV9.timeFormat)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("72rFk", function(module, exports) {

$parcel$export(module.exports, "timeDay", () => $51fe2e20810fcb40$export$8888529b966033e5);
$parcel$export(module.exports, "utcDay", () => $51fe2e20810fcb40$export$c8cbc42cefd47140);
$parcel$export(module.exports, "unixDay", () => $51fe2e20810fcb40$export$fb065be2d7ea4a71);

var $kOu3f = parcelRequire("kOu3f");

var $dXf4A = parcelRequire("dXf4A");
const $51fe2e20810fcb40$export$8888529b966033e5 = (0, $kOu3f.timeInterval)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $dXf4A.durationMinute)) / (0, $dXf4A.durationDay), (date)=>date.getDate() - 1);
const $51fe2e20810fcb40$export$6657a54f3034cf45 = $51fe2e20810fcb40$export$8888529b966033e5.range;
const $51fe2e20810fcb40$export$c8cbc42cefd47140 = (0, $kOu3f.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $dXf4A.durationDay);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const $51fe2e20810fcb40$export$d277e198508549a1 = $51fe2e20810fcb40$export$c8cbc42cefd47140.range;
const $51fe2e20810fcb40$export$fb065be2d7ea4a71 = (0, $kOu3f.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $dXf4A.durationDay);
}, (date)=>{
    return Math.floor(date / (0, $dXf4A.durationDay));
});
const $51fe2e20810fcb40$export$a491caaf5e9481aa = $51fe2e20810fcb40$export$fb065be2d7ea4a71.range;

});
parcelRegister("kOu3f", function(module, exports) {

$parcel$export(module.exports, "timeInterval", () => $f26fc9b6912de968$export$1a539c8b2950ab40);
const $f26fc9b6912de968$var$t0 = new Date, $f26fc9b6912de968$var$t1 = new Date;
function $f26fc9b6912de968$export$1a539c8b2950ab40(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return $f26fc9b6912de968$export$1a539c8b2950ab40((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            $f26fc9b6912de968$var$t0.setTime(+start), $f26fc9b6912de968$var$t1.setTime(+end);
            floori($f26fc9b6912de968$var$t0), floori($f26fc9b6912de968$var$t1);
            return Math.floor(count($f26fc9b6912de968$var$t0, $f26fc9b6912de968$var$t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}

});

parcelRegister("dXf4A", function(module, exports) {

$parcel$export(module.exports, "durationSecond", () => $a28c7a35eadfe1f6$export$79ef0e34099623dc);
$parcel$export(module.exports, "durationMinute", () => $a28c7a35eadfe1f6$export$683905d551c33fa9);
$parcel$export(module.exports, "durationHour", () => $a28c7a35eadfe1f6$export$4157bf0c8e241659);
$parcel$export(module.exports, "durationDay", () => $a28c7a35eadfe1f6$export$353686095f4fbf45);
$parcel$export(module.exports, "durationWeek", () => $a28c7a35eadfe1f6$export$c241eb88520d5016);
$parcel$export(module.exports, "durationMonth", () => $a28c7a35eadfe1f6$export$ab95684df7020b26);
$parcel$export(module.exports, "durationYear", () => $a28c7a35eadfe1f6$export$61f8ee2d834c6959);
const $a28c7a35eadfe1f6$export$79ef0e34099623dc = 1000;
const $a28c7a35eadfe1f6$export$683905d551c33fa9 = $a28c7a35eadfe1f6$export$79ef0e34099623dc * 60;
const $a28c7a35eadfe1f6$export$4157bf0c8e241659 = $a28c7a35eadfe1f6$export$683905d551c33fa9 * 60;
const $a28c7a35eadfe1f6$export$353686095f4fbf45 = $a28c7a35eadfe1f6$export$4157bf0c8e241659 * 24;
const $a28c7a35eadfe1f6$export$c241eb88520d5016 = $a28c7a35eadfe1f6$export$353686095f4fbf45 * 7;
const $a28c7a35eadfe1f6$export$ab95684df7020b26 = $a28c7a35eadfe1f6$export$353686095f4fbf45 * 30;
const $a28c7a35eadfe1f6$export$61f8ee2d834c6959 = $a28c7a35eadfe1f6$export$353686095f4fbf45 * 365;

});


parcelRegister("cKbL9", function(module, exports) {

$parcel$export(module.exports, "timeHour", () => $9472e71f07850dab$export$46c68a5833bc315b);
$parcel$export(module.exports, "utcHour", () => $9472e71f07850dab$export$31f6f2b3c63ac75e);

var $kOu3f = parcelRequire("kOu3f");

var $dXf4A = parcelRequire("dXf4A");
const $9472e71f07850dab$export$46c68a5833bc315b = (0, $kOu3f.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $dXf4A.durationSecond) - date.getMinutes() * (0, $dXf4A.durationMinute));
}, (date, step)=>{
    date.setTime(+date + step * (0, $dXf4A.durationHour));
}, (start, end)=>{
    return (end - start) / (0, $dXf4A.durationHour);
}, (date)=>{
    return date.getHours();
});
const $9472e71f07850dab$export$fb843f9087cd5235 = $9472e71f07850dab$export$46c68a5833bc315b.range;
const $9472e71f07850dab$export$31f6f2b3c63ac75e = (0, $kOu3f.timeInterval)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $dXf4A.durationHour));
}, (start, end)=>{
    return (end - start) / (0, $dXf4A.durationHour);
}, (date)=>{
    return date.getUTCHours();
});
const $9472e71f07850dab$export$6e7a76cd5f50b719 = $9472e71f07850dab$export$31f6f2b3c63ac75e.range;

});

parcelRegister("3wXBo", function(module, exports) {

$parcel$export(module.exports, "timeMinute", () => $292297f992a3b17e$export$a7e4c34a52f0576);
$parcel$export(module.exports, "utcMinute", () => $292297f992a3b17e$export$efe6712d6003761b);

var $kOu3f = parcelRequire("kOu3f");

var $dXf4A = parcelRequire("dXf4A");
const $292297f992a3b17e$export$a7e4c34a52f0576 = (0, $kOu3f.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $dXf4A.durationSecond));
}, (date, step)=>{
    date.setTime(+date + step * (0, $dXf4A.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, $dXf4A.durationMinute);
}, (date)=>{
    return date.getMinutes();
});
const $292297f992a3b17e$export$186d65358374c0a2 = $292297f992a3b17e$export$a7e4c34a52f0576.range;
const $292297f992a3b17e$export$efe6712d6003761b = (0, $kOu3f.timeInterval)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $dXf4A.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, $dXf4A.durationMinute);
}, (date)=>{
    return date.getUTCMinutes();
});
const $292297f992a3b17e$export$cedd563624e8ee50 = $292297f992a3b17e$export$efe6712d6003761b.range;

});

parcelRegister("gyimR", function(module, exports) {

$parcel$export(module.exports, "timeMonth", () => $031c190f93ea3efa$export$7e1084fb688591c1);
$parcel$export(module.exports, "utcMonth", () => $031c190f93ea3efa$export$cd49b3d2bcfe50d5);

var $kOu3f = parcelRequire("kOu3f");
const $031c190f93ea3efa$export$7e1084fb688591c1 = (0, $kOu3f.timeInterval)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const $031c190f93ea3efa$export$3e24aa839cd0f1c4 = $031c190f93ea3efa$export$7e1084fb688591c1.range;
const $031c190f93ea3efa$export$cd49b3d2bcfe50d5 = (0, $kOu3f.timeInterval)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const $031c190f93ea3efa$export$49159f585997498 = $031c190f93ea3efa$export$cd49b3d2bcfe50d5.range;

});

parcelRegister("6gR0W", function(module, exports) {

$parcel$export(module.exports, "second", () => $490d5c36270b8fcb$export$3d3c77ce7df7d30d);

var $kOu3f = parcelRequire("kOu3f");

var $dXf4A = parcelRequire("dXf4A");
const $490d5c36270b8fcb$export$3d3c77ce7df7d30d = (0, $kOu3f.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, $dXf4A.durationSecond));
}, (start, end)=>{
    return (end - start) / (0, $dXf4A.durationSecond);
}, (date)=>{
    return date.getUTCSeconds();
});
const $490d5c36270b8fcb$export$4792e48abc550fa1 = $490d5c36270b8fcb$export$3d3c77ce7df7d30d.range;

});

parcelRegister("nRuo6", function(module, exports) {

$parcel$export(module.exports, "timeTicks", () => $047ba3ec3f41562e$export$60c76498552d28a6);
$parcel$export(module.exports, "timeTickInterval", () => $047ba3ec3f41562e$export$69511150134dd174);

var $W4CTv = parcelRequire("W4CTv");
var $aE6k7 = parcelRequire("aE6k7");

var $dXf4A = parcelRequire("dXf4A");

var $asZKP = parcelRequire("asZKP");

var $6gR0W = parcelRequire("6gR0W");

var $3wXBo = parcelRequire("3wXBo");

var $cKbL9 = parcelRequire("cKbL9");

var $72rFk = parcelRequire("72rFk");

var $aW15j = parcelRequire("aW15j");

var $gyimR = parcelRequire("gyimR");

var $j0Fj9 = parcelRequire("j0Fj9");
function $047ba3ec3f41562e$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $6gR0W.second),
            1,
            (0, $dXf4A.durationSecond)
        ],
        [
            (0, $6gR0W.second),
            5,
            5 * (0, $dXf4A.durationSecond)
        ],
        [
            (0, $6gR0W.second),
            15,
            15 * (0, $dXf4A.durationSecond)
        ],
        [
            (0, $6gR0W.second),
            30,
            30 * (0, $dXf4A.durationSecond)
        ],
        [
            minute,
            1,
            (0, $dXf4A.durationMinute)
        ],
        [
            minute,
            5,
            5 * (0, $dXf4A.durationMinute)
        ],
        [
            minute,
            15,
            15 * (0, $dXf4A.durationMinute)
        ],
        [
            minute,
            30,
            30 * (0, $dXf4A.durationMinute)
        ],
        [
            hour,
            1,
            (0, $dXf4A.durationHour)
        ],
        [
            hour,
            3,
            3 * (0, $dXf4A.durationHour)
        ],
        [
            hour,
            6,
            6 * (0, $dXf4A.durationHour)
        ],
        [
            hour,
            12,
            12 * (0, $dXf4A.durationHour)
        ],
        [
            day,
            1,
            (0, $dXf4A.durationDay)
        ],
        [
            day,
            2,
            2 * (0, $dXf4A.durationDay)
        ],
        [
            week,
            1,
            (0, $dXf4A.durationWeek)
        ],
        [
            month,
            1,
            (0, $dXf4A.durationMonth)
        ],
        [
            month,
            3,
            3 * (0, $dXf4A.durationMonth)
        ],
        [
            year,
            1,
            (0, $dXf4A.durationYear)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $W4CTv.default)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $aE6k7.tickStep)(start / (0, $dXf4A.durationYear), stop / (0, $dXf4A.durationYear), count));
        if (i === 0) return (0, $asZKP.millisecond).every(Math.max((0, $aE6k7.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$047ba3ec3f41562e$export$826ba5ae907e9767, $047ba3ec3f41562e$export$6262d8d056ea44c4] = $047ba3ec3f41562e$var$ticker((0, $j0Fj9.utcYear), (0, $gyimR.utcMonth), (0, $aW15j.utcSunday), (0, $72rFk.unixDay), (0, $cKbL9.utcHour), (0, $3wXBo.utcMinute));
const [$047ba3ec3f41562e$export$60c76498552d28a6, $047ba3ec3f41562e$export$69511150134dd174] = $047ba3ec3f41562e$var$ticker((0, $j0Fj9.timeYear), (0, $gyimR.timeMonth), (0, $aW15j.timeSunday), (0, $72rFk.timeDay), (0, $cKbL9.timeHour), (0, $3wXBo.timeMinute));

});
parcelRegister("asZKP", function(module, exports) {

$parcel$export(module.exports, "millisecond", () => $79ec6c01997bf022$export$edc5e5cb87280477);

var $kOu3f = parcelRequire("kOu3f");
const $79ec6c01997bf022$export$edc5e5cb87280477 = (0, $kOu3f.timeInterval)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
$79ec6c01997bf022$export$edc5e5cb87280477.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $79ec6c01997bf022$export$edc5e5cb87280477;
    return (0, $kOu3f.timeInterval)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const $79ec6c01997bf022$export$9a27fac83d67afd3 = $79ec6c01997bf022$export$edc5e5cb87280477.range;

});

parcelRegister("aW15j", function(module, exports) {

$parcel$export(module.exports, "timeSunday", () => $7f6029921eecd017$export$22ee6205b762968c);
$parcel$export(module.exports, "timeMonday", () => $7f6029921eecd017$export$e79bbe0177cf1b01);
$parcel$export(module.exports, "timeTuesday", () => $7f6029921eecd017$export$57c0658c29f77708);
$parcel$export(module.exports, "timeWednesday", () => $7f6029921eecd017$export$3fbeef226c256e43);
$parcel$export(module.exports, "timeThursday", () => $7f6029921eecd017$export$608689422d5cf9f4);
$parcel$export(module.exports, "timeFriday", () => $7f6029921eecd017$export$548e5227aa183dca);
$parcel$export(module.exports, "timeSaturday", () => $7f6029921eecd017$export$c56a3ad248908e19);
$parcel$export(module.exports, "utcSunday", () => $7f6029921eecd017$export$4898b06303a92011);
$parcel$export(module.exports, "utcMonday", () => $7f6029921eecd017$export$9cfc53b9cfafd080);
$parcel$export(module.exports, "utcThursday", () => $7f6029921eecd017$export$1db08111baec2f53);

var $kOu3f = parcelRequire("kOu3f");

var $dXf4A = parcelRequire("dXf4A");
function $7f6029921eecd017$var$timeWeekday(i) {
    return (0, $kOu3f.timeInterval)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $dXf4A.durationMinute)) / (0, $dXf4A.durationWeek);
    });
}
const $7f6029921eecd017$export$22ee6205b762968c = $7f6029921eecd017$var$timeWeekday(0);
const $7f6029921eecd017$export$e79bbe0177cf1b01 = $7f6029921eecd017$var$timeWeekday(1);
const $7f6029921eecd017$export$57c0658c29f77708 = $7f6029921eecd017$var$timeWeekday(2);
const $7f6029921eecd017$export$3fbeef226c256e43 = $7f6029921eecd017$var$timeWeekday(3);
const $7f6029921eecd017$export$608689422d5cf9f4 = $7f6029921eecd017$var$timeWeekday(4);
const $7f6029921eecd017$export$548e5227aa183dca = $7f6029921eecd017$var$timeWeekday(5);
const $7f6029921eecd017$export$c56a3ad248908e19 = $7f6029921eecd017$var$timeWeekday(6);
const $7f6029921eecd017$export$eac514c8a8674eba = $7f6029921eecd017$export$22ee6205b762968c.range;
const $7f6029921eecd017$export$f7219b1481948356 = $7f6029921eecd017$export$e79bbe0177cf1b01.range;
const $7f6029921eecd017$export$77e22b12c5bed05b = $7f6029921eecd017$export$57c0658c29f77708.range;
const $7f6029921eecd017$export$b85d407a471809e8 = $7f6029921eecd017$export$3fbeef226c256e43.range;
const $7f6029921eecd017$export$c1bc1c49254c8855 = $7f6029921eecd017$export$608689422d5cf9f4.range;
const $7f6029921eecd017$export$3691a1557fff46f1 = $7f6029921eecd017$export$548e5227aa183dca.range;
const $7f6029921eecd017$export$b755452d02cba8d2 = $7f6029921eecd017$export$c56a3ad248908e19.range;
function $7f6029921eecd017$var$utcWeekday(i) {
    return (0, $kOu3f.timeInterval)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, $dXf4A.durationWeek);
    });
}
const $7f6029921eecd017$export$4898b06303a92011 = $7f6029921eecd017$var$utcWeekday(0);
const $7f6029921eecd017$export$9cfc53b9cfafd080 = $7f6029921eecd017$var$utcWeekday(1);
const $7f6029921eecd017$export$2a6d545f77eceb15 = $7f6029921eecd017$var$utcWeekday(2);
const $7f6029921eecd017$export$a5c25d8ed64433c4 = $7f6029921eecd017$var$utcWeekday(3);
const $7f6029921eecd017$export$1db08111baec2f53 = $7f6029921eecd017$var$utcWeekday(4);
const $7f6029921eecd017$export$29265e34dd5921f7 = $7f6029921eecd017$var$utcWeekday(5);
const $7f6029921eecd017$export$85b74dad05049604 = $7f6029921eecd017$var$utcWeekday(6);
const $7f6029921eecd017$export$6f3e1c2b0f7d7880 = $7f6029921eecd017$export$4898b06303a92011.range;
const $7f6029921eecd017$export$1d2d8b858bb366f9 = $7f6029921eecd017$export$9cfc53b9cfafd080.range;
const $7f6029921eecd017$export$1d5f6785fc7f30f8 = $7f6029921eecd017$export$2a6d545f77eceb15.range;
const $7f6029921eecd017$export$7a75faf0e37ef4af = $7f6029921eecd017$export$a5c25d8ed64433c4.range;
const $7f6029921eecd017$export$417eb959611b2f2f = $7f6029921eecd017$export$1db08111baec2f53.range;
const $7f6029921eecd017$export$59d308db7af08c64 = $7f6029921eecd017$export$29265e34dd5921f7.range;
const $7f6029921eecd017$export$a124108a0a7f34c8 = $7f6029921eecd017$export$85b74dad05049604.range;

});

parcelRegister("j0Fj9", function(module, exports) {

$parcel$export(module.exports, "timeYear", () => $dd6e0f506bfbbd03$export$cd17cfe45df0c046);
$parcel$export(module.exports, "utcYear", () => $dd6e0f506bfbbd03$export$d5c3802e389714c4);

var $kOu3f = parcelRequire("kOu3f");
const $dd6e0f506bfbbd03$export$cd17cfe45df0c046 = (0, $kOu3f.timeInterval)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$dd6e0f506bfbbd03$export$cd17cfe45df0c046.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $kOu3f.timeInterval)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const $dd6e0f506bfbbd03$export$69a4e90dd2cc3bd1 = $dd6e0f506bfbbd03$export$cd17cfe45df0c046.range;
const $dd6e0f506bfbbd03$export$d5c3802e389714c4 = (0, $kOu3f.timeInterval)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$dd6e0f506bfbbd03$export$d5c3802e389714c4.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $kOu3f.timeInterval)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const $dd6e0f506bfbbd03$export$3e24d311e17f5802 = $dd6e0f506bfbbd03$export$d5c3802e389714c4.range;

});


parcelRegister("UutV9", function(module, exports) {

$parcel$export(module.exports, "timeFormat", () => $0a9ce0165786feda$export$94f4d87fad5dcf9a);

var $61I4u = parcelRequire("61I4u");
var $0a9ce0165786feda$var$locale;
var $0a9ce0165786feda$export$94f4d87fad5dcf9a;
var $0a9ce0165786feda$export$32b9cd16e1b8c8d2;
var $0a9ce0165786feda$export$1a08fe38f63ebbbb;
var $0a9ce0165786feda$export$3edae9cf8e233729;
$0a9ce0165786feda$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $0a9ce0165786feda$export$2e2bcd8739ae039(definition) {
    $0a9ce0165786feda$var$locale = (0, $61I4u.default)(definition);
    $0a9ce0165786feda$export$94f4d87fad5dcf9a = $0a9ce0165786feda$var$locale.format;
    $0a9ce0165786feda$export$32b9cd16e1b8c8d2 = $0a9ce0165786feda$var$locale.parse;
    $0a9ce0165786feda$export$1a08fe38f63ebbbb = $0a9ce0165786feda$var$locale.utcFormat;
    $0a9ce0165786feda$export$3edae9cf8e233729 = $0a9ce0165786feda$var$locale.utcParse;
    return $0a9ce0165786feda$var$locale;
}

});
parcelRegister("61I4u", function(module, exports) {

$parcel$export(module.exports, "default", () => $463505b9d968caf4$export$2e2bcd8739ae039);

var $72rFk = parcelRequire("72rFk");
var $aW15j = parcelRequire("aW15j");
var $j0Fj9 = parcelRequire("j0Fj9");
function $463505b9d968caf4$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $463505b9d968caf4$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $463505b9d968caf4$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $463505b9d968caf4$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $463505b9d968caf4$var$formatRe(locale_periods), periodLookup = $463505b9d968caf4$var$formatLookup(locale_periods), weekdayRe = $463505b9d968caf4$var$formatRe(locale_weekdays), weekdayLookup = $463505b9d968caf4$var$formatLookup(locale_weekdays), shortWeekdayRe = $463505b9d968caf4$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $463505b9d968caf4$var$formatLookup(locale_shortWeekdays), monthRe = $463505b9d968caf4$var$formatRe(locale_months), monthLookup = $463505b9d968caf4$var$formatLookup(locale_months), shortMonthRe = $463505b9d968caf4$var$formatRe(locale_shortMonths), shortMonthLookup = $463505b9d968caf4$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $463505b9d968caf4$var$formatDayOfMonth,
        "e": $463505b9d968caf4$var$formatDayOfMonth,
        "f": $463505b9d968caf4$var$formatMicroseconds,
        "g": $463505b9d968caf4$var$formatYearISO,
        "G": $463505b9d968caf4$var$formatFullYearISO,
        "H": $463505b9d968caf4$var$formatHour24,
        "I": $463505b9d968caf4$var$formatHour12,
        "j": $463505b9d968caf4$var$formatDayOfYear,
        "L": $463505b9d968caf4$var$formatMilliseconds,
        "m": $463505b9d968caf4$var$formatMonthNumber,
        "M": $463505b9d968caf4$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $463505b9d968caf4$var$formatUnixTimestamp,
        "s": $463505b9d968caf4$var$formatUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$formatSeconds,
        "u": $463505b9d968caf4$var$formatWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$formatWeekNumberSunday,
        "V": $463505b9d968caf4$var$formatWeekNumberISO,
        "w": $463505b9d968caf4$var$formatWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $463505b9d968caf4$var$formatYear,
        "Y": $463505b9d968caf4$var$formatFullYear,
        "Z": $463505b9d968caf4$var$formatZone,
        "%": $463505b9d968caf4$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $463505b9d968caf4$var$formatUTCDayOfMonth,
        "e": $463505b9d968caf4$var$formatUTCDayOfMonth,
        "f": $463505b9d968caf4$var$formatUTCMicroseconds,
        "g": $463505b9d968caf4$var$formatUTCYearISO,
        "G": $463505b9d968caf4$var$formatUTCFullYearISO,
        "H": $463505b9d968caf4$var$formatUTCHour24,
        "I": $463505b9d968caf4$var$formatUTCHour12,
        "j": $463505b9d968caf4$var$formatUTCDayOfYear,
        "L": $463505b9d968caf4$var$formatUTCMilliseconds,
        "m": $463505b9d968caf4$var$formatUTCMonthNumber,
        "M": $463505b9d968caf4$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $463505b9d968caf4$var$formatUnixTimestamp,
        "s": $463505b9d968caf4$var$formatUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$formatUTCSeconds,
        "u": $463505b9d968caf4$var$formatUTCWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$formatUTCWeekNumberSunday,
        "V": $463505b9d968caf4$var$formatUTCWeekNumberISO,
        "w": $463505b9d968caf4$var$formatUTCWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $463505b9d968caf4$var$formatUTCYear,
        "Y": $463505b9d968caf4$var$formatUTCFullYear,
        "Z": $463505b9d968caf4$var$formatUTCZone,
        "%": $463505b9d968caf4$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $463505b9d968caf4$var$parseDayOfMonth,
        "e": $463505b9d968caf4$var$parseDayOfMonth,
        "f": $463505b9d968caf4$var$parseMicroseconds,
        "g": $463505b9d968caf4$var$parseYear,
        "G": $463505b9d968caf4$var$parseFullYear,
        "H": $463505b9d968caf4$var$parseHour24,
        "I": $463505b9d968caf4$var$parseHour24,
        "j": $463505b9d968caf4$var$parseDayOfYear,
        "L": $463505b9d968caf4$var$parseMilliseconds,
        "m": $463505b9d968caf4$var$parseMonthNumber,
        "M": $463505b9d968caf4$var$parseMinutes,
        "p": parsePeriod,
        "q": $463505b9d968caf4$var$parseQuarter,
        "Q": $463505b9d968caf4$var$parseUnixTimestamp,
        "s": $463505b9d968caf4$var$parseUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$parseSeconds,
        "u": $463505b9d968caf4$var$parseWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$parseWeekNumberSunday,
        "V": $463505b9d968caf4$var$parseWeekNumberISO,
        "w": $463505b9d968caf4$var$parseWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $463505b9d968caf4$var$parseYear,
        "Y": $463505b9d968caf4$var$parseFullYear,
        "Z": $463505b9d968caf4$var$parseZone,
        "%": $463505b9d968caf4$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $463505b9d968caf4$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $463505b9d968caf4$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $463505b9d968caf4$var$utcDate($463505b9d968caf4$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $aW15j.utcMonday).ceil(week) : (0, $aW15j.utcMonday)(week);
                    week = (0, $72rFk.utcDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $463505b9d968caf4$var$localDate($463505b9d968caf4$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $aW15j.timeMonday).ceil(week) : (0, $aW15j.timeMonday)(week);
                    week = (0, $72rFk.timeDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $463505b9d968caf4$var$utcDate($463505b9d968caf4$var$newDate(d.y, 0, 1)).getUTCDay() : $463505b9d968caf4$var$localDate($463505b9d968caf4$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $463505b9d968caf4$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $463505b9d968caf4$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $463505b9d968caf4$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $463505b9d968caf4$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $463505b9d968caf4$var$numberRe = /^\s*\d+/, $463505b9d968caf4$var$percentRe = /^%/, $463505b9d968caf4$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $463505b9d968caf4$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $463505b9d968caf4$var$requote(s) {
    return s.replace($463505b9d968caf4$var$requoteRe, "\\$&");
}
function $463505b9d968caf4$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($463505b9d968caf4$var$requote).join("|") + ")", "i");
}
function $463505b9d968caf4$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $463505b9d968caf4$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberSunday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberISO(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberMonday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseFullYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseQuarter(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMonthNumber(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseDayOfMonth(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseDayOfYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseHour24(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMinutes(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseSeconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMilliseconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMicroseconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseLiteralPercent(d, string, i) {
    var n = $463505b9d968caf4$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $463505b9d968caf4$var$parseUnixTimestamp(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$formatDayOfMonth(d, p) {
    return $463505b9d968caf4$var$pad(d.getDate(), p, 2);
}
function $463505b9d968caf4$var$formatHour24(d, p) {
    return $463505b9d968caf4$var$pad(d.getHours(), p, 2);
}
function $463505b9d968caf4$var$formatHour12(d, p) {
    return $463505b9d968caf4$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $463505b9d968caf4$var$formatDayOfYear(d, p) {
    return $463505b9d968caf4$var$pad(1 + (0, $72rFk.timeDay).count((0, $j0Fj9.timeYear)(d), d), p, 3);
}
function $463505b9d968caf4$var$formatMilliseconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getMilliseconds(), p, 3);
}
function $463505b9d968caf4$var$formatMicroseconds(d, p) {
    return $463505b9d968caf4$var$formatMilliseconds(d, p) + "000";
}
function $463505b9d968caf4$var$formatMonthNumber(d, p) {
    return $463505b9d968caf4$var$pad(d.getMonth() + 1, p, 2);
}
function $463505b9d968caf4$var$formatMinutes(d, p) {
    return $463505b9d968caf4$var$pad(d.getMinutes(), p, 2);
}
function $463505b9d968caf4$var$formatSeconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getSeconds(), p, 2);
}
function $463505b9d968caf4$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $463505b9d968caf4$var$formatWeekNumberSunday(d, p) {
    return $463505b9d968caf4$var$pad((0, $aW15j.timeSunday).count((0, $j0Fj9.timeYear)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $aW15j.timeThursday)(d) : (0, $aW15j.timeThursday).ceil(d);
}
function $463505b9d968caf4$var$formatWeekNumberISO(d, p) {
    d = $463505b9d968caf4$var$dISO(d);
    return $463505b9d968caf4$var$pad((0, $aW15j.timeThursday).count((0, $j0Fj9.timeYear)(d), d) + ((0, $j0Fj9.timeYear)(d).getDay() === 4), p, 2);
}
function $463505b9d968caf4$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $463505b9d968caf4$var$formatWeekNumberMonday(d, p) {
    return $463505b9d968caf4$var$pad((0, $aW15j.timeMonday).count((0, $j0Fj9.timeYear)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$formatYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatYearISO(d, p) {
    d = $463505b9d968caf4$var$dISO(d);
    return $463505b9d968caf4$var$pad(d.getFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatFullYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $aW15j.timeThursday)(d) : (0, $aW15j.timeThursday).ceil(d);
    return $463505b9d968caf4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $463505b9d968caf4$var$pad(z / 60 | 0, "0", 2) + $463505b9d968caf4$var$pad(z % 60, "0", 2);
}
function $463505b9d968caf4$var$formatUTCDayOfMonth(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCDate(), p, 2);
}
function $463505b9d968caf4$var$formatUTCHour24(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCHours(), p, 2);
}
function $463505b9d968caf4$var$formatUTCHour12(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $463505b9d968caf4$var$formatUTCDayOfYear(d, p) {
    return $463505b9d968caf4$var$pad(1 + (0, $72rFk.utcDay).count((0, $j0Fj9.utcYear)(d), d), p, 3);
}
function $463505b9d968caf4$var$formatUTCMilliseconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $463505b9d968caf4$var$formatUTCMicroseconds(d, p) {
    return $463505b9d968caf4$var$formatUTCMilliseconds(d, p) + "000";
}
function $463505b9d968caf4$var$formatUTCMonthNumber(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $463505b9d968caf4$var$formatUTCMinutes(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMinutes(), p, 2);
}
function $463505b9d968caf4$var$formatUTCSeconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCSeconds(), p, 2);
}
function $463505b9d968caf4$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $463505b9d968caf4$var$formatUTCWeekNumberSunday(d, p) {
    return $463505b9d968caf4$var$pad((0, $aW15j.utcSunday).count((0, $j0Fj9.utcYear)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $aW15j.utcThursday)(d) : (0, $aW15j.utcThursday).ceil(d);
}
function $463505b9d968caf4$var$formatUTCWeekNumberISO(d, p) {
    d = $463505b9d968caf4$var$UTCdISO(d);
    return $463505b9d968caf4$var$pad((0, $aW15j.utcThursday).count((0, $j0Fj9.utcYear)(d), d) + ((0, $j0Fj9.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $463505b9d968caf4$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $463505b9d968caf4$var$formatUTCWeekNumberMonday(d, p) {
    return $463505b9d968caf4$var$pad((0, $aW15j.utcMonday).count((0, $j0Fj9.utcYear)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$formatUTCYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatUTCYearISO(d, p) {
    d = $463505b9d968caf4$var$UTCdISO(d);
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatUTCFullYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $aW15j.utcThursday)(d) : (0, $aW15j.utcThursday).ceil(d);
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatUTCZone() {
    return "+0000";
}
function $463505b9d968caf4$var$formatLiteralPercent() {
    return "%";
}
function $463505b9d968caf4$var$formatUnixTimestamp(d) {
    return +d;
}
function $463505b9d968caf4$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("13gv1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c42deabcdb569d9$export$2e2bcd8739ae039);
function $0c42deabcdb569d9$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("6RbN1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fe0d67c4ca00f70$export$2e2bcd8739ae039);

var $lQv9d = parcelRequire("lQv9d");
var $4fe0d67c4ca00f70$export$2e2bcd8739ae039 = (0, $lQv9d.default)("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");

});
parcelRegister("lQv9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe769d98421e6dac$export$2e2bcd8739ae039);
function $fe769d98421e6dac$export$2e2bcd8739ae039(specifier) {
    var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
    while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
    return colors;
}

});


parcelRegister("jJCd9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5dfdc386da08eff$export$2e2bcd8739ae039);

var $hpRkj = parcelRequire("hpRkj");

var $3us5W = parcelRequire("3us5W");
function $e5dfdc386da08eff$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $3us5W.Selection)([
        document.querySelectorAll(selector)
    ], [
        document.documentElement
    ]) : new (0, $3us5W.Selection)([
        (0, $hpRkj.default)(selector)
    ], (0, $3us5W.root));
}

});

parcelRegister("ffiwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b196a0c5210e8c70$export$2e2bcd8739ae039);

var $7HXTO = parcelRequire("7HXTO");

var $kDiOX = parcelRequire("kDiOX");

var $7UVQV = parcelRequire("7UVQV");
function $b196a0c5210e8c70$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $b196a0c5210e8c70$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $b196a0c5210e8c70$var$arcStartAngle(d) {
    return d.startAngle;
}
function $b196a0c5210e8c70$var$arcEndAngle(d) {
    return d.endAngle;
}
function $b196a0c5210e8c70$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $b196a0c5210e8c70$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, $kDiOX.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $b196a0c5210e8c70$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $kDiOX.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $kDiOX.sqrt)((0, $kDiOX.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $b196a0c5210e8c70$export$2e2bcd8739ae039() {
    var innerRadius = $b196a0c5210e8c70$var$arcInnerRadius, outerRadius = $b196a0c5210e8c70$var$arcOuterRadius, cornerRadius = (0, $7HXTO.default)(0), padRadius = null, startAngle = $b196a0c5210e8c70$var$arcStartAngle, endAngle = $b196a0c5210e8c70$var$arcEndAngle, padAngle = $b196a0c5210e8c70$var$arcPadAngle, context = null, path = (0, $7UVQV.withPath)(arc);
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, $kDiOX.halfPi), a1 = endAngle.apply(this, arguments) - (0, $kDiOX.halfPi), da = (0, $kDiOX.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = path();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > (0, $kDiOX.epsilon))) context.moveTo(0, 0);
        else if (da > (0, $kDiOX.tau) - (0, $kDiOX.epsilon)) {
            context.moveTo(r1 * (0, $kDiOX.cos)(a0), r1 * (0, $kDiOX.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > (0, $kDiOX.epsilon)) {
                context.moveTo(r0 * (0, $kDiOX.cos)(a1), r0 * (0, $kDiOX.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, $kDiOX.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, $kDiOX.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $kDiOX.min)((0, $kDiOX.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > (0, $kDiOX.epsilon)) {
                var p0 = (0, $kDiOX.asin)(rp / r0 * (0, $kDiOX.sin)(ap)), p1 = (0, $kDiOX.asin)(rp / r1 * (0, $kDiOX.sin)(ap));
                if ((da0 -= p0 * 2) > (0, $kDiOX.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > (0, $kDiOX.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $kDiOX.cos)(a01), y01 = r1 * (0, $kDiOX.sin)(a01), x10 = r0 * (0, $kDiOX.cos)(a10), y10 = r0 * (0, $kDiOX.sin)(a10);
            // Apply rounded corners?
            if (rc > (0, $kDiOX.epsilon)) {
                var x11 = r1 * (0, $kDiOX.cos)(a11), y11 = r1 * (0, $kDiOX.sin)(a11), x00 = r0 * (0, $kDiOX.cos)(a00), y00 = r0 * (0, $kDiOX.sin)(a00), oc;
                // Restrict the corner radius according to the sector angle. If this
                // intersection fails, it’s probably because the arc is too small, so
                // disable the corner radius entirely.
                if (da < (0, $kDiOX.pi)) {
                    if (oc = $b196a0c5210e8c70$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
                        var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $kDiOX.sin)((0, $kDiOX.acos)((ax * bx + ay * by) / ((0, $kDiOX.sqrt)(ax * ax + ay * ay) * (0, $kDiOX.sqrt)(bx * bx + by * by))) / 2), lc = (0, $kDiOX.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                        rc0 = (0, $kDiOX.min)(rc, (r0 - lc) / (kc - 1));
                        rc1 = (0, $kDiOX.min)(rc, (r1 - lc) / (kc + 1));
                    } else rc0 = rc1 = 0;
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > (0, $kDiOX.epsilon))) context.moveTo(x01, y01);
            else if (rc1 > (0, $kDiOX.epsilon)) {
                t0 = $b196a0c5210e8c70$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $b196a0c5210e8c70$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $kDiOX.atan2)(t0.y01, t0.x01), (0, $kDiOX.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $kDiOX.atan2)(t0.y01, t0.x01), (0, $kDiOX.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $kDiOX.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $kDiOX.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $kDiOX.atan2)(t1.y11, t1.x11), (0, $kDiOX.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > (0, $kDiOX.epsilon)) || !(da0 > (0, $kDiOX.epsilon))) context.lineTo(x10, y10);
            else if (rc0 > (0, $kDiOX.epsilon)) {
                t0 = $b196a0c5210e8c70$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $b196a0c5210e8c70$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $kDiOX.atan2)(t0.y01, t0.x01), (0, $kDiOX.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $kDiOX.atan2)(t0.y01, t0.x01), (0, $kDiOX.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $kDiOX.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $kDiOX.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $kDiOX.atan2)(t1.y11, t1.x11), (0, $kDiOX.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, $kDiOX.pi) / 2;
        return [
            (0, $kDiOX.cos)(a) * r,
            (0, $kDiOX.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("7HXTO", function(module, exports) {

$parcel$export(module.exports, "default", () => $59cb0344df9474fa$export$2e2bcd8739ae039);
function $59cb0344df9474fa$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("kDiOX", function(module, exports) {

$parcel$export(module.exports, "abs", () => $f0560c970166d25b$export$2335f513bbd82c6d);
$parcel$export(module.exports, "atan2", () => $f0560c970166d25b$export$b8b770ee6a0d9760);
$parcel$export(module.exports, "cos", () => $f0560c970166d25b$export$50d414a77b60d802);
$parcel$export(module.exports, "max", () => $f0560c970166d25b$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $f0560c970166d25b$export$96ec731ed4dcb222);
$parcel$export(module.exports, "sin", () => $f0560c970166d25b$export$5de3937cb4b592ed);
$parcel$export(module.exports, "sqrt", () => $f0560c970166d25b$export$eba8049fb5020b81);
$parcel$export(module.exports, "epsilon", () => $f0560c970166d25b$export$6c421550c66a327d);
$parcel$export(module.exports, "pi", () => $f0560c970166d25b$export$18c7bea995a110f);
$parcel$export(module.exports, "halfPi", () => $f0560c970166d25b$export$e51408a300e8929a);
$parcel$export(module.exports, "tau", () => $f0560c970166d25b$export$a4b4b4d4d776fe92);
$parcel$export(module.exports, "acos", () => $f0560c970166d25b$export$fd6306be3fde5b04);
$parcel$export(module.exports, "asin", () => $f0560c970166d25b$export$41726bdb1fc63f);
const $f0560c970166d25b$export$2335f513bbd82c6d = Math.abs;
const $f0560c970166d25b$export$b8b770ee6a0d9760 = Math.atan2;
const $f0560c970166d25b$export$50d414a77b60d802 = Math.cos;
const $f0560c970166d25b$export$8960430cfd85939f = Math.max;
const $f0560c970166d25b$export$96ec731ed4dcb222 = Math.min;
const $f0560c970166d25b$export$5de3937cb4b592ed = Math.sin;
const $f0560c970166d25b$export$eba8049fb5020b81 = Math.sqrt;
const $f0560c970166d25b$export$6c421550c66a327d = 1e-12;
const $f0560c970166d25b$export$18c7bea995a110f = Math.PI;
const $f0560c970166d25b$export$e51408a300e8929a = $f0560c970166d25b$export$18c7bea995a110f / 2;
const $f0560c970166d25b$export$a4b4b4d4d776fe92 = 2 * $f0560c970166d25b$export$18c7bea995a110f;
function $f0560c970166d25b$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $f0560c970166d25b$export$18c7bea995a110f : Math.acos(x);
}
function $f0560c970166d25b$export$41726bdb1fc63f(x) {
    return x >= 1 ? $f0560c970166d25b$export$e51408a300e8929a : x <= -1 ? -$f0560c970166d25b$export$e51408a300e8929a : Math.asin(x);
}

});

parcelRegister("7UVQV", function(module, exports) {

$parcel$export(module.exports, "withPath", () => $5c3aa3aea2c844cf$export$fb6e83118a5dcd45);

var $hl2Bj = parcelRequire("hl2Bj");
function $5c3aa3aea2c844cf$export$fb6e83118a5dcd45(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, $hl2Bj.Path)(digits);
}

});
parcelRegister("hl2Bj", function(module, exports) {

$parcel$export(module.exports, "Path", () => $c9f66a4d1c06b373$export$4b2950bdac9b6ee9);
const $c9f66a4d1c06b373$var$pi = Math.PI, $c9f66a4d1c06b373$var$tau = 2 * $c9f66a4d1c06b373$var$pi, $c9f66a4d1c06b373$var$epsilon = 1e-6, $c9f66a4d1c06b373$var$tauEpsilon = $c9f66a4d1c06b373$var$tau - $c9f66a4d1c06b373$var$epsilon;
function $c9f66a4d1c06b373$var$append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function $c9f66a4d1c06b373$var$appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return $c9f66a4d1c06b373$var$append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class $c9f66a4d1c06b373$export$4b2950bdac9b6ee9 {
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? $c9f66a4d1c06b373$var$append : $c9f66a4d1c06b373$var$appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > $c9f66a4d1c06b373$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $c9f66a4d1c06b373$var$epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($c9f66a4d1c06b373$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $c9f66a4d1c06b373$var$epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $c9f66a4d1c06b373$var$epsilon || Math.abs(this._y1 - y0) > $c9f66a4d1c06b373$var$epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $c9f66a4d1c06b373$var$tau + $c9f66a4d1c06b373$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $c9f66a4d1c06b373$var$tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > $c9f66a4d1c06b373$var$epsilon) this._append`A${r},${r},0,${+(da >= $c9f66a4d1c06b373$var$pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
function $c9f66a4d1c06b373$export$bb654e07daaf8c3a() {
    return new $c9f66a4d1c06b373$export$4b2950bdac9b6ee9;
}
// Allow instanceof d3.path
$c9f66a4d1c06b373$export$bb654e07daaf8c3a.prototype = $c9f66a4d1c06b373$export$4b2950bdac9b6ee9.prototype;
function $c9f66a4d1c06b373$export$e181c6ece8d9cc5f(digits = 3) {
    return new $c9f66a4d1c06b373$export$4b2950bdac9b6ee9(+digits);
}

});



parcelRegister("6QL1t", function(module, exports) {

$parcel$export(module.exports, "point", () => $4fcc1327a5d07e55$export$105684a3041cb6f3);
$parcel$export(module.exports, "Basis", () => $4fcc1327a5d07e55$export$957f7263e89bedd2);
$parcel$export(module.exports, "default", () => $4fcc1327a5d07e55$export$2e2bcd8739ae039);
function $4fcc1327a5d07e55$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $4fcc1327a5d07e55$export$957f7263e89bedd2(context) {
    this._context = context;
}
$4fcc1327a5d07e55$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $4fcc1327a5d07e55$export$105684a3041cb6f3(this, this._x1, this._y1); // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
            default:
                $4fcc1327a5d07e55$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $4fcc1327a5d07e55$export$2e2bcd8739ae039(context) {
    return new $4fcc1327a5d07e55$export$957f7263e89bedd2(context);
}

});

parcelRegister("2515N", function(module, exports) {

$parcel$export(module.exports, "default", () => $183ce554afe8c6f0$export$2e2bcd8739ae039);

var $9R4F2 = parcelRequire("9R4F2");

var $6QL1t = parcelRequire("6QL1t");
function $183ce554afe8c6f0$var$BasisClosed(context) {
    this._context = context;
}
$183ce554afe8c6f0$var$BasisClosed.prototype = {
    areaStart: (0, $9R4F2.default),
    areaEnd: (0, $9R4F2.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $6QL1t.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $183ce554afe8c6f0$export$2e2bcd8739ae039(context) {
    return new $183ce554afe8c6f0$var$BasisClosed(context);
}

});
parcelRegister("9R4F2", function(module, exports) {

$parcel$export(module.exports, "default", () => $72ccadd7b0a5f010$export$2e2bcd8739ae039);
function $72ccadd7b0a5f010$export$2e2bcd8739ae039() {}

});


parcelRegister("e1bEB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a34a32e088f640bf$export$2e2bcd8739ae039);

var $6QL1t = parcelRequire("6QL1t");
function $a34a32e088f640bf$var$BasisOpen(context) {
    this._context = context;
}
$a34a32e088f640bf$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $6QL1t.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $a34a32e088f640bf$export$2e2bcd8739ae039(context) {
    return new $a34a32e088f640bf$var$BasisOpen(context);
}

});

parcelRegister("gpIrV", function(module, exports) {

$parcel$export(module.exports, "bumpX", () => $bf3175dc82ec4a49$export$2c099b5096f70ce6);
$parcel$export(module.exports, "bumpY", () => $bf3175dc82ec4a49$export$908da9dfa54cbed6);

var $c0euB = parcelRequire("c0euB");
class $bf3175dc82ec4a49$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $bf3175dc82ec4a49$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point === 0) this._point = 1;
        else {
            const p0 = (0, $c0euB.default)(this._x0, this._y0);
            const p1 = (0, $c0euB.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $c0euB.default)(x, this._y0);
            const p3 = (0, $c0euB.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
        this._x0 = x, this._y0 = y;
    }
}
function $bf3175dc82ec4a49$export$2c099b5096f70ce6(context) {
    return new $bf3175dc82ec4a49$var$Bump(context, true);
}
function $bf3175dc82ec4a49$export$908da9dfa54cbed6(context) {
    return new $bf3175dc82ec4a49$var$Bump(context, false);
}
function $bf3175dc82ec4a49$export$8c82a77a5061b331(context) {
    return new $bf3175dc82ec4a49$var$BumpRadial(context);
}

});
parcelRegister("c0euB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bd0ba086b92e84b$export$2e2bcd8739ae039);
function $8bd0ba086b92e84b$export$2e2bcd8739ae039(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});


parcelRegister("l8Mye", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6400194fd6a0bdb$export$2e2bcd8739ae039);

var $6QL1t = parcelRequire("6QL1t");
function $f6400194fd6a0bdb$var$Bundle(context, beta) {
    this._basis = new (0, $6QL1t.Basis)(context);
    this._beta = beta;
}
$f6400194fd6a0bdb$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $f6400194fd6a0bdb$export$2e2bcd8739ae039 = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, $6QL1t.Basis)(context) : new $f6400194fd6a0bdb$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

});

parcelRegister("hga9n", function(module, exports) {

$parcel$export(module.exports, "point", () => $c90bcdedc71457ea$export$105684a3041cb6f3);
$parcel$export(module.exports, "Cardinal", () => $c90bcdedc71457ea$export$ee51ff373511cbeb);
$parcel$export(module.exports, "default", () => $c90bcdedc71457ea$export$2e2bcd8739ae039);
function $c90bcdedc71457ea$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $c90bcdedc71457ea$export$ee51ff373511cbeb(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$c90bcdedc71457ea$export$ee51ff373511cbeb.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $c90bcdedc71457ea$export$105684a3041cb6f3(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                $c90bcdedc71457ea$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $c90bcdedc71457ea$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $c90bcdedc71457ea$export$ee51ff373511cbeb(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});

parcelRegister("9XrSP", function(module, exports) {

$parcel$export(module.exports, "CardinalClosed", () => $73ff40c99770ef6d$export$da3940d7e9162858);
$parcel$export(module.exports, "default", () => $73ff40c99770ef6d$export$2e2bcd8739ae039);

var $9R4F2 = parcelRequire("9R4F2");

var $hga9n = parcelRequire("hga9n");
function $73ff40c99770ef6d$export$da3940d7e9162858(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$73ff40c99770ef6d$export$da3940d7e9162858.prototype = {
    areaStart: (0, $9R4F2.default),
    areaEnd: (0, $9R4F2.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $hga9n.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $73ff40c99770ef6d$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $73ff40c99770ef6d$export$da3940d7e9162858(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});

parcelRegister("dUIyz", function(module, exports) {

$parcel$export(module.exports, "CardinalOpen", () => $a213115754da7990$export$cd7d1a617282f2f1);
$parcel$export(module.exports, "default", () => $a213115754da7990$export$2e2bcd8739ae039);

var $hga9n = parcelRequire("hga9n");
function $a213115754da7990$export$cd7d1a617282f2f1(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$a213115754da7990$export$cd7d1a617282f2f1.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $hga9n.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $a213115754da7990$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $a213115754da7990$export$cd7d1a617282f2f1(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});

parcelRegister("6FEsA", function(module, exports) {

$parcel$export(module.exports, "point", () => point);
$parcel$export(module.exports, "default", () => $4db5f4f17c3a16b3$export$2e2bcd8739ae039);

var $kDiOX = parcelRequire("kDiOX");

var $hga9n = parcelRequire("hga9n");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, $kDiOX.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, $kDiOX.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $4db5f4f17c3a16b3$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, $hga9n.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});

parcelRegister("loyNQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f936d5ffcfb25824$export$2e2bcd8739ae039);

var $9XrSP = parcelRequire("9XrSP");

var $9R4F2 = parcelRequire("9R4F2");

var $6FEsA = parcelRequire("6FEsA");
function $f936d5ffcfb25824$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$f936d5ffcfb25824$var$CatmullRomClosed.prototype = {
    areaStart: (0, $9R4F2.default),
    areaEnd: (0, $9R4F2.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $6FEsA.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $f936d5ffcfb25824$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $f936d5ffcfb25824$var$CatmullRomClosed(context, alpha) : new (0, $9XrSP.CardinalClosed)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});

parcelRegister("4tc8L", function(module, exports) {

$parcel$export(module.exports, "default", () => $341349acb9991726$export$2e2bcd8739ae039);

var $dUIyz = parcelRequire("dUIyz");

var $6FEsA = parcelRequire("6FEsA");
function $341349acb9991726$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$341349acb9991726$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $6FEsA.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $341349acb9991726$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $341349acb9991726$var$CatmullRomOpen(context, alpha) : new (0, $dUIyz.CardinalOpen)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});

parcelRegister("gEcf1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1e9e09d9174b864$export$2e2bcd8739ae039);
function $c1e9e09d9174b864$var$Linear(context) {
    this._context = context;
}
$c1e9e09d9174b864$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $c1e9e09d9174b864$export$2e2bcd8739ae039(context) {
    return new $c1e9e09d9174b864$var$Linear(context);
}

});

parcelRegister("4CT3t", function(module, exports) {

$parcel$export(module.exports, "default", () => $35e56ad4997e8f65$export$2e2bcd8739ae039);

var $9R4F2 = parcelRequire("9R4F2");
function $35e56ad4997e8f65$var$LinearClosed(context) {
    this._context = context;
}
$35e56ad4997e8f65$var$LinearClosed.prototype = {
    areaStart: (0, $9R4F2.default),
    areaEnd: (0, $9R4F2.default),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $35e56ad4997e8f65$export$2e2bcd8739ae039(context) {
    return new $35e56ad4997e8f65$var$LinearClosed(context);
}

});

parcelRegister("hp3ls", function(module, exports) {

$parcel$export(module.exports, "monotoneX", () => $cab75dc01e66b193$export$99563b5420dbdc55);
$parcel$export(module.exports, "monotoneY", () => $cab75dc01e66b193$export$8b5360456d6bdb88);
function $cab75dc01e66b193$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $cab75dc01e66b193$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($cab75dc01e66b193$var$sign(s0) + $cab75dc01e66b193$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $cab75dc01e66b193$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $cab75dc01e66b193$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $cab75dc01e66b193$var$MonotoneX(context) {
    this._context = context;
}
$cab75dc01e66b193$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $cab75dc01e66b193$var$point(this, this._t0, $cab75dc01e66b193$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $cab75dc01e66b193$var$point(this, $cab75dc01e66b193$var$slope2(this, t1 = $cab75dc01e66b193$var$slope3(this, x, y)), t1);
                break;
            default:
                $cab75dc01e66b193$var$point(this, this._t0, t1 = $cab75dc01e66b193$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $cab75dc01e66b193$var$MonotoneY(context) {
    this._context = new $cab75dc01e66b193$var$ReflectContext(context);
}
($cab75dc01e66b193$var$MonotoneY.prototype = Object.create($cab75dc01e66b193$var$MonotoneX.prototype)).point = function(x, y) {
    $cab75dc01e66b193$var$MonotoneX.prototype.point.call(this, y, x);
};
function $cab75dc01e66b193$var$ReflectContext(context) {
    this._context = context;
}
$cab75dc01e66b193$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $cab75dc01e66b193$export$99563b5420dbdc55(context) {
    return new $cab75dc01e66b193$var$MonotoneX(context);
}
function $cab75dc01e66b193$export$8b5360456d6bdb88(context) {
    return new $cab75dc01e66b193$var$MonotoneY(context);
}

});

parcelRegister("kjPWc", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaddebfc9069a1b$export$2e2bcd8739ae039);
function $ecaddebfc9069a1b$var$Natural(context) {
    this._context = context;
}
$ecaddebfc9069a1b$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $ecaddebfc9069a1b$var$controlPoints(x), py = $ecaddebfc9069a1b$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $ecaddebfc9069a1b$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $ecaddebfc9069a1b$export$2e2bcd8739ae039(context) {
    return new $ecaddebfc9069a1b$var$Natural(context);
}

});

parcelRegister("1zRZO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1262f1c88e9696b5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "stepBefore", () => $1262f1c88e9696b5$export$10eafa5b7478b343);
$parcel$export(module.exports, "stepAfter", () => $1262f1c88e9696b5$export$793b3db073781cbb);
function $1262f1c88e9696b5$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$1262f1c88e9696b5$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $1262f1c88e9696b5$export$2e2bcd8739ae039(context) {
    return new $1262f1c88e9696b5$var$Step(context, 0.5);
}
function $1262f1c88e9696b5$export$10eafa5b7478b343(context) {
    return new $1262f1c88e9696b5$var$Step(context, 0);
}
function $1262f1c88e9696b5$export$793b3db073781cbb(context) {
    return new $1262f1c88e9696b5$var$Step(context, 1);
}

});

parcelRegister("5ti2H", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fbda81220c6ea9c$export$2e2bcd8739ae039);

var $fh6WC = parcelRequire("fh6WC");

var $7HXTO = parcelRequire("7HXTO");

var $gEcf1 = parcelRequire("gEcf1");

var $7UVQV = parcelRequire("7UVQV");

var $kfOCT = parcelRequire("kfOCT");
function $3fbda81220c6ea9c$export$2e2bcd8739ae039(x, y) {
    var defined = (0, $7HXTO.default)(true), context = null, curve = (0, $gEcf1.default), output = null, path = (0, $7UVQV.withPath)(line);
    x = typeof x === "function" ? x : x === undefined ? (0, $kfOCT.x) : (0, $7HXTO.default)(x);
    y = typeof y === "function" ? y : y === undefined ? (0, $kfOCT.y) : (0, $7HXTO.default)(y);
    function line(data) {
        var i, n = (data = (0, $fh6WC.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $7HXTO.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("fh6WC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1edd492c2923d6f$export$2e2bcd8739ae039);
var $b1edd492c2923d6f$export$58adb3bec8346d0f = Array.prototype.slice;
function $b1edd492c2923d6f$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("kfOCT", function(module, exports) {

$parcel$export(module.exports, "x", () => $ebec7ab58e49c436$export$d141bba7fdc215a3);
$parcel$export(module.exports, "y", () => $ebec7ab58e49c436$export$4a5767248b18ef41);
function $ebec7ab58e49c436$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $ebec7ab58e49c436$export$4a5767248b18ef41(p) {
    return p[1];
}

});


parcelRegister("fo0l5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3395c44b48089b3$export$2e2bcd8739ae039);

var $fh6WC = parcelRequire("fh6WC");

var $7HXTO = parcelRequire("7HXTO");

var $f5PAg = parcelRequire("f5PAg");

var $fNubL = parcelRequire("fNubL");

var $kDiOX = parcelRequire("kDiOX");
function $b3395c44b48089b3$export$2e2bcd8739ae039() {
    var value = (0, $fNubL.default), sortValues = (0, $f5PAg.default), sort = null, startAngle = (0, $7HXTO.default)(0), endAngle = (0, $7HXTO.default)((0, $kDiOX.tau)), padAngle = (0, $7HXTO.default)(0);
    function pie(data) {
        var i, n = (data = (0, $fh6WC.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, $kDiOX.tau), Math.max(-(0, $kDiOX.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("f5PAg", function(module, exports) {

$parcel$export(module.exports, "default", () => $afcf5628442ed482$export$2e2bcd8739ae039);
function $afcf5628442ed482$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("fNubL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b802d97edd5fe3af$export$2e2bcd8739ae039);
function $b802d97edd5fe3af$export$2e2bcd8739ae039(d) {
    return d;
}

});


parcelRegister("fOARq", function(module, exports) {

$parcel$export(module.exports, "zoom", () => (parcelRequire("cwuwP")).default);

var $cwuwP = parcelRequire("cwuwP");

var $e3ER1 = parcelRequire("e3ER1");

});
parcelRegister("cwuwP", function(module, exports) {

$parcel$export(module.exports, "default", () => $91e02783b8b1c24a$export$2e2bcd8739ae039);

var $aFEgl = parcelRequire("aFEgl");

var $cohyw = parcelRequire("cohyw");

var $jAaAF = parcelRequire("jAaAF");

var $2oxcP = parcelRequire("2oxcP");
var $hOxpW = parcelRequire("hOxpW");
parcelRequire("dxJVY");
var $f8M3T = parcelRequire("f8M3T");

var $6qNlB = parcelRequire("6qNlB");

var $awhiZ = parcelRequire("awhiZ");

var $e3ER1 = parcelRequire("e3ER1");

var $fmeOl = parcelRequire("fmeOl");
// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $91e02783b8b1c24a$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function $91e02783b8b1c24a$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $91e02783b8b1c24a$var$defaultTransform() {
    return this.__zoom || (0, $e3ER1.identity);
}
function $91e02783b8b1c24a$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $91e02783b8b1c24a$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $91e02783b8b1c24a$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $91e02783b8b1c24a$export$2e2bcd8739ae039() {
    var filter = $91e02783b8b1c24a$var$defaultFilter, extent = $91e02783b8b1c24a$var$defaultExtent, constrain = $91e02783b8b1c24a$var$defaultConstrain, wheelDelta = $91e02783b8b1c24a$var$defaultWheelDelta, touchable = $91e02783b8b1c24a$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $jAaAF.default), listeners = (0, $aFEgl.default)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $91e02783b8b1c24a$var$defaultTransform).on("wheel.zoom", wheeled, {
            passive: false
        }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $91e02783b8b1c24a$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $e3ER1.identity).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $e3ER1.Transform)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $e3ER1.Transform)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $e3ER1.Transform)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $hOxpW.default)(this.that).datum();
            listeners.call(type, this.that, new (0, $awhiZ.default)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $2oxcP.default)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $f8M3T.default)(this);
            g.start();
        }
        (0, $fmeOl.default)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, $hOxpW.default)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $2oxcP.default)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
        (0, $cohyw.default)(event.view);
        (0, $fmeOl.nopropagation)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $f8M3T.default)(this);
        g.start();
        function mousemoved(event) {
            (0, $fmeOl.default)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $2oxcP.default)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $cohyw.yesdrag)(event.view, g.moved);
            (0, $fmeOl.default)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $2oxcP.default)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $fmeOl.default)(event);
        if (duration > 0) (0, $hOxpW.default)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $hOxpW.default)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $fmeOl.nopropagation)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $2oxcP.default)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $f8M3T.default)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $fmeOl.default)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $2oxcP.default)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $fmeOl.nopropagation)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $2oxcP.default)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $hOxpW.default)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $6qNlB.default)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $6qNlB.default)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $6qNlB.default)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $6qNlB.default)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}

});
parcelRegister("jAaAF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4199827a75856fd$export$2e2bcd8739ae039);
var $e4199827a75856fd$var$epsilon2 = 1e-12;
function $e4199827a75856fd$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $e4199827a75856fd$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $e4199827a75856fd$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $e4199827a75856fd$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $e4199827a75856fd$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $e4199827a75856fd$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $e4199827a75856fd$var$tanh(rho * s + r0) - $e4199827a75856fd$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $e4199827a75856fd$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);

});

parcelRegister("6qNlB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aeb7326706b2467$export$2e2bcd8739ae039);
var $4aeb7326706b2467$export$2e2bcd8739ae039 = (x)=>()=>x;

});

parcelRegister("awhiZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a8a51016481311d$export$2e2bcd8739ae039);
function $7a8a51016481311d$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

});

parcelRegister("e3ER1", function(module, exports) {

$parcel$export(module.exports, "Transform", () => $a3c1094a2e8782d7$export$563a914cafbdc389);
$parcel$export(module.exports, "identity", () => $a3c1094a2e8782d7$export$f0954fd7d5368655);
function $a3c1094a2e8782d7$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$a3c1094a2e8782d7$export$563a914cafbdc389.prototype = {
    constructor: $a3c1094a2e8782d7$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $a3c1094a2e8782d7$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $a3c1094a2e8782d7$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $a3c1094a2e8782d7$export$f0954fd7d5368655 = new $a3c1094a2e8782d7$export$563a914cafbdc389(1, 0, 0);
$a3c1094a2e8782d7$export$2e2bcd8739ae039.prototype = $a3c1094a2e8782d7$export$563a914cafbdc389.prototype;
function $a3c1094a2e8782d7$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $a3c1094a2e8782d7$export$f0954fd7d5368655;
    return node.__zoom;
}

});

parcelRegister("fmeOl", function(module, exports) {

$parcel$export(module.exports, "nopropagation", () => $b2e4663bd9fbfcc1$export$2e2561858db9bf47);
$parcel$export(module.exports, "default", () => $b2e4663bd9fbfcc1$export$2e2bcd8739ae039);
function $b2e4663bd9fbfcc1$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $b2e4663bd9fbfcc1$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

});




parcelRegister("i8Fxz", function(module, exports) {
/*! @license DOMPurify 3.1.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.1.6/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    const { entries: entries, setPrototypeOf: setPrototypeOf, isFrozen: isFrozen, getPrototypeOf: getPrototypeOf, getOwnPropertyDescriptor: getOwnPropertyDescriptor } = Object;
    let { freeze: freeze, seal: seal, create: create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply: apply, construct: construct } = typeof Reflect !== 'undefined' && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!construct) construct = function construct(Func, args) {
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param {Function} func - The function to be wrapped and called.
   * @returns {Function} A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param {Function} func - The constructor function to be wrapped and called.
   * @returns {Function} A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param {Object} set - The set to which elements will be added.
   * @param {Array} array - The array containing elements to be added to the set.
   * @param {Function} transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns {Object} The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param {Array} array - The array to be cleaned.
   * @returns {Array} The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param {Object} object - The object to be cloned.
   * @returns {Object} A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (Array.isArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param {Object} object - The object to look up the getter function in its prototype chain.
   * @param {String} prop - The property name for which to find the getter function.
   * @returns {Function} The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns',
        'slot'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        ERB_EXPR: ERB_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR,
        DATA_ATTR: DATA_ATTR,
        ARIA_ATTR: ARIA_ATTR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        DOCTYPE_NAME: DOCTYPE_NAME,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT
    });
    // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {HTMLScriptElement} purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return {TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '3.1.6';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document: document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
        const { importNode: importNode } = originalDocument;
        let hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML('');
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        const MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        const HTML_INTEGRATION_POINTS = addToSet({}, [
            'foreignobject',
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ const _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param  {Node} root The root element or node to start traversing on.
     * @return {NodeIterator} The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param  {Node} object object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ const _isNode = function _isNode(object) {
            return typeof Node === 'function' && object instanceof Node;
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ const _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, ' ');
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param {string} tagName name of the tag of the node to sanitize
     * @returns {boolean} Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            const { attributes: attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                let value = name === 'value' ? attrValue : stringTrim(attrValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, ' ');
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} cfg object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, ' ');
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {String} tag Tag name of containing element.
     * @param  {String} attr Attribute name.
     * @param  {String} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});

parcelRegister("7Mv8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $5aa52c17c0c49e88$export$2e2bcd8739ae039);
/* IMPORT */ 
var $9VYra = parcelRequire("9VYra");

var $fQvWs = parcelRequire("fQvWs");
/* MAIN */ const $5aa52c17c0c49e88$var$adjust = (color, channels)=>{
    const ch = (0, $9VYra.default).parse(color);
    const changes = {};
    for(const c in channels){
        if (!channels[c]) continue;
        changes[c] = ch[c] + channels[c];
    }
    return (0, $fQvWs.default)(color, changes);
};
var /* EXPORT */ $5aa52c17c0c49e88$export$2e2bcd8739ae039 = $5aa52c17c0c49e88$var$adjust;

});
parcelRegister("9VYra", function(module, exports) {

$parcel$export(module.exports, "default", () => $73b851820af8f2fb$export$2e2bcd8739ae039);
/* IMPORT */ 

var $dBA8d = parcelRequire("dBA8d");

var $92mV1 = parcelRequire("92mV1");

var $7cJQd = parcelRequire("7cJQd");

var $2sFbK = parcelRequire("2sFbK");

var $16gY4 = parcelRequire("16gY4");
/* MAIN */ const $73b851820af8f2fb$var$Color = {
    /* VARIABLES */ format: {
        keyword: (0, $7cJQd.default),
        hex: (0, $dBA8d.default),
        rgb: (0, $2sFbK.default),
        rgba: (0, $2sFbK.default),
        hsl: (0, $92mV1.default),
        hsla: (0, $92mV1.default)
    },
    /* API */ parse: (color)=>{
        if (typeof color !== 'string') return color;
        const channels = (0, $dBA8d.default).parse(color) || (0, $2sFbK.default).parse(color) || (0, $92mV1.default).parse(color) || (0, $7cJQd.default).parse(color); // Color providers ordered with performance in mind
        if (channels) return channels;
        throw new Error(`Unsupported color format: "${color}"`);
    },
    stringify: (channels)=>{
        // SASS returns a keyword if possible, but we avoid doing that as it's slower and doesn't really add any value
        if (!channels.changed && channels.color) return channels.color;
        if (channels.type.is((0, $16gY4.TYPE).HSL) || channels.data.r === undefined) return (0, $92mV1.default).stringify(channels);
        else if (channels.a < 1 || !Number.isInteger(channels.r) || !Number.isInteger(channels.g) || !Number.isInteger(channels.b)) return (0, $2sFbK.default).stringify(channels);
        else return (0, $dBA8d.default).stringify(channels);
    }
};
var /* EXPORT */ $73b851820af8f2fb$export$2e2bcd8739ae039 = $73b851820af8f2fb$var$Color;

});
parcelRegister("dBA8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e7ac204f3aac347$export$2e2bcd8739ae039);
/* IMPORT */ 

var $brwIY = parcelRequire("brwIY");

var $16gY4 = parcelRequire("16gY4");
/* MAIN */ const $9e7ac204f3aac347$var$Hex = {
    /* VARIABLES */ re: /^#((?:[a-f0-9]{2}){2,4}|[a-f0-9]{3})$/i,
    /* API */ parse: (color)=>{
        if (color.charCodeAt(0) !== 35) return; // '#'
        const match = color.match($9e7ac204f3aac347$var$Hex.re);
        if (!match) return;
        const hex = match[1];
        const dec = parseInt(hex, 16);
        const length = hex.length;
        const hasAlpha = length % 4 === 0;
        const isFullLength = length > 4;
        const multiplier = isFullLength ? 1 : 17;
        const bits = isFullLength ? 8 : 4;
        const bitsOffset = hasAlpha ? 0 : -1;
        const mask = isFullLength ? 255 : 15;
        return (0, $brwIY.default).set({
            r: (dec >> bits * (bitsOffset + 3) & mask) * multiplier,
            g: (dec >> bits * (bitsOffset + 2) & mask) * multiplier,
            b: (dec >> bits * (bitsOffset + 1) & mask) * multiplier,
            a: hasAlpha ? (dec & mask) * multiplier / 255 : 1
        }, color);
    },
    stringify: (channels)=>{
        const { r: r, g: g, b: b, a: a } = channels;
        if (a < 1) return `#${(0, $16gY4.DEC2HEX)[Math.round(r)]}${(0, $16gY4.DEC2HEX)[Math.round(g)]}${(0, $16gY4.DEC2HEX)[Math.round(b)]}${(0, $16gY4.DEC2HEX)[Math.round(a * 255)]}`;
        else return `#${(0, $16gY4.DEC2HEX)[Math.round(r)]}${(0, $16gY4.DEC2HEX)[Math.round(g)]}${(0, $16gY4.DEC2HEX)[Math.round(b)]}`;
    }
};
var /* EXPORT */ $9e7ac204f3aac347$export$2e2bcd8739ae039 = $9e7ac204f3aac347$var$Hex;

});
parcelRegister("brwIY", function(module, exports) {

$parcel$export(module.exports, "default", () => $854b99ae40e07bd1$export$2e2bcd8739ae039);
/* IMPORT */ 
var $frf5R = parcelRequire("frf5R");
/* MAIN */ const $854b99ae40e07bd1$var$channels = new (0, $frf5R.default)({
    r: 0,
    g: 0,
    b: 0,
    a: 0
}, 'transparent');
var /* EXPORT */ $854b99ae40e07bd1$export$2e2bcd8739ae039 = $854b99ae40e07bd1$var$channels;

});
parcelRegister("frf5R", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3d515e64e537b55$export$2e2bcd8739ae039);
/* IMPORT */ 
var $i9He5 = parcelRequire("i9He5");

var $lF5fw = parcelRequire("lF5fw");

var $16gY4 = parcelRequire("16gY4");
/* MAIN */ class $b3d515e64e537b55$var$Channels {
    /* CONSTRUCTOR */ constructor(data, color){
        this.color = color;
        this.changed = false;
        this.data = data; //TSC
        this.type = new (0, $lF5fw.default)();
    }
    /* API */ set(data, color) {
        this.color = color;
        this.changed = false;
        this.data = data; //TSC
        this.type.type = (0, $16gY4.TYPE).ALL;
        return this;
    }
    /* HELPERS */ _ensureHSL() {
        const data = this.data;
        const { h: h, s: s, l: l } = data;
        if (h === undefined) data.h = (0, $i9He5.default).channel.rgb2hsl(data, 'h');
        if (s === undefined) data.s = (0, $i9He5.default).channel.rgb2hsl(data, 's');
        if (l === undefined) data.l = (0, $i9He5.default).channel.rgb2hsl(data, 'l');
    }
    _ensureRGB() {
        const data = this.data;
        const { r: r, g: g, b: b } = data;
        if (r === undefined) data.r = (0, $i9He5.default).channel.hsl2rgb(data, 'r');
        if (g === undefined) data.g = (0, $i9He5.default).channel.hsl2rgb(data, 'g');
        if (b === undefined) data.b = (0, $i9He5.default).channel.hsl2rgb(data, 'b');
    }
    /* GETTERS */ get r() {
        const data = this.data;
        const r = data.r;
        if (!this.type.is((0, $16gY4.TYPE).HSL) && r !== undefined) return r;
        this._ensureHSL();
        return (0, $i9He5.default).channel.hsl2rgb(data, 'r');
    }
    get g() {
        const data = this.data;
        const g = data.g;
        if (!this.type.is((0, $16gY4.TYPE).HSL) && g !== undefined) return g;
        this._ensureHSL();
        return (0, $i9He5.default).channel.hsl2rgb(data, 'g');
    }
    get b() {
        const data = this.data;
        const b = data.b;
        if (!this.type.is((0, $16gY4.TYPE).HSL) && b !== undefined) return b;
        this._ensureHSL();
        return (0, $i9He5.default).channel.hsl2rgb(data, 'b');
    }
    get h() {
        const data = this.data;
        const h = data.h;
        if (!this.type.is((0, $16gY4.TYPE).RGB) && h !== undefined) return h;
        this._ensureRGB();
        return (0, $i9He5.default).channel.rgb2hsl(data, 'h');
    }
    get s() {
        const data = this.data;
        const s = data.s;
        if (!this.type.is((0, $16gY4.TYPE).RGB) && s !== undefined) return s;
        this._ensureRGB();
        return (0, $i9He5.default).channel.rgb2hsl(data, 's');
    }
    get l() {
        const data = this.data;
        const l = data.l;
        if (!this.type.is((0, $16gY4.TYPE).RGB) && l !== undefined) return l;
        this._ensureRGB();
        return (0, $i9He5.default).channel.rgb2hsl(data, 'l');
    }
    get a() {
        return this.data.a;
    }
    /* SETTERS */ set r(r) {
        this.type.set((0, $16gY4.TYPE).RGB);
        this.changed = true;
        this.data.r = r;
    }
    set g(g) {
        this.type.set((0, $16gY4.TYPE).RGB);
        this.changed = true;
        this.data.g = g;
    }
    set b(b) {
        this.type.set((0, $16gY4.TYPE).RGB);
        this.changed = true;
        this.data.b = b;
    }
    set h(h) {
        this.type.set((0, $16gY4.TYPE).HSL);
        this.changed = true;
        this.data.h = h;
    }
    set s(s) {
        this.type.set((0, $16gY4.TYPE).HSL);
        this.changed = true;
        this.data.s = s;
    }
    set l(l) {
        this.type.set((0, $16gY4.TYPE).HSL);
        this.changed = true;
        this.data.l = l;
    }
    set a(a) {
        this.changed = true;
        this.data.a = a;
    }
}
var /* EXPORT */ $b3d515e64e537b55$export$2e2bcd8739ae039 = $b3d515e64e537b55$var$Channels;

});
parcelRegister("i9He5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d37a9913ae2934c3$export$2e2bcd8739ae039);
/* IMPORT */ 
var $6GOKv = parcelRequire("6GOKv");

var $9tLmx = parcelRequire("9tLmx");

var $jIhm9 = parcelRequire("jIhm9");
/* MAIN */ const $d37a9913ae2934c3$var$Utils = {
    channel: $6GOKv.default,
    lang: $9tLmx.default,
    unit: $jIhm9.default
};
var /* EXPORT */ $d37a9913ae2934c3$export$2e2bcd8739ae039 = $d37a9913ae2934c3$var$Utils;

});
parcelRegister("6GOKv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dee08072568e759$export$2e2bcd8739ae039);
/* IMPORT */ /* MAIN */ const $4dee08072568e759$var$Channel = {
    /* CLAMP */ min: {
        r: 0,
        g: 0,
        b: 0,
        s: 0,
        l: 0,
        a: 0
    },
    max: {
        r: 255,
        g: 255,
        b: 255,
        h: 360,
        s: 100,
        l: 100,
        a: 1
    },
    clamp: {
        r: (r)=>r >= 255 ? 255 : r < 0 ? 0 : r,
        g: (g)=>g >= 255 ? 255 : g < 0 ? 0 : g,
        b: (b)=>b >= 255 ? 255 : b < 0 ? 0 : b,
        h: (h)=>h % 360,
        s: (s)=>s >= 100 ? 100 : s < 0 ? 0 : s,
        l: (l)=>l >= 100 ? 100 : l < 0 ? 0 : l,
        a: (a)=>a >= 1 ? 1 : a < 0 ? 0 : a
    },
    /* CONVERSION */ //SOURCE: https://planetcalc.com/7779
    toLinear: (c)=>{
        const n = c / 255;
        return c > .03928 ? Math.pow((n + .055) / 1.055, 2.4) : n / 12.92;
    },
    //SOURCE: https://gist.github.com/mjackson/5311256
    hue2rgb: (p, q, t)=>{
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    },
    hsl2rgb: ({ h: h, s: s, l: l }, channel)=>{
        if (!s) return l * 2.55; // Achromatic
        h /= 360;
        s /= 100;
        l /= 100;
        const q = l < .5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        switch(channel){
            case 'r':
                return $4dee08072568e759$var$Channel.hue2rgb(p, q, h + 1 / 3) * 255;
            case 'g':
                return $4dee08072568e759$var$Channel.hue2rgb(p, q, h) * 255;
            case 'b':
                return $4dee08072568e759$var$Channel.hue2rgb(p, q, h - 1 / 3) * 255;
        }
    },
    rgb2hsl: ({ r: r, g: g, b: b }, channel)=>{
        r /= 255;
        g /= 255;
        b /= 255;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        const l = (max + min) / 2;
        if (channel === 'l') return l * 100;
        if (max === min) return 0; // Achromatic
        const d = max - min;
        const s = l > .5 ? d / (2 - max - min) : d / (max + min);
        if (channel === 's') return s * 100;
        switch(max){
            case r:
                return ((g - b) / d + (g < b ? 6 : 0)) * 60;
            case g:
                return ((b - r) / d + 2) * 60;
            case b:
                return ((r - g) / d + 4) * 60;
            default:
                return -1; //TSC: TypeScript is stupid and complains if there isn't this useless default statement
        }
    }
};
var /* EXPORT */ $4dee08072568e759$export$2e2bcd8739ae039 = $4dee08072568e759$var$Channel;

});

parcelRegister("9tLmx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e6b8fb52ce08536$export$2e2bcd8739ae039);
/* MAIN */ const $6e6b8fb52ce08536$var$Lang = {
    /* API */ clamp: (number, lower, upper)=>{
        if (lower > upper) return Math.min(lower, Math.max(upper, number));
        return Math.min(upper, Math.max(lower, number));
    },
    round: (number)=>{
        return Math.round(number * 10000000000) / 10000000000;
    }
};
var /* EXPORT */ $6e6b8fb52ce08536$export$2e2bcd8739ae039 = $6e6b8fb52ce08536$var$Lang;

});

parcelRegister("jIhm9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e59f96fde87def9c$export$2e2bcd8739ae039);
/* MAIN */ const $e59f96fde87def9c$var$Unit = {
    /* API */ dec2hex: (dec)=>{
        const hex = Math.round(dec).toString(16);
        return hex.length > 1 ? hex : `0${hex}`;
    }
};
var /* EXPORT */ $e59f96fde87def9c$export$2e2bcd8739ae039 = $e59f96fde87def9c$var$Unit;

});


parcelRegister("lF5fw", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc517fb7e904c8c6$export$2e2bcd8739ae039);
/* IMPORT */ 
var $16gY4 = parcelRequire("16gY4");
/* MAIN */ class $fc517fb7e904c8c6$var$Type {
    constructor(){
        /* VARIABLES */ this.type = (0, $16gY4.TYPE).ALL;
    }
    /* API */ get() {
        return this.type;
    }
    set(type) {
        if (this.type && this.type !== type) throw new Error('Cannot change both RGB and HSL channels at the same time');
        this.type = type;
    }
    reset() {
        this.type = (0, $16gY4.TYPE).ALL;
    }
    is(type) {
        return this.type === type;
    }
}
var /* EXPORT */ $fc517fb7e904c8c6$export$2e2bcd8739ae039 = $fc517fb7e904c8c6$var$Type;

});
parcelRegister("16gY4", function(module, exports) {

$parcel$export(module.exports, "DEC2HEX", () => $0cd3836f9334f96c$export$ad5283b633ba7d15);
$parcel$export(module.exports, "TYPE", () => $0cd3836f9334f96c$export$b87f371cbc396fcf);
/* IMPORT */ 
var $i9He5 = parcelRequire("i9He5");
/* MAIN */ const $0cd3836f9334f96c$export$ad5283b633ba7d15 = {};
for(let i = 0; i <= 255; i++)$0cd3836f9334f96c$export$ad5283b633ba7d15[i] = (0, $i9He5.default).unit.dec2hex(i); // Populating dynamically, striking a balance between code size and performance
const $0cd3836f9334f96c$export$b87f371cbc396fcf = {
    ALL: 0,
    RGB: 1,
    HSL: 2
};

});





parcelRegister("92mV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6946141e9edd75c9$export$2e2bcd8739ae039);
/* IMPORT */ 
var $i9He5 = parcelRequire("i9He5");

var $brwIY = parcelRequire("brwIY");
/* MAIN */ const $6946141e9edd75c9$var$HSL = {
    /* VARIABLES */ re: /^hsla?\(\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e-?\d+)?(?:deg|grad|rad|turn)?)\s*?(?:,|\s)\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e-?\d+)?%)\s*?(?:,|\s)\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e-?\d+)?%)(?:\s*?(?:,|\/)\s*?\+?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e-?\d+)?(%)?))?\s*?\)$/i,
    hueRe: /^(.+?)(deg|grad|rad|turn)$/i,
    /* HELPERS */ _hue2deg: (hue)=>{
        const match = hue.match($6946141e9edd75c9$var$HSL.hueRe);
        if (match) {
            const [, number, unit] = match;
            switch(unit){
                case 'grad':
                    return (0, $i9He5.default).channel.clamp.h(parseFloat(number) * .9);
                case 'rad':
                    return (0, $i9He5.default).channel.clamp.h(parseFloat(number) * 180 / Math.PI);
                case 'turn':
                    return (0, $i9He5.default).channel.clamp.h(parseFloat(number) * 360);
            }
        }
        return (0, $i9He5.default).channel.clamp.h(parseFloat(hue));
    },
    /* API */ parse: (color)=>{
        const charCode = color.charCodeAt(0);
        if (charCode !== 104 && charCode !== 72) return; // 'h'/'H'
        const match = color.match($6946141e9edd75c9$var$HSL.re);
        if (!match) return;
        const [, h, s, l, a, isAlphaPercentage] = match;
        return (0, $brwIY.default).set({
            h: $6946141e9edd75c9$var$HSL._hue2deg(h),
            s: (0, $i9He5.default).channel.clamp.s(parseFloat(s)),
            l: (0, $i9He5.default).channel.clamp.l(parseFloat(l)),
            a: a ? (0, $i9He5.default).channel.clamp.a(isAlphaPercentage ? parseFloat(a) / 100 : parseFloat(a)) : 1
        }, color);
    },
    stringify: (channels)=>{
        const { h: h, s: s, l: l, a: a } = channels;
        if (a < 1) return `hsla(${(0, $i9He5.default).lang.round(h)}, ${(0, $i9He5.default).lang.round(s)}%, ${(0, $i9He5.default).lang.round(l)}%, ${a})`;
        else return `hsl(${(0, $i9He5.default).lang.round(h)}, ${(0, $i9He5.default).lang.round(s)}%, ${(0, $i9He5.default).lang.round(l)}%)`;
    }
};
var /* EXPORT */ $6946141e9edd75c9$export$2e2bcd8739ae039 = $6946141e9edd75c9$var$HSL;

});

parcelRegister("7cJQd", function(module, exports) {

$parcel$export(module.exports, "default", () => $53ed3683ceb860aa$export$2e2bcd8739ae039);
/* IMPORT */ 
var $dBA8d = parcelRequire("dBA8d");
/* MAIN */ const $53ed3683ceb860aa$var$Keyword = {
    /* VARIABLES */ colors: {
        aliceblue: '#f0f8ff',
        antiquewhite: '#faebd7',
        aqua: '#00ffff',
        aquamarine: '#7fffd4',
        azure: '#f0ffff',
        beige: '#f5f5dc',
        bisque: '#ffe4c4',
        black: '#000000',
        blanchedalmond: '#ffebcd',
        blue: '#0000ff',
        blueviolet: '#8a2be2',
        brown: '#a52a2a',
        burlywood: '#deb887',
        cadetblue: '#5f9ea0',
        chartreuse: '#7fff00',
        chocolate: '#d2691e',
        coral: '#ff7f50',
        cornflowerblue: '#6495ed',
        cornsilk: '#fff8dc',
        crimson: '#dc143c',
        cyanaqua: '#00ffff',
        darkblue: '#00008b',
        darkcyan: '#008b8b',
        darkgoldenrod: '#b8860b',
        darkgray: '#a9a9a9',
        darkgreen: '#006400',
        darkgrey: '#a9a9a9',
        darkkhaki: '#bdb76b',
        darkmagenta: '#8b008b',
        darkolivegreen: '#556b2f',
        darkorange: '#ff8c00',
        darkorchid: '#9932cc',
        darkred: '#8b0000',
        darksalmon: '#e9967a',
        darkseagreen: '#8fbc8f',
        darkslateblue: '#483d8b',
        darkslategray: '#2f4f4f',
        darkslategrey: '#2f4f4f',
        darkturquoise: '#00ced1',
        darkviolet: '#9400d3',
        deeppink: '#ff1493',
        deepskyblue: '#00bfff',
        dimgray: '#696969',
        dimgrey: '#696969',
        dodgerblue: '#1e90ff',
        firebrick: '#b22222',
        floralwhite: '#fffaf0',
        forestgreen: '#228b22',
        fuchsia: '#ff00ff',
        gainsboro: '#dcdcdc',
        ghostwhite: '#f8f8ff',
        gold: '#ffd700',
        goldenrod: '#daa520',
        gray: '#808080',
        green: '#008000',
        greenyellow: '#adff2f',
        grey: '#808080',
        honeydew: '#f0fff0',
        hotpink: '#ff69b4',
        indianred: '#cd5c5c',
        indigo: '#4b0082',
        ivory: '#fffff0',
        khaki: '#f0e68c',
        lavender: '#e6e6fa',
        lavenderblush: '#fff0f5',
        lawngreen: '#7cfc00',
        lemonchiffon: '#fffacd',
        lightblue: '#add8e6',
        lightcoral: '#f08080',
        lightcyan: '#e0ffff',
        lightgoldenrodyellow: '#fafad2',
        lightgray: '#d3d3d3',
        lightgreen: '#90ee90',
        lightgrey: '#d3d3d3',
        lightpink: '#ffb6c1',
        lightsalmon: '#ffa07a',
        lightseagreen: '#20b2aa',
        lightskyblue: '#87cefa',
        lightslategray: '#778899',
        lightslategrey: '#778899',
        lightsteelblue: '#b0c4de',
        lightyellow: '#ffffe0',
        lime: '#00ff00',
        limegreen: '#32cd32',
        linen: '#faf0e6',
        magenta: '#ff00ff',
        maroon: '#800000',
        mediumaquamarine: '#66cdaa',
        mediumblue: '#0000cd',
        mediumorchid: '#ba55d3',
        mediumpurple: '#9370db',
        mediumseagreen: '#3cb371',
        mediumslateblue: '#7b68ee',
        mediumspringgreen: '#00fa9a',
        mediumturquoise: '#48d1cc',
        mediumvioletred: '#c71585',
        midnightblue: '#191970',
        mintcream: '#f5fffa',
        mistyrose: '#ffe4e1',
        moccasin: '#ffe4b5',
        navajowhite: '#ffdead',
        navy: '#000080',
        oldlace: '#fdf5e6',
        olive: '#808000',
        olivedrab: '#6b8e23',
        orange: '#ffa500',
        orangered: '#ff4500',
        orchid: '#da70d6',
        palegoldenrod: '#eee8aa',
        palegreen: '#98fb98',
        paleturquoise: '#afeeee',
        palevioletred: '#db7093',
        papayawhip: '#ffefd5',
        peachpuff: '#ffdab9',
        peru: '#cd853f',
        pink: '#ffc0cb',
        plum: '#dda0dd',
        powderblue: '#b0e0e6',
        purple: '#800080',
        rebeccapurple: '#663399',
        red: '#ff0000',
        rosybrown: '#bc8f8f',
        royalblue: '#4169e1',
        saddlebrown: '#8b4513',
        salmon: '#fa8072',
        sandybrown: '#f4a460',
        seagreen: '#2e8b57',
        seashell: '#fff5ee',
        sienna: '#a0522d',
        silver: '#c0c0c0',
        skyblue: '#87ceeb',
        slateblue: '#6a5acd',
        slategray: '#708090',
        slategrey: '#708090',
        snow: '#fffafa',
        springgreen: '#00ff7f',
        tan: '#d2b48c',
        teal: '#008080',
        thistle: '#d8bfd8',
        transparent: '#00000000',
        turquoise: '#40e0d0',
        violet: '#ee82ee',
        wheat: '#f5deb3',
        white: '#ffffff',
        whitesmoke: '#f5f5f5',
        yellow: '#ffff00',
        yellowgreen: '#9acd32'
    },
    /* API */ parse: (color)=>{
        color = color.toLowerCase();
        const hex = $53ed3683ceb860aa$var$Keyword.colors[color];
        if (!hex) return;
        return (0, $dBA8d.default).parse(hex);
    },
    stringify: (channels)=>{
        const hex = (0, $dBA8d.default).stringify(channels);
        for(const name in $53ed3683ceb860aa$var$Keyword.colors){
            if ($53ed3683ceb860aa$var$Keyword.colors[name] === hex) return name;
        }
        return;
    }
};
var /* EXPORT */ $53ed3683ceb860aa$export$2e2bcd8739ae039 = $53ed3683ceb860aa$var$Keyword;

});

parcelRegister("2sFbK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cae2575573d7819$export$2e2bcd8739ae039);
/* IMPORT */ 
var $i9He5 = parcelRequire("i9He5");

var $brwIY = parcelRequire("brwIY");
/* MAIN */ const $1cae2575573d7819$var$RGB = {
    /* VARIABLES */ re: /^rgba?\(\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e\d+)?(%?))\s*?(?:,|\s)\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e\d+)?(%?))\s*?(?:,|\s)\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e\d+)?(%?))(?:\s*?(?:,|\/)\s*?\+?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e\d+)?(%?)))?\s*?\)$/i,
    /* API */ parse: (color)=>{
        const charCode = color.charCodeAt(0);
        if (charCode !== 114 && charCode !== 82) return; // 'r'/'R'
        const match = color.match($1cae2575573d7819$var$RGB.re);
        if (!match) return;
        const [, r, isRedPercentage, g, isGreenPercentage, b, isBluePercentage, a, isAlphaPercentage] = match;
        return (0, $brwIY.default).set({
            r: (0, $i9He5.default).channel.clamp.r(isRedPercentage ? parseFloat(r) * 2.55 : parseFloat(r)),
            g: (0, $i9He5.default).channel.clamp.g(isGreenPercentage ? parseFloat(g) * 2.55 : parseFloat(g)),
            b: (0, $i9He5.default).channel.clamp.b(isBluePercentage ? parseFloat(b) * 2.55 : parseFloat(b)),
            a: a ? (0, $i9He5.default).channel.clamp.a(isAlphaPercentage ? parseFloat(a) / 100 : parseFloat(a)) : 1
        }, color);
    },
    stringify: (channels)=>{
        const { r: r, g: g, b: b, a: a } = channels;
        if (a < 1) return `rgba(${(0, $i9He5.default).lang.round(r)}, ${(0, $i9He5.default).lang.round(g)}, ${(0, $i9He5.default).lang.round(b)}, ${(0, $i9He5.default).lang.round(a)})`;
        else return `rgb(${(0, $i9He5.default).lang.round(r)}, ${(0, $i9He5.default).lang.round(g)}, ${(0, $i9He5.default).lang.round(b)})`;
    }
};
var /* EXPORT */ $1cae2575573d7819$export$2e2bcd8739ae039 = $1cae2575573d7819$var$RGB;

});


parcelRegister("fQvWs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8947d52bd60109c$export$2e2bcd8739ae039);
/* IMPORT */ 
var $i9He5 = parcelRequire("i9He5");

var $9VYra = parcelRequire("9VYra");
/* MAIN */ const $b8947d52bd60109c$var$change = (color, channels)=>{
    const ch = (0, $9VYra.default).parse(color);
    for(const c in channels)ch[c] = (0, $i9He5.default).channel.clamp[c](channels[c]);
    return (0, $9VYra.default).stringify(ch);
};
var /* EXPORT */ $b8947d52bd60109c$export$2e2bcd8739ae039 = $b8947d52bd60109c$var$change;

});


parcelRegister("c94qS", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d79c383ce73afe1$export$2e2bcd8739ae039);
/* IMPORT */ 
var $23Q7e = parcelRequire("23Q7e");
/* MAIN */ const $8d79c383ce73afe1$var$darken = (color, amount)=>{
    return (0, $23Q7e.default)(color, 'l', -amount);
};
var /* EXPORT */ $8d79c383ce73afe1$export$2e2bcd8739ae039 = $8d79c383ce73afe1$var$darken;

});
parcelRegister("23Q7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $180449a7ea225c89$export$2e2bcd8739ae039);
/* IMPORT */ 
var $i9He5 = parcelRequire("i9He5");

var $9VYra = parcelRequire("9VYra");
/* MAIN */ const $180449a7ea225c89$var$adjustChannel = (color, channel, amount)=>{
    const channels = (0, $9VYra.default).parse(color);
    const amountCurrent = channels[channel];
    const amountNext = (0, $i9He5.default).channel.clamp[channel](amountCurrent + amount);
    if (amountCurrent !== amountNext) channels[channel] = amountNext;
    return (0, $9VYra.default).stringify(channels);
};
var /* EXPORT */ $180449a7ea225c89$export$2e2bcd8739ae039 = $180449a7ea225c89$var$adjustChannel;

});


parcelRegister("1LW8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $14a7476243afde53$export$2e2bcd8739ae039);
/* IMPORT */ 
var $9VYra = parcelRequire("9VYra");

var $9L03X = parcelRequire("9L03X");
/* MAIN */ const $14a7476243afde53$var$invert = (color, weight = 100)=>{
    const inverse = (0, $9VYra.default).parse(color);
    inverse.r = 255 - inverse.r;
    inverse.g = 255 - inverse.g;
    inverse.b = 255 - inverse.b;
    return (0, $9L03X.default)(inverse, color, weight);
};
var /* EXPORT */ $14a7476243afde53$export$2e2bcd8739ae039 = $14a7476243afde53$var$invert;

});
parcelRegister("9L03X", function(module, exports) {

$parcel$export(module.exports, "default", () => $71a88d4bf49dee44$export$2e2bcd8739ae039);
/* IMPORT */ 
var $9VYra = parcelRequire("9VYra");

var $b1Vti = parcelRequire("b1Vti");
/* MAIN */ //SOURCE: https://github.com/sass/dart-sass/blob/7457d2e9e7e623d9844ffd037a070cf32d39c348/lib/src/functions/color.dart#L718-L756
const $71a88d4bf49dee44$var$mix = (color1, color2, weight = 50)=>{
    const { r: r1, g: g1, b: b1, a: a1 } = (0, $9VYra.default).parse(color1);
    const { r: r2, g: g2, b: b2, a: a2 } = (0, $9VYra.default).parse(color2);
    const weightScale = weight / 100;
    const weightNormalized = weightScale * 2 - 1;
    const alphaDelta = a1 - a2;
    const weight1combined = weightNormalized * alphaDelta === -1 ? weightNormalized : (weightNormalized + alphaDelta) / (1 + weightNormalized * alphaDelta);
    const weight1 = (weight1combined + 1) / 2;
    const weight2 = 1 - weight1;
    const r = r1 * weight1 + r2 * weight2;
    const g = g1 * weight1 + g2 * weight2;
    const b = b1 * weight1 + b2 * weight2;
    const a = a1 * weightScale + a2 * (1 - weightScale);
    return (0, $b1Vti.default)(r, g, b, a);
};
var /* EXPORT */ $71a88d4bf49dee44$export$2e2bcd8739ae039 = $71a88d4bf49dee44$var$mix;

});
parcelRegister("b1Vti", function(module, exports) {

$parcel$export(module.exports, "default", () => $807c5e5fa0bb8ef9$export$2e2bcd8739ae039);
/* IMPORT */ 
var $i9He5 = parcelRequire("i9He5");

var $brwIY = parcelRequire("brwIY");

var $9VYra = parcelRequire("9VYra");

var $fQvWs = parcelRequire("fQvWs");
/* MAIN */ const $807c5e5fa0bb8ef9$var$rgba = (r, g, b = 0, a = 1)=>{
    if (typeof r !== 'number') return (0, $fQvWs.default)(r, {
        a: g
    });
    const channels = (0, $brwIY.default).set({
        r: (0, $i9He5.default).channel.clamp.r(r),
        g: (0, $i9He5.default).channel.clamp.g(g),
        b: (0, $i9He5.default).channel.clamp.b(b),
        a: (0, $i9He5.default).channel.clamp.a(a)
    });
    return (0, $9VYra.default).stringify(channels);
};
var /* EXPORT */ $807c5e5fa0bb8ef9$export$2e2bcd8739ae039 = $807c5e5fa0bb8ef9$var$rgba;

});



parcelRegister("75Ue8", function(module, exports) {

$parcel$export(module.exports, "default", () => $52a49d8ab10aa029$export$2e2bcd8739ae039);
/* IMPORT */ 
var $aKyob = parcelRequire("aKyob");
/* MAIN */ const $52a49d8ab10aa029$var$isDark = (color)=>{
    return !(0, $aKyob.default)(color);
};
var /* EXPORT */ $52a49d8ab10aa029$export$2e2bcd8739ae039 = $52a49d8ab10aa029$var$isDark;

});
parcelRegister("aKyob", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d38e03a3b8988aa$export$2e2bcd8739ae039);
/* IMPORT */ 
var $4unen = parcelRequire("4unen");
/* MAIN */ const $7d38e03a3b8988aa$var$isLight = (color)=>{
    return (0, $4unen.default)(color) >= .5;
};
var /* EXPORT */ $7d38e03a3b8988aa$export$2e2bcd8739ae039 = $7d38e03a3b8988aa$var$isLight;

});
parcelRegister("4unen", function(module, exports) {

$parcel$export(module.exports, "default", () => $344bfbec30e92bbf$export$2e2bcd8739ae039);
/* IMPORT */ 
var $i9He5 = parcelRequire("i9He5");

var $9VYra = parcelRequire("9VYra");
/* MAIN */ //SOURCE: https://planetcalc.com/7779
const $344bfbec30e92bbf$var$luminance = (color)=>{
    const { r: r, g: g, b: b } = (0, $9VYra.default).parse(color);
    const luminance = .2126 * (0, $i9He5.default).channel.toLinear(r) + .7152 * (0, $i9He5.default).channel.toLinear(g) + .0722 * (0, $i9He5.default).channel.toLinear(b);
    return (0, $i9He5.default).lang.round(luminance);
};
var /* EXPORT */ $344bfbec30e92bbf$export$2e2bcd8739ae039 = $344bfbec30e92bbf$var$luminance;

});



parcelRegister("1Ez1E", function(module, exports) {

$parcel$export(module.exports, "default", () => $1344b2376859816e$export$2e2bcd8739ae039);
/* IMPORT */ 
var $23Q7e = parcelRequire("23Q7e");
/* MAIN */ const $1344b2376859816e$var$lighten = (color, amount)=>{
    return (0, $23Q7e.default)(color, 'l', amount);
};
var /* EXPORT */ $1344b2376859816e$export$2e2bcd8739ae039 = $1344b2376859816e$var$lighten;

});

parcelRegister("e21Zk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a372cb680e5e1128$export$2e2bcd8739ae039);

var $7n3PR = parcelRequire("7n3PR");
/** Error message constants. */ var $a372cb680e5e1128$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $a372cb680e5e1128$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($a372cb680e5e1128$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($a372cb680e5e1128$var$memoize.Cache || (0, $7n3PR.default));
    return memoized;
}
// Expose `MapCache`.
$a372cb680e5e1128$var$memoize.Cache = (0, $7n3PR.default);
var $a372cb680e5e1128$export$2e2bcd8739ae039 = $a372cb680e5e1128$var$memoize;

});
parcelRegister("7n3PR", function(module, exports) {

$parcel$export(module.exports, "default", () => $55dda8022ba8f51a$export$2e2bcd8739ae039);

var $bAMUC = parcelRequire("bAMUC");

var $56mPM = parcelRequire("56mPM");

var $428kg = parcelRequire("428kg");

var $jYsb1 = parcelRequire("jYsb1");

var $5XP4x = parcelRequire("5XP4x");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $55dda8022ba8f51a$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$55dda8022ba8f51a$var$MapCache.prototype.clear = (0, $bAMUC.default);
$55dda8022ba8f51a$var$MapCache.prototype['delete'] = (0, $56mPM.default);
$55dda8022ba8f51a$var$MapCache.prototype.get = (0, $428kg.default);
$55dda8022ba8f51a$var$MapCache.prototype.has = (0, $jYsb1.default);
$55dda8022ba8f51a$var$MapCache.prototype.set = (0, $5XP4x.default);
var $55dda8022ba8f51a$export$2e2bcd8739ae039 = $55dda8022ba8f51a$var$MapCache;

});
parcelRegister("bAMUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8708ff73733b2f97$export$2e2bcd8739ae039);

var $lSo3Y = parcelRequire("lSo3Y");

var $kVnfZ = parcelRequire("kVnfZ");

var $fs3H6 = parcelRequire("fs3H6");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $8708ff73733b2f97$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $lSo3Y.default),
        'map': new ((0, $fs3H6.default) || (0, $kVnfZ.default)),
        'string': new (0, $lSo3Y.default)
    };
}
var $8708ff73733b2f97$export$2e2bcd8739ae039 = $8708ff73733b2f97$var$mapCacheClear;

});
parcelRegister("lSo3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $fed14e894961a2f6$export$2e2bcd8739ae039);

var $kTYGm = parcelRequire("kTYGm");

var $3NrNW = parcelRequire("3NrNW");

var $lyGZN = parcelRequire("lyGZN");

var $lMA2G = parcelRequire("lMA2G");

var $aKknX = parcelRequire("aKknX");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $fed14e894961a2f6$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$fed14e894961a2f6$var$Hash.prototype.clear = (0, $kTYGm.default);
$fed14e894961a2f6$var$Hash.prototype['delete'] = (0, $3NrNW.default);
$fed14e894961a2f6$var$Hash.prototype.get = (0, $lyGZN.default);
$fed14e894961a2f6$var$Hash.prototype.has = (0, $lMA2G.default);
$fed14e894961a2f6$var$Hash.prototype.set = (0, $aKknX.default);
var $fed14e894961a2f6$export$2e2bcd8739ae039 = $fed14e894961a2f6$var$Hash;

});
parcelRegister("kTYGm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37803ed33a1d3d1$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $f37803ed33a1d3d1$var$hashClear() {
    this.__data__ = (0, $cbYyv.default) ? (0, $cbYyv.default)(null) : {};
    this.size = 0;
}
var $f37803ed33a1d3d1$export$2e2bcd8739ae039 = $f37803ed33a1d3d1$var$hashClear;

});
parcelRegister("cbYyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e057c2da47d85b2$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");
/* Built-in method references that are verified to be native. */ var $8e057c2da47d85b2$var$nativeCreate = (0, $jLT9P.default)(Object, 'create');
var $8e057c2da47d85b2$export$2e2bcd8739ae039 = $8e057c2da47d85b2$var$nativeCreate;

});
parcelRegister("jLT9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e64d313d457435ee$export$2e2bcd8739ae039);

var $hJ8AQ = parcelRequire("hJ8AQ");

var $b0QTV = parcelRequire("b0QTV");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e64d313d457435ee$var$getNative(object, key) {
    var value = (0, $b0QTV.default)(object, key);
    return (0, $hJ8AQ.default)(value) ? value : undefined;
}
var $e64d313d457435ee$export$2e2bcd8739ae039 = $e64d313d457435ee$var$getNative;

});
parcelRegister("hJ8AQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce7d4e19db8c5f74$export$2e2bcd8739ae039);

var $4VY3C = parcelRequire("4VY3C");

var $fMWvx = parcelRequire("fMWvx");

var $iYDsF = parcelRequire("iYDsF");

var $5bfPQ = parcelRequire("5bfPQ");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $ce7d4e19db8c5f74$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $ce7d4e19db8c5f74$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $ce7d4e19db8c5f74$var$funcProto = Function.prototype, $ce7d4e19db8c5f74$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $ce7d4e19db8c5f74$var$funcToString = $ce7d4e19db8c5f74$var$funcProto.toString;
/** Used to check objects for own properties. */ var $ce7d4e19db8c5f74$var$hasOwnProperty = $ce7d4e19db8c5f74$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $ce7d4e19db8c5f74$var$reIsNative = RegExp('^' + $ce7d4e19db8c5f74$var$funcToString.call($ce7d4e19db8c5f74$var$hasOwnProperty).replace($ce7d4e19db8c5f74$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $ce7d4e19db8c5f74$var$baseIsNative(value) {
    if (!(0, $iYDsF.default)(value) || (0, $fMWvx.default)(value)) return false;
    var pattern = (0, $4VY3C.default)(value) ? $ce7d4e19db8c5f74$var$reIsNative : $ce7d4e19db8c5f74$var$reIsHostCtor;
    return pattern.test((0, $5bfPQ.default)(value));
}
var $ce7d4e19db8c5f74$export$2e2bcd8739ae039 = $ce7d4e19db8c5f74$var$baseIsNative;

});
parcelRegister("4VY3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $397b12740d7995ef$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $iYDsF = parcelRequire("iYDsF");
/** `Object#toString` result references. */ var $397b12740d7995ef$var$asyncTag = '[object AsyncFunction]', $397b12740d7995ef$var$funcTag = '[object Function]', $397b12740d7995ef$var$genTag = '[object GeneratorFunction]', $397b12740d7995ef$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $397b12740d7995ef$var$isFunction(value) {
    if (!(0, $iYDsF.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $hArsG.default)(value);
    return tag == $397b12740d7995ef$var$funcTag || tag == $397b12740d7995ef$var$genTag || tag == $397b12740d7995ef$var$asyncTag || tag == $397b12740d7995ef$var$proxyTag;
}
var $397b12740d7995ef$export$2e2bcd8739ae039 = $397b12740d7995ef$var$isFunction;

});
parcelRegister("hArsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccdb19c7f0a62300$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $7IZ3R = parcelRequire("7IZ3R");

var $cIkDx = parcelRequire("cIkDx");
/** `Object#toString` result references. */ var $ccdb19c7f0a62300$var$nullTag = '[object Null]', $ccdb19c7f0a62300$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $ccdb19c7f0a62300$var$symToStringTag = (0, $kRxPv.default) ? (0, $kRxPv.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ccdb19c7f0a62300$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ccdb19c7f0a62300$var$undefinedTag : $ccdb19c7f0a62300$var$nullTag;
    return $ccdb19c7f0a62300$var$symToStringTag && $ccdb19c7f0a62300$var$symToStringTag in Object(value) ? (0, $7IZ3R.default)(value) : (0, $cIkDx.default)(value);
}
var $ccdb19c7f0a62300$export$2e2bcd8739ae039 = $ccdb19c7f0a62300$var$baseGetTag;

});
parcelRegister("kRxPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f302ffc9a48734c4$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $f302ffc9a48734c4$var$Symbol = (0, $2mpFt.default).Symbol;
var $f302ffc9a48734c4$export$2e2bcd8739ae039 = $f302ffc9a48734c4$var$Symbol;

});
parcelRegister("2mpFt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b818bf49f333098$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `self`. */ var $1b818bf49f333098$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1b818bf49f333098$var$root = (0, $4kWvg.default) || $1b818bf49f333098$var$freeSelf || Function('return this')();
var $1b818bf49f333098$export$2e2bcd8739ae039 = $1b818bf49f333098$var$root;

});
parcelRegister("4kWvg", function(module, exports) {

$parcel$export(module.exports, "default", () => $32866938ab70cc57$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $32866938ab70cc57$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $32866938ab70cc57$export$2e2bcd8739ae039 = $32866938ab70cc57$var$freeGlobal;

});



parcelRegister("7IZ3R", function(module, exports) {

$parcel$export(module.exports, "default", () => $59fc01f5e412f819$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");
/** Used for built-in method references. */ var $59fc01f5e412f819$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $59fc01f5e412f819$var$hasOwnProperty = $59fc01f5e412f819$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $59fc01f5e412f819$var$nativeObjectToString = $59fc01f5e412f819$var$objectProto.toString;
/** Built-in value references. */ var $59fc01f5e412f819$var$symToStringTag = (0, $kRxPv.default) ? (0, $kRxPv.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $59fc01f5e412f819$var$getRawTag(value) {
    var isOwn = $59fc01f5e412f819$var$hasOwnProperty.call(value, $59fc01f5e412f819$var$symToStringTag), tag = value[$59fc01f5e412f819$var$symToStringTag];
    try {
        value[$59fc01f5e412f819$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $59fc01f5e412f819$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$59fc01f5e412f819$var$symToStringTag] = tag;
        else delete value[$59fc01f5e412f819$var$symToStringTag];
    }
    return result;
}
var $59fc01f5e412f819$export$2e2bcd8739ae039 = $59fc01f5e412f819$var$getRawTag;

});

parcelRegister("cIkDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $94199a1861e07064$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $94199a1861e07064$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $94199a1861e07064$var$nativeObjectToString = $94199a1861e07064$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $94199a1861e07064$var$objectToString(value) {
    return $94199a1861e07064$var$nativeObjectToString.call(value);
}
var $94199a1861e07064$export$2e2bcd8739ae039 = $94199a1861e07064$var$objectToString;

});


parcelRegister("iYDsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0c70c8150db920$export$2e2bcd8739ae039);
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $dd0c70c8150db920$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $dd0c70c8150db920$export$2e2bcd8739ae039 = $dd0c70c8150db920$var$isObject;

});


parcelRegister("fMWvx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7e8b9239f02cfcb$export$2e2bcd8739ae039);

var $gsGrt = parcelRequire("gsGrt");
/** Used to detect methods masquerading as native. */ var $b7e8b9239f02cfcb$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $gsGrt.default) && (0, $gsGrt.default).keys && (0, $gsGrt.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $b7e8b9239f02cfcb$var$isMasked(func) {
    return !!$b7e8b9239f02cfcb$var$maskSrcKey && $b7e8b9239f02cfcb$var$maskSrcKey in func;
}
var $b7e8b9239f02cfcb$export$2e2bcd8739ae039 = $b7e8b9239f02cfcb$var$isMasked;

});
parcelRegister("gsGrt", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfc02efb2c4f5b86$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Used to detect overreaching core-js shims. */ var $bfc02efb2c4f5b86$var$coreJsData = (0, $2mpFt.default)['__core-js_shared__'];
var $bfc02efb2c4f5b86$export$2e2bcd8739ae039 = $bfc02efb2c4f5b86$var$coreJsData;

});


parcelRegister("5bfPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c5a435f91273845$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $3c5a435f91273845$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $3c5a435f91273845$var$funcToString = $3c5a435f91273845$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $3c5a435f91273845$var$toSource(func) {
    if (func != null) {
        try {
            return $3c5a435f91273845$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $3c5a435f91273845$export$2e2bcd8739ae039 = $3c5a435f91273845$var$toSource;

});


parcelRegister("b0QTV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8048bad1174acf1d$export$2e2bcd8739ae039);
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $8048bad1174acf1d$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $8048bad1174acf1d$export$2e2bcd8739ae039 = $8048bad1174acf1d$var$getValue;

});




parcelRegister("3NrNW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c3b841be68d9967$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2c3b841be68d9967$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $2c3b841be68d9967$export$2e2bcd8739ae039 = $2c3b841be68d9967$var$hashDelete;

});

parcelRegister("lyGZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1e2001932a20de$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used to stand-in for `undefined` hash values. */ var $fb1e2001932a20de$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $fb1e2001932a20de$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fb1e2001932a20de$var$hasOwnProperty = $fb1e2001932a20de$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fb1e2001932a20de$var$hashGet(key) {
    var data = this.__data__;
    if (0, $cbYyv.default) {
        var result = data[key];
        return result === $fb1e2001932a20de$var$HASH_UNDEFINED ? undefined : result;
    }
    return $fb1e2001932a20de$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $fb1e2001932a20de$export$2e2bcd8739ae039 = $fb1e2001932a20de$var$hashGet;

});

parcelRegister("lMA2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdba09ea24ad742a$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used for built-in method references. */ var $fdba09ea24ad742a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fdba09ea24ad742a$var$hasOwnProperty = $fdba09ea24ad742a$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fdba09ea24ad742a$var$hashHas(key) {
    var data = this.__data__;
    return (0, $cbYyv.default) ? data[key] !== undefined : $fdba09ea24ad742a$var$hasOwnProperty.call(data, key);
}
var $fdba09ea24ad742a$export$2e2bcd8739ae039 = $fdba09ea24ad742a$var$hashHas;

});

parcelRegister("aKknX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d2e036616ad2fb6$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used to stand-in for `undefined` hash values. */ var $7d2e036616ad2fb6$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $7d2e036616ad2fb6$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $cbYyv.default) && value === undefined ? $7d2e036616ad2fb6$var$HASH_UNDEFINED : value;
    return this;
}
var $7d2e036616ad2fb6$export$2e2bcd8739ae039 = $7d2e036616ad2fb6$var$hashSet;

});


parcelRegister("kVnfZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3bb2bde4f3d2e10$export$2e2bcd8739ae039);

var $htx5f = parcelRequire("htx5f");

var $dEGYX = parcelRequire("dEGYX");

var $eiOY8 = parcelRequire("eiOY8");

var $5yv8I = parcelRequire("5yv8I");

var $67Adw = parcelRequire("67Adw");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f3bb2bde4f3d2e10$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f3bb2bde4f3d2e10$var$ListCache.prototype.clear = (0, $htx5f.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype['delete'] = (0, $dEGYX.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.get = (0, $eiOY8.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.has = (0, $5yv8I.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.set = (0, $67Adw.default);
var $f3bb2bde4f3d2e10$export$2e2bcd8739ae039 = $f3bb2bde4f3d2e10$var$ListCache;

});
parcelRegister("htx5f", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb8ececfecd0309c$export$2e2bcd8739ae039);
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $cb8ececfecd0309c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $cb8ececfecd0309c$export$2e2bcd8739ae039 = $cb8ececfecd0309c$var$listCacheClear;

});

parcelRegister("dEGYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f105a2cb198cf75$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/** Used for built-in method references. */ var $9f105a2cb198cf75$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $9f105a2cb198cf75$var$splice = $9f105a2cb198cf75$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9f105a2cb198cf75$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $9f105a2cb198cf75$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $9f105a2cb198cf75$export$2e2bcd8739ae039 = $9f105a2cb198cf75$var$listCacheDelete;

});
parcelRegister("eWSnX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae20ab4a6778d088$export$2e2bcd8739ae039);

var $lvgV1 = parcelRequire("lvgV1");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ae20ab4a6778d088$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $lvgV1.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $ae20ab4a6778d088$export$2e2bcd8739ae039 = $ae20ab4a6778d088$var$assocIndexOf;

});
parcelRegister("lvgV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa799df2e830873c$export$2e2bcd8739ae039);
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $fa799df2e830873c$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $fa799df2e830873c$export$2e2bcd8739ae039 = $fa799df2e830873c$var$eq;

});



parcelRegister("eiOY8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a69a48810b4d495b$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a69a48810b4d495b$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $a69a48810b4d495b$export$2e2bcd8739ae039 = $a69a48810b4d495b$var$listCacheGet;

});

parcelRegister("5yv8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b84863e34edf18$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $40b84863e34edf18$var$listCacheHas(key) {
    return (0, $eWSnX.default)(this.__data__, key) > -1;
}
var $40b84863e34edf18$export$2e2bcd8739ae039 = $40b84863e34edf18$var$listCacheHas;

});

parcelRegister("67Adw", function(module, exports) {

$parcel$export(module.exports, "default", () => $474f7d7f66ed40d6$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $474f7d7f66ed40d6$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $474f7d7f66ed40d6$export$2e2bcd8739ae039 = $474f7d7f66ed40d6$var$listCacheSet;

});


parcelRegister("fs3H6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3fc56271887eaf3$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $b3fc56271887eaf3$var$Map = (0, $jLT9P.default)((0, $2mpFt.default), 'Map');
var $b3fc56271887eaf3$export$2e2bcd8739ae039 = $b3fc56271887eaf3$var$Map;

});


parcelRegister("56mPM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6f39a956fe6a39$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3b6f39a956fe6a39$var$mapCacheDelete(key) {
    var result = (0, $9vBNU.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $3b6f39a956fe6a39$export$2e2bcd8739ae039 = $3b6f39a956fe6a39$var$mapCacheDelete;

});
parcelRegister("9vBNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ec4556484e81801$export$2e2bcd8739ae039);

var $4WJzL = parcelRequire("4WJzL");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $6ec4556484e81801$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $4WJzL.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $6ec4556484e81801$export$2e2bcd8739ae039 = $6ec4556484e81801$var$getMapData;

});
parcelRegister("4WJzL", function(module, exports) {

$parcel$export(module.exports, "default", () => $399fee9a556f4b4d$export$2e2bcd8739ae039);
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $399fee9a556f4b4d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $399fee9a556f4b4d$export$2e2bcd8739ae039 = $399fee9a556f4b4d$var$isKeyable;

});



parcelRegister("428kg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2efdcea83805e55c$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2efdcea83805e55c$var$mapCacheGet(key) {
    return (0, $9vBNU.default)(this, key).get(key);
}
var $2efdcea83805e55c$export$2e2bcd8739ae039 = $2efdcea83805e55c$var$mapCacheGet;

});

parcelRegister("jYsb1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8a97a3ac9920cdd$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e8a97a3ac9920cdd$var$mapCacheHas(key) {
    return (0, $9vBNU.default)(this, key).has(key);
}
var $e8a97a3ac9920cdd$export$2e2bcd8739ae039 = $e8a97a3ac9920cdd$var$mapCacheHas;

});

parcelRegister("5XP4x", function(module, exports) {

$parcel$export(module.exports, "default", () => $457a144fcd79754e$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $457a144fcd79754e$var$mapCacheSet(key, value) {
    var data = (0, $9vBNU.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $457a144fcd79754e$export$2e2bcd8739ae039 = $457a144fcd79754e$var$mapCacheSet;

});



parcelRegister("gocXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $bee8f03a22cf0d59$export$2e2bcd8739ae039);

var $e7Bvs = parcelRequire("e7Bvs");

var $12iDD = parcelRequire("12iDD");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $bee8f03a22cf0d59$var$merge = (0, $12iDD.default)(function(object, source, srcIndex) {
    (0, $e7Bvs.default)(object, source, srcIndex);
});
var $bee8f03a22cf0d59$export$2e2bcd8739ae039 = $bee8f03a22cf0d59$var$merge;

});
parcelRegister("e7Bvs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a47ed01b5c8928a7$export$2e2bcd8739ae039);

var $9WjpT = parcelRequire("9WjpT");

var $hZfii = parcelRequire("hZfii");

var $RlazS = parcelRequire("RlazS");

var $f8n0l = parcelRequire("f8n0l");

var $iYDsF = parcelRequire("iYDsF");

var $ceNjR = parcelRequire("ceNjR");

var $JLSCP = parcelRequire("JLSCP");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $a47ed01b5c8928a7$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $RlazS.default)(source, function(srcValue, key) {
        stack || (stack = new (0, $9WjpT.default));
        if ((0, $iYDsF.default)(srcValue)) (0, $f8n0l.default)(object, source, key, srcIndex, $a47ed01b5c8928a7$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $JLSCP.default)(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $hZfii.default)(object, key, newValue);
        }
    }, (0, $ceNjR.default));
}
var $a47ed01b5c8928a7$export$2e2bcd8739ae039 = $a47ed01b5c8928a7$var$baseMerge;

});
parcelRegister("9WjpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $73c8979051c99f66$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");

var $czhOX = parcelRequire("czhOX");

var $5QEPI = parcelRequire("5QEPI");

var $lwDUG = parcelRequire("lwDUG");

var $b5lTf = parcelRequire("b5lTf");

var $i8OSr = parcelRequire("i8OSr");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $73c8979051c99f66$var$Stack(entries) {
    var data = this.__data__ = new (0, $kVnfZ.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$73c8979051c99f66$var$Stack.prototype.clear = (0, $czhOX.default);
$73c8979051c99f66$var$Stack.prototype['delete'] = (0, $5QEPI.default);
$73c8979051c99f66$var$Stack.prototype.get = (0, $lwDUG.default);
$73c8979051c99f66$var$Stack.prototype.has = (0, $b5lTf.default);
$73c8979051c99f66$var$Stack.prototype.set = (0, $i8OSr.default);
var $73c8979051c99f66$export$2e2bcd8739ae039 = $73c8979051c99f66$var$Stack;

});
parcelRegister("czhOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $926693c1c5aa1b3b$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $926693c1c5aa1b3b$var$stackClear() {
    this.__data__ = new (0, $kVnfZ.default);
    this.size = 0;
}
var $926693c1c5aa1b3b$export$2e2bcd8739ae039 = $926693c1c5aa1b3b$var$stackClear;

});

parcelRegister("5QEPI", function(module, exports) {

$parcel$export(module.exports, "default", () => $44217bb0c3913906$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44217bb0c3913906$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $44217bb0c3913906$export$2e2bcd8739ae039 = $44217bb0c3913906$var$stackDelete;

});

parcelRegister("lwDUG", function(module, exports) {

$parcel$export(module.exports, "default", () => $fabb8c13d7ec2da0$export$2e2bcd8739ae039);
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fabb8c13d7ec2da0$var$stackGet(key) {
    return this.__data__.get(key);
}
var $fabb8c13d7ec2da0$export$2e2bcd8739ae039 = $fabb8c13d7ec2da0$var$stackGet;

});

parcelRegister("b5lTf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8121243fb2037ab0$export$2e2bcd8739ae039);
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8121243fb2037ab0$var$stackHas(key) {
    return this.__data__.has(key);
}
var $8121243fb2037ab0$export$2e2bcd8739ae039 = $8121243fb2037ab0$var$stackHas;

});

parcelRegister("i8OSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d350707940985b27$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");

var $fs3H6 = parcelRequire("fs3H6");

var $7n3PR = parcelRequire("7n3PR");
/** Used as the size to enable large array optimizations. */ var $d350707940985b27$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $d350707940985b27$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $kVnfZ.default)) {
        var pairs = data.__data__;
        if (!(0, $fs3H6.default) || pairs.length < $d350707940985b27$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $7n3PR.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $d350707940985b27$export$2e2bcd8739ae039 = $d350707940985b27$var$stackSet;

});


parcelRegister("hZfii", function(module, exports) {

$parcel$export(module.exports, "default", () => $d183ff3fc6334acf$export$2e2bcd8739ae039);

var $dLTlW = parcelRequire("dLTlW");

var $lvgV1 = parcelRequire("lvgV1");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $d183ff3fc6334acf$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $lvgV1.default)(object[key], value) || value === undefined && !(key in object)) (0, $dLTlW.default)(object, key, value);
}
var $d183ff3fc6334acf$export$2e2bcd8739ae039 = $d183ff3fc6334acf$var$assignMergeValue;

});
parcelRegister("dLTlW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a06a9a17329ff8a6$export$2e2bcd8739ae039);

var $1RMjB = parcelRequire("1RMjB");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a06a9a17329ff8a6$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $1RMjB.default)) (0, $1RMjB.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $a06a9a17329ff8a6$export$2e2bcd8739ae039 = $a06a9a17329ff8a6$var$baseAssignValue;

});
parcelRegister("1RMjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $15c038100f8779dc$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");
var $15c038100f8779dc$var$defineProperty = function() {
    try {
        var func = (0, $jLT9P.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $15c038100f8779dc$export$2e2bcd8739ae039 = $15c038100f8779dc$var$defineProperty;

});



parcelRegister("RlazS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a055f31ee6b9615$export$2e2bcd8739ae039);

var $XI7zJ = parcelRequire("XI7zJ");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $0a055f31ee6b9615$var$baseFor = (0, $XI7zJ.default)();
var $0a055f31ee6b9615$export$2e2bcd8739ae039 = $0a055f31ee6b9615$var$baseFor;

});
parcelRegister("XI7zJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b37bc59bcb3fc9f$export$2e2bcd8739ae039);
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $0b37bc59bcb3fc9f$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $0b37bc59bcb3fc9f$export$2e2bcd8739ae039 = $0b37bc59bcb3fc9f$var$createBaseFor;

});


parcelRegister("f8n0l", function(module, exports) {

$parcel$export(module.exports, "default", () => $b049729e9a5078ac$export$2e2bcd8739ae039);

var $hZfii = parcelRequire("hZfii");

var $gqoYg = parcelRequire("gqoYg");

var $40E9j = parcelRequire("40E9j");

var $jXStN = parcelRequire("jXStN");

var $7lgl7 = parcelRequire("7lgl7");

var $5VdmZ = parcelRequire("5VdmZ");

var $hf0C9 = parcelRequire("hf0C9");

var $8Y2y0 = parcelRequire("8Y2y0");

var $f3ZL4 = parcelRequire("f3ZL4");

var $4VY3C = parcelRequire("4VY3C");

var $iYDsF = parcelRequire("iYDsF");

var $3rtvu = parcelRequire("3rtvu");

var $cmTeE = parcelRequire("cmTeE");

var $JLSCP = parcelRequire("JLSCP");

var $YMsfP = parcelRequire("YMsfP");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $b049729e9a5078ac$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $JLSCP.default)(object, key), srcValue = (0, $JLSCP.default)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $hZfii.default)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $hf0C9.default)(srcValue), isBuff = !isArr && (0, $f3ZL4.default)(srcValue), isTyped = !isArr && !isBuff && (0, $cmTeE.default)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $hf0C9.default)(objValue)) newValue = objValue;
            else if ((0, $8Y2y0.default)(objValue)) newValue = (0, $jXStN.default)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $gqoYg.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $40E9j.default)(srcValue, true);
            } else newValue = [];
        } else if ((0, $3rtvu.default)(srcValue) || (0, $5VdmZ.default)(srcValue)) {
            newValue = objValue;
            if ((0, $5VdmZ.default)(objValue)) newValue = (0, $YMsfP.default)(objValue);
            else if (!(0, $iYDsF.default)(objValue) || (0, $4VY3C.default)(objValue)) newValue = (0, $7lgl7.default)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    (0, $hZfii.default)(object, key, newValue);
}
var $b049729e9a5078ac$export$2e2bcd8739ae039 = $b049729e9a5078ac$var$baseMergeDeep;

});
parcelRegister("gqoYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf5271c040a1f410$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2mpFt.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $bf5271c040a1f410$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("40E9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb64e5339c21018$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $2eb64e5339c21018$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $9tz5c.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $2eb64e5339c21018$export$2e2bcd8739ae039 = $2eb64e5339c21018$var$cloneTypedArray;

});
parcelRegister("9tz5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e620930bc6a5ada$export$2e2bcd8739ae039);

var $dJVnF = parcelRequire("dJVnF");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $6e620930bc6a5ada$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $dJVnF.default)(result).set(new (0, $dJVnF.default)(arrayBuffer));
    return result;
}
var $6e620930bc6a5ada$export$2e2bcd8739ae039 = $6e620930bc6a5ada$var$cloneArrayBuffer;

});
parcelRegister("dJVnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a00bfcf041d47533$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $a00bfcf041d47533$var$Uint8Array = (0, $2mpFt.default).Uint8Array;
var $a00bfcf041d47533$export$2e2bcd8739ae039 = $a00bfcf041d47533$var$Uint8Array;

});



parcelRegister("jXStN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e88dc98a9c0b5c36$export$2e2bcd8739ae039);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $e88dc98a9c0b5c36$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $e88dc98a9c0b5c36$export$2e2bcd8739ae039 = $e88dc98a9c0b5c36$var$copyArray;

});

parcelRegister("7lgl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $55872b451e11a8ad$export$2e2bcd8739ae039);

var $kgBRQ = parcelRequire("kgBRQ");

var $bzIQZ = parcelRequire("bzIQZ");

var $74QAJ = parcelRequire("74QAJ");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $55872b451e11a8ad$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $74QAJ.default)(object) ? (0, $kgBRQ.default)((0, $bzIQZ.default)(object)) : {};
}
var $55872b451e11a8ad$export$2e2bcd8739ae039 = $55872b451e11a8ad$var$initCloneObject;

});
parcelRegister("kgBRQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec12acf7896f0d70$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");
/** Built-in value references. */ var $ec12acf7896f0d70$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $ec12acf7896f0d70$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $iYDsF.default)(proto)) return {};
        if ($ec12acf7896f0d70$var$objectCreate) return $ec12acf7896f0d70$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $ec12acf7896f0d70$export$2e2bcd8739ae039 = $ec12acf7896f0d70$var$baseCreate;

});

parcelRegister("bzIQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d5c19d81d423c4$export$2e2bcd8739ae039);

var $7N1cZ = parcelRequire("7N1cZ");
/** Built-in value references. */ var $86d5c19d81d423c4$var$getPrototype = (0, $7N1cZ.default)(Object.getPrototypeOf, Object);
var $86d5c19d81d423c4$export$2e2bcd8739ae039 = $86d5c19d81d423c4$var$getPrototype;

});
parcelRegister("7N1cZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5abe0bf7e062106b$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $5abe0bf7e062106b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $5abe0bf7e062106b$export$2e2bcd8739ae039 = $5abe0bf7e062106b$var$overArg;

});


parcelRegister("74QAJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5271b3ac6403835d$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $5271b3ac6403835d$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $5271b3ac6403835d$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $5271b3ac6403835d$var$objectProto;
    return value === proto;
}
var $5271b3ac6403835d$export$2e2bcd8739ae039 = $5271b3ac6403835d$var$isPrototype;

});


parcelRegister("5VdmZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $44fca59879666c41$export$2e2bcd8739ae039);

var $j2nBL = parcelRequire("j2nBL");

var $f2iog = parcelRequire("f2iog");
/** Used for built-in method references. */ var $44fca59879666c41$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $44fca59879666c41$var$hasOwnProperty = $44fca59879666c41$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $44fca59879666c41$var$propertyIsEnumerable = $44fca59879666c41$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $44fca59879666c41$var$isArguments = (0, $j2nBL.default)(function() {
    return arguments;
}()) ? (0, $j2nBL.default) : function(value) {
    return (0, $f2iog.default)(value) && $44fca59879666c41$var$hasOwnProperty.call(value, 'callee') && !$44fca59879666c41$var$propertyIsEnumerable.call(value, 'callee');
};
var $44fca59879666c41$export$2e2bcd8739ae039 = $44fca59879666c41$var$isArguments;

});
parcelRegister("j2nBL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc0844e7eecdb52$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $ddc0844e7eecdb52$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $ddc0844e7eecdb52$var$baseIsArguments(value) {
    return (0, $f2iog.default)(value) && (0, $hArsG.default)(value) == $ddc0844e7eecdb52$var$argsTag;
}
var $ddc0844e7eecdb52$export$2e2bcd8739ae039 = $ddc0844e7eecdb52$var$baseIsArguments;

});
parcelRegister("f2iog", function(module, exports) {

$parcel$export(module.exports, "default", () => $af254ed7460d123e$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $af254ed7460d123e$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $af254ed7460d123e$export$2e2bcd8739ae039 = $af254ed7460d123e$var$isObjectLike;

});



parcelRegister("hf0C9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8d4506109b88831$export$2e2bcd8739ae039);
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c8d4506109b88831$var$isArray = Array.isArray;
var $c8d4506109b88831$export$2e2bcd8739ae039 = $c8d4506109b88831$var$isArray;

});

parcelRegister("8Y2y0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6875e7309728ffbd$export$2e2bcd8739ae039);

var $lAOUf = parcelRequire("lAOUf");

var $f2iog = parcelRequire("f2iog");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $6875e7309728ffbd$var$isArrayLikeObject(value) {
    return (0, $f2iog.default)(value) && (0, $lAOUf.default)(value);
}
var $6875e7309728ffbd$export$2e2bcd8739ae039 = $6875e7309728ffbd$var$isArrayLikeObject;

});
parcelRegister("lAOUf", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb8472aba17743fc$export$2e2bcd8739ae039);

var $4VY3C = parcelRequire("4VY3C");

var $idNmI = parcelRequire("idNmI");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $fb8472aba17743fc$var$isArrayLike(value) {
    return value != null && (0, $idNmI.default)(value.length) && !(0, $4VY3C.default)(value);
}
var $fb8472aba17743fc$export$2e2bcd8739ae039 = $fb8472aba17743fc$var$isArrayLike;

});
parcelRegister("idNmI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43fbbcf5bc665de$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $d43fbbcf5bc665de$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER;
}
var $d43fbbcf5bc665de$export$2e2bcd8739ae039 = $d43fbbcf5bc665de$var$isLength;

});



parcelRegister("f3ZL4", function(module, exports) {

$parcel$export(module.exports, "default", () => $af770abdaf769dee$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");

var $kcGKx = parcelRequire("kcGKx");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2mpFt.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $kcGKx.default);
var $af770abdaf769dee$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("kcGKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb5616d4c933d058$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $eb5616d4c933d058$var$stubFalse() {
    return false;
}
var $eb5616d4c933d058$export$2e2bcd8739ae039 = $eb5616d4c933d058$var$stubFalse;

});


parcelRegister("3rtvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $281ac82f5f5844b1$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $bzIQZ = parcelRequire("bzIQZ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $281ac82f5f5844b1$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $281ac82f5f5844b1$var$funcProto = Function.prototype, $281ac82f5f5844b1$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $281ac82f5f5844b1$var$funcToString = $281ac82f5f5844b1$var$funcProto.toString;
/** Used to check objects for own properties. */ var $281ac82f5f5844b1$var$hasOwnProperty = $281ac82f5f5844b1$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $281ac82f5f5844b1$var$objectCtorString = $281ac82f5f5844b1$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $281ac82f5f5844b1$var$isPlainObject(value) {
    if (!(0, $f2iog.default)(value) || (0, $hArsG.default)(value) != $281ac82f5f5844b1$var$objectTag) return false;
    var proto = (0, $bzIQZ.default)(value);
    if (proto === null) return true;
    var Ctor = $281ac82f5f5844b1$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $281ac82f5f5844b1$var$funcToString.call(Ctor) == $281ac82f5f5844b1$var$objectCtorString;
}
var $281ac82f5f5844b1$export$2e2bcd8739ae039 = $281ac82f5f5844b1$var$isPlainObject;

});

parcelRegister("cmTeE", function(module, exports) {

$parcel$export(module.exports, "default", () => $901262b1d4441a58$export$2e2bcd8739ae039);

var $eaXgH = parcelRequire("eaXgH");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $901262b1d4441a58$var$nodeIsTypedArray = (0, $lFXqE.default) && (0, $lFXqE.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $901262b1d4441a58$var$isTypedArray = $901262b1d4441a58$var$nodeIsTypedArray ? (0, $hb0cD.default)($901262b1d4441a58$var$nodeIsTypedArray) : (0, $eaXgH.default);
var $901262b1d4441a58$export$2e2bcd8739ae039 = $901262b1d4441a58$var$isTypedArray;

});
parcelRegister("eaXgH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a51ff94e4fd33486$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $idNmI = parcelRequire("idNmI");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $a51ff94e4fd33486$var$argsTag = '[object Arguments]', $a51ff94e4fd33486$var$arrayTag = '[object Array]', $a51ff94e4fd33486$var$boolTag = '[object Boolean]', $a51ff94e4fd33486$var$dateTag = '[object Date]', $a51ff94e4fd33486$var$errorTag = '[object Error]', $a51ff94e4fd33486$var$funcTag = '[object Function]', $a51ff94e4fd33486$var$mapTag = '[object Map]', $a51ff94e4fd33486$var$numberTag = '[object Number]', $a51ff94e4fd33486$var$objectTag = '[object Object]', $a51ff94e4fd33486$var$regexpTag = '[object RegExp]', $a51ff94e4fd33486$var$setTag = '[object Set]', $a51ff94e4fd33486$var$stringTag = '[object String]', $a51ff94e4fd33486$var$weakMapTag = '[object WeakMap]';
var $a51ff94e4fd33486$var$arrayBufferTag = '[object ArrayBuffer]', $a51ff94e4fd33486$var$dataViewTag = '[object DataView]', $a51ff94e4fd33486$var$float32Tag = '[object Float32Array]', $a51ff94e4fd33486$var$float64Tag = '[object Float64Array]', $a51ff94e4fd33486$var$int8Tag = '[object Int8Array]', $a51ff94e4fd33486$var$int16Tag = '[object Int16Array]', $a51ff94e4fd33486$var$int32Tag = '[object Int32Array]', $a51ff94e4fd33486$var$uint8Tag = '[object Uint8Array]', $a51ff94e4fd33486$var$uint8ClampedTag = '[object Uint8ClampedArray]', $a51ff94e4fd33486$var$uint16Tag = '[object Uint16Array]', $a51ff94e4fd33486$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $a51ff94e4fd33486$var$typedArrayTags = {};
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float64Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8ClampedTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint32Tag] = true;
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$argsTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayBufferTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$boolTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dataViewTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dateTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$errorTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$funcTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$mapTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$numberTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$objectTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$regexpTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$setTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$stringTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $a51ff94e4fd33486$var$baseIsTypedArray(value) {
    return (0, $f2iog.default)(value) && (0, $idNmI.default)(value.length) && !!$a51ff94e4fd33486$var$typedArrayTags[(0, $hArsG.default)(value)];
}
var $a51ff94e4fd33486$export$2e2bcd8739ae039 = $a51ff94e4fd33486$var$baseIsTypedArray;

});

parcelRegister("hb0cD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8139f05a61e038a$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $c8139f05a61e038a$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $c8139f05a61e038a$export$2e2bcd8739ae039 = $c8139f05a61e038a$var$baseUnary;

});

parcelRegister("lFXqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc7b86a02b9b077f$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $4kWvg.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $fc7b86a02b9b077f$export$2e2bcd8739ae039 = nodeUtil;

});


parcelRegister("JLSCP", function(module, exports) {

$parcel$export(module.exports, "default", () => $08995810b55e3b35$export$2e2bcd8739ae039);
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $08995810b55e3b35$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
var $08995810b55e3b35$export$2e2bcd8739ae039 = $08995810b55e3b35$var$safeGet;

});

parcelRegister("YMsfP", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b6b30ced8685f93$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $ceNjR = parcelRequire("ceNjR");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $0b6b30ced8685f93$var$toPlainObject(value) {
    return (0, $3Wzdm.default)(value, (0, $ceNjR.default)(value));
}
var $0b6b30ced8685f93$export$2e2bcd8739ae039 = $0b6b30ced8685f93$var$toPlainObject;

});
parcelRegister("3Wzdm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2df21abc8bda85fc$export$2e2bcd8739ae039);

var $a6l6i = parcelRequire("a6l6i");

var $dLTlW = parcelRequire("dLTlW");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $2df21abc8bda85fc$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $dLTlW.default)(object, key, newValue);
        else (0, $a6l6i.default)(object, key, newValue);
    }
    return object;
}
var $2df21abc8bda85fc$export$2e2bcd8739ae039 = $2df21abc8bda85fc$var$copyObject;

});
parcelRegister("a6l6i", function(module, exports) {

$parcel$export(module.exports, "default", () => $75aad50ec93ed496$export$2e2bcd8739ae039);

var $dLTlW = parcelRequire("dLTlW");

var $lvgV1 = parcelRequire("lvgV1");
/** Used for built-in method references. */ var $75aad50ec93ed496$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $75aad50ec93ed496$var$hasOwnProperty = $75aad50ec93ed496$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $75aad50ec93ed496$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($75aad50ec93ed496$var$hasOwnProperty.call(object, key) && (0, $lvgV1.default)(objValue, value)) || value === undefined && !(key in object)) (0, $dLTlW.default)(object, key, value);
}
var $75aad50ec93ed496$export$2e2bcd8739ae039 = $75aad50ec93ed496$var$assignValue;

});


parcelRegister("ceNjR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8d0ca4619e1205$export$2e2bcd8739ae039);

var $OC2DR = parcelRequire("OC2DR");

var $28fGX = parcelRequire("28fGX");

var $lAOUf = parcelRequire("lAOUf");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $8e8d0ca4619e1205$var$keysIn(object) {
    return (0, $lAOUf.default)(object) ? (0, $OC2DR.default)(object, true) : (0, $28fGX.default)(object);
}
var $8e8d0ca4619e1205$export$2e2bcd8739ae039 = $8e8d0ca4619e1205$var$keysIn;

});
parcelRegister("OC2DR", function(module, exports) {

$parcel$export(module.exports, "default", () => $09822de5e5cf749f$export$2e2bcd8739ae039);

var $3f4I6 = parcelRequire("3f4I6");

var $5VdmZ = parcelRequire("5VdmZ");

var $hf0C9 = parcelRequire("hf0C9");

var $f3ZL4 = parcelRequire("f3ZL4");

var $cBYZY = parcelRequire("cBYZY");

var $cmTeE = parcelRequire("cmTeE");
/** Used for built-in method references. */ var $09822de5e5cf749f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $09822de5e5cf749f$var$hasOwnProperty = $09822de5e5cf749f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $09822de5e5cf749f$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $hf0C9.default)(value), isArg = !isArr && (0, $5VdmZ.default)(value), isBuff = !isArr && !isArg && (0, $f3ZL4.default)(value), isType = !isArr && !isArg && !isBuff && (0, $cmTeE.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $3f4I6.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $09822de5e5cf749f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $cBYZY.default)(key, length)))) result.push(key);
    return result;
}
var $09822de5e5cf749f$export$2e2bcd8739ae039 = $09822de5e5cf749f$var$arrayLikeKeys;

});
parcelRegister("3f4I6", function(module, exports) {

$parcel$export(module.exports, "default", () => $25c66d2c4e8fadd1$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $25c66d2c4e8fadd1$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $25c66d2c4e8fadd1$export$2e2bcd8739ae039 = $25c66d2c4e8fadd1$var$baseTimes;

});

parcelRegister("cBYZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $92e841cef318fb91$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $92e841cef318fb91$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $92e841cef318fb91$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $92e841cef318fb91$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $92e841cef318fb91$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $92e841cef318fb91$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $92e841cef318fb91$export$2e2bcd8739ae039 = $92e841cef318fb91$var$isIndex;

});


parcelRegister("28fGX", function(module, exports) {

$parcel$export(module.exports, "default", () => $18d88030c379da98$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");

var $74QAJ = parcelRequire("74QAJ");

var $ab5U2 = parcelRequire("ab5U2");
/** Used for built-in method references. */ var $18d88030c379da98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $18d88030c379da98$var$hasOwnProperty = $18d88030c379da98$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $18d88030c379da98$var$baseKeysIn(object) {
    if (!(0, $iYDsF.default)(object)) return (0, $ab5U2.default)(object);
    var isProto = (0, $74QAJ.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$18d88030c379da98$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $18d88030c379da98$export$2e2bcd8739ae039 = $18d88030c379da98$var$baseKeysIn;

});
parcelRegister("ab5U2", function(module, exports) {

$parcel$export(module.exports, "default", () => $768f82a6c66c1e5e$export$2e2bcd8739ae039);
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $768f82a6c66c1e5e$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $768f82a6c66c1e5e$export$2e2bcd8739ae039 = $768f82a6c66c1e5e$var$nativeKeysIn;

});






parcelRegister("12iDD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c146f7fe522bbbb$export$2e2bcd8739ae039);

var $exqIp = parcelRequire("exqIp");

var $fAzJF = parcelRequire("fAzJF");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $0c146f7fe522bbbb$var$createAssigner(assigner) {
    return (0, $exqIp.default)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && (0, $fAzJF.default)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $0c146f7fe522bbbb$export$2e2bcd8739ae039 = $0c146f7fe522bbbb$var$createAssigner;

});
parcelRegister("exqIp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a958ded4e39f3487$export$2e2bcd8739ae039);

var $jSR8v = parcelRequire("jSR8v");

var $dQSON = parcelRequire("dQSON");

var $3CD6d = parcelRequire("3CD6d");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $a958ded4e39f3487$var$baseRest(func, start) {
    return (0, $3CD6d.default)((0, $dQSON.default)(func, start, (0, $jSR8v.default)), func + '');
}
var $a958ded4e39f3487$export$2e2bcd8739ae039 = $a958ded4e39f3487$var$baseRest;

});
parcelRegister("jSR8v", function(module, exports) {

$parcel$export(module.exports, "default", () => $e79c473b2396ff2f$export$2e2bcd8739ae039);
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $e79c473b2396ff2f$var$identity(value) {
    return value;
}
var $e79c473b2396ff2f$export$2e2bcd8739ae039 = $e79c473b2396ff2f$var$identity;

});

parcelRegister("dQSON", function(module, exports) {

$parcel$export(module.exports, "default", () => $a15aa7792aefa7ab$export$2e2bcd8739ae039);

var $dDkGf = parcelRequire("dDkGf");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a15aa7792aefa7ab$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $a15aa7792aefa7ab$var$overRest(func, start, transform) {
    start = $a15aa7792aefa7ab$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $a15aa7792aefa7ab$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $dDkGf.default)(func, this, otherArgs);
    };
}
var $a15aa7792aefa7ab$export$2e2bcd8739ae039 = $a15aa7792aefa7ab$var$overRest;

});
parcelRegister("dDkGf", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ecef59737507c1b$export$2e2bcd8739ae039);
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $9ecef59737507c1b$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $9ecef59737507c1b$export$2e2bcd8739ae039 = $9ecef59737507c1b$var$apply;

});


parcelRegister("3CD6d", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a333ffc4129ee1c$export$2e2bcd8739ae039);

var $b4MjZ = parcelRequire("b4MjZ");

var $8KfXk = parcelRequire("8KfXk");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $2a333ffc4129ee1c$var$setToString = (0, $8KfXk.default)((0, $b4MjZ.default));
var $2a333ffc4129ee1c$export$2e2bcd8739ae039 = $2a333ffc4129ee1c$var$setToString;

});
parcelRegister("b4MjZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $81058d0e7e5193a8$export$2e2bcd8739ae039);

var $5Oe6X = parcelRequire("5Oe6X");

var $1RMjB = parcelRequire("1RMjB");

var $jSR8v = parcelRequire("jSR8v");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $81058d0e7e5193a8$var$baseSetToString = !(0, $1RMjB.default) ? (0, $jSR8v.default) : function(func, string) {
    return (0, $1RMjB.default)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, $5Oe6X.default)(string),
        'writable': true
    });
};
var $81058d0e7e5193a8$export$2e2bcd8739ae039 = $81058d0e7e5193a8$var$baseSetToString;

});
parcelRegister("5Oe6X", function(module, exports) {

$parcel$export(module.exports, "default", () => $43ac9174038e0ebf$export$2e2bcd8739ae039);
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $43ac9174038e0ebf$var$constant(value) {
    return function() {
        return value;
    };
}
var $43ac9174038e0ebf$export$2e2bcd8739ae039 = $43ac9174038e0ebf$var$constant;

});


parcelRegister("8KfXk", function(module, exports) {

$parcel$export(module.exports, "default", () => $65deff1999b4a0f2$export$2e2bcd8739ae039);
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $65deff1999b4a0f2$var$HOT_COUNT = 800, $65deff1999b4a0f2$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $65deff1999b4a0f2$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $65deff1999b4a0f2$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $65deff1999b4a0f2$var$nativeNow(), remaining = $65deff1999b4a0f2$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $65deff1999b4a0f2$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $65deff1999b4a0f2$export$2e2bcd8739ae039 = $65deff1999b4a0f2$var$shortOut;

});



parcelRegister("fAzJF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b595f01ffac528e8$export$2e2bcd8739ae039);

var $lvgV1 = parcelRequire("lvgV1");

var $lAOUf = parcelRequire("lAOUf");

var $cBYZY = parcelRequire("cBYZY");

var $iYDsF = parcelRequire("iYDsF");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $b595f01ffac528e8$var$isIterateeCall(value, index, object) {
    if (!(0, $iYDsF.default)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, $lAOUf.default)(object) && (0, $cBYZY.default)(index, object.length) : type == 'string' && index in object) return (0, $lvgV1.default)(object[index], value);
    return false;
}
var $b595f01ffac528e8$export$2e2bcd8739ae039 = $b595f01ffac528e8$var$isIterateeCall;

});



parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$1c5a554c78c0cd12 = "@scope";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $298fb931ed4fbf8b$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r);
    });
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, c, n, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: c,
        props: n,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$590e8b2c435046d9(e) {
    while(e.root)e = $298fb931ed4fbf8b$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $298fb931ed4fbf8b$export$10d8903dec122b9d(e, e.siblings);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, c, n, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var p = 0;
    var v = 0;
    var b = 0;
    var h = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = n;
    var y = s;
    var j = c;
    var z = k;
    while(w)switch(b = g, g = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (b != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(z += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $298fb931ed4fbf8b$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $298fb931ed4fbf8b$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $298fb931ed4fbf8b$export$7af1228ff777d175(b);
            break;
        case 92:
            z += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a, i), i);
                    if (($298fb931ed4fbf8b$export$9e1725a4cfeada27(b || 1) == 5 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e() || 1) == 5) && $298fb931ed4fbf8b$export$36776f635604f274(z) && $298fb931ed4fbf8b$export$2f35ab04d2335697(z, -1, void 0) !== " ") z += " ";
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * h:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(z) * d;
        case 125 * h:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (v > 0 && ($298fb931ed4fbf8b$export$36776f635604f274(z) - l || h === 0 && b === 47)) $298fb931ed4fbf8b$export$10d8903dec122b9d(v > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(z + ";", c, a, l - 1, i) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(z, " ", "") + ";", c, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(j = $298fb931ed4fbf8b$export$3307ffa7023ede1e(z, r, a, f, o, n, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else {
                            switch(p){
                                case 99:
                                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(z, 3) === 110) break;
                                case 108:
                                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(z, 2) === 97) break;
                                default:
                                    o = 0;
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (o) $298fb931ed4fbf8b$export$98e6a39c04603d36(e, j, j, c && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, j, j, 0, 0, n, u, k, n, x = [], l, y), y), n, y, l, u, c ? x : y);
                            else $298fb931ed4fbf8b$export$98e6a39c04603d36(z, j, j, j, [
                                ""
                            ], y, 0, u, y);
                        }
                    }
            }
            f = o = v = 0, h = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(z), v = b;
        default:
            if (h < 1) {
                if (g == 123) --h;
                else if (g == 125 && h++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(z += $298fb931ed4fbf8b$export$6788812c4e6611e6(g), g * h){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) z += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    p = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(k = z += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (b === 45 && $298fb931ed4fbf8b$export$36776f635604f274(z) == 2) h = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, c, s, t, u, i, f, o, l, p) {
    var v = s - 1;
    var b = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(b);
    for(var w = 0, d = 0, g = 0; w < c; ++w)for(var k = 0, m = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(d = u[w])), x = e; k < h; ++k)if (x = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(d > 0 ? b[k] + " " + m : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(m, /&\f/g, b[k]))) f[g++] = x;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l, p);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0, n);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, c, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, c), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, c + 1, -1), c, n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(c, n, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(c, n)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + c + c;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + c;
        case 4855:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + c;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + c + c;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$2c0f367103c8d01c + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + c + c;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb") + c;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb-rl") + c;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "lr") + c;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + c + c;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + c + c;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + c;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") : "") + c;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /align-content|flex-|-self/g, "") + c;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "shrink", "negative") + c;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "basis", "preferred-size") + c;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "grow", "positive") + c;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + c;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), c, "") + c;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /space-between/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + c;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(c, n) + c;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "template-", "") + c;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return n = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(c + (s = s[n].value), "span", 0) ? c : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-start", "") + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span", 0) ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-start", "") + c;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? c : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-end", "-span"), "span ", "") + c;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + c;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(c) - 1 - n > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 3) == 108 ? "$3" : "$2-$3")) + c;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(c, "stretch", 0) ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "stretch", "fill-available"), n, s) + c : c;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, n, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + n + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +n) + i : "") + c;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + c;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(c, $298fb931ed4fbf8b$export$a9db5e087081082d(c, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(c, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + c;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + c;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "scroll-", "scroll-snap-") + c;
    }
    return c;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var c = 0; c < e.length; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$6aad947bda0f3f46:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            if (!$298fb931ed4fbf8b$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, c, n, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, c, n, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(c, t, u, i) {
    if (c.length > -1) {
        if (!c.return) switch(c.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                c.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(c.value, c.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (c.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(u = c.props, function(n) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(n, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(c, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(c, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, c) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (c[++a] === "global") c[a] = "", c[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(c[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(c) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(c) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("02tYw", function(module, exports) {

$parcel$export(module.exports, "default", () => $0077707102ec2f63$export$2e2bcd8739ae039);

var $lTyg4 = parcelRequire("lTyg4");

var $4wkSQ = parcelRequire("4wkSQ");

var $5VdmZ = parcelRequire("5VdmZ");

var $hf0C9 = parcelRequire("hf0C9");

var $lAOUf = parcelRequire("lAOUf");

var $f3ZL4 = parcelRequire("f3ZL4");

var $74QAJ = parcelRequire("74QAJ");

var $cmTeE = parcelRequire("cmTeE");
/** `Object#toString` result references. */ var $0077707102ec2f63$var$mapTag = '[object Map]', $0077707102ec2f63$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $0077707102ec2f63$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0077707102ec2f63$var$hasOwnProperty = $0077707102ec2f63$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $0077707102ec2f63$var$isEmpty(value) {
    if (value == null) return true;
    if ((0, $lAOUf.default)(value) && ((0, $hf0C9.default)(value) || typeof value == 'string' || typeof value.splice == 'function' || (0, $f3ZL4.default)(value) || (0, $cmTeE.default)(value) || (0, $5VdmZ.default)(value))) return !value.length;
    var tag = (0, $4wkSQ.default)(value);
    if (tag == $0077707102ec2f63$var$mapTag || tag == $0077707102ec2f63$var$setTag) return !value.size;
    if ((0, $74QAJ.default)(value)) return !(0, $lTyg4.default)(value).length;
    for(var key in value){
        if ($0077707102ec2f63$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
var $0077707102ec2f63$export$2e2bcd8739ae039 = $0077707102ec2f63$var$isEmpty;

});
parcelRegister("lTyg4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff094f04b4f9f6ca$export$2e2bcd8739ae039);

var $74QAJ = parcelRequire("74QAJ");

var $4lnKf = parcelRequire("4lnKf");
/** Used for built-in method references. */ var $ff094f04b4f9f6ca$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ff094f04b4f9f6ca$var$hasOwnProperty = $ff094f04b4f9f6ca$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ff094f04b4f9f6ca$var$baseKeys(object) {
    if (!(0, $74QAJ.default)(object)) return (0, $4lnKf.default)(object);
    var result = [];
    for(var key in Object(object))if ($ff094f04b4f9f6ca$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $ff094f04b4f9f6ca$export$2e2bcd8739ae039 = $ff094f04b4f9f6ca$var$baseKeys;

});
parcelRegister("4lnKf", function(module, exports) {

$parcel$export(module.exports, "default", () => $329b8ad85e05c8eb$export$2e2bcd8739ae039);

var $7N1cZ = parcelRequire("7N1cZ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $329b8ad85e05c8eb$var$nativeKeys = (0, $7N1cZ.default)(Object.keys, Object);
var $329b8ad85e05c8eb$export$2e2bcd8739ae039 = $329b8ad85e05c8eb$var$nativeKeys;

});


parcelRegister("4wkSQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $34aa59a61c7ccccb$export$2e2bcd8739ae039);

var $dR5x6 = parcelRequire("dR5x6");

var $fs3H6 = parcelRequire("fs3H6");

var $ab1Hq = parcelRequire("ab1Hq");

var $iypSL = parcelRequire("iypSL");

var $1xFLT = parcelRequire("1xFLT");

var $hArsG = parcelRequire("hArsG");

var $5bfPQ = parcelRequire("5bfPQ");
/** `Object#toString` result references. */ var $34aa59a61c7ccccb$var$mapTag = '[object Map]', $34aa59a61c7ccccb$var$objectTag = '[object Object]', $34aa59a61c7ccccb$var$promiseTag = '[object Promise]', $34aa59a61c7ccccb$var$setTag = '[object Set]', $34aa59a61c7ccccb$var$weakMapTag = '[object WeakMap]';
var $34aa59a61c7ccccb$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $34aa59a61c7ccccb$var$dataViewCtorString = (0, $5bfPQ.default)((0, $dR5x6.default)), $34aa59a61c7ccccb$var$mapCtorString = (0, $5bfPQ.default)((0, $fs3H6.default)), $34aa59a61c7ccccb$var$promiseCtorString = (0, $5bfPQ.default)((0, $ab1Hq.default)), $34aa59a61c7ccccb$var$setCtorString = (0, $5bfPQ.default)((0, $iypSL.default)), $34aa59a61c7ccccb$var$weakMapCtorString = (0, $5bfPQ.default)((0, $1xFLT.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $34aa59a61c7ccccb$var$getTag = (0, $hArsG.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $dR5x6.default) && $34aa59a61c7ccccb$var$getTag(new (0, $dR5x6.default)(new ArrayBuffer(1))) != $34aa59a61c7ccccb$var$dataViewTag || (0, $fs3H6.default) && $34aa59a61c7ccccb$var$getTag(new (0, $fs3H6.default)) != $34aa59a61c7ccccb$var$mapTag || (0, $ab1Hq.default) && $34aa59a61c7ccccb$var$getTag((0, $ab1Hq.default).resolve()) != $34aa59a61c7ccccb$var$promiseTag || (0, $iypSL.default) && $34aa59a61c7ccccb$var$getTag(new (0, $iypSL.default)) != $34aa59a61c7ccccb$var$setTag || (0, $1xFLT.default) && $34aa59a61c7ccccb$var$getTag(new (0, $1xFLT.default)) != $34aa59a61c7ccccb$var$weakMapTag) $34aa59a61c7ccccb$var$getTag = function(value) {
    var result = (0, $hArsG.default)(value), Ctor = result == $34aa59a61c7ccccb$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $5bfPQ.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $34aa59a61c7ccccb$var$dataViewCtorString:
            return $34aa59a61c7ccccb$var$dataViewTag;
        case $34aa59a61c7ccccb$var$mapCtorString:
            return $34aa59a61c7ccccb$var$mapTag;
        case $34aa59a61c7ccccb$var$promiseCtorString:
            return $34aa59a61c7ccccb$var$promiseTag;
        case $34aa59a61c7ccccb$var$setCtorString:
            return $34aa59a61c7ccccb$var$setTag;
        case $34aa59a61c7ccccb$var$weakMapCtorString:
            return $34aa59a61c7ccccb$var$weakMapTag;
    }
    return result;
};
var $34aa59a61c7ccccb$export$2e2bcd8739ae039 = $34aa59a61c7ccccb$var$getTag;

});
parcelRegister("dR5x6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1648453896f67d2$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $a1648453896f67d2$var$DataView = (0, $jLT9P.default)((0, $2mpFt.default), 'DataView');
var $a1648453896f67d2$export$2e2bcd8739ae039 = $a1648453896f67d2$var$DataView;

});

parcelRegister("ab1Hq", function(module, exports) {

$parcel$export(module.exports, "default", () => $768c3ff3ee4df356$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $768c3ff3ee4df356$var$Promise = (0, $jLT9P.default)((0, $2mpFt.default), 'Promise');
var $768c3ff3ee4df356$export$2e2bcd8739ae039 = $768c3ff3ee4df356$var$Promise;

});

parcelRegister("iypSL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d81f7aa452e6e637$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $d81f7aa452e6e637$var$Set = (0, $jLT9P.default)((0, $2mpFt.default), 'Set');
var $d81f7aa452e6e637$export$2e2bcd8739ae039 = $d81f7aa452e6e637$var$Set;

});

parcelRegister("1xFLT", function(module, exports) {

$parcel$export(module.exports, "default", () => $11f94673ff7d99d8$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $11f94673ff7d99d8$var$WeakMap = (0, $jLT9P.default)((0, $2mpFt.default), 'WeakMap');
var $11f94673ff7d99d8$export$2e2bcd8739ae039 = $11f94673ff7d99d8$var$WeakMap;

});



parcelRegister("24OkN", function(module, exports) {
module.exports = import("lQprE").then(()=>parcelRequire('2SHzT'));

});

parcelRegister("k6i1g", function(module, exports) {
module.exports = import("8B3lB").then(()=>parcelRequire('a2TO0'));

});

parcelRegister("k670q", function(module, exports) {
module.exports = Promise.all([
    import("3VJbA"),
    import("iBuLK"),
    import("1PTUU"),
    import("kRk9Q"),
    import("6rNWr"),
    import("o3T7O"),
    import("4QCR7"),
    import("d7zJK")
]).then(()=>parcelRequire('csJsV'));

});

parcelRegister("gpwOt", function(module, exports) {
module.exports = Promise.all([
    import("3VJbA"),
    import("iBuLK"),
    import("1PTUU"),
    import("kRk9Q"),
    import("6rNWr"),
    import("o3T7O"),
    import("4QCR7"),
    import("l721h")
]).then(()=>parcelRequire('fsB26'));

});

parcelRegister("isK8E", function(module, exports) {
module.exports = Promise.all([
    import("6rNWr"),
    import("o3T7O"),
    import("k0GSS")
]).then(()=>parcelRequire('4rteX'));

});

parcelRegister("40XJq", function(module, exports) {
module.exports = import("8iYmU").then(()=>parcelRequire('9bFKz'));

});

parcelRegister("gnEYC", function(module, exports) {
module.exports = import("fJ1I7").then(()=>parcelRequire('b2B33'));

});

parcelRegister("eFkkr", function(module, exports) {
module.exports = import("4DPTu").then(()=>parcelRequire('2xmou'));

});

parcelRegister("e99i0", function(module, exports) {
module.exports = import("2D5r3").then(()=>parcelRequire('3RDy5'));

});

parcelRegister("03Oo5", function(module, exports) {
module.exports = import("k6u0X").then(()=>parcelRequire('cbCn3'));

});

parcelRegister("ePP6R", function(module, exports) {
module.exports = Promise.all([
    import("3VJbA"),
    import("jMxqb")
]).then(()=>parcelRequire('45BOc'));

});

parcelRegister("e16WY", function(module, exports) {
module.exports = Promise.all([
    import("6rNWr"),
    import("o3T7O"),
    import("5nh8P")
]).then(()=>parcelRequire('6D0wx'));

});

parcelRegister("jg7i2", function(module, exports) {
module.exports = import("1EL2V").then(()=>parcelRequire('d6acp'));

});

parcelRegister("3rh1h", function(module, exports) {
module.exports = Promise.all([
    import("fnND7"),
    import("6rNWr"),
    import("o3T7O"),
    import("bNoKA")
]).then(()=>parcelRequire('eLRdY'));

});

parcelRegister("5hQaA", function(module, exports) {
module.exports = Promise.all([
    import("fnND7"),
    import("3VJbA"),
    import("iBuLK"),
    import("1PTUU"),
    import("6rNWr"),
    import("o3T7O"),
    import("9G1WQ")
]).then(()=>parcelRequire('6yDN9'));

});

parcelRegister("gUeMN", function(module, exports) {
module.exports = Promise.all([
    import("3rbcj"),
    import("6rNWr"),
    import("o3T7O"),
    import("fNRqc")
]).then(()=>parcelRequire('2lCoZ'));

});

parcelRegister("hv449", function(module, exports) {
module.exports = Promise.all([
    import("3rbcj"),
    import("3VJbA"),
    import("iBuLK"),
    import("1PTUU"),
    import("6rNWr"),
    import("o3T7O"),
    import("jjCI2")
]).then(()=>parcelRequire('bV97L'));

});

parcelRegister("h4b4r", function(module, exports) {
module.exports = import("7DUYw").then(()=>parcelRequire('f5iMj'));

});

parcelRegister("1mnoh", function(module, exports) {
module.exports = Promise.all([
    import("3VJbA"),
    import("iBuLK"),
    import("4QCR7"),
    import("dBxK2")
]).then(()=>parcelRequire('ixTUd'));

});

parcelRegister("lgpFG", function(module, exports) {
module.exports = import("8mjuI").then(()=>parcelRequire('4zuIQ'));

});

parcelRegister("ll6G0", function(module, exports) {
module.exports = Promise.all([
    import("3VJbA"),
    import("kChHp")
]).then(()=>parcelRequire('k8u8K'));

});

parcelRegister("dBcSy", function(module, exports) {
module.exports = import("dxLyh").then(()=>parcelRequire('jAH8X'));

});

parcelRegister("1sg64", function(module, exports) {
module.exports = Promise.all([
    import("3VJbA"),
    import("iBuLK"),
    import("o3T7O"),
    import("dyhHW")
]).then(()=>parcelRequire('a9aZh'));

});



var $b34XJ = parcelRequire("b34XJ");
parcelRequire("2YFJl");
var $hOxpW = parcelRequire("hOxpW");
var $cwuwP = parcelRequire("cwuwP");

var $8uVid = parcelRequire("8uVid");
/**
 * @file
 * @typedef {import('./types.js').NextNodeData} NextNodeData * 
 */ const $622ae462df063d15$var$_LOG = (0, $8uVid.debug)({
    on: false,
    topic: 'LG4jGraph'
});
const $622ae462df063d15$var$_DBG = (0, $8uVid.debug)({
    on: false,
    topic: 'LG4jGraph'
});
class $622ae462df063d15$export$f7b615bf52e15074 extends HTMLElement {
    constructor(){
        super();
        (0, $b34XJ.N).initialize({
            logLevel: 'none',
            startOnLoad: false,
            theme: 'dark',
            flowchart: {
                useMaxWidth: false
            }
        });
        this._content = null;
        this._activeClass = null;
        // @ts-ignore
        this._lastTransform = null;
        const shadowRoot = this.attachShadow({
            mode: 'open'
        });
        const style = document.createElement("style");
        style.textContent = `
    // :host {
    //   display: block;
    //   width: 100%;
    //   height: 100%;
    // }
    .h-full {
      height: 100%;
    }
    .w-full {
      width: 100%;
    }
    // .flex {
    //   display: flex;
    // }
    .items-center {
      align-items: center;
    }
    .justify-center {
      justify-content: center;
    }
    .bg-neutral {
      --tw-bg-opacity: 1;
      background-color: var(--fallback-n,oklch(var(--n)/var(--tw-bg-opacity)));
  }
    `;
        shadowRoot.appendChild(style);
        const container = document.createElement('div');
        container.classList.add("h-full");
        container.classList.add("w-full");
        container.classList.add("flex");
        container.classList.add("items-center");
        container.classList.add("justify-center");
        container.classList.add("bg-neutral");
        container.classList.add("mermaid");
        // const pre = document.createElement('pre')
        // pre.classList.add("mermaid");
        // container.appendChild( pre );
        shadowRoot.appendChild(container);
        this.#renderDiagram();
    }
    /**
   * @returns {ChildNode[]}
   */ get #textNodes() {
        return Array.from(this.childNodes).filter((node)=>node.nodeType === this.TEXT_NODE);
    }
    /**
   * @returns {string}
   */ get #textContent() {
        if (this._content) {
            if (this._activeClass) return `
        ${this._content}
        classDef ${this._activeClass} fill:#f96
        `;
            return this._content;
        }
        return 'flowchart TD' //this.#textNodes.map(node => node.textContent?.trim()).join('');
        ;
    }
    async #renderDiagram() {
        const svgContainer = this.shadowRoot?.querySelector('.mermaid');
        if (!svgContainer) {
            console.error('svgcontainer not found!');
            return;
        }
        return (0, $b34XJ.N).render('graph', this.#textContent).then((res)=>{
            $622ae462df063d15$var$_LOG('RENDER COMPLETE', svgContainer);
            const { width: width, height: height } = svgContainer.getBoundingClientRect();
            $622ae462df063d15$var$_LOG('width:', width, 'height:', height);
            const translated = res.svg.replace(/height="[\d\.]+"/, `height="${height}"`).replace(/width="[\d\.]+"/, `width="${width}"`);
            svgContainer.innerHTML = translated;
        }).then(()=>this.#svgPanZoom()).then(()=>{
            $622ae462df063d15$var$_LOG(()=>{
                $622ae462df063d15$var$_LOG("boundingClientRect", svgContainer.getBoundingClientRect());
                for (const rc of svgContainer.getClientRects())$622ae462df063d15$var$_LOG(rc);
            });
        }).catch((e)=>console.error('RENDER ERROR', e));
    }
    #svgPanZoom() {
        $622ae462df063d15$var$_LOG('_lastTransform', this._lastTransform);
        // @ts-ignore
        const svgs = $hOxpW.default(this.shadowRoot).select(".mermaid svg");
        const self = this;
        svgs.each(function() {
            // 'this' refers to the current DOM element
            const svg = $hOxpW.default(this);
            svg.html("<g>" + svg.html() + '</g>');
            const inner = svg.select("g");
            const zoom = $cwuwP.default().on("zoom", (event)=>{
                inner.attr("transform", event.transform);
                self._lastTransform = event.transform;
            });
            // @ts-ignore
            const selection = svg.call(zoom);
            if (self._lastTransform !== null) {
                inner.attr("transform", self._lastTransform);
                // [D3.js Set initial zoom level](https://stackoverflow.com/a/46437252/521197)
                // @ts-ignore
                selection.call(zoom.transform, self._lastTransform);
            }
        });
    }
    /**
   * Handles the content event to update the diagram content.
   *
   * @param {CustomEvent} e - The event object containing the new content detail.
   */ #onContent(e) {
        const { detail: newContent } = e;
        this._content = newContent;
        this.#renderDiagram();
    }
    /**
   * Handles the active class event to update the active class in the diagram.
   *
   * @param {CustomEvent<NextNodeData} e - The event object containing the active class detail.
   */ #onActive(e) {
        const { detail: { node: node, subgraphNode: subgraphNode } } = e;
        this._activeClass = subgraphNode ?? node;
        $622ae462df063d15$var$_DBG("Active class updated:", this._activeClass);
        this.#renderDiagram();
    }
    /**
   * Handles the resize event to re-render the diagram.
   */ #resizeHandler = ()=>this.#renderDiagram();
    /**
   * Called when the element is connected to the document's DOM.
   * Sets up event listeners for graph content and active class updates, and window resize.
   */ connectedCallback() {
        // @ts-ignore
        this.addEventListener('graph', this.#onContent);
        // @ts-ignore
        this.addEventListener('graph-active', this.#onActive);
        window.addEventListener('resize', this.#resizeHandler);
    }
    /**
   * Called when the element is disconnected from the document's DOM.
   * Cleans up event listeners for graph content and active class updates, and window resize.
   */ disconnectedCallback() {
        // @ts-ignore
        this.removeEventListener('graph', this.#onContent);
        // @ts-ignore
        this.removeEventListener('graph-active', this.#onActive);
        window.removeEventListener('resize', this.#resizeHandler);
    }
    /**
   * Renders the diagram with the current content and runs the mermaid library.
   * This method is deprecated and should not be used in new code.
   *
   * @deprecated
   * @returns {Promise<void>} A promise that resolves when the diagram rendering and mermaid run are complete.
   */ // @ts-ignore
    async #renderDiagramWithRun() {
        const pres = this.shadowRoot?.querySelectorAll('.mermaid');
        // @ts-ignore
        pres[0].textContent = this.#textContent;
        return (0, $b34XJ.N).run({
            // @ts-ignore
            nodes: pres,
            suppressErrors: true
        }).then(()=>$622ae462df063d15$var$_LOG("RUN COMPLETE")).then(()=>this.#svgPanZoom()).catch((e)=>console.error("RUN ERROR", e));
    }
}
window.customElements.define('lg4j-graph', $622ae462df063d15$export$f7b615bf52e15074);


//# sourceMappingURL=webui.ca1564f8.js.map
